export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AbbreviatedDate: any;
  Currency: any;
  Date: any;
  EasternTimeZoneDate: any;
  RecordString: Record<string, string>;
  Upload: any;
  UserRole: any;
  UserSearchRole: any;
  Void: any;
};

export type AccountExecutive = {
  __typename?: 'AccountExecutive';
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
};

export type AccountFilterOptions = {
  __typename?: 'AccountFilterOptions';
  adAccountId: Scalars['String'];
  adAccountName: Scalars['String'];
};

export type AccountSetInfo = {
  __typename?: 'AccountSetInfo';
  accountId: Scalars['Int'];
  adAccountId: Scalars['ID'];
  adAccountName: Scalars['String'];
};

export type ActiveUsersStatistics = {
  __typename?: 'ActiveUsersStatistics';
  activeUsers: Scalars['Int'];
  percentActive: Maybe<Scalars['Float']>;
  percentUniqueSubmittedBy: Maybe<Scalars['Float']>;
  totalSpend: Scalars['Float'];
  totalUsers: Scalars['Int'];
};

export type AdAccount = Node & {
  __typename?: 'AdAccount';
  access: Maybe<Scalars['String']>;
  accountsApprovedForTerms: Maybe<Scalars['Boolean']>;
  activeCpm: Maybe<Scalars['Float']>;
  adsCount: Maybe<Scalars['Int']>;
  agencyCommissionPercentage: Maybe<Scalars['Float']>;
  approvedForPrepaymentTerms: Maybe<Scalars['Boolean']>;
  assignedUsers: Maybe<Array<User>>;
  billBy: Maybe<Scalars['String']>;
  billableAdServer: Maybe<Scalars['String']>;
  billingCalendar: Maybe<Scalars['String']>;
  billingContact: Maybe<BillingContact>;
  billingTerm: BillingTerm;
  brand: Maybe<Brand>;
  budget: Maybe<Scalars['Int']>;
  campaignsCount: Maybe<Scalars['Int']>;
  campaignsCountStatistic: Maybe<Scalars['Int']>;
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  deleted: Maybe<Scalars['Boolean']>;
  dnaListAppliedByDefault: Maybe<Scalars['Boolean']>;
  dnaListPresetId: Maybe<Scalars['ID']>;
  fundingSource: Maybe<FundingSource>;
  id: Scalars['ID'];
  invoiceByCampaign: Maybe<Scalars['Boolean']>;
  isBaymaxEnabled: Maybe<Scalars['Boolean']>;
  isMatureBrand: Maybe<Scalars['Boolean']>;
  lastLoginAt: Maybe<Scalars['AbbreviatedDate']>;
  name: Scalars['String'];
  organization: Maybe<AdAccountOrganization>;
  organizationId: Maybe<Scalars['ID']>;
  paymentMethod: Maybe<PaymentMethod>;
  status: Maybe<AdAccountStatus>;
  thresholdAmount: Maybe<Scalars['Int']>;
  timezone: Scalars['String'];
  usersCount: Scalars['Int'];
};

export type AdAccountAndOrganizationStatuses = {
  __typename?: 'AdAccountAndOrganizationStatuses';
  adAccountStatus: AdAccountStatus;
  organizationStatus: OrganizationStatus;
};

export type AdAccountAssignment = {
  __typename?: 'AdAccountAssignment';
  id: Scalars['String'];
  name: Scalars['String'];
};

export const AdAccountAudienceSortBy = {
  AudienceId: 'audienceId',
  CreatedAt: 'createdAt',
  DisplayName: 'displayName',
  Id: 'id',
  Name: 'name',
  OptionName: 'optionName',
  Status: 'status',
  TargetType: 'targetType',
} as const;

export type AdAccountAudienceSortBy = (typeof AdAccountAudienceSortBy)[keyof typeof AdAccountAudienceSortBy];
export type AdAccountAudienceSortOptions = {
  sortBy?: InputMaybe<AdAccountAudienceSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export const AdAccountAudienceStatus = {
  Available: 'AVAILABLE',
  Expired: 'EXPIRED',
} as const;

export type AdAccountAudienceStatus = (typeof AdAccountAudienceStatus)[keyof typeof AdAccountAudienceStatus];
export type AdAccountAudienceTargetType = {
  __typename?: 'AdAccountAudienceTargetType';
  displayName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AdAccountAudienceTargetValue = Node & {
  __typename?: 'AdAccountAudienceTargetValue';
  audienceId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  displayName: Maybe<Scalars['String']>;
  expiryDate: Maybe<Scalars['AbbreviatedDate']>;
  gamId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  optionName: Maybe<Scalars['String']>;
  targetType: AdAccountAudienceTargetType;
};

export type AdAccountAudienceTargetValueEdge = Edge & {
  __typename?: 'AdAccountAudienceTargetValueEdge';
  cursor: Scalars['String'];
  node: AdAccountAudienceTargetValue;
};

export type AdAccountAudienceTargetValuePages = Connection & {
  __typename?: 'AdAccountAudienceTargetValuePages';
  edges: Array<AdAccountAudienceTargetValueEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type AdAccountAudiencesFilterOptions = {
  searchTerm?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdAccountAudienceStatus>;
  targetTypeId?: InputMaybe<Scalars['ID']>;
};

export type AdAccountEdge = Edge & {
  __typename?: 'AdAccountEdge';
  cursor: Scalars['String'];
  node: AdAccount;
};

export type AdAccountFilterOptions = {
  billingTerm?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['String']>;
  lastLoginAtFrom?: InputMaybe<Scalars['String']>;
  lastLoginAtTo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Scalars['String']>;
};

export type AdAccountForCampaignWithExtraData = {
  __typename?: 'AdAccountForCampaignWithExtraData';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AdAccountInput = {
  billingContactId?: InputMaybe<Scalars['String']>;
  brandId: Scalars['String'];
  fundingSource?: InputMaybe<FundingSource>;
  invoiceByCampaign?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  paymentMethodExternalId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type AdAccountNotificationOptionsType = {
  __typename?: 'AdAccountNotificationOptionsType';
  notificationTypes: Array<Scalars['String']>;
};

export type AdAccountOptions = Node & {
  __typename?: 'AdAccountOptions';
  accountsApprovedForTerms: Maybe<Scalars['Boolean']>;
  billableAdServer: Maybe<Scalars['String']>;
  fundingSource: Maybe<FundingSource>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AdAccountOptionsEdge = Edge & {
  __typename?: 'AdAccountOptionsEdge';
  cursor: Scalars['String'];
  node: AdAccountOptions;
};

export type AdAccountOptionsWithNotificationTypeEdge = Edge & {
  __typename?: 'AdAccountOptionsWithNotificationTypeEdge';
  cursor: Scalars['String'];
  node: AdAccountWithNotificationTypeOptions;
};

export type AdAccountOrganization = {
  __typename?: 'AdAccountOrganization';
  organizationId: Scalars['ID'];
  organizationName: Scalars['String'];
};

/** AD_ACCOUNT */
export type AdAccountRole = {
  __typename?: 'AdAccountRole';
  accountName: Scalars['String'];
};

export type AdAccountShortInfo = {
  __typename?: 'AdAccountShortInfo';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export const AdAccountSortBy = {
  BillingTerm: 'billingTerm',
  CreatedAt: 'createdAt',
  LastLoginAt: 'lastLoginAt',
  Name: 'name',
  OrganizationName: 'organizationName',
  Status: 'status',
  Type: 'type',
  UsersCount: 'usersCount',
} as const;

export type AdAccountSortBy = (typeof AdAccountSortBy)[keyof typeof AdAccountSortBy];
export type AdAccountSortOptions = {
  sortBy?: InputMaybe<AdAccountSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export const AdAccountStatus = {
  Active: 'ACTIVE',
  Closed: 'CLOSED',
  Disabled: 'DISABLED',
  Inactive: 'INACTIVE',
  InGracePeriod: 'IN_GRACE_PERIOD',
  UnderReview: 'UNDER_REVIEW',
} as const;

export type AdAccountStatus = (typeof AdAccountStatus)[keyof typeof AdAccountStatus];
export type AdAccountUpdate = {
  adAccountName?: InputMaybe<Scalars['String']>;
  agencyCommissionPercentage?: InputMaybe<Scalars['Float']>;
  billableAdServer?: InputMaybe<Scalars['String']>;
  billingCalendar?: InputMaybe<Scalars['String']>;
  billingContactId?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['String']>;
  budget?: InputMaybe<Scalars['Int']>;
  fundingSource?: InputMaybe<FundingSource>;
  invoiceByCampaign?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  paymentMethodExternalId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type AdAccountUpdatePatch = {
  adAccountName?: InputMaybe<Scalars['String']>;
  billingContactId?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['String']>;
  budget?: InputMaybe<Scalars['Int']>;
  dnaListAppliedByDefault?: InputMaybe<Scalars['Boolean']>;
  dnaListPresetId?: InputMaybe<Scalars['ID']>;
  fundingSource?: InputMaybe<FundingSource>;
  type?: InputMaybe<Scalars['String']>;
};

export type AdAccountUpdateStatusInput = {
  id: Scalars['String'];
  status: AdAccountStatus;
};

export type AdAccountWithNotificationTypeOptions = Node & {
  __typename?: 'AdAccountWithNotificationTypeOptions';
  id: Scalars['ID'];
  name: Scalars['String'];
  notificationTypes: Array<Maybe<Scalars['String']>>;
};

export type AdAccountsId = {
  uuids: Array<Scalars['ID']>;
};

export type AdAccountsOptionsPages = Connection & {
  __typename?: 'AdAccountsOptionsPages';
  edges: Array<AdAccountOptionsEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type AdAccountsOptionsWithNotificationTypesPages = Connection & {
  __typename?: 'AdAccountsOptionsWithNotificationTypesPages';
  edges: Array<AdAccountOptionsWithNotificationTypeEdge>;
  enableForAll: Scalars['Boolean'];
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type AdAccountsPages = Connection & {
  __typename?: 'AdAccountsPages';
  edges: Array<AdAccountEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type AdAsset = {
  __typename?: 'AdAsset';
  caption: Maybe<Scalars['String']>;
  createdAt: Scalars['AbbreviatedDate'];
  duration: Maybe<Scalars['Float']>;
  externalAssetId: Maybe<Scalars['ID']>;
  format: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rejectionReason: Maybe<Array<Scalars['String']>>;
  size: Maybe<Scalars['Float']>;
  sourceUrl: Maybe<Scalars['String']>;
  status: CreativeStatus;
};

export type AdBrand = {
  __typename?: 'AdBrand';
  id: Maybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type AdEdge = Edge & {
  __typename?: 'AdEdge';
  cursor: Scalars['String'];
  node: AdInfo;
};

export type AdFilterOptions = {
  adAccountId?: InputMaybe<Scalars['ID']>;
  assetName?: InputMaybe<Scalars['String']>;
  assetStatus?: InputMaybe<Array<InputMaybe<CreativeStatus>>>;
  brandId?: InputMaybe<Scalars['ID']>;
  submittedBy?: InputMaybe<Scalars['ID']>;
};

export const AdFormat = {
  Choice: 'CHOICE',
  GatewayGo: 'GATEWAY_GO',
  KervEnhanced: 'KERV_ENHANCED',
  Standard: 'STANDARD',
} as const;

export type AdFormat = (typeof AdFormat)[keyof typeof AdFormat];
export type AdFormatConfig = {
  __typename?: 'AdFormatConfig';
  adFormat: Scalars['ID'];
  excludedAdDurations: Maybe<Array<Maybe<Scalars['String']>>>;
  minBudget: Scalars['Float'];
  packageIds: Maybe<Array<Maybe<Scalars['String']>>>;
  packageNames: Maybe<Scalars['String']>;
};

export type AdInfo = Node & {
  __typename?: 'AdInfo';
  asset: AdAsset;
  assetS3Url: Maybe<Scalars['String']>;
  brand: AdBrand;
  creativeLibraryId: Scalars['String'];
  creativeManagerId: Maybe<Scalars['ID']>;
  creativeType: Scalars['String'];
  deletable: Scalars['Boolean'];
  duration: Maybe<Scalars['Float']>;
  format: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDisneyAi: Maybe<Scalars['Boolean']>;
  lineItems: Maybe<Array<Maybe<CreativeLineItemInfo>>>;
  size: Maybe<Scalars['Float']>;
  status: CreativeStatus;
  submittedBy: Maybe<SubmittedBy>;
};

export type AdInput = {
  organizationId: Scalars['ID'];
};

export const AdProduct = {
  AdSelector: 'AD_SELECTOR',
  AdSelectorSlate: 'AD_SELECTOR_SLATE',
  AdSelectorVideo: 'AD_SELECTOR_VIDEO',
  BeSelector: 'BE_SELECTOR',
  BingeAdFree: 'BINGE_AD_FREE',
  BingeReward: 'BINGE_REWARD',
  BingeSlate: 'BINGE_SLATE',
  BingeTeaser: 'BINGE_TEASER',
  BingeVideo: 'BINGE_VIDEO',
  Brightline: 'BRIGHTLINE',
  Choice: 'CHOICE',
  CollectionLogo: 'COLLECTION_LOGO',
  CoverStoryLogo: 'COVER_STORY_LOGO',
  GatewayGo: 'GATEWAY_GO',
  GatewayShop: 'GATEWAY_SHOP',
  HouseVideo: 'HOUSE_VIDEO',
  HubLogo: 'HUB_LOGO',
  Innovid: 'INNOVID',
  Marquee: 'MARQUEE',
  MaxSelector: 'MAX_SELECTOR',
  Pause: 'PAUSE',
  PausePlus: 'PAUSE_PLUS',
  Slate: 'SLATE',
  Video: 'VIDEO',
  VideoPlus: 'VIDEO_PLUS',
} as const;

export type AdProduct = (typeof AdProduct)[keyof typeof AdProduct];
export const AdProductInput = {
  Video: 'VIDEO',
} as const;

export type AdProductInput = (typeof AdProductInput)[keyof typeof AdProductInput];
export type AdSelectorBrandsFilterOptions = {
  isPolitical?: InputMaybe<Scalars['Boolean']>;
};

export type AdSnapshot = {
  __typename?: 'AdSnapshot';
  adTags: Maybe<Array<AdSnapshotTag>>;
  creativeId: Scalars['ID'];
  weight: Maybe<Scalars['Float']>;
};

export type AdSnapshotInput = {
  adTags?: InputMaybe<Array<UpdateAdTags>>;
  creativeId: Scalars['ID'];
  weight?: InputMaybe<Scalars['Float']>;
};

export type AdSnapshotTag = {
  __typename?: 'AdSnapshotTag';
  id: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export const AdSortBy = {
  AssetName: 'assetName',
  AssetStatus: 'assetStatus',
  Brand: 'brand',
  CreatedAt: 'createdAt',
  Name: 'name',
  SubmittedBy: 'submittedBy',
} as const;

export type AdSortBy = (typeof AdSortBy)[keyof typeof AdSortBy];
export type AdSortOptions = {
  sortBy?: InputMaybe<AdSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export const AdStatus = {
  Approved: 'APPROVED',
  Draft: 'DRAFT',
  Invalid: 'INVALID',
  Published: 'PUBLISHED',
  Rejected: 'REJECTED',
  Submitted: 'SUBMITTED',
  UnderReview: 'UNDER_REVIEW',
  Unknown: 'UNKNOWN',
  Vast: 'VAST',
} as const;

export type AdStatus = (typeof AdStatus)[keyof typeof AdStatus];
export type AdTags = {
  __typename?: 'AdTags';
  configuredAdTag: ConfiguredUrl;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type AdType = {
  __typename?: 'AdType';
  actions: Maybe<LineItemCreativeActions>;
  adTags: Maybe<Array<Maybe<AdTags>>>;
  creative: Maybe<LineItemCreative>;
  disabledReasons: Maybe<LineItemCreativeDisableReasons>;
  weight: Maybe<Scalars['Float']>;
};

export type AddAdvertiserBrandInput = {
  brandName: Scalars['String'];
  industryId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type AddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export const AdminReportsTemplateSystemName = {
  AllLineItems: 'ALL_LINE_ITEMS',
  CampaignLineItemsAdminView: 'CAMPAIGN_LINE_ITEMS_ADMIN_VIEW',
  CimSpend: 'CIM_SPEND',
  CuratedAudienceUsage: 'CURATED_AUDIENCE_USAGE',
  DeliveryPerformance: 'DELIVERY_PERFORMANCE',
  DetailedData: 'DETAILED_DATA',
  DigitalOrder: 'DIGITAL_ORDER',
  IfpForecastedVsDelivered: 'IFP_FORECASTED_VS_DELIVERED',
  LineItemsWithoutAds: 'LINE_ITEMS_WITHOUT_ADS',
  LineItemDrafts: 'LINE_ITEM_DRAFTS',
  LineItemSummary: 'LINE_ITEM_SUMMARY',
  LineItemSummaryDetailed: 'LINE_ITEM_SUMMARY_DETAILED',
  PricingSummary: 'PRICING_SUMMARY',
  UsersSummaryData: 'USERS_SUMMARY_DATA',
} as const;

export type AdminReportsTemplateSystemName =
  (typeof AdminReportsTemplateSystemName)[keyof typeof AdminReportsTemplateSystemName];
export type AdsList = Connection & {
  __typename?: 'AdsList';
  edges: Array<AdEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type Advertiser = {
  __typename?: 'Advertiser';
  adAccounts: Array<AdAccountShortInfo>;
  advertiserId: Scalars['ID'];
  advertiserName: Scalars['String'];
};

export type Advertisers = {
  __typename?: 'Advertisers';
  advertisers: Array<Advertiser>;
  organizationId: Scalars['ID'];
};

export type AdyenPaymentMethod = {
  __typename?: 'AdyenPaymentMethod';
  accountSet: Maybe<Array<Maybe<Scalars['String']>>>;
  brand: Maybe<Scalars['String']>;
  cardholderName: Maybe<Scalars['String']>;
  expirationMonth: Maybe<Scalars['String']>;
  expirationYear: Maybe<Scalars['String']>;
  lastFour: Maybe<Scalars['String']>;
  organizationExternalId: Scalars['ID'];
  paymentMethodExternalId: Scalars['String'];
  paymentMethodName: Scalars['String'];
  paymentMethodProcessor: Maybe<Scalars['String']>;
  paymentType: Scalars['Int'];
  token: Maybe<Scalars['String']>;
};

export type AllCampaignsAdAccountFilter = {
  __typename?: 'AllCampaignsAdAccountFilter';
  id: Scalars['ID'];
  name: Scalars['String'];
  orgId: Scalars['ID'];
};

export type AllCampaignsCreateFiltersResponse = {
  __typename?: 'AllCampaignsCreateFiltersResponse';
  adAccountIds: Array<Maybe<Scalars['ID']>>;
};

export type AllCampaignsCreateReportInput = {
  adAccountIds: Array<InputMaybe<Scalars['ID']>>;
};

export type AllCampaignsCreateReportResponse = BrunoBaseReport & {
  __typename?: 'AllCampaignsCreateReportResponse';
  createdAt: Scalars['Date'];
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  failedExceptionType: Maybe<Scalars['String']>;
  failedReason: Maybe<Scalars['String']>;
  filters: AllCampaignsCreateFiltersResponse;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  reportTemplate: BrunoReportTemplate;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type AllCampaignsFilters = {
  __typename?: 'AllCampaignsFilters';
  adAccounts: Array<Maybe<AllCampaignsAdAccountFilter>>;
};

export type AllCampaignsReport = BrunoBaseReport & {
  __typename?: 'AllCampaignsReport';
  createdAt: Scalars['Date'];
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  failedExceptionType: Maybe<Scalars['String']>;
  failedReason: Maybe<Scalars['String']>;
  filters: AllCampaignsFilters;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  reportTemplate: BrunoReportTemplate;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export const AllUsersSortBy = {
  Created: 'created',
  Email: 'email',
  FirstName: 'firstName',
  LastLoginAt: 'lastLoginAt',
  OrganizationName: 'organizationName',
} as const;

export type AllUsersSortBy = (typeof AllUsersSortBy)[keyof typeof AllUsersSortBy];
export type AllUsersStrictSortOptions = {
  sortBy?: InputMaybe<AllUsersSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type AssetActions = {
  __typename?: 'AssetActions';
  canAttach: Maybe<Scalars['Boolean']>;
  canDelete: Maybe<Scalars['Boolean']>;
  disabledReasons: Maybe<AssetDisableReasons>;
};

export type AssetData = {
  __typename?: 'AssetData';
  assetUrl: Maybe<Scalars['String']>;
  fileName: Maybe<Scalars['String']>;
  fonziExternalAssetId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
};

export type AssetDetails = {
  __typename?: 'AssetDetails';
  actions: Maybe<AssetActions>;
  assetId: Scalars['ID'];
  assetSourceId: Maybe<Scalars['ID']>;
  assetType: Maybe<AssetType>;
  brandId: Maybe<Scalars['String']>;
  brandName: Maybe<Scalars['String']>;
  caption: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  duration: Maybe<Scalars['Float']>;
  format: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  rejectionReason: Maybe<Array<Scalars['String']>>;
  size: Maybe<Scalars['Float']>;
  sourceUrl: Maybe<Scalars['String']>;
  status: Maybe<AssetStatus>;
  thumbnailUrl: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['AbbreviatedDate']>;
};

export type AssetDisableReasons = {
  __typename?: 'AssetDisableReasons';
  attach: Maybe<Array<Maybe<Scalars['String']>>>;
  delete: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AssetEdge = {
  __typename?: 'AssetEdge';
  cursor: Scalars['String'];
  node: AssetLibraryItem;
};

export type AssetInfo = {
  __typename?: 'AssetInfo';
  createdAt: Scalars['AbbreviatedDate'];
  duration: Scalars['Float'];
  format: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  size: Maybe<Scalars['Float']>;
  sourceUrl: Maybe<Scalars['String']>;
  status: VastStatus;
};

export type AssetLibraryItem = {
  __typename?: 'AssetLibraryItem';
  actions: Maybe<AssetActions>;
  assetId: Scalars['ID'];
  assetSourceId: Maybe<Scalars['ID']>;
  assetType: Maybe<AssetType>;
  brandId: Maybe<Scalars['String']>;
  brandName: Maybe<Scalars['String']>;
  comments: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['AbbreviatedDate'];
  duration: Maybe<Scalars['Float']>;
  format: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  rejectionReason: Maybe<Array<Scalars['String']>>;
  size: Maybe<Scalars['Float']>;
  sourceUrl: Maybe<Scalars['String']>;
  status: Maybe<AssetStatus>;
  updatedAt: Maybe<Scalars['AbbreviatedDate']>;
};

export type AssetLibrarySearchInput = {
  adFormat?: InputMaybe<AdFormat>;
  assetType?: InputMaybe<AssetType>;
  brandId?: InputMaybe<Scalars['ID']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  search?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<AdSortOptions>;
  status?: InputMaybe<AssetStatus>;
};

export type AssetLibrarySearchPayloadPage = {
  __typename?: 'AssetLibrarySearchPayloadPage';
  edges: Array<AssetEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type AssetRequirements = {
  __typename?: 'AssetRequirements';
  isValid: Scalars['Boolean'];
  message: Maybe<Scalars['String']>;
  parameterName: Scalars['String'];
  parameterType: Scalars['String'];
  parameterValue: Maybe<Scalars['String']>;
};

/** No INVALID status: that is a creative-only status. An asset is REJECTED, never INVALID. */
export const AssetStatus = {
  Approved: 'APPROVED',
  Draft: 'DRAFT',
  PendingApproval: 'PENDING_APPROVAL',
  Rejected: 'REJECTED',
} as const;

export type AssetStatus = (typeof AssetStatus)[keyof typeof AssetStatus];
/**
 * CO asset-type wire vocabulary (assetLibrarySearch/AssetLibraryItem only) — VIDEO or DISPLAY,
 * matching CO's AssetTypeEnum. DISPLAY is CO's name for the "Image" asset type shown in the UI.
 */
export const AssetType = {
  Display: 'DISPLAY',
  Video: 'VIDEO',
} as const;

export type AssetType = (typeof AssetType)[keyof typeof AssetType];
export type Assignment = {
  __typename?: 'Assignment';
  adAccountId: Scalars['ID'];
  adAccountName: Scalars['String'];
  assignment: Scalars['String'];
};

/** Boolean audience rule root. Contains groups only. */
export type AudienceDefinition = {
  __typename?: 'AudienceDefinition';
  not: Scalars['Boolean'];
  subClass: Scalars['String'];
  termList: Array<AudienceRuleGroup>;
};

export type AudienceDefinitionInput = {
  not: Scalars['Boolean'];
  subClass: Scalars['String'];
  termList: Array<AudienceRuleGroupInput>;
};

export const AudiencePremiumType = {
  Both: 'BOTH',
  OneP: 'ONE_P',
  ThreeP: 'THREE_P',
} as const;

export type AudiencePremiumType = (typeof AudiencePremiumType)[keyof typeof AudiencePremiumType];
export type AudienceRule = {
  __typename?: 'AudienceRule';
  definition: AudienceDefinition;
};

/** Boolean audience rule group. Contains sets only. */
export type AudienceRuleGroup = {
  __typename?: 'AudienceRuleGroup';
  not: Scalars['Boolean'];
  subClass: Scalars['String'];
  termList: Array<AudienceRuleSet>;
};

export type AudienceRuleGroupInput = {
  not: Scalars['Boolean'];
  subClass: Scalars['String'];
  termList: Array<AudienceRuleSetInput>;
};

export type AudienceRuleInput = {
  definition: AudienceDefinitionInput;
};

/** Boolean audience rule set. Contains audience IDs only. */
export type AudienceRuleSet = {
  __typename?: 'AudienceRuleSet';
  dimension: Scalars['String'];
  not: Scalars['Boolean'];
  subClass: Scalars['String'];
  valueSet: Array<Scalars['String']>;
};

export type AudienceRuleSetInput = {
  dimension: Scalars['String'];
  not: Scalars['Boolean'];
  subClass: Scalars['String'];
  valueSet: Array<Scalars['String']>;
};

export type AudienceTarget = {
  __typename?: 'AudienceTarget';
  id: Scalars['String'];
  premiumType: AudiencePremiumType;
};

export type AudienceTargetInput = {
  id: Scalars['String'];
  premiumType: AudiencePremiumType;
};

export const AudienceType = {
  OneAndThreeParty: 'ONE_AND_THREE_PARTY',
  TwoParty: 'TWO_PARTY',
} as const;

export type AudienceType = (typeof AudienceType)[keyof typeof AudienceType];
export type AudienceTypes = {
  __typename?: 'AudienceTypes';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Audiences = Node & {
  __typename?: 'Audiences';
  displayName: Scalars['String'];
  expiryDate: Maybe<Scalars['AbbreviatedDate']>;
  hierarchy: Maybe<Hierarchy>;
  id: Scalars['ID'];
  isAllowed: Maybe<Scalars['Boolean']>;
  isRequired: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  politicalAdVisibility: Maybe<Scalars['Boolean']>;
  specialAdVisibility: Maybe<Scalars['Boolean']>;
  targetType: AudiencesTargetType;
  visible: Scalars['Boolean'];
};

export type AudiencesChartMetrics = {
  __typename?: 'AudiencesChartMetrics';
  metrics: Array<AudiencesReportChartMetric>;
  total: Scalars['Int'];
};

export type AudiencesReportChartMetric = {
  __typename?: 'AudiencesReportChartMetric';
  percentile: Scalars['Float'];
  total: Scalars['Int'];
  value: Scalars['String'];
};

export type AudiencesTargetType = {
  __typename?: 'AudiencesTargetType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isAllowed: Scalars['Boolean'];
  name: Scalars['String'];
};

export type BaseReport = {
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  houseNumberOrName: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
};

export type BillingAddressInput = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  houseNumberOrName: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
};

export type BillingContact = Node & {
  __typename?: 'BillingContact';
  email: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Maybe<Scalars['ID']>;
  lastName: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type BillingContactEdge = Edge & {
  __typename?: 'BillingContactEdge';
  cursor: Scalars['String'];
  node: BillingContact;
};

export type BillingContactInput = {
  orgId: Scalars['String'];
  userId: Scalars['ID'];
};

export type BillingContactsPage = Connection & {
  __typename?: 'BillingContactsPage';
  edges: Array<BillingContactEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export const BillingTerm = {
  Immediate: 'IMMEDIATE',
  Net_30: 'NET_30',
  Net_45: 'NET_45',
  Net_60: 'NET_60',
  Net_90: 'NET_90',
  Prepayment: 'PREPAYMENT',
} as const;

export type BillingTerm = (typeof BillingTerm)[keyof typeof BillingTerm];
export const BillingType = {
  Immediate: 'IMMEDIATE',
  Net_30: 'NET_30',
  Net_45: 'NET_45',
  Net_60: 'NET_60',
  Net_90: 'NET_90',
  Prepayment: 'PREPAYMENT',
  Threshold: 'THRESHOLD',
} as const;

export type BillingType = (typeof BillingType)[keyof typeof BillingType];
export type BillingTypeOptions = {
  __typename?: 'BillingTypeOptions';
  name: Scalars['String'];
  value: Scalars['Int'];
};

export type Brand = Node & {
  __typename?: 'Brand';
  address: Address;
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  id: Scalars['ID'];
  industry: Industry;
  name: Scalars['String'];
  status: BrandStatus;
};

export type BrandDescription = {
  __typename?: 'BrandDescription';
  id: Scalars['ID'];
  industry: Industry;
  name: Scalars['String'];
};

export type BrandDetails = {
  __typename?: 'BrandDetails';
  adAccountList: Array<Maybe<AdAccount>>;
  brand: Brand;
  hasActiveCampaigns: Scalars['Boolean'];
};

export type BrandEdge = Edge & {
  __typename?: 'BrandEdge';
  cursor: Scalars['String'];
  node: Brand;
};

export type BrandInput = {
  address?: InputMaybe<AddressInput>;
  industryId: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export const BrandStatus = {
  Active: 'ACTIVE',
  Approved: 'APPROVED',
  Inactive: 'INACTIVE',
  InReview: 'IN_REVIEW',
  Rejected: 'REJECTED',
} as const;

export type BrandStatus = (typeof BrandStatus)[keyof typeof BrandStatus];
export type BrandsByUserFilterOptions = {
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type BrandsFilterOptions = {
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type BrandsPage = Connection & {
  __typename?: 'BrandsPage';
  edges: Array<BrandEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type BrandsSortOptions = {
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type Broadcast = Node & {
  __typename?: 'Broadcast';
  broadcaster: Maybe<Scalars['String']>;
  endDateTime: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notificationTemplate: Maybe<NotificationTemplate>;
  readNotifications: Maybe<Scalars['Int']>;
  recipients: Maybe<RecipientInfo>;
  recipientsType: Maybe<RecipientsTypes>;
  repeatDayOfWeek: Maybe<Day>;
  repeatNumberOfDayOfWeekOfMonth: Maybe<Scalars['Int']>;
  scheduledCadence: Maybe<FrequencyType>;
  startDateTime: Maybe<Scalars['String']>;
  status: BroadcastStatus;
  totalNotifications: Maybe<Scalars['Int']>;
  type: Maybe<SendingType>;
};

export type BroadcastEdge = Edge & {
  __typename?: 'BroadcastEdge';
  cursor: Scalars['String'];
  node: Broadcast;
};

export type BroadcastFilterOptions = {
  broadcaster?: InputMaybe<Scalars['String']>;
  recipients?: InputMaybe<RecipientsTypes>;
  scheduledAtAfter?: InputMaybe<Scalars['AbbreviatedDate']>;
  scheduledAtBefore?: InputMaybe<Scalars['AbbreviatedDate']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BroadcastStatus>;
};

export type BroadcastInput = {
  broadcaster?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  notificationTemplate: NotificationTemplateInput;
  recipients: RecipientInfoInput;
  repeatDayOfWeek?: InputMaybe<Day>;
  repeatNumberOfDayOfWeekOfMonth?: InputMaybe<Scalars['Int']>;
  scheduledCadence?: InputMaybe<FrequencyType>;
  startDateTime?: InputMaybe<Scalars['String']>;
  status: BroadcastStatus;
  type: SendingType;
};

export type BroadcastPage = Connection & {
  __typename?: 'BroadcastPage';
  edges: Array<BroadcastEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export const BroadcastStatus = {
  Complete: 'COMPLETE',
  Draft: 'DRAFT',
  Failed: 'FAILED',
  Processing: 'PROCESSING',
  Scheduled: 'SCHEDULED',
  Sent: 'SENT',
  Stopped: 'STOPPED',
} as const;

export type BroadcastStatus = (typeof BroadcastStatus)[keyof typeof BroadcastStatus];
export type Broadcaster = Node & {
  __typename?: 'Broadcaster';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BroadcasterEdge = Edge & {
  __typename?: 'BroadcasterEdge';
  cursor: Scalars['String'];
  node: Broadcaster;
};

export type BroadcasterFilterOptions = {
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type BroadcastersList = Connection & {
  __typename?: 'BroadcastersList';
  edges: Array<BroadcasterEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export const BroadcastsSortBy = {
  Broadcaster: 'broadcaster',
  Name: 'name',
  Recipients: 'recipients',
  ScheduledDate: 'scheduledDate',
  Status: 'status',
} as const;

export type BroadcastsSortBy = (typeof BroadcastsSortBy)[keyof typeof BroadcastsSortBy];
export type BroadcastsSortOptions = {
  sortBy?: InputMaybe<BroadcastsSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type BrunoBaseReport = {
  createdAt: Scalars['Date'];
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  failedExceptionType: Maybe<Scalars['String']>;
  failedReason: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  reportTemplate: BrunoReportTemplate;
  schedule: Maybe<ReportSchedule>;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type BrunoCreateDetailedReportFiltersResponse = {
  __typename?: 'BrunoCreateDetailedReportFiltersResponse';
  adAccountId: Maybe<Scalars['ID']>;
  campaignId: Scalars['ID'];
  dimensions: Array<Maybe<Scalars['String']>>;
  lineItems: Array<Maybe<Scalars['ID']>>;
};

export type BrunoCreateDetailedReportReportInput = {
  adAccountId?: InputMaybe<Scalars['ID']>;
  campaignId: Scalars['ID'];
  dimensions: Array<InputMaybe<Scalars['String']>>;
  lineItems: Array<InputMaybe<Scalars['ID']>>;
};

export type BrunoCreateDetailedReportReportResponse = BrunoBaseReport & {
  __typename?: 'BrunoCreateDetailedReportReportResponse';
  createdAt: Scalars['Date'];
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  failedExceptionType: Maybe<Scalars['String']>;
  failedReason: Maybe<Scalars['String']>;
  filters: BrunoCreateDetailedReportFiltersResponse;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  reportTemplate: BrunoReportTemplate;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type BrunoDetailedReportCampaignFilter = {
  __typename?: 'BrunoDetailedReportCampaignFilter';
  adAccountId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BrunoDetailedReportEdge = Edge & {
  __typename?: 'BrunoDetailedReportEdge';
  cursor: Scalars['String'];
  node: BrunoDetailedReportInfo;
};

export type BrunoDetailedReportFilters = {
  __typename?: 'BrunoDetailedReportFilters';
  adAccountId: Maybe<Scalars['ID']>;
  campaign: BrunoDetailedReportCampaignFilter;
  dimensions: Array<Maybe<Scalars['String']>>;
  lineItems: Array<Maybe<BrunoDetailedReportLineItemFilter>>;
};

export type BrunoDetailedReportInfo = Node & {
  __typename?: 'BrunoDetailedReportInfo';
  createdAt: Scalars['Date'];
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: BrunoDetailedReportPageFilter;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  reportTemplate: BrunoReportTemplate;
  schedule: Maybe<ReportSchedule>;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type BrunoDetailedReportLineItemFilter = {
  __typename?: 'BrunoDetailedReportLineItemFilter';
  endDate: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['String'];
};

export type BrunoDetailedReportPageFilter = {
  __typename?: 'BrunoDetailedReportPageFilter';
  campaign: BrunoDetailedReportCampaignFilter;
};

export type BrunoDetailedReportPermissions = {
  readCampaign: Scalars['Boolean'];
  readLineItems: Scalars['Boolean'];
};

export type BrunoDetailedReportReport = BrunoBaseReport & {
  __typename?: 'BrunoDetailedReportReport';
  createdAt: Scalars['Date'];
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  failedExceptionType: Maybe<Scalars['String']>;
  failedReason: Maybe<Scalars['String']>;
  filters: BrunoDetailedReportFilters;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  reportTemplate: BrunoReportTemplate;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type BrunoDetailedReportsPage = Connection & {
  __typename?: 'BrunoDetailedReportsPage';
  edges: Array<BrunoDetailedReportEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type BrunoReportEdge = Edge & {
  __typename?: 'BrunoReportEdge';
  cursor: Scalars['String'];
  node: BrunoReportInfo;
};

export type BrunoReportInfo = Node & {
  __typename?: 'BrunoReportInfo';
  createdAt: Scalars['Date'];
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  failedExceptionType: Maybe<Scalars['String']>;
  failedReason: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  reportTemplate: BrunoReportTemplate;
  schedule: Maybe<ReportSchedule>;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type BrunoReportTemplate = {
  __typename?: 'BrunoReportTemplate';
  description: Scalars['String'];
  id: Scalars['ID'];
  lastUpdatedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  systemName: ReportTemplateSystemName;
};

export type BrunoReportTemplatesResponse = {
  __typename?: 'BrunoReportTemplatesResponse';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  systemName: AdminReportsTemplateSystemName;
};

export type BrunoReportsFilterOptions = {
  adAccountId?: InputMaybe<Scalars['ID']>;
  campaignId?: InputMaybe<Scalars['ID']>;
  hasPermissionToReadCampaigns?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<InputMaybe<ReportStatus>>>;
  type?: InputMaybe<ReportTemplateSystemName>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type BrunoReportsPage = Connection & {
  __typename?: 'BrunoReportsPage';
  edges: Array<BrunoReportEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type BulkChangeRoles = {
  advertisers: Array<BulkChangeRolesAdvertisers>;
  roleName: Scalars['UserRole'];
};

export type BulkChangeRolesAdvertisers = {
  adAccounts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  advertiserId: Scalars['String'];
  removeRolesFromRelatedAdAccounts?: InputMaybe<Scalars['Boolean']>;
};

export const CacheControlScope = {
  Private: 'PRIVATE',
  Public: 'PUBLIC',
} as const;

export type CacheControlScope = (typeof CacheControlScope)[keyof typeof CacheControlScope];
export type Campaign = {
  __typename?: 'Campaign';
  count: Scalars['Int'];
};

export const CampaignAdFormatFilter = {
  AdSelector: 'AD_SELECTOR',
  KervEnhanced: 'KERV_ENHANCED',
  StandardVast: 'STANDARD_VAST',
  StandardVideo: 'STANDARD_VIDEO',
} as const;

export type CampaignAdFormatFilter = (typeof CampaignAdFormatFilter)[keyof typeof CampaignAdFormatFilter];
export type CampaignCreateInput = {
  adAccountId: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type CampaignCreateResponse = {
  __typename?: 'CampaignCreateResponse';
  id: Scalars['ID'];
  name: Scalars['String'];
  timeZone: Maybe<Scalars['String']>;
};

export type CampaignEdge = Edge & {
  __typename?: 'CampaignEdge';
  cursor: Scalars['String'];
  node: CampaignInfo;
};

export type CampaignEdgeWithExtraData = Edge & {
  __typename?: 'CampaignEdgeWithExtraData';
  cursor: Scalars['String'];
  node: CampaignInfoWithExtraData;
};

export type CampaignInfo = Node & {
  __typename?: 'CampaignInfo';
  adAccountId: Maybe<Scalars['ID']>;
  budget: Scalars['Float'];
  deliveredImpressions: Maybe<Scalars['Float']>;
  deliveredReach: Maybe<Scalars['Float']>;
  discountedBudget: Maybe<Scalars['Float']>;
  endTime: Maybe<Scalars['AbbreviatedDate']>;
  hasLineItems: Maybe<Scalars['Boolean']>;
  hasMajorLineItems: Maybe<Scalars['Boolean']>;
  hasMoreLines: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lineItems: Maybe<Array<LineItem>>;
  name: Scalars['String'];
  o1Id: Maybe<Scalars['String']>;
  organizationId: Maybe<Scalars['String']>;
  promoCodeDiscountPercentage: Maybe<Scalars['Float']>;
  promoCodeName: Maybe<Scalars['String']>;
  publicId: Maybe<Scalars['Float']>;
  revisionType: Maybe<Scalars['String']>;
  startTime: Maybe<Scalars['AbbreviatedDate']>;
  targetImpressions: Maybe<Scalars['Float']>;
  targetImpressionsBeforeDiscount: Maybe<Scalars['Float']>;
  timeZone: Maybe<Scalars['String']>;
  totalLineItemCount: Maybe<Scalars['Int']>;
};

export type CampaignInfoWithExtraData = Node & {
  __typename?: 'CampaignInfoWithExtraData';
  adAccount: Maybe<AdAccountForCampaignWithExtraData>;
  budget: Maybe<Scalars['Float']>;
  deliveredFrequency: Maybe<Scalars['Float']>;
  deliveredImpressions: Maybe<Scalars['Float']>;
  deliveredReach: Maybe<Scalars['Float']>;
  discountedBudget: Maybe<Scalars['Float']>;
  endTime: Maybe<Scalars['AbbreviatedDate']>;
  hasLineItems: Maybe<Scalars['Boolean']>;
  hasMajorLineItems: Maybe<Scalars['Boolean']>;
  hasMoreLines: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lineItems: Maybe<Array<LineItemWithExtraData>>;
  name: Maybe<Scalars['String']>;
  organization: Maybe<OrganizationForCampaignWithExtraData>;
  promoCodeName: Maybe<Scalars['String']>;
  publicId: Maybe<Scalars['Int']>;
  revisionType: Maybe<Scalars['String']>;
  startTime: Maybe<Scalars['AbbreviatedDate']>;
  submittedAt: Maybe<Scalars['AbbreviatedDate']>;
  targetImpressions: Maybe<Scalars['Float']>;
  timezone: Maybe<Scalars['String']>;
  timezoneLocked: Maybe<Scalars['Boolean']>;
  totalSpent: Maybe<Scalars['Float']>;
};

export type CampaignInput = {
  adAccountIds: Array<Scalars['String']>;
  isSubmitted?: InputMaybe<Scalars['Boolean']>;
};

export type CampaignOption = Node & {
  __typename?: 'CampaignOption';
  adAccountId: Scalars['String'];
  endTime: Maybe<Scalars['AbbreviatedDate']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  startTime: Maybe<Scalars['AbbreviatedDate']>;
};

export type CampaignOptionsEdge = Edge & {
  __typename?: 'CampaignOptionsEdge';
  cursor: Scalars['String'];
  node: CampaignOption;
};

export type CampaignReportResponse = {
  __typename?: 'CampaignReportResponse';
  adAccountId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  sfOpportunityId: Maybe<Scalars['String']>;
  sourceSystem: Maybe<Scalars['String']>;
};

export type CampaignReviewSummaryReportInput = {
  adAccountIds: Array<Scalars['String']>;
  campaignId: Scalars['String'];
  lineItems: Array<Scalars['String']>;
  organizationId: Scalars['ID'];
};

export type CampaignSearchScheduleInput = {
  end: ScheduleDateInput;
  start: ScheduleDateInput;
};

export type CampaignShortInfo = Node & {
  __typename?: 'CampaignShortInfo';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CampaignShortInfoEdge = Edge & {
  __typename?: 'CampaignShortInfoEdge';
  cursor: Scalars['String'];
  node: CampaignShortInfo;
};

export const CampaignSortBy = {
  Budget: 'budget',
  EndTime: 'endTime',
  Name: 'name',
  PublicId: 'publicId',
  PublisherIds: 'publisherIds',
  StartTime: 'startTime',
  SubmittedAt: 'submittedAt',
  TotalSpent: 'totalSpent',
} as const;

export type CampaignSortBy = (typeof CampaignSortBy)[keyof typeof CampaignSortBy];
export type CampaignStatisticForAdAccount = {
  __typename?: 'CampaignStatisticForAdAccount';
  adAccountId: Maybe<Scalars['ID']>;
  campaignsCount: Maybe<Scalars['Int']>;
  creativesCount: Maybe<Scalars['Int']>;
  organizationId: Maybe<Scalars['ID']>;
  totalSpent: Maybe<Scalars['Int']>;
};

export type CampaignUpdateResponse = {
  __typename?: 'CampaignUpdateResponse';
  id: Scalars['ID'];
  lineItems: Maybe<Array<Maybe<LineItem>>>;
  name: Maybe<Scalars['String']>;
  sfOpportunityId: Maybe<Scalars['String']>;
  sourceSystem: Maybe<Scalars['String']>;
  timeZone: Maybe<Scalars['String']>;
};

export type Campaigns = {
  __typename?: 'Campaigns';
  campaignExternalId: Scalars['String'];
  campaignStatus: Scalars['Int'];
};

export type CampaignsExportFilterOptions = {
  adFormat?: InputMaybe<CampaignAdFormatFilter>;
  adStatus?: InputMaybe<AdStatus>;
  campaignName?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['AbbreviatedDate']>;
  filterToOrganizationsOfUserId?: InputMaybe<Scalars['ID']>;
  hamIndustryName?: InputMaybe<Scalars['String']>;
  lineItemStatus?: InputMaybe<LineItemStatus>;
  orgId?: InputMaybe<Scalars['ID']>;
  organizationCrmLinkType?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['AbbreviatedDate']>;
};

export type CampaignsFilterOptions = {
  adAccountId?: InputMaybe<Scalars['ID']>;
  adFormat?: InputMaybe<Array<InputMaybe<CampaignAdFormatFilter>>>;
  adStatus?: InputMaybe<Array<InputMaybe<AdStatus>>>;
  endDate?: InputMaybe<Scalars['AbbreviatedDate']>;
  hasDeliveryImpressions?: InputMaybe<Scalars['Boolean']>;
  includeExtraData?: InputMaybe<Scalars['Boolean']>;
  lineItemStatus?: InputMaybe<LineItemStatus>;
  packageId?: InputMaybe<Scalars['ID']>;
  publisherIds?: InputMaybe<Array<Scalars['ID']>>;
  searchField?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['AbbreviatedDate']>;
};

export type CampaignsFilterOptionsWithExtraData = {
  adAccountId?: InputMaybe<Scalars['ID']>;
  adFormat?: InputMaybe<Array<InputMaybe<CampaignAdFormatFilter>>>;
  adStatus?: InputMaybe<Array<InputMaybe<AdStatus>>>;
  endDate?: InputMaybe<Scalars['AbbreviatedDate']>;
  filterToOrganizationsOfUserId?: InputMaybe<Scalars['ID']>;
  hamIndustryName?: InputMaybe<Scalars['String']>;
  hasDeliveryImpressions?: InputMaybe<Scalars['Boolean']>;
  idList?: InputMaybe<Array<Scalars['ID']>>;
  lineItemStatus?: InputMaybe<LineItemStatus>;
  orgId?: InputMaybe<Scalars['ID']>;
  organizationCrmLinkType?: InputMaybe<Scalars['String']>;
  pacingStatus?: InputMaybe<PacingStatus>;
  packageId?: InputMaybe<Scalars['ID']>;
  publisherIds?: InputMaybe<Array<Scalars['ID']>>;
  searchField?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['AbbreviatedDate']>;
};

export type CampaignsOptions = Connection & {
  __typename?: 'CampaignsOptions';
  edges: Array<CampaignOptionsEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type CampaignsPage = Connection & {
  __typename?: 'CampaignsPage';
  edges: Array<CampaignEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type CampaignsPageWithExtraData = Connection & {
  __typename?: 'CampaignsPageWithExtraData';
  edges: Array<CampaignEdgeWithExtraData>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type CampaignsShortInfoPage = Connection & {
  __typename?: 'CampaignsShortInfoPage';
  edges: Array<CampaignShortInfoEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type CampaignsSortOptions = {
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type CampaignsStatistics = {
  __typename?: 'CampaignsStatistics';
  conversionRate: Maybe<Scalars['Float']>;
  sellerAssistedConversionRate: Maybe<Scalars['Float']>;
  submittedAndDraftedBudget: Scalars['Float'];
  submittedBudget: Scalars['Float'];
};

export type CampaignsStrictSortOptions = {
  sortBy?: InputMaybe<CampaignSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type CarouselImage = {
  __typename?: 'CarouselImage';
  externalId: Scalars['ID'];
  imageFileName: Scalars['String'];
  rank: Scalars['Int'];
};

export const CategoryEnum = {
  Account: 'ACCOUNT',
  Ad: 'AD',
  Billing: 'BILLING',
  Campaign: 'CAMPAIGN',
  DisneyRepresentativeUpdate: 'DISNEY_REPRESENTATIVE_UPDATE',
  LineItem: 'LINE_ITEM',
  Report: 'REPORT',
  Transaction: 'TRANSACTION',
  User: 'USER',
} as const;

export type CategoryEnum = (typeof CategoryEnum)[keyof typeof CategoryEnum];
export type CloneCreativeResult = {
  __typename?: 'CloneCreativeResult';
  adFormat: Maybe<AdFormat>;
  creativeId: Scalars['ID'];
  creativeManagerId: Maybe<Scalars['ID']>;
  experienceId: Maybe<Scalars['ID']>;
  previewUrl: Maybe<Scalars['String']>;
  status: CreativeLibraryStatus;
  thumbnailUrl: Maybe<Scalars['String']>;
};

export type ConfiguredUrl = {
  __typename?: 'ConfiguredUrl';
  replacedValues: Scalars['RecordString'];
  url: Scalars['String'];
};

export type Connection = {
  edges: Array<Edge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type ContentItem = {
  __typename?: 'ContentItem';
  externalId: Scalars['ID'];
  imageFileName: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rank: Scalars['Int'];
};

export type CoreOffering = {
  __typename?: 'CoreOffering';
  id: Scalars['ID'];
  systemName: Scalars['String'];
  title: Scalars['String'];
};

export type CreateAudienceInput = {
  adAccountIds: Array<Scalars['String']>;
  displayName: Scalars['String'];
  expiryDate?: InputMaybe<Scalars['String']>;
  rule?: InputMaybe<AudienceRuleInput>;
  segmentId?: InputMaybe<Scalars['String']>;
  targetTypeId: Scalars['ID'];
};

export type CreateVast = {
  __typename?: 'CreateVast';
  creativeLibraryId: Scalars['ID'];
  creativeManagerId: Maybe<Scalars['ID']>;
  creativeType: Maybe<CreativeType>;
  deletable: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lineItems: Maybe<Array<Maybe<Scalars['String']>>>;
  replacedUrl: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  vendorName: Maybe<Scalars['String']>;
};

export type CreativeActions = {
  __typename?: 'CreativeActions';
  canAttach: Maybe<Scalars['Boolean']>;
  canClone: Maybe<Scalars['Boolean']>;
  canDelete: Maybe<Scalars['Boolean']>;
  disabledReasons: Maybe<CreativeDisableReasons>;
};

export type CreativeDetails = {
  __typename?: 'CreativeDetails';
  actions: Maybe<CreativeActions>;
  adFormat: Maybe<AdFormat>;
  asset: Maybe<CreativeDetailsAsset>;
  brand: Maybe<CreativeDetailsBrand>;
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  creativeLibraryId: Maybe<Scalars['String']>;
  creativeManagerId: Maybe<Scalars['ID']>;
  creativeType: Maybe<CreativeType>;
  duration: Maybe<Scalars['Float']>;
  experienceId: Maybe<Scalars['String']>;
  format: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDisneyAi: Maybe<Scalars['Boolean']>;
  lineItems: Maybe<Array<CreativeLineItemInfo>>;
  name: Maybe<Scalars['String']>;
  previewUrl: Maybe<Scalars['String']>;
  rejectionReason: Maybe<Array<Scalars['String']>>;
  size: Maybe<Scalars['Float']>;
  status: Maybe<CreativeLibraryStatus>;
  thumbnailUrl: Maybe<Scalars['String']>;
};

export type CreativeDetailsAsset = {
  __typename?: 'CreativeDetailsAsset';
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  rejectionReason: Maybe<Array<Scalars['String']>>;
  sourceUrl: Maybe<Scalars['String']>;
};

export type CreativeDetailsBrand = {
  __typename?: 'CreativeDetailsBrand';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type CreativeDisableReasons = {
  __typename?: 'CreativeDisableReasons';
  attach: Maybe<Array<Maybe<Scalars['String']>>>;
  clone: Maybe<Array<Maybe<Scalars['String']>>>;
  delete: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CreativeEdge = {
  __typename?: 'CreativeEdge';
  cursor: Scalars['String'];
  node: CreativeLibraryItem;
};

export type CreativeLibraryItem = {
  __typename?: 'CreativeLibraryItem';
  actions: Maybe<CreativeActions>;
  adFormat: Maybe<AdFormat>;
  brandId: Maybe<Scalars['String']>;
  brandName: Maybe<Scalars['String']>;
  createdAt: Scalars['AbbreviatedDate'];
  createdBy: Maybe<Scalars['String']>;
  creativeId: Scalars['ID'];
  creativeManagerId: Maybe<Scalars['ID']>;
  creativeType: Maybe<CreativeType>;
  description: Maybe<Scalars['String']>;
  experienceId: Maybe<Scalars['String']>;
  isDisneyAi: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  previewUrl: Maybe<Scalars['String']>;
  sourceUrl: Maybe<Scalars['String']>;
  status: Maybe<CreativeLibraryStatus>;
  thumbnailUrl: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['AbbreviatedDate']>;
};

export type CreativeLibrarySearchInput = {
  adFormat?: InputMaybe<AdFormat>;
  brandId?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['String']>;
  creativeType?: InputMaybe<Scalars['String']>;
  lineItemId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<CreativeSortOptions>;
  status?: InputMaybe<CreativeLibraryStatus>;
};

export type CreativeLibrarySearchPayloadPage = {
  __typename?: 'CreativeLibrarySearchPayloadPage';
  edges: Array<CreativeEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export const CreativeLibraryStatus = {
  Approved: 'APPROVED',
  Draft: 'DRAFT',
  Invalid: 'INVALID',
  PendingApproval: 'PENDING_APPROVAL',
} as const;

export type CreativeLibraryStatus = (typeof CreativeLibraryStatus)[keyof typeof CreativeLibraryStatus];
export type CreativeLineItemInfo = {
  __typename?: 'CreativeLineItemInfo';
  adAccountId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export const CreativeSortBy = {
  Brand: 'brand',
  CreatedAt: 'createdAt',
  CreativeName: 'creativeName',
  Name: 'name',
  SubmittedBy: 'submittedBy',
  UpdatedAt: 'updatedAt',
} as const;

export type CreativeSortBy = (typeof CreativeSortBy)[keyof typeof CreativeSortBy];
export type CreativeSortOptions = {
  sortBy?: InputMaybe<CreativeSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export const CreativeStatus = {
  Approved: 'APPROVED',
  Draft: 'DRAFT',
  Invalid: 'INVALID',
  PendingApproval: 'PENDING_APPROVAL',
  Published: 'PUBLISHED',
  Rejected: 'REJECTED',
  Submitted: 'SUBMITTED',
  UnderReview: 'UNDER_REVIEW',
  Unknown: 'UNKNOWN',
  Vast: 'VAST',
} as const;

export type CreativeStatus = (typeof CreativeStatus)[keyof typeof CreativeStatus];
export const CreativeType = {
  AdSelectorSlate: 'AD_SELECTOR_SLATE',
  AdSelectorVideo: 'AD_SELECTOR_VIDEO',
  InstreamDxc: 'INSTREAM_DXC',
  Kerv: 'KERV',
  Vast: 'VAST',
  VastVideo: 'VAST_VIDEO',
  Video: 'VIDEO',
} as const;

export type CreativeType = (typeof CreativeType)[keyof typeof CreativeType];
export type CreativeVast = {
  __typename?: 'CreativeVast';
  creativeLibraryId: Scalars['String'];
  creativeManagerId: Scalars['String'];
  creativeType: CreativeType;
  deletable: Scalars['Boolean'];
  id: Scalars['ID'];
  lineItems: Maybe<Array<Maybe<CreativeLineItemInfo>>>;
  replacedUrl: Maybe<Scalars['String']>;
  status: CreativeStatus;
  url: Scalars['String'];
  vendorName: Maybe<Scalars['String']>;
};

export type CrmLink = {
  __typename?: 'CrmLink';
  crmId: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type CuratedAudienceUsageReport = BrunoBaseReport & {
  __typename?: 'CuratedAudienceUsageReport';
  createdAt: Scalars['Date'];
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  failedExceptionType: Maybe<Scalars['String']>;
  failedReason: Maybe<Scalars['String']>;
  filters: CuratedAudienceUsageReportFilters;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  reportTemplate: BrunoReportTemplate;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type CuratedAudienceUsageReportFilters = {
  __typename?: 'CuratedAudienceUsageReportFilters';
  initialFromDate: Scalars['Date'];
};

export type CuratedAudienceUsageReportInput = {
  initialFromDate: Scalars['Date'];
};

export type CustomAudience = {
  __typename?: 'CustomAudience';
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
};

export type CustomAudienceById = Node & {
  __typename?: 'CustomAudienceById';
  adAccountIds: Array<Scalars['ID']>;
  audienceId: Maybe<Scalars['ID']>;
  audienceName: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  expiryDate: Maybe<Scalars['String']>;
  gamId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  nameMapping: Maybe<Scalars['RecordString']>;
  /** Boolean audience related types, other custom audiences do not contain them */
  rule: Maybe<AudienceRule>;
  targetType: CustomAudienceByIdTargetType;
};

export type CustomAudienceByIdTargetType = {
  __typename?: 'CustomAudienceByIdTargetType';
  displayName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAllowed: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export const DateRange = {
  CurrentMonth: 'CURRENT_MONTH',
  CurrentYear: 'CURRENT_YEAR',
  Custom: 'CUSTOM',
  Last_7Days: 'LAST_7_DAYS',
  Last_30Days: 'LAST_30_DAYS',
  LastYear: 'LAST_YEAR',
  LifeTime: 'LIFE_TIME',
  PreviousMonth: 'PREVIOUS_MONTH',
} as const;

export type DateRange = (typeof DateRange)[keyof typeof DateRange];
export const DateRangeForStatistic = {
  CurrentMonth: 'CURRENT_MONTH',
  CurrentQuarter: 'CURRENT_QUARTER',
  Last_7Days: 'LAST_7_DAYS',
  PreviousMonth: 'PREVIOUS_MONTH',
} as const;

export type DateRangeForStatistic = (typeof DateRangeForStatistic)[keyof typeof DateRangeForStatistic];
export const Day = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY',
} as const;

export type Day = (typeof Day)[keyof typeof Day];
export type DayParting = {
  firstActiveHour: Scalars['Int'];
  friday?: InputMaybe<Scalars['Boolean']>;
  lastActiveHour: Scalars['Int'];
  monday?: InputMaybe<Scalars['Boolean']>;
  saturday?: InputMaybe<Scalars['Boolean']>;
  sunday?: InputMaybe<Scalars['Boolean']>;
  thursday?: InputMaybe<Scalars['Boolean']>;
  tuesday?: InputMaybe<Scalars['Boolean']>;
  wednesday?: InputMaybe<Scalars['Boolean']>;
};

export type DayPartings = {
  __typename?: 'DayPartings';
  firstActiveHour: Maybe<Scalars['Int']>;
  friday: Maybe<Scalars['Boolean']>;
  lastActiveHour: Maybe<Scalars['Int']>;
  monday: Maybe<Scalars['Boolean']>;
  saturday: Maybe<Scalars['Boolean']>;
  sunday: Maybe<Scalars['Boolean']>;
  thursday: Maybe<Scalars['Boolean']>;
  tuesday: Maybe<Scalars['Boolean']>;
  wednesday: Maybe<Scalars['Boolean']>;
};

export const Days = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY',
} as const;

export type Days = (typeof Days)[keyof typeof Days];
export type DefinitionInput = {
  not?: InputMaybe<Scalars['Boolean']>;
};

export type DelayDates = {
  __typename?: 'DelayDates';
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type DeliveryPerformanceReport = BrunoBaseReport & {
  __typename?: 'DeliveryPerformanceReport';
  createdAt: Scalars['Date'];
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  failedExceptionType: Maybe<Scalars['String']>;
  failedReason: Maybe<Scalars['String']>;
  filters: DeliveryPerformanceReportFilters;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  reportTemplate: BrunoReportTemplate;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type DeliveryPerformanceReportFilters = {
  __typename?: 'DeliveryPerformanceReportFilters';
  adAccountId: Maybe<Scalars['ID']>;
  campaign: BrunoDetailedReportCampaignFilter;
};

export type DeliveryPerformanceReportFiltersResponse = {
  __typename?: 'DeliveryPerformanceReportFiltersResponse';
  adAccountId: Maybe<Scalars['ID']>;
  campaignId: Scalars['ID'];
  groupByLineItem: Scalars['Boolean'];
};

export type DeliveryPerformanceReportInput = {
  adAccountId?: InputMaybe<Scalars['ID']>;
  campaignId: Scalars['ID'];
  groupByLineItem?: InputMaybe<Scalars['Boolean']>;
};

export type DeliveryPerformanceReportResponse = BrunoBaseReport & {
  __typename?: 'DeliveryPerformanceReportResponse';
  createdAt: Scalars['Date'];
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  failedExceptionType: Maybe<Scalars['String']>;
  failedReason: Maybe<Scalars['String']>;
  filters: DeliveryPerformanceReportFiltersResponse;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  reportTemplate: BrunoReportTemplate;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type DemoTarget = {
  __typename?: 'DemoTarget';
  id: Scalars['String'];
  type: DemoTargetType;
};

export type DemoTargetInput = {
  id: Scalars['String'];
  type: DemoTargetType;
};

export const DemoTargetType = {
  Age: 'AGE',
  Gender: 'GENDER',
} as const;

export type DemoTargetType = (typeof DemoTargetType)[keyof typeof DemoTargetType];
export type DeprecatedReport = {
  __typename?: 'DeprecatedReport';
  campaign: Maybe<CampaignReportResponse>;
  emailNow: Maybe<Scalars['Boolean']>;
  endTime: Maybe<Scalars['AbbreviatedDate']>;
  id: Scalars['ID'];
  lineItems: Maybe<Array<Maybe<LineItem>>>;
  startTime: Maybe<Scalars['AbbreviatedDate']>;
  status: Maybe<Scalars['String']>;
  targetTypes: Maybe<Array<Maybe<TargetType>>>;
};

export type DeprecatedReportInput = {
  emailNow?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  metricsTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  rollUpType?: InputMaybe<RollUpType>;
  schedule?: InputMaybe<DeprecatedScheduleInput>;
  startDate?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DeprecatedScheduleInput = {
  days?: InputMaybe<Array<Scalars['String']>>;
  frequency: Frequency;
};

export type DetailedDataReport = BaseReport & {
  __typename?: 'DetailedDataReport';
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: DetailedDataReportFilters;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type DetailedDataReportFileUrlInput = {
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: DetailedDateReportFiltersInput;
  startDate?: InputMaybe<Scalars['String']>;
  templateId: Scalars['ID'];
};

export type DetailedDataReportFilters = {
  __typename?: 'DetailedDataReportFilters';
  advertiserId: Maybe<Scalars['String']>;
  lineItems: Maybe<Array<Scalars['ID']>>;
  metricsTypes: Maybe<Array<Scalars['String']>>;
  rollUpType: Maybe<RollUpType>;
};

export type DetailedDateReportFiltersInput = {
  advertiserId?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<Scalars['ID']>>;
  metricsTypes?: InputMaybe<Array<Scalars['String']>>;
  rollUpType?: InputMaybe<RollUpType>;
};

export type DeviceBreakout = {
  __typename?: 'DeviceBreakout';
  completions: Scalars['Float'];
  deviceBreakdown: Scalars['Float'];
  deviceName: Scalars['String'];
  impressions: Scalars['Float'];
};

export type DimensionValue = Node & {
  __typename?: 'DimensionValue';
  displayName: Maybe<Scalars['String']>;
  gamId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  segmentId: Scalars['String'];
};

export type DimensionValueEdge = Edge & {
  __typename?: 'DimensionValueEdge';
  cursor: Scalars['String'];
  node: DimensionValue;
};

export type DimensionValuePages = Connection & {
  __typename?: 'DimensionValuePages';
  edges: Array<DimensionValueEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export const Dimensions = {
  Age: 'AGE',
  AgeDemo: 'AGE_DEMO',
  AgeGender: 'AGE_GENDER',
  Audience: 'AUDIENCE',
  Device: 'DEVICE',
  Gender: 'GENDER',
  Genre: 'GENRE',
  Geo: 'GEO',
  GeoState: 'GEO_STATE',
  Locations: 'LOCATIONS',
} as const;

export type Dimensions = (typeof Dimensions)[keyof typeof Dimensions];
export type DraftLineItemInput = {
  adAccountId: Scalars['String'];
  campaignId: Scalars['ID'];
  name: Scalars['String'];
};

export type DxcCreative = {
  __typename?: 'DxcCreative';
  adFormat: Maybe<AdFormat>;
  creativeId: Scalars['ID'];
  creativeManagerId: Scalars['ID'];
  experienceId: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  previewUrl: Maybe<Scalars['String']>;
  status: CreativeLibraryStatus;
  thumbnailUrl: Maybe<Scalars['String']>;
};

export type Edge = {
  cursor: Scalars['String'];
  node: Node;
};

export type EditValidationRoleResponse = {
  __typename?: 'EditValidationRoleResponse';
  role: Maybe<LineItemEditRole>;
  securityEnabled: Scalars['Boolean'];
};

export type EntityName = AdAccountRole | GenericRole;

export const EntityType = {
  AdAccount: 'AD_ACCOUNT',
  CreativeLibrary: 'CREATIVE_LIBRARY',
  MarketerOrganization: 'MARKETER_ORGANIZATION',
  PublisherOrganization: 'PUBLISHER_ORGANIZATION',
} as const;

export type EntityType = (typeof EntityType)[keyof typeof EntityType];
/**
 * Filters shared by every report in an Export All request. Deliberately limited to the fields the Export All modal
 * collects, which are the only filters all report templates have in common.
 */
export type ExportAllReportsFiltersInput = {
  advertiserId?: InputMaybe<Scalars['String']>;
  campaignIds: Array<Scalars['String']>;
  organizationId: Scalars['String'];
};

/**
 * Exports several report templates as a single merged file. Templates are exported in the order given, which determines
 * sheet order in the workbook and section order in the PDF.
 */
export type ExportAllReportsInput = {
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  exportFormat: ExportFormat;
  fileName?: InputMaybe<Scalars['String']>;
  filters: ExportAllReportsFiltersInput;
  startDate?: InputMaybe<Scalars['String']>;
  templateIds: Array<Scalars['ID']>;
};

export const ExportFormat = {
  Csv: 'CSV',
  Excel: 'EXCEL',
  Pdf: 'PDF',
} as const;

export type ExportFormat = (typeof ExportFormat)[keyof typeof ExportFormat];
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type FeatureFlagsResponse = {
  __typename?: 'FeatureFlagsResponse';
  flags: Array<FeatureFlag>;
};

export const Frequency = {
  Daily: 'DAILY',
  Monthly: 'MONTHLY',
  Weekly: 'WEEKLY',
} as const;

export type Frequency = (typeof Frequency)[keyof typeof Frequency];
export const FrequencyType = {
  Monthly: 'MONTHLY',
  Weekly: 'WEEKLY',
} as const;

export type FrequencyType = (typeof FrequencyType)[keyof typeof FrequencyType];
export const FundingSource = {
  Ach: 'ACH',
  Coupon: 'COUPON',
  CreditCard: 'CREDIT_CARD',
  LineOfCredit: 'LINE_OF_CREDIT',
  Wire: 'WIRE',
} as const;

export type FundingSource = (typeof FundingSource)[keyof typeof FundingSource];
/** Includes MARKETER_ORGANIZATION, CREATIVE_LIBRARY, PUBLISHER_ORGANIZATION */
export type GenericRole = {
  __typename?: 'GenericRole';
  id: Scalars['String'];
};

export type GenreChartMetrics = {
  __typename?: 'GenreChartMetrics';
  metrics: Array<PlatformReportChartMetric>;
  total: Scalars['Int'];
};

export type GenreReportChartMetric = {
  __typename?: 'GenreReportChartMetric';
  percentile: Scalars['Float'];
  total: Scalars['Int'];
  value: Scalars['String'];
};

export type Genres = {
  __typename?: 'Genres';
  genreDelivery: Scalars['Float'];
  genreName: Scalars['String'];
};

export type GeoTarget = {
  __typename?: 'GeoTarget';
  id: Scalars['String'];
  type: GeoTargetType;
};

export type GeoTargetInput = {
  id: Scalars['String'];
  type: GeoTargetType;
};

export const GeoTargetType = {
  City: 'CITY',
  Dma: 'DMA',
  State: 'STATE',
  Zipcode: 'ZIPCODE',
} as const;

export type GeoTargetType = (typeof GeoTargetType)[keyof typeof GeoTargetType];
export type GetBrunoReportTypeByIdResponse = {
  __typename?: 'GetBrunoReportTypeByIdResponse';
  systemName: ReportTemplateSystemName;
  templateId: Scalars['ID'];
};

export type GetReportSecondaryUsersList = {
  __typename?: 'GetReportSecondaryUsersList';
  createdAt: Scalars['String'];
  email: Scalars['String'];
  entityType: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastLoginAt: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type GetUsersEdge = Edge & {
  __typename?: 'GetUsersEdge';
  cursor: Scalars['String'];
  node: GetUsersNode;
};

export type GetUsersNode = Node & {
  __typename?: 'GetUsersNode';
  email: Scalars['String'];
  firstName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName: Maybe<Scalars['String']>;
};

export type GetUsersPage = Connection & {
  __typename?: 'GetUsersPage';
  edges: Array<GetUsersEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type Hierarchy = {
  __typename?: 'Hierarchy';
  source: Scalars['String'];
  tiers: Array<Scalars['String']>;
};

export type Industry = {
  __typename?: 'Industry';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type InfoMetrics = {
  __typename?: 'InfoMetrics';
  lineItems: Array<InfoMetricsLineItem>;
};

export type InfoMetricsLineItem = LineItemInterface & {
  __typename?: 'InfoMetricsLineItem';
  discountedUnitCost: Maybe<Scalars['Float']>;
  endTime: Maybe<Scalars['AbbreviatedDate']>;
  externalId: Scalars['String'];
  impressionEndDate: Maybe<Scalars['String']>;
  impressionGoal: Maybe<Scalars['Int']>;
  impressionStartDate: Maybe<Scalars['String']>;
  metrics: Array<Maybe<Metrics>>;
  name: Scalars['String'];
  sourceId: Maybe<Scalars['String']>;
  startTime: Maybe<Scalars['AbbreviatedDate']>;
  status: Scalars['String'];
  targets: Array<Maybe<ReportTarget>>;
  totalImpressions: Scalars['Int'];
  unitCost: Scalars['Float'];
  unitCostType: Maybe<Scalars['String']>;
};

export type InputDeleteCreative = {
  creativeId: Scalars['ID'];
};

export type InputDimensionValueFilter = {
  gamId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type InventoryDetail = {
  __typename?: 'InventoryDetail';
  availableInventory: Maybe<Scalars['Float']>;
  availableInventoryPercentage: Scalars['Int'];
  suggestions: Array<Maybe<Scalars['String']>>;
};

export type InventoryDetailInput = {
  lineItemId?: InputMaybe<Scalars['ID']>;
  lineItemRevision?: InputMaybe<Scalars['String']>;
};

export const InvitationStatus = {
  NotSent: 'NOT_SENT',
  ResentInvite: 'RESENT_INVITE',
  SentPasswordReset: 'SENT_PASSWORD_RESET',
} as const;

export type InvitationStatus = (typeof InvitationStatus)[keyof typeof InvitationStatus];
export const InviteNotSentReason = {
  SendEmailDisabled: 'SEND_EMAIL_DISABLED',
  UnknownStatus: 'UNKNOWN_STATUS',
  UserDeactivated: 'USER_DEACTIVATED',
} as const;

export type InviteNotSentReason = (typeof InviteNotSentReason)[keyof typeof InviteNotSentReason];
export type Invoice = Node & {
  __typename?: 'Invoice';
  adAccountId: Scalars['String'];
  adAccountName: Maybe<Scalars['String']>;
  advertiserName: Scalars['String'];
  billedAmount: Scalars['Currency'];
  billingPeriod: Scalars['String'];
  billingType: BillingType;
  cannotRetryReason: Maybe<Scalars['String']>;
  cannotRetryReasonMessage: Maybe<Scalars['String']>;
  dueDate: Scalars['EasternTimeZoneDate'];
  endDate: Maybe<Scalars['EasternTimeZoneDate']>;
  id: Scalars['ID'];
  invoiceExternalId: Scalars['ID'];
  invoiceName: Scalars['String'];
  invoicePaymentStatus: InvoicePaymentStatuses;
  remainingAmount: Scalars['Float'];
  retryable: Maybe<Scalars['Boolean']>;
  startDate: Scalars['EasternTimeZoneDate'];
};

export type InvoiceEdge = Edge & {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['String'];
  node: Invoice;
};

export type InvoicePage = Connection & {
  __typename?: 'InvoicePage';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export const InvoicePaymentStatuses = {
  Failed: 'FAILED',
  Hold: 'HOLD',
  Overdue: 'OVERDUE',
  PartiallyFailed: 'PARTIALLY_FAILED',
  PartialPayment: 'PARTIAL_PAYMENT',
  Paused: 'PAUSED',
  Pending: 'PENDING',
  Processing: 'PROCESSING',
  RefundFailed: 'REFUND_FAILED',
  RevisedPending: 'REVISED_PENDING',
  Success: 'SUCCESS',
  Void: 'VOID',
} as const;

export type InvoicePaymentStatuses = (typeof InvoicePaymentStatuses)[keyof typeof InvoicePaymentStatuses];
export type InvoiceSearchInput = {
  adAccount?: InputMaybe<Array<Scalars['String']>>;
  billingType?: InputMaybe<Array<BillingType>>;
  id: Scalars['ID'];
  invoicePaymentStatus?: InputMaybe<Array<InvoicePaymentStatuses>>;
};

export const InvoiceSortBy = {
  AdAccountName: 'adAccountName',
  Amount: 'amount',
  BillingDate: 'billingDate',
  BillingPeriod: 'billingPeriod',
  DueDate: 'dueDate',
  Id: 'id',
  InvoiceStatus: 'invoiceStatus',
} as const;

export type InvoiceSortBy = (typeof InvoiceSortBy)[keyof typeof InvoiceSortBy];
export type InvoiceSortOptions = {
  sortBy?: InputMaybe<InvoiceSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type InvoiceStatusFilterOptions = {
  __typename?: 'InvoiceStatusFilterOptions';
  name: InvoicePaymentStatuses;
  value: Scalars['Int'];
};

export type InvoiceWithLastTransaction = {
  __typename?: 'InvoiceWithLastTransaction';
  billedAmount: Scalars['Currency'];
  cannotRetryReason: Maybe<Scalars['String']>;
  cannotRetryReasonMessage: Maybe<Scalars['String']>;
  invoiceEndDate: Maybe<Scalars['String']>;
  invoiceExternalId: Scalars['ID'];
  invoicePaymentStatus: InvoicePaymentStatuses;
  invoiceStartDate: Maybe<Scalars['String']>;
  lastTransaction: Maybe<ShortTransactionData>;
  retryable: Maybe<Scalars['Boolean']>;
};

export type InvoicesFilters = {
  __typename?: 'InvoicesFilters';
  accountFilterOptions: Maybe<Array<AccountFilterOptions>>;
  billingTypeOptions: Maybe<Array<BillingTypeOptions>>;
  invoicePaymentStatusOptions: Maybe<Array<InvoiceStatusFilterOptions>>;
};

export const InvoicesSource = {
  Campaigns: 'campaigns',
  Organizations: 'organizations',
} as const;

export type InvoicesSource = (typeof InvoicesSource)[keyof typeof InvoicesSource];
export type KervMinimalBudget = {
  __typename?: 'KERVMinimalBudget';
  budget: Scalars['Float'];
};

export type LastPaymentInfo = {
  __typename?: 'LastPaymentInfo';
  cannotRefundReason: Maybe<Scalars['String']>;
  chargedAmount: Maybe<Scalars['Currency']>;
  declineCode: Maybe<Scalars['String']>;
  declineReason: Maybe<Scalars['String']>;
  invoiceExternalId: Maybe<Scalars['String']>;
  transactionStatus: Maybe<TransactionStatuses>;
  updatedOn: Maybe<Scalars['String']>;
};

export type LateLine = Node & {
  __typename?: 'LateLine';
  accountExecutive: Maybe<AccountExecutive>;
  campaignName: Scalars['String'];
  endDate: Scalars['String'];
  id: Scalars['ID'];
  lineItemName: Scalars['String'];
  operativeOrderId: Scalars['ID'];
  startDate: Scalars['String'];
};

export type LateLineEdge = Edge & {
  __typename?: 'LateLineEdge';
  cursor: Scalars['String'];
  node: LateLine;
};

export type LateLinesFilterInput = {
  endDate?: InputMaybe<MinMaxStringValuesInput>;
  startDate?: InputMaybe<MinMaxStringValuesInput>;
};

export type LateLinesPage = Connection & {
  __typename?: 'LateLinesPage';
  edges: Array<LateLineEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type LineItem = LineItemInterface & {
  __typename?: 'LineItem';
  adDuration: Maybe<Scalars['String']>;
  adFormat: Maybe<Scalars['String']>;
  adStatus: Maybe<Scalars['String']>;
  ads: Maybe<Array<Maybe<AdType>>>;
  allowMatureContent: Maybe<Scalars['Boolean']>;
  budget: Maybe<Scalars['Float']>;
  campaignId: Scalars['ID'];
  dayPartings: Maybe<Array<Maybe<DayPartings>>>;
  deliveredFrequency: Maybe<Scalars['Float']>;
  deliveredImpressions: Maybe<Scalars['Float']>;
  deliveredReach: Maybe<Scalars['Float']>;
  discountedBudget: Maybe<Scalars['Float']>;
  discountedUnitCost: Maybe<Scalars['Float']>;
  endTime: Maybe<Scalars['AbbreviatedDate']>;
  frequencyCap: Maybe<Scalars['Int']>;
  frequencyCapUnit: Maybe<Scalars['String']>;
  hasAdvancedOverride: Maybe<Scalars['Boolean']>;
  hasDnaApplied: Maybe<Scalars['Boolean']>;
  hasKervOverride: Maybe<Scalars['Boolean']>;
  hasRateCardOverride: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  ifpAvailableImpressions: Maybe<Scalars['Float']>;
  ifpForecastRunAt: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  orderProduct: Maybe<LineItemOrderProduct>;
  pacingSchedules: Maybe<Array<PacingValues>>;
  pacingStatus: Maybe<PacingStatus>;
  package: Maybe<Package>;
  prepaymentStatus: Maybe<PrepaymentStatus>;
  publicId: Maybe<Scalars['Float']>;
  /** Left as optional cuz old LI can be without publishers */
  publishers: Maybe<Array<Maybe<PublisherType>>>;
  revisionNumber: Scalars['String'];
  startTime: Maybe<Scalars['AbbreviatedDate']>;
  status: Scalars['String'];
  targetImpressions: Maybe<Scalars['Float']>;
  targetImpressionsBeforeDiscount: Maybe<Scalars['Float']>;
  targetValues: Maybe<LineItemTargets>;
  totalSpent: Maybe<Scalars['Float']>;
  unitCost: Maybe<Scalars['Float']>;
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['String']>;
};

export type LineItemByCampaignIdV2 = {
  __typename?: 'LineItemByCampaignIdV2';
  adFormat: Maybe<Scalars['String']>;
  adStatus: Maybe<AdStatus>;
  ads: Maybe<Array<Maybe<AdType>>>;
  budget: Maybe<Scalars['Float']>;
  dayPartings: Maybe<Array<Maybe<DayPartings>>>;
  deliveredFrequency: Maybe<Scalars['Float']>;
  deliveredImpressions: Maybe<Scalars['Float']>;
  deliveredReach: Maybe<Scalars['Float']>;
  discountedBudget: Maybe<Scalars['Float']>;
  endTime: Maybe<Scalars['AbbreviatedDate']>;
  hasRateCardOverride: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  ifpAvailableImpressions: Maybe<Scalars['Float']>;
  ifpForecastRunAt: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  organizationId: Maybe<Scalars['String']>;
  pacingSchedules: Maybe<Array<PacingValues>>;
  pacingStatus: Maybe<PacingStatus>;
  package: Maybe<Package>;
  prepaymentStatus: Maybe<PrepaymentStatus>;
  rateCardId: Maybe<Scalars['String']>;
  startTime: Maybe<Scalars['AbbreviatedDate']>;
  status: Scalars['String'];
  targetImpressions: Maybe<Scalars['Float']>;
  totalSpent: Maybe<Scalars['Float']>;
  unitCost: Maybe<Scalars['Float']>;
};

export type LineItemCreative = {
  __typename?: 'LineItemCreative';
  asset: Maybe<AdAsset>;
  assets: Maybe<Array<Maybe<AdAsset>>>;
  brandId: Maybe<Scalars['String']>;
  creativeLibraryId: Scalars['ID'];
  creativeType: CreativeType;
  deletable: Scalars['Boolean'];
  duration: Maybe<Scalars['Float']>;
  experienceId: Maybe<Scalars['String']>;
  format: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDisneyAi: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  previewUrl: Maybe<Scalars['String']>;
  size: Maybe<Scalars['Float']>;
  status: Maybe<Scalars['String']>;
  thumbnail: Maybe<Scalars['String']>;
  thumbnailUrl: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type LineItemCreativeActions = {
  __typename?: 'LineItemCreativeActions';
  canDetach: Maybe<Scalars['Boolean']>;
};

export type LineItemCreativeDisableReasons = {
  __typename?: 'LineItemCreativeDisableReasons';
  detach: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type LineItemEditInput = {
  currentState: LineItemStateSnapshotInput;
  hasLowInventoryForecast: Scalars['Boolean'];
  isPostSubmit: Scalars['Boolean'];
  pricingModel: LineItemPricingModel;
  proposedState: LineItemStateSnapshotInput;
  role: LineItemEditRole;
};

export const LineItemEditRole = {
  Advertiser: 'ADVERTISER',
  Seller: 'SELLER',
  SupportAdmin: 'SUPPORT_ADMIN',
} as const;

export type LineItemEditRole = (typeof LineItemEditRole)[keyof typeof LineItemEditRole];
export type LineItemEditValidationResponse = {
  __typename?: 'LineItemEditValidationResponse';
  keepsCpmUnchanged: Scalars['Boolean'];
  valid: Scalars['Boolean'];
  violatedRules: Array<RuleViolation>;
};

export type LineItemEstimatedCost = {
  __typename?: 'LineItemEstimatedCost';
  estimatedDailyImpressions: Scalars['Float'];
  impressions: Scalars['Float'];
  preEmptibleAvailable: Scalars['Boolean'];
  rateCardId: Scalars['String'];
  rateCardVersion: Scalars['String'];
  unitCost: Scalars['Float'];
};

export type LineItemEstimatedCostInput = {
  adAccountId: Scalars['String'];
  adDuration?: InputMaybe<Scalars['String']>;
  adFormat?: InputMaybe<AdFormat>;
  allowMatureContent: Scalars['Boolean'];
  budget: Scalars['Float'];
  dayPartings?: InputMaybe<Array<InputMaybe<DayParting>>>;
  endTime: Scalars['Date'];
  /** TODO [ssat-17934]: Remove hasKervCreative when FF release-ssat-17934-ad-format-premium-pricing-feature is cleaned up */
  hasKervCreative?: InputMaybe<Scalars['Boolean']>;
  isPreemptible: Scalars['Boolean'];
  lineItemId: Scalars['String'];
  packageId?: InputMaybe<Scalars['ID']>;
  publisherIds?: InputMaybe<Array<Scalars['String']>>;
  startTime: Scalars['Date'];
  targets: Array<InputMaybe<TargetData>>;
};

export type LineItemInterface = {
  discountedUnitCost: Maybe<Scalars['Float']>;
  endTime: Maybe<Scalars['AbbreviatedDate']>;
  name: Scalars['String'];
  startTime: Maybe<Scalars['AbbreviatedDate']>;
  status: Scalars['String'];
  unitCost: Maybe<Scalars['Float']>;
};

export type LineItemOrderProduct = {
  __typename?: 'LineItemOrderProduct';
  isPreemptible: Maybe<Scalars['Boolean']>;
  specialCategory: Maybe<Scalars['String']>;
};

export const LineItemPricingModel = {
  Prepaid: 'PREPAID',
  PriceOverride: 'PRICE_OVERRIDE',
  Standard: 'STANDARD',
} as const;

export type LineItemPricingModel = (typeof LineItemPricingModel)[keyof typeof LineItemPricingModel];
export const LineItemQuickAction = {
  Cancel: 'cancel',
  Clone: 'clone',
  Delete: 'delete',
  Edit: 'edit',
  Pause: 'pause',
  Resume: 'resume',
  Suspend: 'suspend',
} as const;

export type LineItemQuickAction = (typeof LineItemQuickAction)[keyof typeof LineItemQuickAction];
export type LineItemSourceIdInput = {
  id: Scalars['ID'];
};

export type LineItemStateSnapshot = {
  __typename?: 'LineItemStateSnapshot';
  ads: Maybe<Array<AdSnapshot>>;
  audienceTargets: Maybe<Array<AudienceTarget>>;
  budget: Maybe<Scalars['Float']>;
  demoTargets: Maybe<Array<DemoTarget>>;
  endTime: Maybe<Scalars['String']>;
  genreTargets: Maybe<Array<Scalars['String']>>;
  geoTargets: Maybe<Array<GeoTarget>>;
  name: Maybe<Scalars['String']>;
  platformTargets: Maybe<Array<PlatformTarget>>;
  startTime: Maybe<Scalars['String']>;
};

export type LineItemStateSnapshotInput = {
  ads?: InputMaybe<Array<AdSnapshotInput>>;
  audienceTargets?: InputMaybe<Array<AudienceTargetInput>>;
  budget?: InputMaybe<Scalars['Float']>;
  demoTargets?: InputMaybe<Array<DemoTargetInput>>;
  endTime?: InputMaybe<Scalars['String']>;
  genreTargets?: InputMaybe<Array<Scalars['String']>>;
  geoTargets?: InputMaybe<Array<GeoTargetInput>>;
  name?: InputMaybe<Scalars['String']>;
  platformTargets?: InputMaybe<Array<PlatformTarget>>;
  startTime?: InputMaybe<Scalars['String']>;
};

export const LineItemStatus = {
  Cancelled: 'CANCELLED',
  Complete: 'COMPLETE',
  Delivered: 'DELIVERED',
  Draft: 'DRAFT',
  Live: 'LIVE',
  Paused: 'PAUSED',
  PendingApproval: 'PENDING_APPROVAL',
  Ready: 'READY',
  Submitted: 'SUBMITTED',
  Suspended: 'SUSPENDED',
  Underdelivered: 'UNDERDELIVERED',
} as const;

export type LineItemStatus = (typeof LineItemStatus)[keyof typeof LineItemStatus];
export type LineItemTargetValue = {
  __typename?: 'LineItemTargetValue';
  id: Scalars['ID'];
  isAllowed: Maybe<Scalars['Boolean']>;
  isExclusion: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  originalName: Maybe<Scalars['String']>;
  targetTypeId: Maybe<Scalars['ID']>;
};

export type LineItemTargets = {
  __typename?: 'LineItemTargets';
  age: Maybe<Array<Maybe<LineItemTargetValue>>>;
  audiences: Maybe<Array<Maybe<LineItemTargetValue>>>;
  city: Maybe<Array<Maybe<LineItemTargetValue>>>;
  content: Maybe<Array<Maybe<LineItemTargetValue>>>;
  dma: Maybe<Array<Maybe<LineItemTargetValue>>>;
  platform: Maybe<Array<Maybe<LineItemTargetValue>>>;
  retargeting: Maybe<Array<Maybe<LineItemTargetValue>>>;
  state: Maybe<Array<Maybe<LineItemTargetValue>>>;
  zip: Maybe<Array<Maybe<LineItemTargetValue>>>;
};

export type LineItemWithDifferentCpm = {
  __typename?: 'LineItemWithDifferentCPM';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LineItemWithExtraData = {
  __typename?: 'LineItemWithExtraData';
  adDuration: Maybe<Scalars['String']>;
  adFormat: Maybe<Scalars['String']>;
  adStatus: Maybe<Scalars['String']>;
  adTagsExist: Maybe<Scalars['Boolean']>;
  ads: Maybe<Array<Maybe<AdType>>>;
  allowMatureContent: Maybe<Scalars['Boolean']>;
  budget: Maybe<Scalars['Float']>;
  dayPartings: Maybe<Array<Maybe<DayPartings>>>;
  deliveredFrequency: Maybe<Scalars['Float']>;
  deliveredImpressions: Maybe<Scalars['Float']>;
  deliveredReach: Maybe<Scalars['Float']>;
  discountedBudget: Maybe<Scalars['Float']>;
  discountedUnitCost: Maybe<Scalars['Float']>;
  endTime: Maybe<Scalars['AbbreviatedDate']>;
  frequencyCap: Maybe<Scalars['Int']>;
  frequencyCapUnit: Maybe<Scalars['String']>;
  hasAdvancedOverride: Maybe<Scalars['Boolean']>;
  hasKervOverride: Maybe<Scalars['Boolean']>;
  hasRateCardOverride: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  ifpAvailableImpressions: Maybe<Scalars['Float']>;
  ifpForecastRunAt: Maybe<Scalars['Date']>;
  name: Maybe<Scalars['String']>;
  orderProduct: Maybe<LineItemOrderProduct>;
  pacingSchedules: Maybe<Array<PacingValues>>;
  pacingStatus: Maybe<PacingStatus>;
  package: Maybe<Package>;
  prepaymentStatus: Maybe<PrepaymentStatus>;
  publicId: Maybe<Scalars['Int']>;
  publishers: Maybe<Array<Maybe<PublisherType>>>;
  rateCardId: Maybe<Scalars['String']>;
  revisionNumber: Maybe<Scalars['Float']>;
  startTime: Maybe<Scalars['AbbreviatedDate']>;
  status: Maybe<Scalars['String']>;
  submittedAt: Maybe<Scalars['AbbreviatedDate']>;
  targetImpressions: Maybe<Scalars['Float']>;
  targetValues: Maybe<LineItemTargets>;
  totalSpent: Maybe<Scalars['Float']>;
  unitCost: Maybe<Scalars['Float']>;
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['String']>;
};

export type LineItemsByCampaignIdFilterOptions = {
  lineItemName?: InputMaybe<Scalars['String']>;
  lineItemStatus?: InputMaybe<Scalars['String']>;
  lineItemVersionType?: InputMaybe<Scalars['String']>;
  onlyWithDeliveredImpressions?: InputMaybe<Scalars['Boolean']>;
};

export type LineItemsByCampaignIdV2FilterOptions = {
  customStatusSort?: InputMaybe<Array<LineItemStatus>>;
  includeAds?: InputMaybe<Scalars['Boolean']>;
  lineItemStatus?: InputMaybe<Array<LineItemStatus>>;
  lineItemVersionType?: InputMaybe<RevisionType>;
  name?: InputMaybe<Scalars['String']>;
};

export const LineItemsByCampaignIdV2SortBy = {
  EndTime: 'endTime',
  Name: 'name',
  StartTime: 'startTime',
} as const;

export type LineItemsByCampaignIdV2SortBy =
  (typeof LineItemsByCampaignIdV2SortBy)[keyof typeof LineItemsByCampaignIdV2SortBy];
export type LineItemsByCampaignV2SortOptions = {
  sortBy?: InputMaybe<LineItemsByCampaignIdV2SortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type LinkAssetResult = {
  __typename?: 'LinkAssetResult';
  assetId: Scalars['ID'];
  assetSourceId: Maybe<Scalars['ID']>;
};

export type LinkPaymentMethod = {
  adAccountIds: Array<Scalars['ID']>;
};

export type LocationsDetailedDimensions = {
  __typename?: 'LocationsDetailedDimensions';
  city: Scalars['String'];
  state: Scalars['String'];
  zipcode: Scalars['String'];
};

export type LocationsTableMetric = {
  __typename?: 'LocationsTableMetric';
  detailedDimensions: LocationsDetailedDimensions;
  percentile: Scalars['Float'];
  total: Scalars['Int'];
};

export type LocationsTableMetricResult = {
  __typename?: 'LocationsTableMetricResult';
  city: Scalars['String'];
  state: Scalars['String'];
  totalImpressions: Scalars['Int'];
  zipCode: Scalars['String'];
};

export type LocationsTableMetrics = {
  __typename?: 'LocationsTableMetrics';
  metrics: Array<LocationsTableMetric>;
  total: Scalars['Int'];
};

export type LocationsTableMetricsResult = {
  __typename?: 'LocationsTableMetricsResult';
  metrics: Array<LocationsTableMetricResult>;
  total: Scalars['Int'];
};

export const LoginActivity = {
  Active: 'ACTIVE',
  All: 'ALL',
  Inactive: 'INACTIVE',
} as const;

export type LoginActivity = (typeof LoginActivity)[keyof typeof LoginActivity];
export const MetricTypes = {
  AgeDemo: 'AgeDemo',
  Audience: 'Audience',
  Device: 'Device',
  Genre: 'Genre',
  Geo: 'Geo',
} as const;

export type MetricTypes = (typeof MetricTypes)[keyof typeof MetricTypes];
export type Metrics = {
  __typename?: 'Metrics';
  data: Maybe<Array<Maybe<MetricsData>>>;
  dimensions: Maybe<Array<Maybe<MetricsDimensions>>>;
};

export type MetricsData = {
  __typename?: 'MetricsData';
  averageFrequency: Scalars['Float'];
  completions: Scalars['Float'];
  cost: Scalars['Float'];
  startDate: Scalars['String'];
  uniqueDevices: Scalars['Float'];
};

export type MetricsDimensions = {
  __typename?: 'MetricsDimensions';
  type: Scalars['String'];
  value: Scalars['String'];
};

export type MetricsInput = {
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  templateId: Scalars['ID'];
};

export type MetricsStatus = {
  __typename?: 'MetricsStatus';
  delay: Maybe<DelayDates>;
  lastUpdated: Maybe<Scalars['String']>;
};

export type MetricsStatusRequest = {
  adAccountIds: Array<Scalars['ID']>;
  organizationId: Scalars['ID'];
};

export type MinMaxNumberValues = {
  __typename?: 'MinMaxNumberValues';
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
};

export type MinMaxNumberValuesInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type MinMaxStringValues = {
  __typename?: 'MinMaxStringValues';
  max: Maybe<Scalars['String']>;
  min: Maybe<Scalars['String']>;
};

export type MinMaxStringValuesInput = {
  max?: InputMaybe<Scalars['String']>;
  min?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateUser: Maybe<Scalars['Void']>;
  addAdvertiserBrand: Brand;
  advancedOverride: Maybe<Scalars['Void']>;
  applyAdChanges: Maybe<Scalars['Void']>;
  bulkChangeUserRoles: Maybe<Scalars['Void']>;
  cancelAllLineItemsByCampaignId: Maybe<LineItem>;
  cloneCampaignByID: CampaignUpdateResponse;
  cloneCreative: CloneCreativeResult;
  configureUrl: Maybe<ConfiguredUrl>;
  createAdAccount: AdAccount;
  createAgencyBrand: Brand;
  createAllCampaignsDataReport: Maybe<AllCampaignsCreateReportResponse>;
  createAudience: Maybe<CustomAudience>;
  createBroadcast: Broadcast;
  createBrunoDetailedDataReport: Maybe<BrunoCreateDetailedReportReportResponse>;
  createBrunoReport: Maybe<BrunoReportInfo>;
  createCampaign: Maybe<CampaignCreateResponse>;
  createDeliveryPerformance: Maybe<DeliveryPerformanceReportResponse>;
  createDetailedDataReport: Maybe<DetailedDataReport>;
  createDraftLineItem: Maybe<LineItem>;
  createPaymentMethodAdyen: AdyenPaymentMethod;
  createReachFrequencyReport: Maybe<ReachFrequencyReport>;
  createReport: Maybe<ReportInfo>;
  createStandardDeliveryDeviceHigherCategoryReport: Maybe<StandardDeliveryDeviceHigherCategoryReport>;
  createStandardDeliveryReport: Maybe<StandardDeliveryReport>;
  createTopLineGenreDeliveryReport: Maybe<TopLineGenreDeliveryReport>;
  createVast: CreateVast;
  deactivateUser: Maybe<Scalars['Void']>;
  deleteAdAccount: Maybe<Scalars['Void']>;
  deleteAsset: Maybe<Scalars['Void']>;
  deleteAudience: Maybe<Scalars['Void']>;
  deleteBroadcast: Maybe<Scalars['Void']>;
  deleteCampaign: Maybe<Scalars['Void']>;
  deleteCreative: Maybe<Scalars['Void']>;
  deleteDraftLineItem: Maybe<Scalars['Void']>;
  deleteDxcCreative: Maybe<Scalars['Void']>;
  deleteLineItemCreativeByRevision: Maybe<Scalars['Void']>;
  deleteOrganization: Maybe<Scalars['Void']>;
  deletePaymentMethod: Maybe<Scalars['Void']>;
  deleteReport: Maybe<Scalars['Void']>;
  deleteSeller: Maybe<User>;
  detachPromoCode: Maybe<Scalars['Void']>;
  duplicateBroadcast: Broadcast;
  editLineItem: Maybe<LineItem>;
  editLineItemDraft: Maybe<LineItem>;
  editSeller: Maybe<User>;
  exportAllReports: Scalars['String'];
  forceCancelReport: Maybe<BrunoReportInfo>;
  forceDeleteReport: Maybe<Scalars['Void']>;
  generateDetailedDataReportFileUrl: Scalars['String'];
  generateLateLinesReport: Scalars['String'];
  generatePresignedUrl: PresignedUrl;
  generateReachFrequencyReportFileUrl: Scalars['String'];
  generateStandardDeliveryDeviceHigherCategoryReportFileUrl: Scalars['String'];
  generateStandardDeliveryReportFileUrl: Scalars['String'];
  generateTopLineGenreDeliveryReportFileUrl: Scalars['String'];
  inviteSeller: Array<User>;
  inviteSellerWithCsv: Array<Maybe<Scalars['String']>>;
  inviteUser: User;
  linkAsset: LinkAssetResult;
  linkVideoCreative: AdInfo;
  makeAllNotificationsRead: Maybe<Scalars['Void']>;
  markSelectedNotifications: Maybe<Scalars['Void']>;
  operateAsAgency: Maybe<Scalars['Void']>;
  overrideCPM: Maybe<Scalars['Void']>;
  overrideKERV: Maybe<Scalars['Void']>;
  quickActionLineItemByID: LineItem;
  quickActionReportByID: Maybe<ReportInfo>;
  refundTransaction: Maybe<Scalars['Void']>;
  reserveKERVLineItem: ReserveKervResponse;
  resumeBroadcast: Broadcast;
  resumeOrStopReport: ReportStatusInfo;
  retryPaymentMethodByInvoiceExtId: RetryPaymentMethod;
  retryPaymentMethodByPaymentId: Array<Maybe<RetryPaymentMethod>>;
  retryReport: Maybe<BrunoReportInfo>;
  saveDxcCreative: DxcCreative;
  sendPromoCode: Maybe<Scalars['Void']>;
  sendTestEmail: Maybe<Scalars['Void']>;
  stopBroadcast: Broadcast;
  submitDxcCreative: DxcCreative;
  submitLineItems: Maybe<Array<Maybe<LineItem>>>;
  toggleNotificationSettings: Maybe<Scalars['Void']>;
  toggleNotificationSettingsByTheUser: Maybe<Scalars['Void']>;
  toggleUserNotificationSettings: Maybe<Scalars['Void']>;
  unsubscribeFromReport: Maybe<Scalars['Void']>;
  updateAdAccount: AdAccount;
  updateAdAccountPatch: AdAccount;
  updateAdAccountStatus: Maybe<Scalars['Void']>;
  updateAllCampaignsReport: Maybe<AllCampaignsCreateReportResponse>;
  updateAudience: Maybe<Scalars['Void']>;
  updateBrand: Brand;
  updateBroadcast: Broadcast;
  updateBrunoDetailedReport: Maybe<BrunoCreateDetailedReportReportResponse>;
  updateBrunoReport: Maybe<BrunoReportInfo>;
  updateCampaign: Maybe<CampaignUpdateResponse>;
  updateCreativeName: UpdateCreativeNameResult;
  updateCuratedAudienceUsageReport: Maybe<CuratedAudienceUsageReport>;
  updateDeliveryPerformance: Maybe<DeliveryPerformanceReportResponse>;
  updateDraftLineItem: Maybe<LineItem>;
  updateLastActivity: Maybe<Scalars['Void']>;
  updateLineItemAds3PTags: Maybe<LineItem>;
  updateLineItemPackageId: Maybe<LineItem>;
  updateOrgActivity: Maybe<Scalars['Void']>;
  updateOrganization: Organization;
  updateOrganizationStatus: Maybe<Scalars['Void']>;
  updatePaymentMethodAdyen: AdyenPaymentMethod;
  updatePaymentMethodPerAdAccount: Maybe<Scalars['Void']>;
  updatePaymentMethodPerAdAccounts: Maybe<Scalars['Void']>;
  updateReachFrequencyReport: Maybe<ReachFrequencyReport>;
  updateReport: Maybe<ReportInfo>;
  updateStandardDeliveryDeviceHigherCategoryReport: Maybe<StandardDeliveryDeviceHigherCategoryReport>;
  updateStandardDeliveryReport: Maybe<StandardDeliveryReport>;
  updateTopLineGenreDeliveryReport: Maybe<TopLineGenreDeliveryReport>;
  updateUser: User;
  updateUserPhone: User;
  updateUserRoles: Maybe<User>;
  uploadKervVast: UploadKervVast;
  validateReCAPTCHA: ReCaptchaResponse;
  validateVast: Maybe<VastInfo>;
};

export type MutationActivateUserArgs = {
  id: Scalars['ID'];
};

export type MutationAddAdvertiserBrandArgs = {
  input: AddAdvertiserBrandInput;
};

export type MutationAdvancedOverrideArgs = {
  eligible: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type MutationApplyAdChangesArgs = {
  id: Scalars['ID'];
};

export type MutationBulkChangeUserRolesArgs = {
  input: Array<BulkChangeRoles>;
  orgId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type MutationCancelAllLineItemsByCampaignIdArgs = {
  campaignId: Scalars['ID'];
};

export type MutationCloneCampaignByIdArgs = {
  campaignId: Scalars['ID'];
};

export type MutationCloneCreativeArgs = {
  creativeId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type MutationConfigureUrlArgs = {
  url: Scalars['String'];
};

export type MutationCreateAdAccountArgs = {
  input: AdAccountInput;
};

export type MutationCreateAgencyBrandArgs = {
  input: BrandInput;
};

export type MutationCreateAllCampaignsDataReportArgs = {
  filters: AllCampaignsCreateReportInput;
  report: ReportInput;
};

export type MutationCreateAudienceArgs = {
  input: CreateAudienceInput;
};

export type MutationCreateBroadcastArgs = {
  broadcastInput: BroadcastInput;
};

export type MutationCreateBrunoDetailedDataReportArgs = {
  filters: BrunoCreateDetailedReportReportInput;
  report: ReportInput;
};

export type MutationCreateBrunoReportArgs = {
  report: ReportInput;
};

export type MutationCreateCampaignArgs = {
  input: CampaignCreateInput;
};

export type MutationCreateDeliveryPerformanceArgs = {
  filters: DeliveryPerformanceReportInput;
  report: ReportInput;
};

export type MutationCreateDetailedDataReportArgs = {
  filters: DetailedDateReportFiltersInput;
  report: ReportInput;
};

export type MutationCreateDraftLineItemArgs = {
  input: DraftLineItemInput;
};

export type MutationCreatePaymentMethodAdyenArgs = {
  input: PaymentMethodInput;
};

export type MutationCreateReachFrequencyReportArgs = {
  filters: ReachFrequencyReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  report: ReportInput;
};

export type MutationCreateReportArgs = {
  input: DeprecatedReportInput;
};

export type MutationCreateStandardDeliveryDeviceHigherCategoryReportArgs = {
  filters: StandardDeliveryDeviceHigherCategoryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  report: ReportInput;
};

export type MutationCreateStandardDeliveryReportArgs = {
  filters: StandardDeliveryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  report: ReportInput;
};

export type MutationCreateTopLineGenreDeliveryReportArgs = {
  filters: TopLineGenreDeliveryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  report: ReportInput;
};

export type MutationCreateVastArgs = {
  brandId: Scalars['ID'];
  organizationId: Scalars['ID'];
  type?: InputMaybe<VastCreativeType>;
  url: Scalars['String'];
};

export type MutationDeactivateUserArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteAdAccountArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteAssetArgs = {
  assetSourceId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type MutationDeleteAudienceArgs = {
  adAccountIds: Array<Scalars['String']>;
  id: Scalars['ID'];
};

export type MutationDeleteBroadcastArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteCampaignArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteCreativeArgs = {
  creativeId: Scalars['ID'];
};

export type MutationDeleteDraftLineItemArgs = {
  lineItemId: Scalars['ID'];
};

export type MutationDeleteDxcCreativeArgs = {
  creativeId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type MutationDeleteLineItemCreativeByRevisionArgs = {
  creativeId: Scalars['ID'];
  lineItemId: Scalars['ID'];
  lineItemVersion: Scalars['String'];
};

export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID'];
};

export type MutationDeletePaymentMethodArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteReportArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteSellerArgs = {
  userId: Scalars['ID'];
};

export type MutationDetachPromoCodeArgs = {
  campaignId: Scalars['ID'];
};

export type MutationDuplicateBroadcastArgs = {
  id: Scalars['ID'];
};

export type MutationEditLineItemArgs = {
  input: LineItemEditInput;
  lineItemUuid: Scalars['ID'];
};

export type MutationEditLineItemDraftArgs = {
  input: LineItemEditInput;
  lineItemUuid: Scalars['ID'];
};

export type MutationEditSellerArgs = {
  input: SellerEditInput;
};

export type MutationExportAllReportsArgs = {
  input: ExportAllReportsInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
};

export type MutationForceCancelReportArgs = {
  id: Scalars['ID'];
};

export type MutationForceDeleteReportArgs = {
  id: Scalars['ID'];
};

export type MutationGenerateDetailedDataReportFileUrlArgs = {
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  reportData: DetailedDataReportFileUrlInput;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type MutationGenerateLateLinesReportArgs = {
  advertiserId: Scalars['ID'];
  filterOptions?: InputMaybe<LateLinesFilterInput>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  orgId: Scalars['ID'];
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type MutationGeneratePresignedUrlArgs = {
  key: Scalars['String'];
};

export type MutationGenerateReachFrequencyReportFileUrlArgs = {
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  reportData: ReachFrequencyReportFileUrlInput;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type MutationGenerateStandardDeliveryDeviceHigherCategoryReportFileUrlArgs = {
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  reportData: StandardDeliveryDeviceHigherCategoryReportFileUrlInput;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type MutationGenerateStandardDeliveryReportFileUrlArgs = {
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  reportData: StandardDeliveryReportFileUrlInput;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type MutationGenerateTopLineGenreDeliveryReportFileUrlArgs = {
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  reportData: TopLineGenreDeliveryReportFileUrlInput;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type MutationInviteSellerArgs = {
  input: SellerInviteInput;
};

export type MutationInviteSellerWithCsvArgs = {
  input: Array<SellerInviteInput>;
};

export type MutationInviteUserArgs = {
  id: Scalars['ID'];
  input: UserInviteInput;
};

export type MutationLinkAssetArgs = {
  adFormat?: InputMaybe<AdFormat>;
  assetType: Scalars['String'];
  brandId: Scalars['String'];
  organizationId: Scalars['String'];
  s3Key: Scalars['String'];
};

export type MutationLinkVideoCreativeArgs = {
  brandId: Scalars['String'];
  organizationId: Scalars['String'];
  s3Key: Scalars['String'];
};

export type MutationMakeAllNotificationsReadArgs = {
  userId: Scalars['ID'];
};

export type MutationMarkSelectedNotificationsArgs = {
  action: ReadOrUnread;
  ids: Array<Scalars['ID']>;
};

export type MutationOperateAsAgencyArgs = {
  id: Scalars['ID'];
};

export type MutationOverrideCpmArgs = {
  cancelOverride?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  unitCost?: InputMaybe<Scalars['Float']>;
};

export type MutationOverrideKervArgs = {
  eligible: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type MutationQuickActionLineItemByIdArgs = {
  action: LineItemQuickAction;
  lineItemId: Scalars['ID'];
};

export type MutationQuickActionReportByIdArgs = {
  action: ReportQuickAction;
  reportId: Scalars['ID'];
};

export type MutationRefundTransactionArgs = {
  input: RefundTransactionInput;
};

export type MutationReserveKervLineItemArgs = {
  orgId: Scalars['ID'];
};

export type MutationResumeBroadcastArgs = {
  id: Scalars['ID'];
};

export type MutationResumeOrStopReportArgs = {
  action: StopOrResumeReport;
  id: Scalars['ID'];
};

export type MutationRetryPaymentMethodByInvoiceExtIdArgs = {
  id: Scalars['ID'];
};

export type MutationRetryPaymentMethodByPaymentIdArgs = {
  id: Scalars['ID'];
};

export type MutationRetryReportArgs = {
  id: Scalars['ID'];
};

export type MutationSaveDxcCreativeArgs = {
  brandId: Scalars['String'];
  creativeManagerId: Scalars['ID'];
  experienceId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type MutationSendPromoCodeArgs = {
  campaignId: Scalars['ID'];
  promoCodeName: Scalars['String'];
};

export type MutationSendTestEmailArgs = {
  input: TestEmailInput;
};

export type MutationStopBroadcastArgs = {
  id: Scalars['ID'];
};

export type MutationSubmitDxcCreativeArgs = {
  creativeId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type MutationSubmitLineItemsArgs = {
  campaignId: Scalars['ID'];
  lineItemUuids: Array<LineItemSourceIdInput>;
};

export type MutationToggleNotificationSettingsArgs = {
  input: NotificationSettingsInput;
  userId: Scalars['ID'];
};

export type MutationToggleNotificationSettingsByTheUserArgs = {
  enableForAll: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type MutationToggleUserNotificationSettingsArgs = {
  enableForAll: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type MutationUnsubscribeFromReportArgs = {
  id: Scalars['ID'];
};

export type MutationUpdateAdAccountArgs = {
  canUpdatePaymentMethod: Scalars['Boolean'];
  id: Scalars['ID'];
  input: AdAccountUpdate;
};

export type MutationUpdateAdAccountPatchArgs = {
  id: Scalars['ID'];
  input: AdAccountUpdatePatch;
};

export type MutationUpdateAdAccountStatusArgs = {
  input: AdAccountUpdateStatusInput;
};

export type MutationUpdateAllCampaignsReportArgs = {
  filters: AllCampaignsCreateReportInput;
  id: Scalars['ID'];
  report: UpdateReportInput;
};

export type MutationUpdateAudienceArgs = {
  id: Scalars['ID'];
  input: UpdateAudienceInput;
};

export type MutationUpdateBrandArgs = {
  id: Scalars['ID'];
  input: BrandInput;
  orgId: Scalars['ID'];
};

export type MutationUpdateBroadcastArgs = {
  broadcastInput: BroadcastInput;
};

export type MutationUpdateBrunoDetailedReportArgs = {
  filters: BrunoCreateDetailedReportReportInput;
  id: Scalars['ID'];
  report: UpdateReportInput;
};

export type MutationUpdateBrunoReportArgs = {
  id: Scalars['ID'];
  report: UpdateReportInput;
};

export type MutationUpdateCampaignArgs = {
  id: Scalars['ID'];
  input: UpdateCampaign;
};

export type MutationUpdateCreativeNameArgs = {
  creativeId: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type MutationUpdateCuratedAudienceUsageReportArgs = {
  filters: CuratedAudienceUsageReportInput;
  id: Scalars['ID'];
  report: UpdateReportInput;
};

export type MutationUpdateDeliveryPerformanceArgs = {
  filters: DeliveryPerformanceReportInput;
  id: Scalars['ID'];
  report: UpdateReportInput;
};

export type MutationUpdateDraftLineItemArgs = {
  input: UpdateDraftLineItem;
  lineItemId: Scalars['ID'];
};

export type MutationUpdateLastActivityArgs = {
  adAccountId: Scalars['ID'];
};

export type MutationUpdateLineItemAds3PTagsArgs = {
  ads: Array<InputMaybe<UpdateAdType>>;
  lineItemId: Scalars['ID'];
};

export type MutationUpdateLineItemPackageIdArgs = {
  lineItemId: Scalars['ID'];
  packageId: Scalars['ID'];
};

export type MutationUpdateOrgActivityArgs = {
  id: Scalars['ID'];
};

export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID'];
  input: OrganizationInput;
};

export type MutationUpdateOrganizationStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};

export type MutationUpdatePaymentMethodAdyenArgs = {
  input: UpdateAdyenPaymentMethodInput;
  methodId: Scalars['String'];
};

export type MutationUpdatePaymentMethodPerAdAccountArgs = {
  adAccountId: Scalars['ID'];
  input: PaymentMethodUpdate;
};

export type MutationUpdatePaymentMethodPerAdAccountsArgs = {
  input: LinkPaymentMethod;
  paymentMethodExternalId: Scalars['ID'];
};

export type MutationUpdateReachFrequencyReportArgs = {
  filters: ReachFrequencyReportFiltersInput;
  id: Scalars['ID'];
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  report: UpdateReportInput;
};

export type MutationUpdateReportArgs = {
  id: Scalars['ID'];
  input: DeprecatedReportInput;
};

export type MutationUpdateStandardDeliveryDeviceHigherCategoryReportArgs = {
  filters: StandardDeliveryDeviceHigherCategoryReportFiltersInput;
  id: Scalars['ID'];
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  report: UpdateReportInput;
};

export type MutationUpdateStandardDeliveryReportArgs = {
  filters: StandardDeliveryReportFiltersInput;
  id: Scalars['ID'];
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  report: UpdateReportInput;
};

export type MutationUpdateTopLineGenreDeliveryReportArgs = {
  filters: TopLineGenreDeliveryReportFiltersInput;
  id: Scalars['ID'];
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  report: UpdateReportInput;
};

export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  input: UserInput;
  orgId: Scalars['ID'];
};

export type MutationUpdateUserPhoneArgs = {
  id: Scalars['ID'];
  phone: Scalars['String'];
};

export type MutationUpdateUserRolesArgs = {
  id: Scalars['ID'];
  input: UpdateUserRolesInput;
  orgId: Scalars['ID'];
};

export type MutationUploadKervVastArgs = {
  adDuration?: InputMaybe<Scalars['String']>;
  creativeId: Scalars['ID'];
  orgId: Scalars['ID'];
  url?: InputMaybe<Scalars['String']>;
};

export type MutationValidateReCaptchaArgs = {
  token: Scalars['String'];
};

export type MutationValidateVastArgs = {
  type?: InputMaybe<VastCreativeType>;
  url: Scalars['String'];
};

export type Node = {
  id: Maybe<Scalars['ID']>;
};

export type Notification = Node & {
  __typename?: 'Notification';
  acked: Scalars['Boolean'];
  category: Maybe<CategoryEnum>;
  createdAt: Maybe<Scalars['String']>;
  header: Scalars['String'];
  icon: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPopUp: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
};

export type NotificationEdge = Edge & {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String'];
  node: Notification;
};

export type NotificationPage = Connection & {
  __typename?: 'NotificationPage';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type NotificationSettingsByAdAccountInput = {
  adAccountId: Scalars['ID'];
  enabledForAdStatus: Scalars['Boolean'];
  enabledForCampaignStatus: Scalars['Boolean'];
  enabledForPaymentTransaction: Scalars['Boolean'];
};

export type NotificationSettingsInput = {
  enableForAll?: InputMaybe<Scalars['Boolean']>;
  notificationSettingsByAdAccount?: InputMaybe<Array<NotificationSettingsByAdAccountInput>>;
};

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  category: Maybe<CategoryEnum>;
  emailSubject: Maybe<Scalars['String']>;
  header: Scalars['String'];
  iconReference: Scalars['String'];
  id: Maybe<Scalars['ID']>;
  isEmail: Scalars['Boolean'];
  isInApp: Scalars['Boolean'];
  isPopUp: Scalars['Boolean'];
  text: Scalars['String'];
};

export type NotificationTemplateInput = {
  category?: InputMaybe<CategoryEnum>;
  emailSubject?: InputMaybe<Scalars['String']>;
  header: Scalars['String'];
  iconReference: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  isEmail: Scalars['Boolean'];
  isInApp: Scalars['Boolean'];
  isPopUp: Scalars['Boolean'];
  text: Scalars['String'];
};

export type NotificationsFilterOptions = {
  category?: InputMaybe<CategoryEnum>;
  createdAtAfter?: InputMaybe<Scalars['AbbreviatedDate']>;
  createdAtBefore?: InputMaybe<Scalars['AbbreviatedDate']>;
  isAcknowledged?: InputMaybe<Scalars['Boolean']>;
  isPopUp?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export const OrderOption = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;

export type OrderOption = (typeof OrderOption)[keyof typeof OrderOption];
export type OrgCreativeLibrary = {
  __typename?: 'OrgCreativeLibrary';
  creativeLibraryId: Scalars['ID'];
};

export type Organization = {
  __typename?: 'Organization';
  address: Address;
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  creativeAgentAccessAllowed: Maybe<Scalars['Boolean']>;
  crmLink: Maybe<Scalars['String']>;
  dailySpendLimitOverride: Maybe<Scalars['Float']>;
  dailySpendLimitOverrideAllowed: Maybe<Scalars['Boolean']>;
  daypartingAllowed: Maybe<Scalars['Boolean']>;
  disabledReason: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBaymaxEnabled: Maybe<Scalars['Boolean']>;
  lastLoginAt: Maybe<Scalars['AbbreviatedDate']>;
  minLineItemBudgetOverride: Maybe<Scalars['Float']>;
  minLineItemBudgetOverrideAllowed: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  operatesAsAgency: Scalars['Boolean'];
  phoneNumber: Maybe<Scalars['String']>;
  scheduledPacingAllowed: Maybe<Scalars['Boolean']>;
  status: OrganizationStatus;
  threepBillingEligible: Maybe<Scalars['Boolean']>;
};

export type OrganizationDetails = {
  __typename?: 'OrganizationDetails';
  activeCampaignsCount: Scalars['Int'];
  activeCpm: Scalars['Currency'];
  address: Address;
  approvedForTerms: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  creativeAgentAccessAllowed: Maybe<Scalars['Boolean']>;
  crmLink: Scalars['String'];
  dailySpendLimitOverride: Maybe<Scalars['Float']>;
  dailySpendLimitOverrideAllowed: Maybe<Scalars['Boolean']>;
  daypartingAllowed: Maybe<Scalars['Boolean']>;
  draftAdsLimit: Maybe<Scalars['Int']>;
  draftCreativesCount: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isBaymaxEnabled: Scalars['Boolean'];
  lastLoginAt: Maybe<Scalars['AbbreviatedDate']>;
  lineOfCredit: Scalars['Int'];
  minLineItemBudgetOverride: Maybe<Scalars['Float']>;
  minLineItemBudgetOverrideAllowed: Maybe<Scalars['Boolean']>;
  monthlyAdsLimit: Maybe<Scalars['Int']>;
  monthlyCreativesCount: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  operatesAsAgency: Maybe<Scalars['Boolean']>;
  paidInvoicingEnabled: Scalars['Boolean'];
  phoneNumber: Maybe<Scalars['String']>;
  scheduledPacingAllowed: Maybe<Scalars['Boolean']>;
  sellers: Array<Maybe<Scalars['String']>>;
  status: OrganizationStatus;
  threepBillingEligible: Maybe<Scalars['Boolean']>;
  thresholdAmount: Maybe<Scalars['Float']>;
  totalSpent: Maybe<Scalars['Currency']>;
};

export type OrganizationEdge = Edge & {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String'];
  node: OrganizationListItem;
};

export type OrganizationFilterOptions = {
  createdDateEnd?: InputMaybe<Scalars['String']>;
  createdDateStart?: InputMaybe<Scalars['String']>;
  hideByAdAccountAccess?: InputMaybe<Scalars['Boolean']>;
  isBaymaxEnabled?: InputMaybe<Scalars['Boolean']>;
  lastLoginDateEnd?: InputMaybe<Scalars['String']>;
  lastLoginDateStart?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrganizationStatus>;
  type?: InputMaybe<Scalars['String']>;
};

export type OrganizationForCampaignWithExtraData = {
  __typename?: 'OrganizationForCampaignWithExtraData';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type OrganizationInput = {
  address?: InputMaybe<AddressInput>;
  creativeAgentAccessAllowed?: InputMaybe<Scalars['Boolean']>;
  dailySpendLimitOverride?: InputMaybe<Scalars['Float']>;
  dailySpendLimitOverrideAllowed?: InputMaybe<Scalars['Boolean']>;
  daypartingAllowed?: InputMaybe<Scalars['Boolean']>;
  draftAdsLimit?: InputMaybe<Scalars['Int']>;
  minLineItemBudgetOverride?: InputMaybe<Scalars['Float']>;
  minLineItemBudgetOverrideAllowed?: InputMaybe<Scalars['Boolean']>;
  monthlyAdsLimit?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  scheduledPacingAllowed?: InputMaybe<Scalars['Boolean']>;
  threepBillingEligible?: InputMaybe<Scalars['Boolean']>;
  thresholdAmount?: InputMaybe<Scalars['Float']>;
};

export type OrganizationListItem = Node & {
  __typename?: 'OrganizationListItem';
  activeCampaignsCount: Maybe<Scalars['Int']>;
  adAccountsCount: Scalars['Int'];
  baymaxEnabled: Maybe<Scalars['Boolean']>;
  campaignsCount: Maybe<Scalars['Int']>;
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  crmLink: Maybe<CrmLink>;
  id: Scalars['ID'];
  lastLoginAt: Maybe<Scalars['AbbreviatedDate']>;
  name: Scalars['String'];
  status: OrganizationStatus;
  totalSpent: Maybe<Scalars['Float']>;
  usersCount: Scalars['Int'];
};

export const OrganizationSortBy = {
  AdAccountsCount: 'adAccountsCount',
  CreatedAt: 'createdAt',
  IsBaymaxEnabled: 'isBaymaxEnabled',
  LastLoginAt: 'lastLoginAt',
  Name: 'name',
  Status: 'status',
  UsersCount: 'usersCount',
} as const;

export type OrganizationSortBy = (typeof OrganizationSortBy)[keyof typeof OrganizationSortBy];
export type OrganizationSortOptions = {
  sortBy?: InputMaybe<OrganizationSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type OrganizationStatistics = {
  __typename?: 'OrganizationStatistics';
  campaignsActive: Scalars['Int'];
  campaignsTotal: Scalars['Int'];
  lineItemsEnded: Scalars['Int'];
  lineItemsInFlight: Scalars['Int'];
  lineItemsLate: Scalars['Int'];
  lineItemsTotal: Scalars['Int'];
  lineItemsUpcoming: Scalars['Int'];
};

export const OrganizationStatus = {
  Active: 'ACTIVE',
  Closed: 'CLOSED',
  Disabled: 'DISABLED',
  Inactive: 'INACTIVE',
  InGracePeriod: 'IN_GRACE_PERIOD',
  UnderReview: 'UNDER_REVIEW',
} as const;

export type OrganizationStatus = (typeof OrganizationStatus)[keyof typeof OrganizationStatus];
export type OrganizationsList = Connection & {
  __typename?: 'OrganizationsList';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export const PacingStatus = {
  OnPacing: 'ON_PACING',
  OverPacing: 'OVER_PACING',
  UnderPacing: 'UNDER_PACING',
} as const;

export type PacingStatus = (typeof PacingStatus)[keyof typeof PacingStatus];
export type PacingValues = {
  __typename?: 'PacingValues';
  endTime: Scalars['AbbreviatedDate'];
  pacingShare: Scalars['Float'];
  startTime: Scalars['AbbreviatedDate'];
};

export type PacingValuesInput = {
  endTime: Scalars['AbbreviatedDate'];
  pacingShare: Scalars['Float'];
  startTime: Scalars['AbbreviatedDate'];
};

export type Package = {
  __typename?: 'Package';
  allowDayparting: Maybe<Scalars['Boolean']>;
  categories: Maybe<Array<Maybe<PackageCategory>>>;
  coreOffering: Maybe<CoreOffering>;
  endDate: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  largeHeroImageFile: Maybe<Scalars['String']>;
  longDescription: Maybe<Scalars['String']>;
  partners: Maybe<Array<Maybe<Scalars['String']>>>;
  publishers: Maybe<Array<Maybe<PublisherType>>>;
  rank: Maybe<Scalars['Int']>;
  selectable: Maybe<Scalars['Boolean']>;
  shortDescription: Maybe<Scalars['String']>;
  showLearnMore: Maybe<Scalars['Boolean']>;
  smallHeroImageFile: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type PackageCategory = {
  __typename?: 'PackageCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PackageFullInfo = {
  __typename?: 'PackageFullInfo';
  buyingPlatforms: Maybe<Array<Scalars['String']>>;
  carouselImages: Maybe<Array<CarouselImage>>;
  categories: Maybe<Array<Maybe<PackageCategory>>>;
  contentTitle: Maybe<Scalars['String']>;
  contents: Maybe<Array<ContentItem>>;
  coreOffering: Maybe<CoreOffering>;
  endDate: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  largeHeroImageFile: Maybe<Scalars['String']>;
  longDescription: Maybe<Scalars['String']>;
  presetId: Maybe<Scalars['ID']>;
  publishers: Maybe<Array<Maybe<PublisherType>>>;
  rank: Scalars['Int'];
  shortDescription: Maybe<Scalars['String']>;
  smallHeroImageFile: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']>;
  nextCursor: Maybe<Scalars['String']>;
  previousCursor: Maybe<Scalars['String']>;
  startCursor: Maybe<Scalars['String']>;
};

export type PaginationLimit = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type PaginationOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PaymentFilterOptions = {
  paymentMethodName?: InputMaybe<Scalars['String']>;
};

export type PaymentMethod = Node & {
  __typename?: 'PaymentMethod';
  accountSet: Maybe<Array<Maybe<AccountSetInfo>>>;
  billingAddress: Maybe<BillingAddress>;
  brand: Maybe<Scalars['String']>;
  cardholderName: Maybe<Scalars['String']>;
  expirationMonth: Maybe<Scalars['Int']>;
  expirationYear: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  invoicePaymentStatus: Maybe<InvoicePaymentStatuses>;
  lastFour: Maybe<Scalars['String']>;
  lastPayment: Maybe<LastPaymentInfo>;
  organizationExternalId: Scalars['ID'];
  paymentMethodExternalId: Scalars['ID'];
  paymentMethodName: Scalars['String'];
  paymentMethodProcessor: Maybe<PaymentMethodProcessor>;
  paymentType: PaymentType;
  token: Maybe<Scalars['String']>;
  updatedOn: Maybe<Scalars['Date']>;
};

export type PaymentMethodFilterOptions = {
  __typename?: 'PaymentMethodFilterOptions';
  brand: Scalars['String'];
  lastFour: Scalars['String'];
  paymentMethodExternalId: Scalars['String'];
  paymentMethodName: Scalars['String'];
  status: Scalars['String'];
};

export type PaymentMethodInput = {
  billingAddress: BillingAddressInput;
  encryptedCardNumber: Scalars['String'];
  encryptedExpiryMonth: Scalars['String'];
  encryptedExpiryYear: Scalars['String'];
  encryptedSecurityCode: Scalars['String'];
  holderName: Scalars['String'];
  organizationExternalId: Scalars['String'];
  paymentMethodName: Scalars['String'];
};

export const PaymentMethodProcessor = {
  Adyen: 'ADYEN',
  Worldpay: 'WORLDPAY',
} as const;

export type PaymentMethodProcessor = (typeof PaymentMethodProcessor)[keyof typeof PaymentMethodProcessor];
export const PaymentMethodSortBy = {
  PaymentMethodName: 'paymentMethodName',
} as const;

export type PaymentMethodSortBy = (typeof PaymentMethodSortBy)[keyof typeof PaymentMethodSortBy];
export type PaymentMethodSortOptions = {
  sortBy?: InputMaybe<PaymentMethodSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type PaymentMethodUpdate = {
  paymentMethodExternalId?: InputMaybe<Scalars['String']>;
};

export const PaymentType = {
  CreditCard: 'CREDIT_CARD',
  LineOfCredit: 'LINE_OF_CREDIT',
} as const;

export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType];
export type PaymentsEdge = Edge & {
  __typename?: 'PaymentsEdge';
  cursor: Scalars['String'];
  node: PaymentMethod;
};

export type PaymentsList = Connection & {
  __typename?: 'PaymentsList';
  edges: Array<PaymentsEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type Permissions = {
  __typename?: 'Permissions';
  ADMIN_CREATE_PAYMENTS: Scalars['Boolean'];
  ADMIN_DELETE_PAYMENTS: Scalars['Boolean'];
  ADMIN_READ_PAYMENTS: Scalars['Boolean'];
  ADMIN_REFUND_PAYMENTS: Scalars['Boolean'];
  ADMIN_RETRY_PAYMENTS: Scalars['Boolean'];
  ADMIN_UPDATE_PAYMENTS: Scalars['Boolean'];
  ADMIN_UPDATE_THRESHOLD: Scalars['Boolean'];
  APPLY_PROMO_CODE: Scalars['Boolean'];
  BUILD_REPORT: Scalars['Boolean'];
  CANCEL_LINE_ITEM: Scalars['Boolean'];
  CLONE_LINE_ITEM: Scalars['Boolean'];
  CONFIGURE_AD_TAG: Scalars['Boolean'];
  CREATE_ADVANCED_CREATIVE: Scalars['Boolean'];
  CREATE_AD_ACCOUNT: Scalars['Boolean'];
  CREATE_ASSET: Scalars['Boolean'];
  CREATE_BRAND: Scalars['Boolean'];
  CREATE_BROADCAST: Scalars['Boolean'];
  CREATE_CAMPAIGN: Scalars['Boolean'];
  CREATE_CREATIVE: Scalars['Boolean'];
  CREATE_INDUSTRY: Scalars['Boolean'];
  CREATE_LINEITEM: Scalars['Boolean'];
  CREATE_PAYMENTS: Scalars['Boolean'];
  CREATE_REPORT: Scalars['Boolean'];
  CREATE_USER: Scalars['Boolean'];
  DELETE_AD_ACCOUNT: Scalars['Boolean'];
  DELETE_BROADCAST: Scalars['Boolean'];
  DELETE_CAMPAIGN: Scalars['Boolean'];
  DELETE_CREATIVE: Scalars['Boolean'];
  DELETE_CREATIVES: Scalars['Boolean'];
  DELETE_LINE_ITEM: Scalars['Boolean'];
  DELETE_ORGANIZATION: Scalars['Boolean'];
  DELETE_PAYMENTS: Scalars['Boolean'];
  DELETE_REPORT: Scalars['Boolean'];
  DETACH_PROMO_CODE: Scalars['Boolean'];
  GENIE_UI_ACCESS: Scalars['Boolean'];
  GET_CAMPAIGN: Scalars['Boolean'];
  GET_LINE_ITEM: Scalars['Boolean'];
  INVITE_USER: Scalars['Boolean'];
  OVERRIDE_LINE_ITEM_KERV: Scalars['Boolean'];
  OVERRIDE_LINE_ITEM_PRICE: Scalars['Boolean'];
  PAUSE_LINE_ITEM: Scalars['Boolean'];
  READ_AD_ACCOUNT: Scalars['Boolean'];
  READ_ALL_ADS: Scalars['Boolean'];
  READ_ALL_CAMPAIGNS: Scalars['Boolean'];
  READ_ALL_LINE_ITEMS: Scalars['Boolean'];
  READ_BRAND: Scalars['Boolean'];
  READ_BROADCAST: Scalars['Boolean'];
  READ_CAMPAIGN_LINEITEMS: Scalars['Boolean'];
  READ_CREATIVE: Scalars['Boolean'];
  READ_CREATIVES: Scalars['Boolean'];
  READ_INDUSTRY: Scalars['Boolean'];
  READ_LEGACY_REPORT: Scalars['Boolean'];
  READ_NOTIFICATION: Scalars['Boolean'];
  READ_ORGANIZATION: Scalars['Boolean'];
  READ_OWN_USER: Scalars['Boolean'];
  READ_PACKAGE: Scalars['Boolean'];
  READ_PAYMENTS: Scalars['Boolean'];
  READ_REPORT: Scalars['Boolean'];
  READ_REPORT_TEMPLATE: Scalars['Boolean'];
  READ_ROLES: Scalars['Boolean'];
  READ_TARGETING: Scalars['Boolean'];
  READ_USER: Scalars['Boolean'];
  READ_USERS: Scalars['Boolean'];
  RESUME_LINE_ITEM: Scalars['Boolean'];
  SUBMIT_ADS: Scalars['Boolean'];
  SUBMIT_LINE_ITEM: Scalars['Boolean'];
  SUSPEND_LINE_ITEM: Scalars['Boolean'];
  UPDATE_AD_ACCOUNT: Scalars['Boolean'];
  UPDATE_AD_ACCOUNT_BILLING_CONTACT: Scalars['Boolean'];
  UPDATE_AD_ACCOUNT_BRAND: Scalars['Boolean'];
  UPDATE_AD_ACCOUNT_NAME: Scalars['Boolean'];
  UPDATE_AD_ACCOUNT_STATUS: Scalars['Boolean'];
  UPDATE_AD_FORMAT: Scalars['Boolean'];
  UPDATE_BRAND: Scalars['Boolean'];
  UPDATE_BROADCAST: Scalars['Boolean'];
  UPDATE_CAMPAIGN: Scalars['Boolean'];
  UPDATE_INDUSTRY: Scalars['Boolean'];
  UPDATE_LINE_ITEM: Scalars['Boolean'];
  UPDATE_LINE_ITEM_OVERRIDES: Scalars['Boolean'];
  UPDATE_NOTIFICATION_SETTINGS: Scalars['Boolean'];
  UPDATE_ORGANIZATION: Scalars['Boolean'];
  UPDATE_PAYMENTS: Scalars['Boolean'];
  UPDATE_REPORT: Scalars['Boolean'];
  UPDATE_USER: Scalars['Boolean'];
  USER_STATUS_UPDATE: Scalars['Boolean'];
};

export type PermissionsByAdAccount = {
  __typename?: 'PermissionsByAdAccount';
  id: Scalars['String'];
  permissions: Permissions;
};

export type PermittedRole = {
  __typename?: 'PermittedRole';
  displayName: Scalars['String'];
  name: Scalars['UserRole'];
};

export type PlatformChartMetrics = {
  __typename?: 'PlatformChartMetrics';
  metrics: Array<PlatformReportChartMetric>;
  total: Scalars['Int'];
};

export type PlatformReportChartMetric = {
  __typename?: 'PlatformReportChartMetric';
  percentile: Scalars['Float'];
  total: Scalars['Int'];
  value: Scalars['String'];
};

export const PlatformTarget = {
  Desktop: 'DESKTOP',
  LivingRoom: 'LIVING_ROOM',
  Mobile: 'MOBILE',
} as const;

export type PlatformTarget = (typeof PlatformTarget)[keyof typeof PlatformTarget];
export const PrepaymentStatus = {
  Paid: 'PAID',
  PendingPayment: 'PENDING_PAYMENT',
} as const;

export type PrepaymentStatus = (typeof PrepaymentStatus)[keyof typeof PrepaymentStatus];
export type Preset = {
  __typename?: 'Preset';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PresignedUrl = {
  __typename?: 'PresignedUrl';
  key: Scalars['String'];
  url: Scalars['String'];
};

export const Publisher = {
  DisneyPlus: 'DISNEY_PLUS',
  DisneyStreaming: 'DISNEY_STREAMING',
  Espn: 'ESPN',
  Hulu: 'HULU',
  Sports: 'SPORTS',
} as const;

export type Publisher = (typeof Publisher)[keyof typeof Publisher];
export type PublisherType = {
  __typename?: 'PublisherType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  systemName: Scalars['String'];
};

export type QCheckVast = VastInterface & {
  __typename?: 'QCheckVast';
  id: Scalars['ID'];
  isValid: Scalars['Boolean'];
  rejectionReasons: Maybe<Array<Scalars['String']>>;
  results: Array<Maybe<VastItem>>;
};

export type Query = {
  __typename?: 'Query';
  adAccount: AdAccount;
  adAccountAudiences: AdAccountAudienceTargetValuePages;
  adAccountNotificationOptions: AdAccountNotificationOptionsType;
  adAccountWithExtraData: AdAccount;
  adAccountsByBrand: Array<Maybe<AdAccount>>;
  adAccountsById: Array<AdAccount>;
  adAccountsByOrganization: Array<AdAccount>;
  adAccountsByUser: AdAccountsPages;
  allAdAccounts: AdAccountsPages;
  allAdAccountsOptions: AdAccountsOptionsPages;
  allAdAccountsOptionsWithNotificationTypes: AdAccountsOptionsWithNotificationTypesPages;
  assetDetails: AssetDetails;
  assetLibrarySearch: AssetLibrarySearchPayloadPage;
  baymaxOrganizations: Array<Organization>;
  billingContacts: BillingContactsPage;
  campaignCount: Campaign;
  checkCpmValuesInLineItems: Array<Maybe<LineItemWithDifferentCpm>>;
  checkIfMatureContentIsAllowed: Maybe<Scalars['Boolean']>;
  checkIfZipCodesAreAllowed: Maybe<Scalars['Boolean']>;
  creative: AdInfo;
  creativeDetails: CreativeDetails;
  creativeLibrarySearch: CreativeLibrarySearchPayloadPage;
  customAudienceById: CustomAudienceById;
  customAudienceTypes: Array<AdAccountAudienceTargetType>;
  downloadPerformanceReports: Maybe<Scalars['String']>;
  exportCampaignsSummary: Scalars['String'];
  exportUsersSummary: Scalars['String'];
  featureFlags: FeatureFlagsResponse;
  getActiveUsersStatistics: ActiveUsersStatistics;
  getAdAccountAndOrganizationStatuses: AdAccountAndOrganizationStatuses;
  getAdAccountIdsByCampaigns: Array<Scalars['ID']>;
  getAdSelectorBrands: BrandsPage;
  getAdvertisersByOrgId: Advertisers;
  getAgeTargetings: Array<TargetValue>;
  getAllAdAccountsByOrgId: AdAccountsPages;
  getAllCampaignsReportById: AllCampaignsReport;
  getAudienceTypes: Maybe<Array<AudienceTypes>>;
  getAudiences: Array<Audiences>;
  getAudiencesChartMetrics: Array<AudiencesChartMetrics>;
  getBrandById: Brand;
  /** queries by pages */
  getBrandDetailsById: BrandDetails;
  getBrandsByOrgId: BrandsPage;
  getBroadcast: Broadcast;
  getBroadcasters: BroadcastersList;
  getBroadcastsList: BroadcastPage;
  getBrunoDetailedDataReportById: BrunoDetailedReportReport;
  getBrunoDetailedReports: BrunoDetailedReportsPage;
  getBrunoDownloadLink: Scalars['String'];
  /**
   * We use getBrunoReportById endpoint for 2 type of reports: Line Items Without Ads and Line Items Drafts as they do not have any filters values.
   * Please create separate queries if they will have them and remove getBrunoReportById
   */
  getBrunoReportById: BrunoReportInfo;
  getBrunoReportTemplates: Array<BrunoReportTemplatesResponse>;
  getBrunoReportTypeById: GetBrunoReportTypeByIdResponse;
  getBrunoReports: BrunoReportsPage;
  getCampaignByUUID: CampaignInfo;
  getCampaignByUUIDWithRevision: CampaignInfo;
  getCampaignOptions: CampaignsOptions;
  getCampaignReviewSummaryReport: Maybe<Scalars['String']>;
  getCampaigns: CampaignsPage;
  getCampaignsNamesAndIds: CampaignsShortInfoPage;
  getCampaignsStatistics: CampaignsStatistics;
  getCampaignsWithExtraData: CampaignsPageWithExtraData;
  getContentTargetings: Array<TargetValue>;
  getCreativeLibrariesBrands: Array<Brand>;
  getCreativeLibrary: OrgCreativeLibrary;
  getCreativeVast: CreativeVast;
  getCreativesByOrgId: AdsList;
  getCuratedAudienceUsageReportById: CuratedAudienceUsageReport;
  getDeliveryPerformanceReportById: DeliveryPerformanceReport;
  getDimensionValues: DimensionValuePages;
  getGenreChartMetrics: Array<GenreChartMetrics>;
  getInventoryDetail: InventoryDetail;
  getInvoiceByInvoiceExtId: InvoiceWithLastTransaction;
  getInvoicesFilters: InvoicesFilters;
  getLateLines: LateLinesPage;
  getLineItemsByCampaignId: Maybe<Array<LineItem>>;
  getLineItemsByCampaignIdV2: Array<LineItemByCampaignIdV2>;
  getLocationTargetings: Array<TargetValue>;
  getLocationsTableMetrics: Array<LocationsTableMetricsResult>;
  getMetricsStatus: MetricsStatus;
  getMinimalBudgetToReserveKERVLineItem: KervMinimalBudget;
  getNotificationsByUser: NotificationPage;
  getOrganizationDetails: OrganizationDetails;
  getOrganizationStatistic: OrganizationStatistics;
  getOrganizationsByUser: Maybe<Array<Organization>>;
  getPackageById: PackageFullInfo;
  getPackages: Array<Package>;
  getPackagesByLineItemID: Array<Package>;
  getPermittedUserRoles: UserRoles;
  getPlatformChartMetrics: Array<PlatformChartMetrics>;
  getPlatformTargetings: Array<TargetValue>;
  getPresetList: Maybe<Array<Preset>>;
  getPublisherTypes: Array<PublisherType>;
  getReachFrequencyReport: ReachFrequencyReport;
  getReachFrequencyReportMetrics: ReachFrequencyReportMetricsPage;
  getReport: ReportItemMetrics;
  getReportById: DeprecatedReport;
  getReportSecondaryUsersList: Array<GetReportSecondaryUsersList>;
  getReportStatistics: ReportStatistics;
  getRequirementsForAdFormat: Maybe<Array<AdFormatConfig>>;
  getRetargetings: Array<TargetValue>;
  getRoleClaims: UserRoleClaims;
  getSellers: SearchUsersPage;
  getStandardDeliveryDeviceHigherCategoryReport: StandardDeliveryDeviceHigherCategoryReport;
  getStandardDeliveryDeviceHigherCategoryReportMetrics: StandardDeliveryDeviceHigherCategoryReportMetricsPage;
  getStandardDeliveryReport: StandardDeliveryReport;
  getStandardDeliveryReportMetrics: StandardDeliveryReportMetricsPage;
  getSubmittedByList: Array<Maybe<SubmittedBy>>;
  getThresholdAmountByOrgId: Threshold;
  getThresholdList: Array<ThresholdLevel>;
  getTimezones: Array<Timezone>;
  getTopLineGenreDeliveryReport: TopLineGenreDeliveryReport;
  getTopLineGenreDeliveryReportMetrics: TopLineGenreDeliveryReportMetricsPage;
  getTotalImpressionChartMetrics: Array<TotalImpressionsChartMetrics>;
  getTransactionHistory: TransactionHistoryPage;
  getTransactionsFilters: TransactionsFilters;
  getUserById: User;
  getUserByOrgId: Maybe<Array<SearchUser>>;
  getUsers: SearchUsersPage;
  getUsersByAdAccount: Maybe<Array<User>>;
  getUsersByOrgIdOrAdAccountId: SearchUsersPage;
  getZipCodes: Array<TargetValue>;
  hamIndustries: Array<Industry>;
  industries: Array<Industry>;
  invoices: InvoicePage;
  lineItemById: LineItem;
  lineItemByIdWithRevisions: Maybe<Array<LineItem>>;
  lineItemEditCurrentState: LineItemStateSnapshot;
  lineItemEditValidationRole: EditValidationRoleResponse;
  lineItemEstimatedCost: LineItemEstimatedCost;
  loggedInUserByOrganization: User;
  myPermissions: UserPermissions;
  organization: Organization;
  organizationsByUser: Array<Organization>;
  paymentMethodByPaymentId: PaymentMethod;
  paymentMethods: PaymentsList;
  qCheckVast: QCheckVast;
  reportCsv: ReportLink;
  reportInfoMetrics: InfoMetrics;
  reportList: ReportListMetrics;
  resendUserInvite: UserInvitation;
  resendUserInviteWithReCAPTCHAValidation: UserInvitationWithReCaptchaValidation;
  searchOrganizations: OrganizationsList;
  searchOrganizationsFilter: OrganizationsList;
  searchUser: Array<Maybe<SearchUser>>;
  searchUsers: SearchUsersPage;
  searchUsersByAdAccountId: SearchUsersPage;
  template: Template;
  templatesWithReports: Array<TemplateWithReport>;
  userOrganizationInfo: User;
  validateLineItemEdit: LineItemEditValidationResponse;
};

export type QueryAdAccountArgs = {
  accountId: Scalars['ID'];
};

export type QueryAdAccountAudiencesArgs = {
  adAccountId: Scalars['ID'];
  filterOptions?: InputMaybe<AdAccountAudiencesFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<AdAccountAudienceSortOptions>;
};

export type QueryAdAccountNotificationOptionsArgs = {
  adAccountId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type QueryAdAccountWithExtraDataArgs = {
  accountId: Scalars['ID'];
};

export type QueryAdAccountsByBrandArgs = {
  brandId: Scalars['ID'];
};

export type QueryAdAccountsByIdArgs = {
  input: AdAccountsId;
};

export type QueryAdAccountsByOrganizationArgs = {
  organizationId: Scalars['ID'];
};

export type QueryAdAccountsByUserArgs = {
  paginationOptions?: InputMaybe<PaginationOptions>;
  userId: Scalars['ID'];
};

export type QueryAllAdAccountsArgs = {
  filterOptions?: InputMaybe<AdAccountFilterOptions>;
  includePaymentInfo: Scalars['Boolean'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<AdAccountSortOptions>;
};

export type QueryAllAdAccountsOptionsArgs = {
  billingContactUserId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  paginationOptions?: InputMaybe<PaginationOptions>;
};

export type QueryAllAdAccountsOptionsWithNotificationTypesArgs = {
  name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<AdAccountSortOptions>;
  userId: Scalars['ID'];
};

export type QueryAssetDetailsArgs = {
  assetId: Scalars['ID'];
  orgId: Scalars['ID'];
};

export type QueryAssetLibrarySearchArgs = {
  input: AssetLibrarySearchInput;
};

export type QueryBillingContactsArgs = {
  input: BillingContactInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
};

export type QueryCampaignCountArgs = {
  input: CampaignInput;
};

export type QueryCheckCpmValuesInLineItemsArgs = {
  id: Scalars['ID'];
  lineItemList?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryCheckIfMatureContentIsAllowedArgs = {
  lineItemId: Scalars['ID'];
};

export type QueryCheckIfZipCodesAreAllowedArgs = {
  lineItemId: Scalars['ID'];
};

export type QueryCreativeArgs = {
  id: Scalars['ID'];
  includeUserData?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCreativeDetailsArgs = {
  id: Scalars['ID'];
};

export type QueryCreativeLibrarySearchArgs = {
  input: CreativeLibrarySearchInput;
};

export type QueryCustomAudienceByIdArgs = {
  customAudienceId: Scalars['ID'];
};

export type QueryDownloadPerformanceReportsArgs = {
  campaignId: Scalars['ID'];
  dimensionList: Array<InputMaybe<Dimensions>>;
  lineItems: Array<Scalars['String']>;
};

export type QueryExportCampaignsSummaryArgs = {
  filterOptions?: InputMaybe<CampaignsExportFilterOptions>;
};

export type QueryExportUsersSummaryArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  loginActivity?: InputMaybe<LoginActivity>;
  organizationId?: InputMaybe<Scalars['ID']>;
  sellerId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type QueryFeatureFlagsArgs = {
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type QueryGetActiveUsersStatisticsArgs = {
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  hamIndustryName?: InputMaybe<Scalars['String']>;
  loginActivity?: InputMaybe<LoginActivity>;
  organizationId?: InputMaybe<Scalars['ID']>;
  sellerId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type QueryGetAdAccountAndOrganizationStatusesArgs = {
  adAccountId: Scalars['ID'];
  orgId: Scalars['ID'];
};

export type QueryGetAdAccountIdsByCampaignsArgs = {
  campaignIds: Array<Scalars['ID']>;
};

export type QueryGetAdSelectorBrandsArgs = {
  filterOptions?: InputMaybe<AdSelectorBrandsFilterOptions>;
  orgId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
};

export type QueryGetAdvertisersByOrgIdArgs = {
  accessTypes?: InputMaybe<Array<Scalars['String']>>;
  orgId: Scalars['ID'];
};

export type QueryGetAgeTargetingsArgs = {
  lineItemId: Scalars['ID'];
};

export type QueryGetAllAdAccountsByOrgIdArgs = {
  organizationId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
};

export type QueryGetAllCampaignsReportByIdArgs = {
  canReadAdAccount?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type QueryGetAudiencesArgs = {
  lineItemId: Scalars['ID'];
};

export type QueryGetAudiencesChartMetricsArgs = {
  campaignId: Scalars['ID'];
  lineItems: Array<Scalars['String']>;
};

export type QueryGetBrandByIdArgs = {
  id: Scalars['ID'];
};

export type QueryGetBrandDetailsByIdArgs = {
  brandId: Scalars['ID'];
};

export type QueryGetBrandsByOrgIdArgs = {
  filterOptions?: InputMaybe<BrandsFilterOptions>;
  orgId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<BrandsSortOptions>;
};

export type QueryGetBroadcastArgs = {
  broadcastId: Scalars['ID'];
};

export type QueryGetBroadcastersArgs = {
  filterOptions?: InputMaybe<BroadcasterFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
};

export type QueryGetBroadcastsListArgs = {
  filterOptions?: InputMaybe<BroadcastFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<BroadcastsSortOptions>;
};

export type QueryGetBrunoDetailedDataReportByIdArgs = {
  id: Scalars['ID'];
  permissions?: InputMaybe<BrunoDetailedReportPermissions>;
};

export type QueryGetBrunoDetailedReportsArgs = {
  filterOptions?: InputMaybe<BrunoReportsFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type QueryGetBrunoDownloadLinkArgs = {
  id: Scalars['ID'];
};

export type QueryGetBrunoReportByIdArgs = {
  id: Scalars['ID'];
};

export type QueryGetBrunoReportTypeByIdArgs = {
  id: Scalars['ID'];
};

export type QueryGetBrunoReportsArgs = {
  filterOptions?: InputMaybe<BrunoReportsFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<ReportStrictSortOptions>;
};

export type QueryGetCampaignByUuidArgs = {
  campaignId: Scalars['ID'];
  lineItemList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryGetCampaignByUuidWithRevisionArgs = {
  campaignId: Scalars['ID'];
  lineItemList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revisionType?: InputMaybe<Scalars['String']>;
};

export type QueryGetCampaignOptionsArgs = {
  adAccountId?: InputMaybe<Scalars['String']>;
  hasDeliveryImpressions?: InputMaybe<Scalars['Boolean']>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  searchField?: InputMaybe<Scalars['String']>;
};

export type QueryGetCampaignReviewSummaryReportArgs = {
  exportFormat: ExportFormat;
  filterOptions: CampaignReviewSummaryReportInput;
  sortOptions: SortOptions;
};

export type QueryGetCampaignsArgs = {
  filterOptions?: InputMaybe<CampaignsFilterOptions>;
  includeTargetAllowed?: InputMaybe<Scalars['Boolean']>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<CampaignsSortOptions>;
};

export type QueryGetCampaignsNamesAndIdsArgs = {
  adAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  schedule?: InputMaybe<CampaignSearchScheduleInput>;
  search?: InputMaybe<Scalars['String']>;
};

export type QueryGetCampaignsStatisticsArgs = {
  endDate: Scalars['String'];
  hamIndustryName?: InputMaybe<Scalars['String']>;
  organizationCrmLinkType?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  packageId?: InputMaybe<Scalars['ID']>;
  sellerId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['String'];
};

export type QueryGetCampaignsWithExtraDataArgs = {
  filterOptions?: InputMaybe<CampaignsFilterOptionsWithExtraData>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<CampaignsStrictSortOptions>;
};

export type QueryGetContentTargetingsArgs = {
  lineItemId: Scalars['ID'];
};

export type QueryGetCreativeLibrariesBrandsArgs = {
  orgId: Scalars['ID'];
};

export type QueryGetCreativeLibraryArgs = {
  orgId: Scalars['ID'];
};

export type QueryGetCreativeVastArgs = {
  id: Scalars['ID'];
};

export type QueryGetCreativesByOrgIdArgs = {
  filterOptions?: InputMaybe<AdFilterOptions>;
  includeUserData?: InputMaybe<Scalars['Boolean']>;
  orgId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<AdSortOptions>;
};

export type QueryGetCuratedAudienceUsageReportByIdArgs = {
  id: Scalars['ID'];
};

export type QueryGetDeliveryPerformanceReportByIdArgs = {
  canReadCampaigns: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type QueryGetDimensionValuesArgs = {
  filterData: InputDimensionValueFilter;
  targetTypeId: Scalars['ID'];
};

export type QueryGetGenreChartMetricsArgs = {
  campaignId: Scalars['ID'];
  lineItems: Array<Scalars['String']>;
};

export type QueryGetInventoryDetailArgs = {
  input?: InputMaybe<InventoryDetailInput>;
};

export type QueryGetInvoiceByInvoiceExtIdArgs = {
  id: Scalars['String'];
};

export type QueryGetInvoicesFiltersArgs = {
  adAccountId?: InputMaybe<Scalars['ID']>;
  orgId?: InputMaybe<Scalars['ID']>;
};

export type QueryGetLateLinesArgs = {
  advertiserId: Scalars['ID'];
  filterOptions?: InputMaybe<LateLinesFilterInput>;
  orgId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type QueryGetLineItemsByCampaignIdArgs = {
  filterOptions?: InputMaybe<LineItemsByCampaignIdFilterOptions>;
  id: Scalars['ID'];
};

export type QueryGetLineItemsByCampaignIdV2Args = {
  filterOptions?: InputMaybe<LineItemsByCampaignIdV2FilterOptions>;
  id: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationLimit>;
  sortOptions?: InputMaybe<LineItemsByCampaignV2SortOptions>;
};

export type QueryGetLocationTargetingsArgs = {
  lineItemId: Scalars['ID'];
};

export type QueryGetLocationsTableMetricsArgs = {
  campaignId: Scalars['ID'];
  lineItems: Array<Scalars['String']>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type QueryGetMetricsStatusArgs = {
  metricsStatusRequest: MetricsStatusRequest;
};

export type QueryGetMinimalBudgetToReserveKervLineItemArgs = {
  lineItemId: Scalars['ID'];
};

export type QueryGetNotificationsByUserArgs = {
  filterOptions?: InputMaybe<NotificationsFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
  userId: Scalars['ID'];
};

export type QueryGetOrganizationDetailsArgs = {
  hasPermissionsForGetSellers?: InputMaybe<Scalars['Boolean']>;
  orgId: Scalars['ID'];
};

export type QueryGetOrganizationStatisticArgs = {
  adAccountIds: Array<Scalars['ID']>;
  dateRange: DateRangeForStatistic;
  organizationId: Scalars['ID'];
};

export type QueryGetOrganizationsByUserArgs = {
  userId: Scalars['ID'];
};

export type QueryGetPackageByIdArgs = {
  packageId: Scalars['ID'];
};

export type QueryGetPackagesArgs = {
  adAccountId?: InputMaybe<Scalars['ID']>;
};

export type QueryGetPackagesByLineItemIdArgs = {
  endTime?: InputMaybe<Scalars['Date']>;
  lineItemId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export type QueryGetPermittedUserRolesArgs = {
  isForUpdate?: InputMaybe<Scalars['Boolean']>;
  orgId: Scalars['ID'];
};

export type QueryGetPlatformChartMetricsArgs = {
  campaignId: Scalars['ID'];
  lineItems: Array<Scalars['String']>;
};

export type QueryGetPlatformTargetingsArgs = {
  lineItemId: Scalars['ID'];
};

export type QueryGetPresetListArgs = {
  idList?: InputMaybe<Scalars['ID']>;
};

export type QueryGetReachFrequencyReportArgs = {
  id: Scalars['ID'];
};

export type QueryGetReachFrequencyReportMetricsArgs = {
  filterOptions: ReachFrequencyReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  metricsOptions: MetricsInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type QueryGetReportArgs = {
  id: Scalars['ID'];
};

export type QueryGetReportByIdArgs = {
  id: Scalars['ID'];
};

export type QueryGetReportSecondaryUsersListArgs = {
  adAccountIds: Array<Scalars['ID']>;
  excludeSellers?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};

export type QueryGetReportStatisticsArgs = {
  campaignIds: Array<Scalars['ID']>;
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type QueryGetRetargetingsArgs = {
  lineItemId: Scalars['ID'];
};

export type QueryGetRoleClaimsArgs = {
  userId: Scalars['ID'];
};

export type QueryGetSellersArgs = {
  filterOptions?: InputMaybe<SellersFilterOptions>;
  includeOrganizations: Scalars['Boolean'];
  orgId?: InputMaybe<Scalars['ID']>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SellersSortOptions>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type QueryGetStandardDeliveryDeviceHigherCategoryReportArgs = {
  id: Scalars['ID'];
};

export type QueryGetStandardDeliveryDeviceHigherCategoryReportMetricsArgs = {
  filterOptions: StandardDeliveryDeviceHigherCategoryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  metricsOptions: MetricsInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type QueryGetStandardDeliveryReportArgs = {
  id: Scalars['ID'];
};

export type QueryGetStandardDeliveryReportMetricsArgs = {
  filterOptions: StandardDeliveryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  metricsOptions: MetricsInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type QueryGetSubmittedByListArgs = {
  id: Scalars['ID'];
};

export type QueryGetThresholdAmountByOrgIdArgs = {
  id: Scalars['ID'];
};

export type QueryGetTopLineGenreDeliveryReportArgs = {
  id: Scalars['ID'];
};

export type QueryGetTopLineGenreDeliveryReportMetricsArgs = {
  filterOptions: TopLineGenreDeliveryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
  metricsOptions: MetricsInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortOptions?: InputMaybe<SortOptions>;
};

export type QueryGetTotalImpressionChartMetricsArgs = {
  campaignId: Scalars['ID'];
  lineItems: Array<Scalars['String']>;
};

export type QueryGetTransactionHistoryArgs = {
  filterInput?: InputMaybe<TransactionHistoryFilter>;
  orgId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<TransactionSortOptions>;
};

export type QueryGetTransactionsFiltersArgs = {
  orgId: Scalars['ID'];
};

export type QueryGetUserByIdArgs = {
  userId: Scalars['ID'];
};

export type QueryGetUserByOrgIdArgs = {
  isUserNonDeletable?: InputMaybe<Scalars['Boolean']>;
  orgId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type QueryGetUsersArgs = {
  idList?: InputMaybe<Array<Scalars['ID']>>;
  orgId?: InputMaybe<Scalars['ID']>;
  paginationOptions?: InputMaybe<PaginationOptions>;
};

export type QueryGetUsersByAdAccountArgs = {
  adAccountId: Scalars['ID'];
};

export type QueryGetUsersByOrgIdOrAdAccountIdArgs = {
  currentId: Scalars['ID'];
  filterOptions?: InputMaybe<UsersFilterOptions>;
  includeOrganizations: Scalars['Boolean'];
  isOrg: Scalars['Boolean'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<UsersSortOptions>;
};

export type QueryGetZipCodesArgs = {
  lineItemId: Scalars['ID'];
  zipCodes: Array<Scalars['String']>;
};

export type QueryInvoicesArgs = {
  filterInput: InvoiceSearchInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<InvoiceSortOptions>;
  source?: InputMaybe<InvoicesSource>;
};

export type QueryLineItemByIdArgs = {
  adAccountId?: InputMaybe<Scalars['ID']>;
  includeAssets?: InputMaybe<Scalars['Boolean']>;
  lastMajor?: InputMaybe<Scalars['Boolean']>;
  lineItemId: Scalars['ID'];
  shouldValidate?: InputMaybe<Scalars['Boolean']>;
};

export type QueryLineItemByIdWithRevisionsArgs = {
  lineItemId: Scalars['ID'];
};

export type QueryLineItemEditCurrentStateArgs = {
  lineItemUuid: Scalars['ID'];
};

export type QueryLineItemEstimatedCostArgs = {
  input: LineItemEstimatedCostInput;
};

export type QueryLoggedInUserByOrganizationArgs = {
  orgId: Scalars['ID'];
};

export type QueryMyPermissionsArgs = {
  isGhostMode?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};

export type QueryPaymentMethodByPaymentIdArgs = {
  id: Scalars['ID'];
};

export type QueryPaymentMethodsArgs = {
  filterOptions?: InputMaybe<PaymentFilterOptions>;
  orgId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<PaymentMethodSortOptions>;
};

export type QueryQCheckVastArgs = {
  reIngest?: InputMaybe<Scalars['Boolean']>;
  vastId: Scalars['ID'];
};

export type QueryReportCsvArgs = {
  input: ReportRequest;
};

export type QueryReportInfoMetricsArgs = {
  input: ReportRequest;
};

export type QueryReportListArgs = {
  adAccountId: Scalars['ID'];
  filterOptions?: InputMaybe<ReportFilterOptions>;
  paginationOptions?: InputMaybe<ReportPaginationOptions>;
  sortOptions?: InputMaybe<ReportSortOptions>;
};

export type QueryResendUserInviteArgs = {
  email: Scalars['String'];
};

export type QueryResendUserInviteWithReCaptchaValidationArgs = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export type QuerySearchOrganizationsArgs = {
  filterOptions?: InputMaybe<OrganizationFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<OrganizationSortOptions>;
};

export type QuerySearchOrganizationsFilterArgs = {
  filterOptions?: InputMaybe<OrganizationFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<OrganizationSortOptions>;
};

export type QuerySearchUserArgs = {
  userId: Scalars['ID'];
};

export type QuerySearchUsersArgs = {
  filterOptions?: InputMaybe<UsersFilterOptions>;
  paginationOptions: PaginationOptions;
  sortOptions?: InputMaybe<AllUsersStrictSortOptions>;
};

export type QuerySearchUsersByAdAccountIdArgs = {
  adAccountId: Scalars['ID'];
  filterOptions?: InputMaybe<UsersByAdAccountFilterOptions>;
  paginationOptions: PaginationOptions;
  sortOptions?: InputMaybe<UsersSortOptions>;
};

export type QueryTemplateArgs = {
  id: Scalars['ID'];
};

export type QueryTemplatesWithReportsArgs = {
  advertiserId?: InputMaybe<Scalars['String']>;
  orgId: Scalars['ID'];
};

export type QueryUserOrganizationInfoArgs = {
  orgId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type QueryValidateLineItemEditArgs = {
  input: LineItemEditInput;
};

export type ReCaptchaResponse = {
  __typename?: 'ReCAPTCHAResponse';
  challengeTs: Maybe<Scalars['Date']>;
  errorMessages: Maybe<Array<Scalars['String']>>;
  hostname: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ReachFrequencyReport = BaseReport & {
  __typename?: 'ReachFrequencyReport';
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: ReachFrequencyReportFilters;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type ReachFrequencyReportFileUrlInput = {
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: ReachFrequencyReportFiltersInput;
  startDate?: InputMaybe<Scalars['String']>;
  templateId: Scalars['ID'];
};

export type ReachFrequencyReportFilters = {
  __typename?: 'ReachFrequencyReportFilters';
  adProduct: Maybe<Array<AdProduct>>;
  campaignIds: Array<Scalars['String']>;
  campaigns: Maybe<Array<CampaignShortInfo>>;
  cpm: Maybe<MinMaxNumberValues>;
  deliveryGoal: Maybe<MinMaxNumberValues>;
  endDate: Maybe<MinMaxStringValues>;
  estimatedAdFrequency: Maybe<MinMaxNumberValues>;
  estimatedUniqueDevices: Maybe<MinMaxNumberValues>;
  netCompletions: Maybe<MinMaxNumberValues>;
  organizationId: Scalars['String'];
  publisher: Maybe<Array<Publisher>>;
  revenue: Maybe<MinMaxNumberValues>;
  startDate: Maybe<MinMaxStringValues>;
};

export type ReachFrequencyReportFiltersInput = {
  adProduct?: InputMaybe<Array<AdProduct>>;
  advertiserId?: InputMaybe<Scalars['String']>;
  campaignIds: Array<Scalars['String']>;
  cpm?: InputMaybe<MinMaxNumberValuesInput>;
  deliveryGoal?: InputMaybe<MinMaxNumberValuesInput>;
  endDate?: InputMaybe<MinMaxStringValuesInput>;
  estimatedAdFrequency?: InputMaybe<MinMaxNumberValuesInput>;
  estimatedUniqueDevices?: InputMaybe<MinMaxNumberValuesInput>;
  netCompletions?: InputMaybe<MinMaxNumberValuesInput>;
  organizationId: Scalars['String'];
  publisher?: InputMaybe<Array<Publisher>>;
  revenue?: InputMaybe<MinMaxNumberValuesInput>;
  startDate?: InputMaybe<MinMaxStringValuesInput>;
};

export type ReachFrequencyReportLineItem = {
  __typename?: 'ReachFrequencyReportLineItem';
  adProduct: Maybe<AdProduct>;
  cpm: Maybe<Scalars['Float']>;
  deliveryGoal: Maybe<Scalars['Float']>;
  endDate: Maybe<Scalars['String']>;
  estimatedAdFrequency: Maybe<Scalars['Float']>;
  estimatedUniqueDevices: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  netCompletions: Maybe<Scalars['Float']>;
  publisher: Maybe<Scalars['String']>;
  revenue: Maybe<Scalars['Float']>;
  startDate: Maybe<Scalars['String']>;
};

export type ReachFrequencyReportMetrics = Node & {
  __typename?: 'ReachFrequencyReportMetrics';
  accountExecutive: Maybe<Scalars['String']>;
  accountManager: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  campaignName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItemName: Scalars['String'];
  lineItems: Array<ReachFrequencyReportLineItem>;
};

export type ReachFrequencyReportMetricsEdge = Edge & {
  __typename?: 'ReachFrequencyReportMetricsEdge';
  cursor: Scalars['String'];
  node: ReachFrequencyReportMetrics;
};

export type ReachFrequencyReportMetricsPage = Connection & {
  __typename?: 'ReachFrequencyReportMetricsPage';
  edges: Array<ReachFrequencyReportMetricsEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export const ReadOrUnread = {
  Read: 'READ',
  Unread: 'UNREAD',
} as const;

export type ReadOrUnread = (typeof ReadOrUnread)[keyof typeof ReadOrUnread];
export type RecipientInfo = {
  __typename?: 'RecipientInfo';
  excludedOrganizations: Maybe<Array<Scalars['ID']>>;
  includedOrganizations: Maybe<Array<Scalars['ID']>>;
  segment: SegmentType;
  touchPointEndDate: Maybe<Scalars['String']>;
  touchPointStartDate: Maybe<Scalars['String']>;
  touchpoint: Maybe<Touchpoint>;
  userType: Maybe<UserType>;
};

export type RecipientInfoInput = {
  excludedOrganizations?: InputMaybe<Array<Scalars['ID']>>;
  includedOrganizations?: InputMaybe<Array<Scalars['ID']>>;
  segment: SegmentType;
  touchPointEndDate?: InputMaybe<Scalars['String']>;
  touchPointStartDate?: InputMaybe<Scalars['String']>;
  touchpoint?: InputMaybe<Touchpoint>;
};

export const RecipientsTypes = {
  AffectedAdvertisers: 'AFFECTED_ADVERTISERS',
  AllAdvertisers: 'ALL_ADVERTISERS',
  SelectedOrganizations: 'SELECTED_ORGANIZATIONS',
} as const;

export type RecipientsTypes = (typeof RecipientsTypes)[keyof typeof RecipientsTypes];
export type RefundTransactionInput = {
  amount: Scalars['Float'];
  invoiceExtId: Scalars['ID'];
  transactionId: Scalars['ID'];
};

export type Report = BaseReport & {
  __typename?: 'Report';
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: ReportFilters;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type ReportFilterOptions = {
  campaignId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type ReportFilters =
  | DetailedDataReportFilters
  | ReachFrequencyReportFilters
  | StandardDeliveryDeviceHigherCategoryReportFilters
  | StandardDeliveryReportFilters
  | TopLineGenreDeliveryReportFilters;

export const ReportFiltersTypeName = {
  DetailedDataReportFilters: 'DetailedDataReportFilters',
  ReachFrequencyReportFilters: 'ReachFrequencyReportFilters',
  StandardDeliveryDeviceHigherCategoryReportFilters: 'StandardDeliveryDeviceHigherCategoryReportFilters',
  StandardDeliveryReportFilters: 'StandardDeliveryReportFilters',
  TopLineGenreDeliveryReportFilters: 'TopLineGenreDeliveryReportFilters',
} as const;

export type ReportFiltersTypeName = (typeof ReportFiltersTypeName)[keyof typeof ReportFiltersTypeName];
export type ReportInfo = {
  __typename?: 'ReportInfo';
  emailNow: Maybe<Scalars['Boolean']>;
  endDate: Maybe<Scalars['AbbreviatedDate']>;
  externalId: Scalars['ID'];
  lineItems: Maybe<Array<Maybe<Scalars['String']>>>;
  metricsTypes: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  rollUpType: Maybe<RollUpType>;
  schedule: Maybe<ReportSchedule>;
  startDate: Maybe<Scalars['AbbreviatedDate']>;
  status: Maybe<Scalars['String']>;
  userIds: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ReportInput = {
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  exportFormat: ExportFormat;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients?: InputMaybe<Array<Scalars['ID']>>;
  schedule: ReportScheduleInput;
  startDate?: InputMaybe<Scalars['String']>;
  templateId: Scalars['ID'];
};

export type ReportItemMetrics = {
  __typename?: 'ReportItemMetrics';
  campaignId: Scalars['ID'];
  emailNow: Scalars['Boolean'];
  endDate: Scalars['AbbreviatedDate'];
  externalId: Scalars['String'];
  latestReportLink: Scalars['String'];
  lineItems: Maybe<Array<Maybe<Scalars['String']>>>;
  metricsTypes: Array<Maybe<Scalars['String']>>;
  name: Scalars['String'];
  rollUpType: Maybe<Scalars['String']>;
  schedule: Maybe<ReportSchedule>;
  startDate: Scalars['AbbreviatedDate'];
  status: Scalars['String'];
  userIds: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ReportLink = {
  __typename?: 'ReportLink';
  url: Scalars['String'];
};

export type ReportListMetrics = {
  __typename?: 'ReportListMetrics';
  curPageNumber: Scalars['Int'];
  data: Reports;
  limit: Scalars['Int'];
  totalNumbers: Scalars['Int'];
  totalPageNumbers: Scalars['Int'];
};

export type ReportPaginationOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ReportPublisherStatistic = {
  __typename?: 'ReportPublisherStatistic';
  statistics: Maybe<Array<StatisticType>>;
};

export const ReportQuickAction = {
  Delete: 'delete',
  Resume: 'resume',
  Stop: 'stop',
} as const;

export type ReportQuickAction = (typeof ReportQuickAction)[keyof typeof ReportQuickAction];
export type ReportRequest = {
  ids: Array<Scalars['ID']>;
  metricsTypes: Array<MetricTypes>;
};

export type ReportSchedule = {
  __typename?: 'ReportSchedule';
  days: Maybe<Array<Day>>;
  emailAttachment: Maybe<Scalars['Boolean']>;
  emailNow: Maybe<Scalars['Boolean']>;
  frequency: Maybe<Frequency>;
};

export type ReportScheduleInput = {
  days?: InputMaybe<Array<Day>>;
  emailAttachment?: InputMaybe<Scalars['Boolean']>;
  emailNow?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Frequency>;
};

export const ReportSortBy = {
  CreatedAt: 'createdAt',
  Name: 'name',
  Status: 'status',
  TemplateName: 'templateName',
} as const;

export type ReportSortBy = (typeof ReportSortBy)[keyof typeof ReportSortBy];
export type ReportSortOptions = {
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type ReportStatistics = {
  __typename?: 'ReportStatistics';
  adProduct: Maybe<Array<StatisticType>>;
  platform: Maybe<Array<StatisticType>>;
  publisherBreakdown: Maybe<Array<StatisticType>>;
};

export const ReportStatus = {
  Complete: 'COMPLETE',
  Delayed: 'DELAYED',
  Failed: 'FAILED',
  Pending: 'PENDING',
  Ready: 'READY',
  Scheduled: 'SCHEDULED',
  Stopped: 'STOPPED',
} as const;

export type ReportStatus = (typeof ReportStatus)[keyof typeof ReportStatus];
export type ReportStatusInfo = {
  __typename?: 'ReportStatusInfo';
  id: Scalars['ID'];
  status: ReportStatus;
};

export type ReportStrictSortOptions = {
  sortBy?: InputMaybe<ReportSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type ReportTarget = {
  __typename?: 'ReportTarget';
  exclusion: Scalars['Boolean'];
  value: ReportTargetValue;
};

export type ReportTargetType = {
  __typename?: 'ReportTargetType';
  externalId: Scalars['String'];
  name: Scalars['String'];
};

export type ReportTargetValue = {
  __typename?: 'ReportTargetValue';
  deleted: Scalars['Boolean'];
  displayName: Scalars['String'];
  externalId: Scalars['String'];
  name: Scalars['String'];
  specialAdVisibility: Scalars['Boolean'];
  targetType: Maybe<ReportTargetType>;
  visible: Scalars['Boolean'];
};

export const ReportTemplateName = {
  DigitalOrder: 'DIGITAL_ORDER',
  LineItemSummary: 'LINE_ITEM_SUMMARY',
  LineItemSummaryDetailed: 'LINE_ITEM_SUMMARY_DETAILED',
} as const;

export type ReportTemplateName = (typeof ReportTemplateName)[keyof typeof ReportTemplateName];
export const ReportTemplateSystemName = {
  AllLineItems: 'ALL_LINE_ITEMS',
  CimSpend: 'CIM_SPEND',
  CuratedAudienceUsage: 'CURATED_AUDIENCE_USAGE',
  DeliveryPerformance: 'DELIVERY_PERFORMANCE',
  DetailedData: 'DETAILED_DATA',
  IfpForecastedVsDelivered: 'IFP_FORECASTED_VS_DELIVERED',
  LineItemsWithoutAds: 'LINE_ITEMS_WITHOUT_ADS',
  LineItemDrafts: 'LINE_ITEM_DRAFTS',
} as const;

export type ReportTemplateSystemName = (typeof ReportTemplateSystemName)[keyof typeof ReportTemplateSystemName];
export type Reports = {
  __typename?: 'Reports';
  reports: Array<ReportItemMetrics>;
};

export type ReportsChartInput = {
  campaignId: Scalars['ID'];
  dimensions?: InputMaybe<Array<Dimensions>>;
  groupBy?: InputMaybe<Dimensions>;
  includeDetailedDimensions?: InputMaybe<Scalars['Boolean']>;
  lineItems: Array<Scalars['String']>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  rollUpType: RollUpType;
  sortOptions?: InputMaybe<SortOptions>;
};

export type ReserveKervResponse = {
  __typename?: 'ReserveKERVResponse';
  creativeLibraryId: Scalars['String'];
  creativeType: Scalars['String'];
  deletable: Scalars['Boolean'];
  id: Scalars['String'];
  status: Scalars['String'];
};

export type RetryPaymentMethod = {
  __typename?: 'RetryPaymentMethod';
  adAccountId: Scalars['ID'];
  billedAmount: Scalars['Int'];
  campaigns: Array<Campaigns>;
  chargedAmount: Scalars['Int'];
  declineReason: Maybe<Scalars['String']>;
  errorCode: Maybe<Scalars['String']>;
  failedCount: Maybe<Scalars['Int']>;
  invoiceExternalId: Scalars['String'];
  invoicePaymentStatus: Scalars['String'];
  remainingBalance: Scalars['Int'];
  transactionId: Scalars['Int'];
  transactionStatus: Scalars['String'];
};

export const RevisionType = {
  Major: 'MAJOR',
  MajorOnly: 'MAJOR_ONLY',
  Minor: 'MINOR',
} as const;

export type RevisionType = (typeof RevisionType)[keyof typeof RevisionType];
export type Roles = {
  entityId: Scalars['String'];
  entityType: EntityType;
  role: Scalars['UserRole'];
};

export type RolesV4 = {
  __typename?: 'RolesV4';
  entityId: Scalars['String'];
  entityType: EntityType;
};

export const RollUpType = {
  All: 'ALL',
  Daily: 'DAILY',
} as const;

export type RollUpType = (typeof RollUpType)[keyof typeof RollUpType];
export type RuleViolation = {
  __typename?: 'RuleViolation';
  field: Maybe<Scalars['String']>;
  message: Scalars['String'];
  ruleCode: RuleViolationCode;
};

export const RuleViolationCode = {
  AdvertiserBudgetIncreaseNotAllowed: 'ADVERTISER_BUDGET_INCREASE_NOT_ALLOWED',
  AdvertiserFieldNotEditable: 'ADVERTISER_FIELD_NOT_EDITABLE',
  AudienceOnePCannotBeFullyRemoved: 'AUDIENCE_ONE_P_CANNOT_BE_FULLY_REMOVED',
  AudienceThreePCannotBeFullyRemoved: 'AUDIENCE_THREE_P_CANNOT_BE_FULLY_REMOVED',
  CurrentStateStale: 'CURRENT_STATE_STALE',
  DemoTargetingCannotBeFullyRemoved: 'DEMO_TARGETING_CANNOT_BE_FULLY_REMOVED',
  GenreCannotBeAddedWhenOriginallyAbsent: 'GENRE_CANNOT_BE_ADDED_WHEN_ORIGINALLY_ABSENT',
  GenreCannotBeFullyRemoved: 'GENRE_CANNOT_BE_FULLY_REMOVED',
  GeoTargetingCannotBeFullyRemoved: 'GEO_TARGETING_CANNOT_BE_FULLY_REMOVED',
  LineItemNotInEditableSubmittedState: 'LINE_ITEM_NOT_IN_EDITABLE_SUBMITTED_STATE',
  LowInventoryFieldNotEditable: 'LOW_INVENTORY_FIELD_NOT_EDITABLE',
  PlatformCannotBeFullyRemoved: 'PLATFORM_CANNOT_BE_FULLY_REMOVED',
  PlatformLivingRoomCannotBeAdded: 'PLATFORM_LIVING_ROOM_CANNOT_BE_ADDED',
  PlatformLivingRoomCannotBeRemoved: 'PLATFORM_LIVING_ROOM_CANNOT_BE_REMOVED',
  PrepaidBudgetChangeNotAllowed: 'PREPAID_BUDGET_CHANGE_NOT_ALLOWED',
  PrepaidEndTimeChangeNotAllowed: 'PREPAID_END_TIME_CHANGE_NOT_ALLOWED',
  PrepaidNameChangeNotAllowed: 'PREPAID_NAME_CHANGE_NOT_ALLOWED',
  PrepaidStartTimeChangeNotAllowed: 'PREPAID_START_TIME_CHANGE_NOT_ALLOWED',
  PriceOverrideFieldNotEditable: 'PRICE_OVERRIDE_FIELD_NOT_EDITABLE',
} as const;

export type RuleViolationCode = (typeof RuleViolationCode)[keyof typeof RuleViolationCode];
export type ScheduleDateInput = {
  day: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type SearchUser = Node & {
  __typename?: 'SearchUser';
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  deletable: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastLoginAt: Maybe<Scalars['AbbreviatedDate']>;
  lastName: Maybe<Scalars['String']>;
  organizations: Maybe<Array<UserOrganization>>;
  organizationsCount: Maybe<Scalars['Int']>;
  phone: Maybe<Scalars['String']>;
  role: Maybe<Scalars['UserSearchRole']>;
  status: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['AbbreviatedDate']>;
};

export type SearchUserEdge = Edge & {
  __typename?: 'SearchUserEdge';
  cursor: Scalars['String'];
  node: SearchUser;
};

export type SearchUsersPage = Connection & {
  __typename?: 'SearchUsersPage';
  edges: Array<SearchUserEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export const SegmentType = {
  AffectedOrganizations: 'AFFECTED_ORGANIZATIONS',
  Custom: 'CUSTOM',
} as const;

export type SegmentType = (typeof SegmentType)[keyof typeof SegmentType];
export type SellerEditInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  roleList: Array<Roles>;
};

export type SellerInviteInput = {
  email: Scalars['String'];
  organisationList: Array<Scalars['String']>;
};

export const SellerSortBy = {
  Created: 'created',
  Email: 'email',
  FirstName: 'firstName',
  LastLoginAt: 'lastLoginAt',
  OrganizationCount: 'organizationCount',
} as const;

export type SellerSortBy = (typeof SellerSortBy)[keyof typeof SellerSortBy];
export type SellersFilterOptions = {
  email?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
};

export type SellersSortOptions = {
  sortBy?: InputMaybe<Array<SellerSortBy>>;
  sortOrder?: InputMaybe<OrderOption>;
};

export const SendingType = {
  SendImmediately: 'SEND_IMMEDIATELY',
  SendLater: 'SEND_LATER',
  SendRepeating: 'SEND_REPEATING',
} as const;

export type SendingType = (typeof SendingType)[keyof typeof SendingType];
export type SharedStandardDeliveryReportFilters = {
  adProduct: Maybe<Array<AdProduct>>;
  campaignIds: Array<Scalars['String']>;
  campaigns: Maybe<Array<CampaignShortInfo>>;
  cpm: Maybe<MinMaxNumberValues>;
  endDate: Maybe<MinMaxStringValues>;
  organizationId: Scalars['String'];
  publisher: Maybe<Array<Publisher>>;
  revenue: Maybe<MinMaxNumberValues>;
  startDate: Maybe<MinMaxStringValues>;
};

export type ShortTransactionData = {
  __typename?: 'ShortTransactionData';
  amount: Scalars['Currency'];
  status: Scalars['String'];
  transactionDate: Scalars['EasternTimeZoneDate'];
};

export type SortOptions = {
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type StandardDeliveryDeviceHigherCategoryReport = BaseReport & {
  __typename?: 'StandardDeliveryDeviceHigherCategoryReport';
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: StandardDeliveryDeviceHigherCategoryReportFilters;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type StandardDeliveryDeviceHigherCategoryReportFileUrlInput = {
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: StandardDeliveryDeviceHigherCategoryReportFiltersInput;
  startDate?: InputMaybe<Scalars['String']>;
  templateId: Scalars['ID'];
};

export type StandardDeliveryDeviceHigherCategoryReportFilters = SharedStandardDeliveryReportFilters & {
  __typename?: 'StandardDeliveryDeviceHigherCategoryReportFilters';
  adProduct: Maybe<Array<AdProduct>>;
  campaignIds: Array<Scalars['String']>;
  campaigns: Maybe<Array<CampaignShortInfo>>;
  cpm: Maybe<MinMaxNumberValues>;
  deliveryGoal: Maybe<MinMaxNumberValues>;
  endDate: Maybe<MinMaxStringValues>;
  lifetimeCompletions: Maybe<MinMaxNumberValues>;
  organizationId: Scalars['String'];
  publisher: Maybe<Array<Publisher>>;
  revenue: Maybe<MinMaxNumberValues>;
  startDate: Maybe<MinMaxStringValues>;
};

export type StandardDeliveryDeviceHigherCategoryReportFiltersInput = {
  adProduct?: InputMaybe<Array<AdProduct>>;
  advertiserId?: InputMaybe<Scalars['String']>;
  campaignIds: Array<Scalars['String']>;
  campaignName?: InputMaybe<Scalars['String']>;
  cpm?: InputMaybe<MinMaxNumberValuesInput>;
  deliveryGoal?: InputMaybe<MinMaxNumberValuesInput>;
  endDate?: InputMaybe<MinMaxStringValuesInput>;
  lifetimeCompletions?: InputMaybe<MinMaxNumberValuesInput>;
  organizationId: Scalars['String'];
  publisher?: InputMaybe<Array<Publisher>>;
  revenue?: InputMaybe<MinMaxNumberValuesInput>;
  startDate?: InputMaybe<MinMaxStringValuesInput>;
};

export type StandardDeliveryDeviceHigherCategoryReportLineItem = {
  __typename?: 'StandardDeliveryDeviceHigherCategoryReportLineItem';
  adProduct: Maybe<AdProduct>;
  cpm: Maybe<Scalars['Float']>;
  deliveryGoal: Maybe<Scalars['Float']>;
  deviceBreakout: Maybe<Array<DeviceBreakout>>;
  endDate: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lifetimeCompletions: Maybe<Scalars['Float']>;
  publisher: Maybe<Scalars['String']>;
  revenue: Maybe<Scalars['Float']>;
  startDate: Maybe<Scalars['String']>;
};

export type StandardDeliveryDeviceHigherCategoryReportMetrics = Node & {
  __typename?: 'StandardDeliveryDeviceHigherCategoryReportMetrics';
  accountExecutive: Maybe<Scalars['String']>;
  accountManager: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  campaignName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItemName: Scalars['String'];
  lineItems: Array<StandardDeliveryDeviceHigherCategoryReportLineItem>;
};

export type StandardDeliveryDeviceHigherCategoryReportMetricsEdge = Edge & {
  __typename?: 'StandardDeliveryDeviceHigherCategoryReportMetricsEdge';
  cursor: Scalars['String'];
  node: StandardDeliveryDeviceHigherCategoryReportMetrics;
};

export type StandardDeliveryDeviceHigherCategoryReportMetricsPage = Connection & {
  __typename?: 'StandardDeliveryDeviceHigherCategoryReportMetricsPage';
  edges: Array<StandardDeliveryDeviceHigherCategoryReportMetricsEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type StandardDeliveryReport = BaseReport & {
  __typename?: 'StandardDeliveryReport';
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: StandardDeliveryReportFilters;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type StandardDeliveryReportFileUrlInput = {
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: StandardDeliveryReportFiltersInput;
  startDate?: InputMaybe<Scalars['String']>;
  templateId: Scalars['ID'];
};

export type StandardDeliveryReportFilters = SharedStandardDeliveryReportFilters & {
  __typename?: 'StandardDeliveryReportFilters';
  adProduct: Maybe<Array<AdProduct>>;
  campaignIds: Array<Scalars['String']>;
  campaigns: Maybe<Array<CampaignShortInfo>>;
  cpm: Maybe<MinMaxNumberValues>;
  endDate: Maybe<MinMaxStringValues>;
  orderGoal: Maybe<MinMaxNumberValues>;
  organizationId: Scalars['String'];
  publisher: Maybe<Array<Publisher>>;
  revenue: Maybe<MinMaxNumberValues>;
  startDate: Maybe<MinMaxStringValues>;
};

export type StandardDeliveryReportFiltersInput = {
  adProduct?: InputMaybe<Array<AdProduct>>;
  advertiserId?: InputMaybe<Scalars['String']>;
  campaignIds: Array<Scalars['String']>;
  cpm?: InputMaybe<MinMaxNumberValuesInput>;
  endDate?: InputMaybe<MinMaxStringValuesInput>;
  orderGoal?: InputMaybe<MinMaxNumberValuesInput>;
  organizationId: Scalars['String'];
  publisher?: InputMaybe<Array<Publisher>>;
  revenue?: InputMaybe<MinMaxNumberValuesInput>;
  startDate?: InputMaybe<MinMaxStringValuesInput>;
};

export type StandardDeliveryReportLineItem = {
  __typename?: 'StandardDeliveryReportLineItem';
  adProduct: Maybe<AdProduct>;
  completions: Maybe<Scalars['Float']>;
  cpm: Maybe<Scalars['Float']>;
  endDate: Maybe<Scalars['String']>;
  estimatedBillable: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  impressions: Maybe<Scalars['Float']>;
  orderGoal: Maybe<Scalars['Float']>;
  overUnderDelivery: Maybe<Scalars['Float']>;
  overUnderSpend: Maybe<Scalars['Float']>;
  publisher: Maybe<Scalars['String']>;
  revenue: Maybe<Scalars['Float']>;
  startDate: Maybe<Scalars['String']>;
  thirdPartyGrossBillableImpressions: Maybe<Scalars['Float']>;
  vcrPercentage: Maybe<Scalars['Float']>;
};

export type StandardDeliveryReportMetrics = Node & {
  __typename?: 'StandardDeliveryReportMetrics';
  accountExecutive: Maybe<Scalars['String']>;
  accountManager: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  campaignName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItemName: Scalars['String'];
  lineItems: Array<StandardDeliveryReportLineItem>;
};

export type StandardDeliveryReportMetricsEdge = Edge & {
  __typename?: 'StandardDeliveryReportMetricsEdge';
  cursor: Scalars['String'];
  node: StandardDeliveryReportMetrics;
};

export type StandardDeliveryReportMetricsPage = Connection & {
  __typename?: 'StandardDeliveryReportMetricsPage';
  edges: Array<StandardDeliveryReportMetricsEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type StatisticType = {
  __typename?: 'StatisticType';
  type: Scalars['String'];
  value: Scalars['String'];
};

export const Status = {
  Active: 'ACTIVE',
  Approved: 'APPROVED',
  Disabled: 'DISABLED',
  Inactive: 'INACTIVE',
  InReview: 'IN_REVIEW',
  Pending: 'PENDING',
  Ready: 'READY',
  Rejected: 'REJECTED',
} as const;

export type Status = (typeof Status)[keyof typeof Status];
export const StopOrResumeReport = {
  Resume: 'RESUME',
  Stop: 'STOP',
} as const;

export type StopOrResumeReport = (typeof StopOrResumeReport)[keyof typeof StopOrResumeReport];
export type SubmittedBy = {
  __typename?: 'SubmittedBy';
  email: Scalars['String'];
  firstName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPublisher: Maybe<Scalars['Boolean']>;
  lastName: Maybe<Scalars['String']>;
  rolesV4: Maybe<Array<RolesV4>>;
};

export type TargetData = {
  isExclusion: Scalars['Boolean'];
  targetId: Scalars['String'];
};

export type TargetType = {
  __typename?: 'TargetType';
  displayName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAllowed: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type TargetValue = {
  __typename?: 'TargetValue';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isAllowed: Scalars['Boolean'];
  isRequired: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  targetType: TargetType;
  targetTypeName: Scalars['String'];
};

export type TargetingRuleInput = {
  definition?: InputMaybe<DefinitionInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type Template = {
  __typename?: 'Template';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  systemName: TemplateSystemName;
};

export const TemplateSystemName = {
  DetailedData: 'DETAILED_DATA',
  DPlusDevice: 'D_PLUS_DEVICE',
  DPlusStandardDelivery: 'D_PLUS_STANDARD_DELIVERY',
  DPlusStandardDelivery_3P: 'D_PLUS_STANDARD_DELIVERY_3P',
  LineItemReachFrequency: 'LINE_ITEM_REACH_FREQUENCY',
  TopLineGenreDelivery: 'TOP_LINE_GENRE_DELIVERY',
} as const;

export type TemplateSystemName = (typeof TemplateSystemName)[keyof typeof TemplateSystemName];
export type TemplateWithReport = {
  __typename?: 'TemplateWithReport';
  description: Scalars['String'];
  id: Scalars['ID'];
  lastUpdatedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reports: Array<Report>;
  systemName: TemplateSystemName;
  totalScheduled: Scalars['Int'];
};

export type TestEmailInput = {
  emailAddress: Scalars['String'];
  emailBody: Scalars['String'];
  emailSubject: Scalars['String'];
};

export type Threshold = {
  __typename?: 'Threshold';
  organizationExternalId: Scalars['String'];
  thresholdAmount: Maybe<Scalars['Int']>;
};

export type ThresholdLevel = {
  __typename?: 'ThresholdLevel';
  amount: Scalars['Float'];
  level: Scalars['Int'];
};

export type Timezone = {
  __typename?: 'Timezone';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type TopLineGenreDeliveryReport = BaseReport & {
  __typename?: 'TopLineGenreDeliveryReport';
  dateRange: DateRange;
  endDate: Maybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: TopLineGenreDeliveryReportFilters;
  id: Scalars['ID'];
  lastGeneratedAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  recipients: Maybe<Array<Scalars['ID']>>;
  schedule: ReportSchedule;
  startDate: Maybe<Scalars['String']>;
  status: ReportStatus;
  templateId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type TopLineGenreDeliveryReportFileUrlInput = {
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  exportFormat: ExportFormat;
  filters: TopLineGenreDeliveryReportFiltersInput;
  startDate?: InputMaybe<Scalars['String']>;
  templateId: Scalars['ID'];
};

export type TopLineGenreDeliveryReportFilters = {
  __typename?: 'TopLineGenreDeliveryReportFilters';
  adProduct: Maybe<Array<AdProduct>>;
  campaignIds: Array<Scalars['String']>;
  campaigns: Maybe<Array<CampaignShortInfo>>;
  genres: Maybe<Array<Genres>>;
  organizationId: Scalars['String'];
  publisher: Maybe<Array<Publisher>>;
};

export type TopLineGenreDeliveryReportFiltersInput = {
  adProduct?: InputMaybe<Array<AdProduct>>;
  advertiserId?: InputMaybe<Scalars['String']>;
  campaignIds: Array<Scalars['String']>;
  genres?: InputMaybe<Array<Scalars['String']>>;
  organizationId: Scalars['String'];
  publisher?: InputMaybe<Array<Publisher>>;
};

export type TopLineGenreDeliveryReportLineItem = {
  __typename?: 'TopLineGenreDeliveryReportLineItem';
  adProduct: Maybe<AdProduct>;
  cpm: Maybe<Scalars['Float']>;
  deliveryGoal: Maybe<Scalars['Float']>;
  endDate: Maybe<Scalars['String']>;
  genres: Maybe<Array<Genres>>;
  id: Scalars['ID'];
  publisher: Maybe<Scalars['String']>;
  revenue: Maybe<Scalars['Float']>;
  startDate: Maybe<Scalars['String']>;
};

export type TopLineGenreDeliveryReportMetrics = Node & {
  __typename?: 'TopLineGenreDeliveryReportMetrics';
  accountExecutive: Maybe<Scalars['String']>;
  accountManager: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  campaignName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItemName: Scalars['String'];
  lineItems: Array<TopLineGenreDeliveryReportLineItem>;
};

export type TopLineGenreDeliveryReportMetricsEdge = Edge & {
  __typename?: 'TopLineGenreDeliveryReportMetricsEdge';
  cursor: Scalars['String'];
  node: TopLineGenreDeliveryReportMetrics;
};

export type TopLineGenreDeliveryReportMetricsPage = Connection & {
  __typename?: 'TopLineGenreDeliveryReportMetricsPage';
  edges: Array<TopLineGenreDeliveryReportMetricsEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type TotalImpressionsChartMetric = {
  __typename?: 'TotalImpressionsChartMetric';
  percentile: Scalars['Float'];
  time: Scalars['String'];
  total: Scalars['Int'];
};

export type TotalImpressionsChartMetrics = {
  __typename?: 'TotalImpressionsChartMetrics';
  metrics: Array<TotalImpressionsChartMetric>;
  total: Scalars['Int'];
};

export const Touchpoint = {
  OrganizationCreationDate: 'ORGANIZATION_CREATION_DATE',
  OrganizationLastLoginDate: 'ORGANIZATION_LAST_LOGIN_DATE',
} as const;

export type Touchpoint = (typeof Touchpoint)[keyof typeof Touchpoint];
export type TransactionHistory = Node & {
  __typename?: 'TransactionHistory';
  adAccountId: Scalars['ID'];
  adAccountName: Maybe<Scalars['String']>;
  amount: Scalars['Currency'];
  cannotRefundReason: Maybe<Scalars['String']>;
  cannotRetryReason: Maybe<Scalars['String']>;
  cannotRetryReasonMessage: Maybe<Scalars['String']>;
  creditCardBrand: Scalars['String'];
  creditCardLastFour: Scalars['String'];
  declineReason: Maybe<Scalars['String']>;
  errorResponceCode: Scalars['Int'];
  id: Scalars['ID'];
  internalNote: Scalars['String'];
  invoiceExternalId: Scalars['ID'];
  organizationExternalId: Scalars['ID'];
  paymentType: PaymentType;
  receiptNumber: Scalars['Int'];
  refundable: Maybe<Scalars['Boolean']>;
  retryable: Maybe<Scalars['Boolean']>;
  transactionDate: Scalars['EasternTimeZoneDate'];
  transactionStatus: TransactionStatuses;
  transactionType: Scalars['String'];
};

export type TransactionHistoryEdge = Edge & {
  __typename?: 'TransactionHistoryEdge';
  cursor: Scalars['String'];
  node: TransactionHistory;
};

export type TransactionHistoryFilter = {
  adAccount?: InputMaybe<Array<Scalars['String']>>;
  paymentMethod?: InputMaybe<Array<Scalars['String']>>;
  transactionStatus?: InputMaybe<Array<TransactionStatuses>>;
};

export type TransactionHistoryPage = Connection & {
  __typename?: 'TransactionHistoryPage';
  edges: Array<TransactionHistoryEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export const TransactionSortBy = {
  AdAccountName: 'adAccountName',
  Amount: 'amount',
  Id: 'id',
  TransactionDate: 'transactionDate',
  TransactionStatus: 'transactionStatus',
} as const;

export type TransactionSortBy = (typeof TransactionSortBy)[keyof typeof TransactionSortBy];
export type TransactionSortOptions = {
  sortBy?: InputMaybe<TransactionSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export type TransactionStatusFilterOptions = {
  __typename?: 'TransactionStatusFilterOptions';
  name: TransactionStatuses;
  value: Scalars['Int'];
};

export const TransactionStatuses = {
  Chargeback: 'CHARGEBACK',
  ChargebackReversed: 'CHARGEBACK_REVERSED',
  CustomerFailed: 'CUSTOMER_FAILED',
  Initiated: 'INITIATED',
  Refunded: 'REFUNDED',
  RefundedReversed: 'REFUNDED_REVERSED',
  RefundFailed: 'REFUND_FAILED',
  RefundInitiated: 'REFUND_INITIATED',
  Success: 'SUCCESS',
  SystemFailed: 'SYSTEM_FAILED',
} as const;

export type TransactionStatuses = (typeof TransactionStatuses)[keyof typeof TransactionStatuses];
export type TransactionsFilters = {
  __typename?: 'TransactionsFilters';
  accountFilterOptions: Maybe<Array<AccountFilterOptions>>;
  paymentMethodFilterOptions: Maybe<Array<PaymentMethodFilterOptions>>;
  transactionStatusOptions: Maybe<Array<TransactionStatusFilterOptions>>;
};

export type UpdateAdTags = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type UpdateAdType = {
  adTags?: InputMaybe<Array<InputMaybe<UpdateAdTags>>>;
  creativeId?: InputMaybe<Scalars['ID']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type UpdateAdyenPaymentMethodInput = {
  billingAddress: BillingAddressInput;
  expiryMonth: Scalars['Int'];
  expiryYear: Scalars['Int'];
  holderName: Scalars['String'];
  paymentMethodName: Scalars['String'];
};

export type UpdateAudienceInput = {
  adAccountIds: Array<Scalars['String']>;
  displayName: Scalars['String'];
  expiryDate?: InputMaybe<Scalars['String']>;
  rule?: InputMaybe<AudienceRuleInput>;
  targetTypeId: Scalars['ID'];
};

export type UpdateCampaign = {
  name?: InputMaybe<Scalars['String']>;
  promoCodeName?: InputMaybe<Scalars['String']>;
  sfOpportunityId?: InputMaybe<Scalars['String']>;
  sourceSystem?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type UpdateCreativeNameResult = {
  __typename?: 'UpdateCreativeNameResult';
  creativeId: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateDraftLineItem = {
  adDuration?: InputMaybe<Scalars['String']>;
  adFormat?: InputMaybe<Scalars['String']>;
  ads?: InputMaybe<Array<InputMaybe<UpdateAdType>>>;
  allowMatureContent?: InputMaybe<Scalars['Boolean']>;
  budget?: InputMaybe<Scalars['Float']>;
  dayPartings?: InputMaybe<Array<InputMaybe<DayParting>>>;
  endTime?: InputMaybe<Scalars['Date']>;
  frequencyCap?: InputMaybe<Scalars['Int']>;
  frequencyCapUnit?: InputMaybe<Scalars['String']>;
  hasDnaApplied?: InputMaybe<Scalars['Boolean']>;
  isPreemptible: Scalars['Boolean'];
  name: Scalars['String'];
  pacingSchedules?: InputMaybe<Array<PacingValuesInput>>;
  packageId?: InputMaybe<Scalars['ID']>;
  publisherIds?: InputMaybe<Array<Scalars['ID']>>;
  startTime?: InputMaybe<Scalars['Date']>;
  targets?: InputMaybe<Array<InputMaybe<UpdateTargetData>>>;
  /**
   * Campaign's resolved effective IANA timezone (SSAT-20005/SSAT-20032). Never forwarded to
   * campaign-orchestrator — it is stripped in the resolver and used only to interpret startTime/
   * endTime/pacingSchedules when release-ssat-18592-campaign-timezone-full-allowlist is on.
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type UpdateLineItem = {
  __typename?: 'UpdateLineItem';
  adDuration: Maybe<Scalars['String']>;
  adStatus: Maybe<Scalars['String']>;
  asset: Maybe<AssetData>;
  budget: Maybe<Scalars['Float']>;
  campaignId: Maybe<Scalars['Int']>;
  dayPartings: Maybe<Array<Maybe<DayPartings>>>;
  deliveredImpressions: Maybe<Scalars['Float']>;
  discountedUnitCost: Maybe<Scalars['Float']>;
  endTime: Maybe<Scalars['AbbreviatedDate']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  rateCardId: Maybe<Scalars['String']>;
  rateCardVersion: Maybe<Scalars['String']>;
  revisionNumber: Maybe<Scalars['Int']>;
  startTime: Maybe<Scalars['AbbreviatedDate']>;
  status: Maybe<Scalars['String']>;
  targetImpressions: Maybe<Scalars['Float']>;
  targets: Maybe<Array<Maybe<TargetValue>>>;
  unitCost: Maybe<Scalars['Float']>;
};

export type UpdateReportInput = {
  dateRange: DateRange;
  endDate?: InputMaybe<Scalars['String']>;
  exportFormat: ExportFormat;
  name: Scalars['String'];
  recipients?: InputMaybe<Array<Scalars['ID']>>;
  schedule: ReportScheduleInput;
  startDate?: InputMaybe<Scalars['String']>;
};

export type UpdateTargetData = {
  id: Scalars['ID'];
  isExclusion: Scalars['Boolean'];
};

export type UpdateUserRolesInput = {
  assignments?: InputMaybe<Array<InputMaybe<BulkChangeRoles>>>;
  roleList: Array<Roles>;
};

export type UploadKervVast = {
  __typename?: 'UploadKervVAST';
  creativeLibraryId: Scalars['String'];
  creativeManagerId: Scalars['String'];
  creativeType: Scalars['String'];
  deletable: Scalars['Boolean'];
  id: Scalars['ID'];
  replacedUrl: Maybe<Scalars['String']>;
  status: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type User = Node & {
  __typename?: 'User';
  adAccountScopedAssignmentName: Maybe<Scalars['String']>;
  assignments: Maybe<Array<Assignment>>;
  createdAt: Maybe<Scalars['AbbreviatedDate']>;
  deletable: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastLoginAt: Maybe<Scalars['AbbreviatedDate']>;
  lastName: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  roleList: Array<UserOrganizationInfoRoles>;
  status: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['AbbreviatedDate']>;
};

export const UserAssignment = {
  AdAccountAdmins: 'AD_ACCOUNT_ADMINS',
  Analysts: 'ANALYSTS',
  Buyers: 'BUYERS',
  OrganizationAdmins: 'ORGANIZATION_ADMINS',
  Sellers: 'SELLERS',
} as const;

export type UserAssignment = (typeof UserAssignment)[keyof typeof UserAssignment];
export type UserEdge = Edge & {
  __typename?: 'UserEdge';
  cursor: Scalars['String'];
  node: User;
};

export type UserInput = {
  assignments?: InputMaybe<Array<InputMaybe<BulkChangeRoles>>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type UserInvitation = {
  __typename?: 'UserInvitation';
  invitationStatus: InvitationStatus;
  inviteNotSentReason: Maybe<InviteNotSentReason>;
  userStatus: Scalars['String'];
};

export type UserInvitationWithReCaptchaValidation = {
  __typename?: 'UserInvitationWithReCAPTCHAValidation';
  errorMessages: Maybe<Array<Scalars['String']>>;
  invitationStatus: Maybe<InvitationStatus>;
  inviteNotSentReason: Maybe<InviteNotSentReason>;
  reCAPTCHASuccess: Scalars['Boolean'];
  userStatus: Maybe<Scalars['String']>;
};

export type UserInviteInput = {
  assignments?: InputMaybe<Array<InputMaybe<BulkChangeRoles>>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  roleList: Array<Roles>;
};

export type UserOrganization = {
  __typename?: 'UserOrganization';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UserOrganizationInfoRoles = {
  __typename?: 'UserOrganizationInfoRoles';
  entityId: Scalars['String'];
  entityName: Maybe<EntityName>;
  entityType: EntityType;
  role: Scalars['UserRole'];
};

export type UserPermissions = {
  __typename?: 'UserPermissions';
  adAccountPermissions: Maybe<Array<PermissionsByAdAccount>>;
  permissions: Permissions;
  roles: Array<Scalars['String']>;
};

/** Full role assignments from AO role-claims (same compressed format as JWT user_role_v4). */
export type UserRoleClaims = {
  __typename?: 'UserRoleClaims';
  compressedRoles: Scalars['String'];
  roleCount: Maybe<Scalars['Int']>;
  userId: Scalars['ID'];
};

export type UserRoles = {
  __typename?: 'UserRoles';
  adAccountRoles: Maybe<Array<PermittedRole>>;
  adAccounts: Maybe<Array<AdAccountAssignment>>;
  creativeLibraryId: Maybe<Scalars['String']>;
  organizationRoles: Maybe<Array<PermittedRole>>;
};

export const UserSortBy = {
  Created: 'created',
  Email: 'email',
  FirstName: 'firstName',
  LastLoginAt: 'lastLoginAt',
  LastName: 'lastName',
  Role: 'role',
  Status: 'status',
} as const;

export type UserSortBy = (typeof UserSortBy)[keyof typeof UserSortBy];
export const UserType = {
  SpecificUsers: 'SPECIFIC_USERS',
  UserAssignment: 'USER_ASSIGNMENT',
} as const;

export type UserType = (typeof UserType)[keyof typeof UserType];
export type UsersByAdAccountFilterOptions = {
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UsersFilterOptions = {
  endDate?: InputMaybe<Scalars['String']>;
  filterToOrganizationsOfUserId?: InputMaybe<Scalars['ID']>;
  /**
   * Login activity filter for Admin Users list
   * ACTIVE: users with a login in the selected date range
   * INACTIVE: users with no login history (fallback to updatedAt range) or inactive statuses
   * ALL: union of ACTIVE plus the INACTIVE class
   */
  loginActivity?: InputMaybe<LoginActivity>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

export type UsersPage = Connection & {
  __typename?: 'UsersPage';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type UsersSortOptions = {
  sortBy?: InputMaybe<UserSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
};

export const VastCreativeType = {
  Kerv: 'KERV',
  VastVideo: 'VAST_VIDEO',
} as const;

export type VastCreativeType = (typeof VastCreativeType)[keyof typeof VastCreativeType];
export type VastInfo = {
  __typename?: 'VastInfo';
  isValid: Scalars['Boolean'];
  originalUrl: Maybe<Scalars['String']>;
  replacedMacros: Maybe<Array<VastReplacedMacros>>;
  replacedUrl: Maybe<Scalars['String']>;
};

export type VastInterface = {
  isValid: Scalars['Boolean'];
  results: Array<Maybe<VastItem>>;
};

export type VastItem = {
  __typename?: 'VastItem';
  asset: AssetInfo;
  requirements: Array<AssetRequirements>;
};

export type VastReplacedMacros = {
  __typename?: 'VastReplacedMacros';
  key: Maybe<Scalars['String']>;
  values: Maybe<VastReplacedMacrosValue>;
};

export type VastReplacedMacrosValue = {
  __typename?: 'VastReplacedMacrosValue';
  from: Maybe<Scalars['String']>;
  to: Maybe<Scalars['String']>;
};

export const VastStatus = {
  Approved: 'APPROVED',
  PendingApproval: 'PENDING_APPROVAL',
  Rejected: 'REJECTED',
} as const;

export type VastStatus = (typeof VastStatus)[keyof typeof VastStatus];
/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  deprecationReason: Maybe<Scalars['String']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean'];
  deprecationReason: Maybe<Scalars['String']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  deprecationReason: Maybe<Scalars['String']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  specifiedByURL: Maybe<Scalars['String']>;
  fields: Maybe<Array<__Field>>;
  interfaces: Maybe<Array<__Type>>;
  possibleTypes: Maybe<Array<__Type>>;
  enumValues: Maybe<Array<__EnumValue>>;
  inputFields: Maybe<Array<__InputValue>>;
  ofType: Maybe<__Type>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export const __TypeKind = {
  /** Indicates this type is a scalar. */
  Scalar: 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object: 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface: 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union: 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum: 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject: 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List: 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull: 'NON_NULL',
} as const;

export type __TypeKind = (typeof __TypeKind)[keyof typeof __TypeKind];
export type CreateAdAccountMutationVariables = Exact<{
  name: Scalars['String'];
  brandId: Scalars['String'];
  organizationId: Scalars['String'];
  billingContactId?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  invoiceByCampaign?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}>;

export type CreateAdAccountMutation = {
  __typename?: 'Mutation';
  createAdAccount: { __typename?: 'AdAccount'; id: string };
};

export type DeleteAdAccountMutationVariables = Exact<{
  accountId: Scalars['ID'];
}>;

export type DeleteAdAccountMutation = { __typename?: 'Mutation'; deleteAdAccount: any | null };

export type UpdateAdAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  brandId: Scalars['String'];
  organizationId: Scalars['String'];
  billingContactId?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  fundingSource?: InputMaybe<FundingSource>;
  billableAdServer?: InputMaybe<Scalars['String']>;
  invoiceByCampaign?: InputMaybe<Scalars['Boolean']>;
  canUpdatePaymentMethod: Scalars['Boolean'];
  billingCalendar?: InputMaybe<Scalars['String']>;
  agencyCommissionPercentage?: InputMaybe<Scalars['Float']>;
  timezone?: InputMaybe<Scalars['String']>;
}>;

export type UpdateAdAccountMutation = {
  __typename?: 'Mutation';
  updateAdAccount: { __typename?: 'AdAccount'; id: string };
};

export type UpdateAdAccountPatchMutationVariables = Exact<{
  id: Scalars['ID'];
  adAccountName?: InputMaybe<Scalars['String']>;
  budget?: InputMaybe<Scalars['Int']>;
  brandId?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  fundingSource?: InputMaybe<FundingSource>;
  billingContactId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  dnaListPresetId?: InputMaybe<Scalars['ID']>;
  dnaListAppliedByDefault?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateAdAccountPatchMutation = {
  __typename?: 'Mutation';
  updateAdAccountPatch: { __typename?: 'AdAccount'; id: string };
};

export type UpdateAdAccountStatusMutationVariables = Exact<{
  input: AdAccountUpdateStatusInput;
}>;

export type UpdateAdAccountStatusMutation = { __typename?: 'Mutation'; updateAdAccountStatus: any | null };

export type UpdateLastActivityMutationVariables = Exact<{
  adAccountId: Scalars['ID'];
}>;

export type UpdateLastActivityMutation = { __typename?: 'Mutation'; updateLastActivity: any | null };

export type UpdatePaymentMethodPerAdAccountsMutationVariables = Exact<{
  paymentMethodExternalId: Scalars['ID'];
  input: LinkPaymentMethod;
}>;

export type UpdatePaymentMethodPerAdAccountsMutation = {
  __typename?: 'Mutation';
  updatePaymentMethodPerAdAccounts: any | null;
};

export type AdAccountsListForOrganizationQueryVariables = Exact<{
  includePaymentInfo: Scalars['Boolean'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  filterOptions?: InputMaybe<AdAccountFilterOptions>;
  sortOptions?: InputMaybe<AdAccountSortOptions>;
}>;

export type AdAccountsListForOrganizationQuery = {
  __typename?: 'Query';
  allAdAccounts: {
    __typename?: 'AdAccountsPages';
    total: number;
    edges: Array<{
      __typename?: 'AdAccountEdge';
      node: {
        __typename?: 'AdAccount';
        id: string;
        name: string;
        createdAt: any | null;
        status: AdAccountStatus | null;
        lastLoginAt: any | null;
        usersCount: number;
        access: string | null;
        billingTerm: BillingTerm;
        billBy: string | null;
        activeCpm: number | null;
        campaignsCount: number | null;
        campaignsCountStatistic: number | null;
        adsCount: number | null;
        thresholdAmount: number | null;
        timezone: string;
        brand: { __typename?: 'Brand'; name: string } | null;
        billingContact: {
          __typename?: 'BillingContact';
          id: string | null;
          firstName: string;
          lastName: string;
        } | null;
      };
    }>;
  };
};

export type AllAdAccountsQueryVariables = Exact<{
  includePaymentInfo: Scalars['Boolean'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  filterOptions?: InputMaybe<AdAccountFilterOptions>;
  sortOptions?: InputMaybe<AdAccountSortOptions>;
}>;

export type AllAdAccountsQuery = {
  __typename?: 'Query';
  allAdAccounts: {
    __typename?: 'AdAccountsPages';
    total: number;
    edges: Array<{
      __typename?: 'AdAccountEdge';
      node: {
        __typename?: 'AdAccount';
        id: string;
        name: string;
        createdAt: any | null;
        status: AdAccountStatus | null;
        lastLoginAt: any | null;
        usersCount: number;
        access: string | null;
        billingTerm: BillingTerm;
        billBy: string | null;
        activeCpm: number | null;
        campaignsCount: number | null;
        adsCount: number | null;
        thresholdAmount: number | null;
        campaignsCountStatistic: number | null;
        timezone: string;
        brand: { __typename?: 'Brand'; name: string } | null;
        billingContact: {
          __typename?: 'BillingContact';
          id: string | null;
          firstName: string;
          lastName: string;
        } | null;
        organization: { __typename?: 'AdAccountOrganization'; organizationId: string; organizationName: string } | null;
      };
    }>;
  };
};

export type GetAdAccountByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAdAccountByIdQuery = {
  __typename?: 'Query';
  adAccount: {
    __typename?: 'AdAccount';
    id: string;
    name: string;
    status: AdAccountStatus | null;
    createdAt: any | null;
    lastLoginAt: any | null;
    fundingSource: FundingSource | null;
    timezone: string;
    accountsApprovedForTerms: boolean | null;
    approvedForPrepaymentTerms: boolean | null;
    campaignsCountStatistic: number | null;
    billableAdServer: string | null;
    invoiceByCampaign: boolean | null;
    isMatureBrand: boolean | null;
    billingCalendar: string | null;
    agencyCommissionPercentage: number | null;
    dnaListPresetId: string | null;
    dnaListAppliedByDefault: boolean | null;
    billingContact: {
      __typename?: 'BillingContact';
      id: string | null;
      firstName: string;
      lastName: string;
      email: string | null;
    } | null;
    brand: {
      __typename?: 'Brand';
      id: string;
      name: string;
      industry: { __typename?: 'Industry'; id: string; name: string };
    } | null;
    assignedUsers: Array<{
      __typename?: 'User';
      firstName: string | null;
      lastName: string | null;
      id: string;
      adAccountScopedAssignmentName: string | null;
    }> | null;
    paymentMethod: {
      __typename?: 'PaymentMethod';
      paymentMethodExternalId: string;
      paymentMethodName: string;
      lastFour: string | null;
      brand: string | null;
    } | null;
  };
};

export type AllAdAccountsOptionsWithNotificationTypesQueryVariables = Exact<{
  paginationOptions?: InputMaybe<PaginationOptions>;
  name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
  sortOptions?: InputMaybe<AdAccountSortOptions>;
}>;

export type AllAdAccountsOptionsWithNotificationTypesQuery = {
  __typename?: 'Query';
  allAdAccountsOptionsWithNotificationTypes: {
    __typename?: 'AdAccountsOptionsWithNotificationTypesPages';
    enableForAll: boolean;
    total: number;
    edges: Array<{
      __typename?: 'AdAccountOptionsWithNotificationTypeEdge';
      node: {
        __typename?: 'AdAccountWithNotificationTypeOptions';
        id: string;
        name: string;
        notificationTypes: Array<string | null>;
      };
    }>;
  };
};

export type GetAdAccountViewByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAdAccountViewByIdQuery = {
  __typename?: 'Query';
  adAccountWithExtraData: {
    __typename?: 'AdAccount';
    name: string;
    status: AdAccountStatus | null;
    organization: { __typename?: 'AdAccountOrganization'; organizationId: string; organizationName: string } | null;
  };
};

export type GetAdAccountWithExtraDataByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAdAccountWithExtraDataByIdQuery = {
  __typename?: 'Query';
  adAccountWithExtraData: {
    __typename?: 'AdAccount';
    id: string;
    name: string;
    status: AdAccountStatus | null;
    billBy: string | null;
    billingTerm: BillingTerm;
    createdAt: any | null;
    access: string | null;
    lastLoginAt: any | null;
    accountsApprovedForTerms: boolean | null;
    activeCpm: number | null;
    timezone: string;
    campaignsCountStatistic: number | null;
    dnaListPresetId: string | null;
    dnaListAppliedByDefault: boolean | null;
    organization: { __typename?: 'AdAccountOrganization'; organizationId: string; organizationName: string } | null;
    billingContact: {
      __typename?: 'BillingContact';
      id: string | null;
      firstName: string;
      lastName: string;
      email: string | null;
    } | null;
    brand: { __typename?: 'Brand'; id: string; name: string } | null;
    paymentMethod: {
      __typename?: 'PaymentMethod';
      paymentMethodExternalId: string;
      paymentMethodName: string;
      lastFour: string | null;
      brand: string | null;
    } | null;
  };
};

export type GetAdAccountsByBrandQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAdAccountsByBrandQuery = {
  __typename?: 'Query';
  adAccountsByBrand: Array<{
    __typename?: 'AdAccount';
    id: string;
    name: string;
    status: AdAccountStatus | null;
  } | null>;
};

export type GetAdAccountIdsByCampaignsQueryVariables = Exact<{
  campaignIds: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type GetAdAccountIdsByCampaignsQuery = { __typename?: 'Query'; getAdAccountIdsByCampaigns: Array<string> };

export type GetAllAdAccountsByOrgIdQueryVariables = Exact<{
  paginationOptions?: InputMaybe<PaginationOptions>;
  organizationId: Scalars['ID'];
}>;

export type GetAllAdAccountsByOrgIdQuery = {
  __typename?: 'Query';
  getAllAdAccountsByOrgId: {
    __typename?: 'AdAccountsPages';
    total: number;
    edges: Array<{
      __typename?: 'AdAccountEdge';
      node: {
        __typename?: 'AdAccount';
        id: string;
        name: string;
        accountsApprovedForTerms: boolean | null;
        isBaymaxEnabled: boolean | null;
        brand: { __typename?: 'Brand'; id: string; name: string } | null;
      };
    }>;
  };
};

export type GetAdvertisersByOrgIdQueryVariables = Exact<{
  orgId: Scalars['ID'];
  accessTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetAdvertisersByOrgIdQuery = {
  __typename?: 'Query';
  getAdvertisersByOrgId: {
    __typename?: 'Advertisers';
    organizationId: string;
    advertisers: Array<{
      __typename?: 'Advertiser';
      advertiserId: string;
      advertiserName: string;
      adAccounts: Array<{ __typename?: 'AdAccountShortInfo'; id: string; name: string }>;
    }>;
  };
};

export type CreateAudienceMutationVariables = Exact<{
  input: CreateAudienceInput;
}>;

export type CreateAudienceMutation = {
  __typename?: 'Mutation';
  createAudience: { __typename?: 'CustomAudience'; id: string; name: string | null } | null;
};

export type DeleteAudienceMutationVariables = Exact<{
  id: Scalars['ID'];
  adAccountIds: Array<Scalars['String']> | Scalars['String'];
}>;

export type DeleteAudienceMutation = { __typename?: 'Mutation'; deleteAudience: any | null };

export type UpdateAudienceMutationVariables = Exact<{
  audienceId: Scalars['ID'];
  input: UpdateAudienceInput;
}>;

export type UpdateAudienceMutation = { __typename?: 'Mutation'; updateAudience: any | null };

export type AdAccountAudiencesQueryVariables = Exact<{
  adAccountId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  filterOptions?: InputMaybe<AdAccountAudiencesFilterOptions>;
  sortOptions?: InputMaybe<AdAccountAudienceSortOptions>;
}>;

export type AdAccountAudiencesQuery = {
  __typename?: 'Query';
  adAccountAudiences: {
    __typename?: 'AdAccountAudienceTargetValuePages';
    total: number;
    edges: Array<{
      __typename?: 'AdAccountAudienceTargetValueEdge';
      node: {
        __typename?: 'AdAccountAudienceTargetValue';
        id: string;
        name: string | null;
        displayName: string | null;
        createdAt: any | null;
        expiryDate: any | null;
        audienceId: string | null;
        optionName: string | null;
        gamId: string | null;
        targetType: {
          __typename?: 'AdAccountAudienceTargetType';
          id: string;
          name: string;
          displayName: string | null;
        };
      };
    }>;
  };
};

export type CustomAudienceByIdQueryVariables = Exact<{
  customAudienceId: Scalars['ID'];
}>;

export type CustomAudienceByIdQuery = {
  __typename?: 'Query';
  customAudienceById: {
    __typename?: 'CustomAudienceById';
    id: string;
    name: string | null;
    displayName: string | null;
    expiryDate: string | null;
    createdAt: string | null;
    audienceName: string | null;
    audienceId: string | null;
    adAccountIds: Array<string>;
    gamId: string | null;
    nameMapping: Record<string, string> | null;
    targetType: {
      __typename?: 'CustomAudienceByIdTargetType';
      id: string;
      name: string;
      displayName: string | null;
      isAllowed: boolean | null;
    };
    rule: {
      __typename?: 'AudienceRule';
      definition: {
        __typename?: 'AudienceDefinition';
        subClass: string;
        not: boolean;
        termList: Array<{
          __typename?: 'AudienceRuleGroup';
          subClass: string;
          not: boolean;
          termList: Array<{
            __typename?: 'AudienceRuleSet';
            dimension: string;
            subClass: string;
            valueSet: Array<string>;
            not: boolean;
          }>;
        }>;
      };
    } | null;
  };
};

export type MockAdminAudienceNameOptionsQueryVariables = Exact<{
  searchField?: InputMaybe<Scalars['String']>;
}>;

export type MockAdminAudienceNameOptionsQuery = { __typename: 'Query' };

export type GetAudienceTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAudienceTypesQuery = {
  __typename?: 'Query';
  getAudienceTypes: Array<{ __typename?: 'AudienceTypes'; id: string; name: string; displayName: string }> | null;
};

export type CustomAudienceTypesQueryVariables = Exact<{ [key: string]: never }>;

export type CustomAudienceTypesQuery = {
  __typename?: 'Query';
  customAudienceTypes: Array<{
    __typename?: 'AdAccountAudienceTargetType';
    id: string;
    name: string;
    displayName: string | null;
  }>;
};

export type GetDimensionValuesQueryVariables = Exact<{
  targetTypeId: Scalars['ID'];
  filterData: InputDimensionValueFilter;
}>;

export type GetDimensionValuesQuery = {
  __typename?: 'Query';
  getDimensionValues: {
    __typename?: 'DimensionValuePages';
    total: number;
    edges: Array<{
      __typename?: 'DimensionValueEdge';
      node: {
        __typename?: 'DimensionValue';
        id: string | null;
        name: string;
        displayName: string | null;
        segmentId: string;
        gamId: string | null;
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; nextCursor: string | null };
  };
};

export type RefundTransactionMutationVariables = Exact<{
  transactionId: Scalars['ID'];
  invoiceExtId: Scalars['ID'];
  amount: Scalars['Float'];
}>;

export type RefundTransactionMutation = { __typename?: 'Mutation'; refundTransaction: any | null };

export type GetTransactionsByOrgIdQueryVariables = Exact<{
  orgId: Scalars['ID'];
  filterInput: TransactionHistoryFilter;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<TransactionSortOptions>;
}>;

export type GetTransactionsByOrgIdQuery = {
  __typename?: 'Query';
  getTransactionHistory: {
    __typename?: 'TransactionHistoryPage';
    total: number;
    edges: Array<{
      __typename?: 'TransactionHistoryEdge';
      node: {
        __typename?: 'TransactionHistory';
        id: string;
        adAccountId: string;
        adAccountName: string | null;
        declineReason: string | null;
        transactionDate: any;
        transactionStatus: TransactionStatuses;
        amount: any;
        creditCardBrand: string;
        creditCardLastFour: string;
        invoiceExternalId: string;
        cannotRefundReason: string | null;
        refundable: boolean | null;
      };
    }>;
  };
};

export type GetTransactionsByOrgIdWithRetryFieldsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  filterInput: TransactionHistoryFilter;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<TransactionSortOptions>;
}>;

export type GetTransactionsByOrgIdWithRetryFieldsQuery = {
  __typename?: 'Query';
  getTransactionHistory: {
    __typename?: 'TransactionHistoryPage';
    total: number;
    edges: Array<{
      __typename?: 'TransactionHistoryEdge';
      node: {
        __typename?: 'TransactionHistory';
        id: string;
        adAccountId: string;
        adAccountName: string | null;
        declineReason: string | null;
        transactionDate: any;
        transactionStatus: TransactionStatuses;
        amount: any;
        creditCardBrand: string;
        creditCardLastFour: string;
        invoiceExternalId: string;
        cannotRefundReason: string | null;
        refundable: boolean | null;
        retryable: boolean | null;
        cannotRetryReason: string | null;
        cannotRetryReasonMessage: string | null;
      };
    }>;
  };
};

export type GetTransactionsFiltersQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;

export type GetTransactionsFiltersQuery = {
  __typename?: 'Query';
  getTransactionsFilters: {
    __typename?: 'TransactionsFilters';
    accountFilterOptions: Array<{
      __typename?: 'AccountFilterOptions';
      adAccountId: string;
      adAccountName: string;
    }> | null;
    paymentMethodFilterOptions: Array<{
      __typename?: 'PaymentMethodFilterOptions';
      brand: string;
      lastFour: string;
      paymentMethodExternalId: string;
      paymentMethodName: string;
      status: string;
    }> | null;
    transactionStatusOptions: Array<{
      __typename?: 'TransactionStatusFilterOptions';
      name: TransactionStatuses;
      value: number;
    }> | null;
  };
};

export type GetBillingContactsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orgId: Scalars['String'];
  userId: Scalars['ID'];
}>;

export type GetBillingContactsQuery = {
  __typename?: 'Query';
  billingContacts: {
    __typename?: 'BillingContactsPage';
    total: number;
    edges: Array<{
      __typename?: 'BillingContactEdge';
      node: { __typename?: 'BillingContact'; id: string | null; firstName: string; lastName: string; status: string };
    }>;
  };
};

export type CreateAdvertiserBrandMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  industryId: Scalars['ID'];
  brandName: Scalars['String'];
}>;

export type CreateAdvertiserBrandMutation = {
  __typename?: 'Mutation';
  addAdvertiserBrand: {
    __typename?: 'Brand';
    status: BrandStatus;
    createdAt: any | null;
    id: string;
    name: string;
    address: {
      __typename?: 'Address';
      line1: string;
      line2: string | null;
      city: string;
      country: string;
      zipCode: string;
      state: string;
    };
    industry: { __typename?: 'Industry'; id: string; name: string };
  };
};

export type CreateAgencyBrandMutationVariables = Exact<{
  industryId: Scalars['ID'];
  organizationId: Scalars['ID'];
  name: Scalars['String'];
  line1: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  zipCode: Scalars['String'];
}>;

export type CreateAgencyBrandMutation = {
  __typename?: 'Mutation';
  createAgencyBrand: { __typename?: 'Brand'; id: string; name: string };
};

export type UpdateBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  orgId: Scalars['ID'];
  brandInput: BrandInput;
}>;

export type UpdateBrandMutation = {
  __typename?: 'Mutation';
  updateBrand: {
    __typename?: 'Brand';
    id: string;
    name: string;
    industry: { __typename?: 'Industry'; id: string; name: string };
  };
};

export type GetBrandsByOrgIdQueryVariables = Exact<{
  orgId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;

export type GetBrandsByOrgIdQuery = {
  __typename?: 'Query';
  getBrandsByOrgId: {
    __typename?: 'BrandsPage';
    total: number;
    edges: Array<{
      __typename?: 'BrandEdge';
      node: {
        __typename?: 'Brand';
        id: string;
        name: string;
        status: BrandStatus;
        address: {
          __typename?: 'Address';
          line1: string;
          line2: string | null;
          city: string;
          country: string;
          zipCode: string;
          state: string;
        };
      };
    }>;
  };
};

export type GetAdSelectorBrandsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  filterOptions?: InputMaybe<AdSelectorBrandsFilterOptions>;
}>;

export type GetAdSelectorBrandsQuery = {
  __typename?: 'Query';
  getAdSelectorBrands: {
    __typename?: 'BrandsPage';
    total: number;
    edges: Array<{ __typename?: 'BrandEdge'; node: { __typename?: 'Brand'; id: string; name: string } }>;
  };
};

export type GetCreativeLibrariesBrandsQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;

export type GetCreativeLibrariesBrandsQuery = {
  __typename?: 'Query';
  getCreativeLibrariesBrands: Array<{
    __typename?: 'Brand';
    id: string;
    name: string;
    status: BrandStatus;
    address: {
      __typename?: 'Address';
      line1: string;
      line2: string | null;
      city: string;
      country: string;
      zipCode: string;
      state: string;
    };
  }>;
};

export type GetBrandDetailsByIdQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;

export type GetBrandDetailsByIdQuery = {
  __typename?: 'Query';
  getBrandDetailsById: {
    __typename?: 'BrandDetails';
    hasActiveCampaigns: boolean;
    brand: {
      __typename?: 'Brand';
      status: BrandStatus;
      createdAt: any | null;
      id: string;
      name: string;
      address: {
        __typename?: 'Address';
        line1: string;
        line2: string | null;
        city: string;
        country: string;
        zipCode: string;
        state: string;
      };
      industry: { __typename?: 'Industry'; id: string; name: string };
    };
    adAccountList: Array<{
      __typename?: 'AdAccount';
      id: string;
      name: string;
      status: AdAccountStatus | null;
      createdAt: any | null;
      lastLoginAt: any | null;
      fundingSource: FundingSource | null;
      accountsApprovedForTerms: boolean | null;
      approvedForPrepaymentTerms: boolean | null;
      campaignsCountStatistic: number | null;
      billableAdServer: string | null;
      invoiceByCampaign: boolean | null;
      isMatureBrand: boolean | null;
      billingCalendar: string | null;
      agencyCommissionPercentage: number | null;
      dnaListPresetId: string | null;
      dnaListAppliedByDefault: boolean | null;
      billingContact: {
        __typename?: 'BillingContact';
        id: string | null;
        firstName: string;
        lastName: string;
        email: string | null;
      } | null;
      brand: {
        __typename?: 'Brand';
        id: string;
        name: string;
        industry: { __typename?: 'Industry'; id: string; name: string };
      } | null;
      assignedUsers: Array<{
        __typename?: 'User';
        firstName: string | null;
        lastName: string | null;
        id: string;
        adAccountScopedAssignmentName: string | null;
      }> | null;
      paymentMethod: {
        __typename?: 'PaymentMethod';
        paymentMethodExternalId: string;
        paymentMethodName: string;
        lastFour: string | null;
        brand: string | null;
      } | null;
    } | null>;
  };
};

export type CreateBroadcastMutationVariables = Exact<{
  broadcastInput: BroadcastInput;
}>;

export type CreateBroadcastMutation = {
  __typename?: 'Mutation';
  createBroadcast: { __typename?: 'Broadcast'; id: string; name: string };
};

export type DeleteBroadcastMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteBroadcastMutation = { __typename?: 'Mutation'; deleteBroadcast: any | null };

export type UpdateBroadcastMutationVariables = Exact<{
  broadcastInput: BroadcastInput;
}>;

export type UpdateBroadcastMutation = {
  __typename?: 'Mutation';
  updateBroadcast: { __typename?: 'Broadcast'; id: string; name: string };
};

export type DuplicateBroadcastMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DuplicateBroadcastMutation = {
  __typename?: 'Mutation';
  duplicateBroadcast: { __typename?: 'Broadcast'; id: string; name: string };
};

export type ResumeBroadcastMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ResumeBroadcastMutation = {
  __typename?: 'Mutation';
  resumeBroadcast: { __typename?: 'Broadcast'; id: string; name: string };
};

export type SendTestEmailMutationVariables = Exact<{
  input: TestEmailInput;
}>;

export type SendTestEmailMutation = { __typename?: 'Mutation'; sendTestEmail: any | null };

export type StopBroadcastMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type StopBroadcastMutation = {
  __typename?: 'Mutation';
  stopBroadcast: { __typename?: 'Broadcast'; id: string; name: string };
};

export type GetBroadcastQueryVariables = Exact<{
  broadcastId: Scalars['ID'];
}>;

export type GetBroadcastQuery = {
  __typename?: 'Query';
  getBroadcast: {
    __typename?: 'Broadcast';
    id: string;
    name: string;
    broadcaster: string | null;
    status: BroadcastStatus;
    type: SendingType | null;
    startDateTime: string | null;
    endDateTime: string | null;
    scheduledCadence: FrequencyType | null;
    repeatDayOfWeek: Day | null;
    repeatNumberOfDayOfWeekOfMonth: number | null;
    readNotifications: number | null;
    totalNotifications: number | null;
    recipientsType: RecipientsTypes | null;
    recipients: {
      __typename?: 'RecipientInfo';
      segment: SegmentType;
      userType: UserType | null;
      includedOrganizations: Array<string> | null;
      excludedOrganizations: Array<string> | null;
      touchpoint: Touchpoint | null;
      touchPointStartDate: string | null;
      touchPointEndDate: string | null;
    } | null;
    notificationTemplate: {
      __typename?: 'NotificationTemplate';
      id: string | null;
      isEmail: boolean;
      isInApp: boolean;
      isPopUp: boolean;
      category: CategoryEnum | null;
      header: string;
      emailSubject: string | null;
      iconReference: string;
      text: string;
    } | null;
  };
};

export type GetBroadcastersQueryVariables = Exact<{
  filterOptions?: InputMaybe<BroadcasterFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
}>;

export type GetBroadcastersQuery = {
  __typename?: 'Query';
  getBroadcasters: {
    __typename?: 'BroadcastersList';
    total: number;
    edges: Array<{ __typename?: 'BroadcasterEdge'; node: { __typename?: 'Broadcaster'; id: string; name: string } }>;
  };
};

export type GetBroadcastsListQueryVariables = Exact<{
  filterOptions?: InputMaybe<BroadcastFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<BroadcastsSortOptions>;
}>;

export type GetBroadcastsListQuery = {
  __typename?: 'Query';
  getBroadcastsList: {
    __typename?: 'BroadcastPage';
    total: number;
    edges: Array<{
      __typename?: 'BroadcastEdge';
      node: {
        __typename?: 'Broadcast';
        id: string;
        name: string;
        broadcaster: string | null;
        status: BroadcastStatus;
        type: SendingType | null;
        startDateTime: string | null;
        endDateTime: string | null;
        scheduledCadence: FrequencyType | null;
        repeatDayOfWeek: Day | null;
        repeatNumberOfDayOfWeekOfMonth: number | null;
        readNotifications: number | null;
        totalNotifications: number | null;
        recipientsType: RecipientsTypes | null;
        recipients: {
          __typename?: 'RecipientInfo';
          segment: SegmentType;
          userType: UserType | null;
          includedOrganizations: Array<string> | null;
          excludedOrganizations: Array<string> | null;
          touchpoint: Touchpoint | null;
          touchPointStartDate: string | null;
          touchPointEndDate: string | null;
        } | null;
        notificationTemplate: {
          __typename?: 'NotificationTemplate';
          id: string | null;
          isEmail: boolean;
          isInApp: boolean;
          isPopUp: boolean;
          category: CategoryEnum | null;
          header: string;
          emailSubject: string | null;
          iconReference: string;
          text: string;
        } | null;
      };
    }>;
  };
};

export type PacingFragment = { __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number };

export type AdAccountForCampaignWithExtraDataFragmentFragment = {
  __typename?: 'AdAccountForCampaignWithExtraData';
  id: string;
  name: string;
};

export type GetAgeTargetingsQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type GetAgeTargetingsQuery = {
  __typename?: 'Query';
  getAgeTargetings: Array<{
    __typename?: 'TargetValue';
    id: string;
    name: string | null;
    displayName: string;
    isAllowed: boolean;
    isRequired: boolean | null;
  }>;
};

export type CampaignInfoFragment = {
  __typename?: 'CampaignInfo';
  id: string;
  adAccountId: string | null;
  name: string;
  startTime: any | null;
  endTime: any | null;
  budget: number;
  discountedBudget: number | null;
  deliveredReach: number | null;
  targetImpressions: number | null;
  publicId: number | null;
  deliveredImpressions: number | null;
  hasMajorLineItems: boolean | null;
  hasLineItems: boolean | null;
  promoCodeName: string | null;
  promoCodeDiscountPercentage: number | null;
  revisionType: string | null;
  totalLineItemCount: number | null;
  hasMoreLines: boolean | null;
  o1Id: string | null;
  timeZone: string | null;
  organizationId: string | null;
  lineItems: Array<{
    __typename?: 'LineItem';
    id: string;
    campaignId: string;
    status: string;
    adStatus: string | null;
    adFormat: string | null;
    adDuration: string | null;
    startTime: any | null;
    name: string;
    budget: number | null;
    endTime: any | null;
    targetImpressions: number | null;
    targetImpressionsBeforeDiscount: number | null;
    publicId: number | null;
    deliveredImpressions: number | null;
    deliveredReach: number | null;
    deliveredFrequency: number | null;
    unitCost: number | null;
    updatedAt: any | null;
    updatedBy: string | null;
    discountedBudget: number | null;
    discountedUnitCost: number | null;
    allowMatureContent: boolean | null;
    frequencyCapUnit: string | null;
    frequencyCap: number | null;
    revisionNumber: string;
    totalSpent: number | null;
    hasRateCardOverride: boolean | null;
    hasKervOverride: boolean | null;
    hasAdvancedOverride: boolean | null;
    hasDnaApplied: boolean | null;
    prepaymentStatus: PrepaymentStatus | null;
    ads: Array<{
      __typename?: 'AdType';
      weight: number | null;
      creative: {
        __typename?: 'LineItemCreative';
        url: string | null;
        name: string | null;
        thumbnail: string | null;
        duration: number | null;
        size: number | null;
        format: string | null;
        id: string;
        creativeLibraryId: string;
        deletable: boolean;
        status: string | null;
        creativeType: CreativeType;
        previewUrl: string | null;
        thumbnailUrl: string | null;
        experienceId: string | null;
        brandId: string | null;
        isDisneyAi: boolean | null;
        asset: {
          __typename?: 'AdAsset';
          id: string;
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          createdAt: any;
          rejectionReason: Array<string> | null;
          externalAssetId: string | null;
        } | null;
        assets: Array<{
          __typename?: 'AdAsset';
          id: string;
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          caption: string | null;
        } | null> | null;
      } | null;
      adTags: Array<{
        __typename?: 'AdTags';
        id: string;
        name: string;
        type: string;
        url: string;
        configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
      } | null> | null;
      actions: { __typename?: 'LineItemCreativeActions'; canDetach: boolean | null } | null;
      disabledReasons: { __typename?: 'LineItemCreativeDisableReasons'; detach: Array<string | null> | null } | null;
    } | null> | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    package: {
      __typename?: 'Package';
      id: string;
      title: string;
      rank: number | null;
      startDate: string | null;
      endDate: string | null;
      largeHeroImageFile: string | null;
      smallHeroImageFile: string | null;
      shortDescription: string | null;
      longDescription: string | null;
      allowDayparting: boolean | null;
      partners: Array<string | null> | null;
      selectable: boolean | null;
      showLearnMore: boolean | null;
      categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
      publishers: Array<{
        __typename?: 'PublisherType';
        id: string;
        systemName: string;
        displayName: string;
      } | null> | null;
      coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
    } | null;
    pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
    dayPartings: Array<{
      __typename?: 'DayPartings';
      friday: boolean | null;
      monday: boolean | null;
      thursday: boolean | null;
      tuesday: boolean | null;
      wednesday: boolean | null;
      sunday: boolean | null;
      saturday: boolean | null;
      lastActiveHour: number | null;
      firstActiveHour: number | null;
    } | null> | null;
    targetValues: {
      __typename?: 'LineItemTargets';
      zip: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      state: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      city: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      dma: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      platform: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      audiences: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      retargeting: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      age: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      content: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
    } | null;
    orderProduct: {
      __typename?: 'LineItemOrderProduct';
      isPreemptible: boolean | null;
      specialCategory: string | null;
    } | null;
  }> | null;
};

export type ConfigureUrlFragmentFragment = {
  __typename?: 'ConfiguredUrl';
  url: string;
  replacedValues: Record<string, string>;
};

export type GetContentTargetingsQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type GetContentTargetingsQuery = {
  __typename?: 'Query';
  getContentTargetings: Array<{
    __typename?: 'TargetValue';
    id: string;
    name: string | null;
    displayName: string;
    isAllowed: boolean;
    isRequired: boolean | null;
  }>;
};

export type DayPartingsFragment = {
  __typename?: 'DayPartings';
  friday: boolean | null;
  monday: boolean | null;
  thursday: boolean | null;
  tuesday: boolean | null;
  wednesday: boolean | null;
  sunday: boolean | null;
  saturday: boolean | null;
  lastActiveHour: number | null;
  firstActiveHour: number | null;
};

export type GetRetargetingsQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type GetRetargetingsQuery = {
  __typename?: 'Query';
  getRetargetings: Array<{
    __typename?: 'TargetValue';
    id: string;
    name: string | null;
    displayName: string;
    isAllowed: boolean;
    isRequired: boolean | null;
  }>;
};

export type LineItemCreativeFragment = {
  __typename?: 'LineItemCreative';
  id: string;
  creativeLibraryId: string;
  status: string | null;
  creativeType: CreativeType;
  name: string | null;
  thumbnail: string | null;
  duration: number | null;
  size: number | null;
  format: string | null;
  deletable: boolean;
  brandId: string | null;
  isDisneyAi: boolean | null;
  asset: {
    __typename?: 'AdAsset';
    id: string;
    name: string;
    status: CreativeStatus;
    sourceUrl: string | null;
    createdAt: any;
    externalAssetId: string | null;
    rejectionReason: Array<string> | null;
  } | null;
};

export type LineItemFragment = {
  __typename?: 'LineItem';
  id: string;
  campaignId: string;
  status: string;
  adStatus: string | null;
  adFormat: string | null;
  adDuration: string | null;
  startTime: any | null;
  name: string;
  budget: number | null;
  endTime: any | null;
  targetImpressions: number | null;
  targetImpressionsBeforeDiscount: number | null;
  publicId: number | null;
  deliveredImpressions: number | null;
  deliveredReach: number | null;
  deliveredFrequency: number | null;
  unitCost: number | null;
  updatedAt: any | null;
  updatedBy: string | null;
  discountedBudget: number | null;
  discountedUnitCost: number | null;
  allowMatureContent: boolean | null;
  frequencyCapUnit: string | null;
  frequencyCap: number | null;
  revisionNumber: string;
  totalSpent: number | null;
  hasRateCardOverride: boolean | null;
  hasKervOverride: boolean | null;
  hasAdvancedOverride: boolean | null;
  hasDnaApplied: boolean | null;
  prepaymentStatus: PrepaymentStatus | null;
  ads: Array<{
    __typename?: 'AdType';
    weight: number | null;
    creative: {
      __typename?: 'LineItemCreative';
      url: string | null;
      name: string | null;
      thumbnail: string | null;
      duration: number | null;
      size: number | null;
      format: string | null;
      id: string;
      creativeLibraryId: string;
      deletable: boolean;
      status: string | null;
      creativeType: CreativeType;
      previewUrl: string | null;
      thumbnailUrl: string | null;
      experienceId: string | null;
      brandId: string | null;
      isDisneyAi: boolean | null;
      asset: {
        __typename?: 'AdAsset';
        id: string;
        name: string;
        sourceUrl: string | null;
        status: CreativeStatus;
        createdAt: any;
        rejectionReason: Array<string> | null;
        externalAssetId: string | null;
      } | null;
      assets: Array<{
        __typename?: 'AdAsset';
        id: string;
        name: string;
        sourceUrl: string | null;
        status: CreativeStatus;
        caption: string | null;
      } | null> | null;
    } | null;
    adTags: Array<{
      __typename?: 'AdTags';
      id: string;
      name: string;
      type: string;
      url: string;
      configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
    } | null> | null;
    actions: { __typename?: 'LineItemCreativeActions'; canDetach: boolean | null } | null;
    disabledReasons: { __typename?: 'LineItemCreativeDisableReasons'; detach: Array<string | null> | null } | null;
  } | null> | null;
  publishers: Array<{
    __typename?: 'PublisherType';
    id: string;
    systemName: string;
    displayName: string;
  } | null> | null;
  package: {
    __typename?: 'Package';
    id: string;
    title: string;
    rank: number | null;
    startDate: string | null;
    endDate: string | null;
    largeHeroImageFile: string | null;
    smallHeroImageFile: string | null;
    shortDescription: string | null;
    longDescription: string | null;
    allowDayparting: boolean | null;
    partners: Array<string | null> | null;
    selectable: boolean | null;
    showLearnMore: boolean | null;
    categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
  } | null;
  pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
  dayPartings: Array<{
    __typename?: 'DayPartings';
    friday: boolean | null;
    monday: boolean | null;
    thursday: boolean | null;
    tuesday: boolean | null;
    wednesday: boolean | null;
    sunday: boolean | null;
    saturday: boolean | null;
    lastActiveHour: number | null;
    firstActiveHour: number | null;
  } | null> | null;
  targetValues: {
    __typename?: 'LineItemTargets';
    zip: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    state: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    city: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    dma: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    platform: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    audiences: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    retargeting: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    age: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    content: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
  } | null;
  orderProduct: {
    __typename?: 'LineItemOrderProduct';
    isPreemptible: boolean | null;
    specialCategory: string | null;
  } | null;
};

export type GetLocationTargetingsQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type GetLocationTargetingsQuery = {
  __typename?: 'Query';
  getLocationTargetings: Array<{
    __typename?: 'TargetValue';
    targetTypeName: string;
    id: string;
    name: string | null;
    displayName: string;
    isAllowed: boolean;
    isRequired: boolean | null;
  }>;
};

export type OrganizationForCampaignWithExtraDataFragmentFragment = {
  __typename?: 'OrganizationForCampaignWithExtraData';
  id: string;
  name: string;
};

export type GetPlatformTargetingsQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type GetPlatformTargetingsQuery = {
  __typename?: 'Query';
  getPlatformTargetings: Array<{
    __typename?: 'TargetValue';
    id: string;
    name: string | null;
    displayName: string;
    isAllowed: boolean;
    isRequired: boolean | null;
  }>;
};

export type TagFragmentFragment = {
  __typename?: 'AdTags';
  id: string;
  name: string;
  type: string;
  url: string;
  configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
};

export type TargetTypeFragmentFragment = {
  __typename?: 'LineItemTargetValue';
  id: string;
  name: string | null;
  targetTypeId: string | null;
  isExclusion: boolean | null;
  isAllowed: boolean | null;
  originalName: string | null;
};

export type TargetValueFragment = {
  __typename?: 'TargetValue';
  id: string;
  name: string | null;
  displayName: string;
  isAllowed: boolean;
  isRequired: boolean | null;
};

export type DetachPromoCodeMutationVariables = Exact<{
  campaignId: Scalars['ID'];
}>;

export type DetachPromoCodeMutation = { __typename?: 'Mutation'; detachPromoCode: any | null };

export type AdvancedOverrideMutationVariables = Exact<{
  id: Scalars['ID'];
  eligible: Scalars['Boolean'];
}>;

export type AdvancedOverrideMutation = { __typename?: 'Mutation'; advancedOverride: any | null };

export type ApplyAdChangesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ApplyAdChangesMutation = { __typename?: 'Mutation'; applyAdChanges: any | null };

export type CancelAllLineItemsByCampaignIdMutationVariables = Exact<{
  campaignId: Scalars['ID'];
}>;

export type CancelAllLineItemsByCampaignIdMutation = {
  __typename?: 'Mutation';
  cancelAllLineItemsByCampaignId: { __typename?: 'LineItem'; id: string } | null;
};

export type CloneCampaignByIdMutationVariables = Exact<{
  campaignId: Scalars['ID'];
}>;

export type CloneCampaignByIdMutation = {
  __typename?: 'Mutation';
  cloneCampaignByID: { __typename?: 'CampaignUpdateResponse'; id: string };
};

export type ConfigureUrlMutationVariables = Exact<{
  url: Scalars['String'];
}>;

export type ConfigureUrlMutation = {
  __typename?: 'Mutation';
  configureUrl: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> } | null;
};

export type CreateCampaignMutationVariables = Exact<{
  input: CampaignCreateInput;
}>;

export type CreateCampaignMutation = {
  __typename?: 'Mutation';
  createCampaign: { __typename?: 'CampaignCreateResponse'; id: string; name: string; timeZone: string | null } | null;
};

export type CreateDraftLineItemMutationVariables = Exact<{
  input: DraftLineItemInput;
}>;

export type CreateDraftLineItemMutation = {
  __typename?: 'Mutation';
  createDraftLineItem: { __typename?: 'LineItem'; id: string; name: string } | null;
};

export type DeleteCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteCampaignMutation = { __typename?: 'Mutation'; deleteCampaign: any | null };

export type DeleteDraftLineItemMutationVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type DeleteDraftLineItemMutation = { __typename?: 'Mutation'; deleteDraftLineItem: any | null };

export type EditLineItemMutationVariables = Exact<{
  lineItemUuid: Scalars['ID'];
  input: LineItemEditInput;
}>;

export type EditLineItemMutation = {
  __typename?: 'Mutation';
  editLineItem: {
    __typename?: 'LineItem';
    id: string;
    name: string;
    status: string;
    budget: number | null;
    revisionNumber: string;
  } | null;
};

export type EditLineItemDraftMutationVariables = Exact<{
  lineItemUuid: Scalars['ID'];
  input: LineItemEditInput;
}>;

export type EditLineItemDraftMutation = {
  __typename?: 'Mutation';
  editLineItemDraft: {
    __typename?: 'LineItem';
    id: string;
    name: string;
    status: string;
    budget: number | null;
    revisionNumber: string;
    updatedAt: any | null;
  } | null;
};

export type OverrideCpmMutationVariables = Exact<{
  id: Scalars['ID'];
  unitCost?: InputMaybe<Scalars['Float']>;
  cancelOverride?: InputMaybe<Scalars['Boolean']>;
}>;

export type OverrideCpmMutation = { __typename?: 'Mutation'; overrideCPM: any | null };

export type OverrideKervMutationVariables = Exact<{
  id: Scalars['ID'];
  eligible: Scalars['Boolean'];
}>;

export type OverrideKervMutation = { __typename?: 'Mutation'; overrideKERV: any | null };

export type QuickActionLineItemByIdMutationVariables = Exact<{
  lineItemId: Scalars['ID'];
  action: LineItemQuickAction;
}>;

export type QuickActionLineItemByIdMutation = {
  __typename?: 'Mutation';
  quickActionLineItemByID: { __typename?: 'LineItem'; id: string };
};

export type QuickActionReportByIdMutationVariables = Exact<{
  reportId: Scalars['ID'];
  action: ReportQuickAction;
}>;

export type QuickActionReportByIdMutation = {
  __typename?: 'Mutation';
  quickActionReportByID: { __typename?: 'ReportInfo'; externalId: string } | null;
};

export type SubmitLineItemsMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  lineItemUuids: Array<LineItemSourceIdInput> | LineItemSourceIdInput;
}>;

export type SubmitLineItemsMutation = {
  __typename?: 'Mutation';
  submitLineItems: Array<{ __typename?: 'LineItem'; id: string } | null> | null;
};

export type SendPromoCodeMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  promoCodeName: Scalars['String'];
}>;

export type SendPromoCodeMutation = { __typename?: 'Mutation'; sendPromoCode: any | null };

export type UpdateCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateCampaign;
}>;

export type UpdateCampaignMutation = {
  __typename?: 'Mutation';
  updateCampaign: {
    __typename?: 'CampaignUpdateResponse';
    id: string;
    name: string | null;
    timeZone: string | null;
  } | null;
};

export type UpdateDraftLineItemMutationVariables = Exact<{
  lineItemId: Scalars['ID'];
  input: UpdateDraftLineItem;
}>;

export type UpdateDraftLineItemMutation = {
  __typename?: 'Mutation';
  updateDraftLineItem: {
    __typename?: 'LineItem';
    name: string;
    id: string;
    startTime: any | null;
    endTime: any | null;
    status: string;
    adDuration: string | null;
    adFormat: string | null;
    adStatus: string | null;
    targetImpressions: number | null;
    deliveredImpressions: number | null;
    ifpAvailableImpressions: number | null;
    ifpForecastRunAt: any | null;
    deliveredFrequency: number | null;
    discountedBudget: number | null;
    budget: number | null;
    frequencyCap: number | null;
    frequencyCapUnit: string | null;
    pacingStatus: PacingStatus | null;
    updatedAt: any | null;
    allowMatureContent: boolean | null;
    totalSpent: number | null;
    updatedBy: string | null;
    revisionNumber: string;
    unitCost: number | null;
    discountedUnitCost: number | null;
    hasDnaApplied: boolean | null;
    prepaymentStatus: PrepaymentStatus | null;
    pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    package: {
      __typename?: 'Package';
      id: string;
      title: string;
      rank: number | null;
      startDate: string | null;
      endDate: string | null;
      largeHeroImageFile: string | null;
      smallHeroImageFile: string | null;
      shortDescription: string | null;
      longDescription: string | null;
      allowDayparting: boolean | null;
      partners: Array<string | null> | null;
      selectable: boolean | null;
      showLearnMore: boolean | null;
      categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
      publishers: Array<{
        __typename?: 'PublisherType';
        id: string;
        systemName: string;
        displayName: string;
      } | null> | null;
      coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
    } | null;
    dayPartings: Array<{
      __typename?: 'DayPartings';
      friday: boolean | null;
      monday: boolean | null;
      thursday: boolean | null;
      tuesday: boolean | null;
      wednesday: boolean | null;
      sunday: boolean | null;
      saturday: boolean | null;
      lastActiveHour: number | null;
      firstActiveHour: number | null;
    } | null> | null;
    ads: Array<{
      __typename?: 'AdType';
      weight: number | null;
      creative: {
        __typename?: 'LineItemCreative';
        url: string | null;
        thumbnailUrl: string | null;
        duration: number | null;
        size: number | null;
        format: string | null;
        id: string;
        creativeLibraryId: string;
        deletable: boolean;
        status: string | null;
        creativeType: CreativeType;
        name: string | null;
        experienceId: string | null;
        previewUrl: string | null;
        asset: {
          __typename?: 'AdAsset';
          id: string;
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          createdAt: any;
        } | null;
      } | null;
      adTags: Array<{
        __typename?: 'AdTags';
        id: string;
        name: string;
        type: string;
        url: string;
        configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
      } | null> | null;
      actions: { __typename?: 'LineItemCreativeActions'; canDetach: boolean | null } | null;
      disabledReasons: { __typename?: 'LineItemCreativeDisableReasons'; detach: Array<string | null> | null } | null;
    } | null> | null;
    targetValues: {
      __typename?: 'LineItemTargets';
      zip: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      state: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      city: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      dma: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      platform: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      audiences: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      retargeting: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      age: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      content: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
    } | null;
    orderProduct: { __typename?: 'LineItemOrderProduct'; isPreemptible: boolean | null } | null;
  } | null;
};

export type UpdateLineItemAds3PTagsMutationVariables = Exact<{
  lineItemId: Scalars['ID'];
  ads: Array<InputMaybe<UpdateAdType>> | InputMaybe<UpdateAdType>;
}>;

export type UpdateLineItemAds3PTagsMutation = {
  __typename?: 'Mutation';
  updateLineItemAds3PTags: { __typename?: 'LineItem'; id: string } | null;
};

export type UpdateLineItemPackageIdMutationVariables = Exact<{
  lineItemId: Scalars['ID'];
  packageId: Scalars['ID'];
}>;

export type UpdateLineItemPackageIdMutation = {
  __typename?: 'Mutation';
  updateLineItemPackageId: { __typename?: 'LineItem'; id: string } | null;
};

export type AssetsForLineItemQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
  includeAssets?: InputMaybe<Scalars['Boolean']>;
}>;

export type AssetsForLineItemQuery = {
  __typename?: 'Query';
  lineItemById: {
    __typename?: 'LineItem';
    adStatus: string | null;
    ads: Array<{
      __typename?: 'AdType';
      weight: number | null;
      creative: {
        __typename?: 'LineItemCreative';
        url: string | null;
        name: string | null;
        thumbnail: string | null;
        duration: number | null;
        size: number | null;
        format: string | null;
        id: string;
        creativeLibraryId: string;
        deletable: boolean;
        status: string | null;
        creativeType: CreativeType;
        previewUrl: string | null;
        thumbnailUrl: string | null;
        asset: {
          __typename?: 'AdAsset';
          id: string;
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          createdAt: any;
          rejectionReason: Array<string> | null;
        } | null;
        assets: Array<{
          __typename?: 'AdAsset';
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          caption: string | null;
          format: string | null;
          size: number | null;
          duration: number | null;
          createdAt: any;
        } | null> | null;
      } | null;
      adTags: Array<{
        __typename?: 'AdTags';
        id: string;
        name: string;
        type: string;
        url: string;
        configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
      } | null> | null;
      actions: { __typename?: 'LineItemCreativeActions'; canDetach: boolean | null } | null;
      disabledReasons: { __typename?: 'LineItemCreativeDisableReasons'; detach: Array<string | null> | null } | null;
    } | null> | null;
  };
};

export type GetCampaignsNamesAndIdsQueryVariables = Exact<{
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  adAccountIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  schedule?: InputMaybe<CampaignSearchScheduleInput>;
}>;

export type GetCampaignsNamesAndIdsQuery = {
  __typename?: 'Query';
  getCampaignsNamesAndIds: {
    __typename?: 'CampaignsShortInfoPage';
    total: number;
    edges: Array<{
      __typename?: 'CampaignShortInfoEdge';
      node: { __typename?: 'CampaignShortInfo'; id: string; name: string };
    }>;
  };
};

export type GetLineItemsWithDifferentCpmQueryVariables = Exact<{
  id: Scalars['ID'];
  lineItemList?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetLineItemsWithDifferentCpmQuery = {
  __typename?: 'Query';
  checkCpmValuesInLineItems: Array<{ __typename?: 'LineItemWithDifferentCPM'; id: string; name: string } | null>;
};

export type GetMinimalBudgetToReserveKervLineItemQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type GetMinimalBudgetToReserveKervLineItemQuery = {
  __typename?: 'Query';
  getMinimalBudgetToReserveKERVLineItem: { __typename?: 'KERVMinimalBudget'; budget: number };
};

export type GetPackageByIdQueryVariables = Exact<{
  packageId: Scalars['ID'];
}>;

export type GetPackageByIdQuery = {
  __typename?: 'Query';
  getPackageById: {
    __typename?: 'PackageFullInfo';
    id: string;
    title: string;
    rank: number;
    presetId: string | null;
    startDate: string | null;
    endDate: string | null;
    largeHeroImageFile: string | null;
    smallHeroImageFile: string | null;
    shortDescription: string | null;
    longDescription: string | null;
    buyingPlatforms: Array<string> | null;
    contentTitle: string | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
    carouselImages: Array<{
      __typename?: 'CarouselImage';
      externalId: string;
      imageFileName: string;
      rank: number;
    }> | null;
    contents: Array<{
      __typename?: 'ContentItem';
      externalId: string;
      name: string;
      imageFileName: string | null;
      rank: number;
    }> | null;
    coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
  };
};

export type GetPackagesQueryVariables = Exact<{
  adAccountId?: InputMaybe<Scalars['ID']>;
}>;

export type GetPackagesQuery = {
  __typename?: 'Query';
  getPackages: Array<{
    __typename?: 'Package';
    id: string;
    title: string;
    rank: number | null;
    startDate: string | null;
    endDate: string | null;
    largeHeroImageFile: string | null;
    smallHeroImageFile: string | null;
    shortDescription: string | null;
    longDescription: string | null;
    allowDayparting: boolean | null;
    partners: Array<string | null> | null;
    selectable: boolean | null;
    showLearnMore: boolean | null;
    categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
  }>;
};

export type GetPackagesByLineItemIdQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
  startTime?: InputMaybe<Scalars['Date']>;
  endTime?: InputMaybe<Scalars['Date']>;
  query?: InputMaybe<Scalars['String']>;
}>;

export type GetPackagesByLineItemIdQuery = {
  __typename?: 'Query';
  getPackagesByLineItemID: Array<{
    __typename?: 'Package';
    id: string;
    title: string;
    rank: number | null;
    startDate: string | null;
    endDate: string | null;
    largeHeroImageFile: string | null;
    smallHeroImageFile: string | null;
    shortDescription: string | null;
    longDescription: string | null;
    allowDayparting: boolean | null;
    partners: Array<string | null> | null;
    selectable: boolean | null;
    showLearnMore: boolean | null;
    categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
  }>;
};

export type PublisherTypeFragment = {
  __typename?: 'PublisherType';
  id: string;
  systemName: string;
  displayName: string;
};

export type GetPublisherTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetPublisherTypesQuery = {
  __typename?: 'Query';
  getPublisherTypes: Array<{ __typename?: 'PublisherType'; id: string; displayName: string; systemName: string }>;
};

export type GetCampaignsStatisticsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']>;
  sellerId?: InputMaybe<Scalars['ID']>;
  packageId?: InputMaybe<Scalars['ID']>;
  hamIndustryName?: InputMaybe<Scalars['String']>;
  organizationCrmLinkType?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;

export type GetCampaignsStatisticsQuery = {
  __typename?: 'Query';
  getCampaignsStatistics: {
    __typename?: 'CampaignsStatistics';
    submittedBudget: number;
    submittedAndDraftedBudget: number;
    conversionRate: number | null;
    sellerAssistedConversionRate: number | null;
  };
};

export type ExportCampaignsSummaryQueryVariables = Exact<{
  filterOptions?: InputMaybe<CampaignsExportFilterOptions>;
}>;

export type ExportCampaignsSummaryQuery = { __typename?: 'Query'; exportCampaignsSummary: string };

export type CheckIfZipCodesAreAllowedQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type CheckIfZipCodesAreAllowedQuery = { __typename?: 'Query'; checkIfZipCodesAreAllowed: boolean | null };

export type GetAudiencesQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type GetAudiencesQuery = {
  __typename?: 'Query';
  getAudiences: Array<{
    __typename?: 'Audiences';
    id: string;
    name: string;
    displayName: string;
    expiryDate: any | null;
    isRequired: boolean | null;
    isAllowed: boolean | null;
    politicalAdVisibility: boolean | null;
    specialAdVisibility: boolean | null;
    visible: boolean;
    hierarchy: { __typename?: 'Hierarchy'; source: string; tiers: Array<string> } | null;
    targetType: {
      __typename?: 'AudiencesTargetType';
      id: string;
      name: string;
      displayName: string;
      isAllowed: boolean;
    };
  }>;
};

export type GetCampaignByUuidQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  lineItemList?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;

export type GetCampaignByUuidQuery = {
  __typename?: 'Query';
  getCampaignByUUID: {
    __typename?: 'CampaignInfo';
    id: string;
    adAccountId: string | null;
    name: string;
    startTime: any | null;
    endTime: any | null;
    budget: number;
    discountedBudget: number | null;
    deliveredReach: number | null;
    targetImpressions: number | null;
    publicId: number | null;
    deliveredImpressions: number | null;
    hasMajorLineItems: boolean | null;
    hasLineItems: boolean | null;
    promoCodeName: string | null;
    promoCodeDiscountPercentage: number | null;
    revisionType: string | null;
    totalLineItemCount: number | null;
    hasMoreLines: boolean | null;
    o1Id: string | null;
    timeZone: string | null;
    organizationId: string | null;
    lineItems: Array<{
      __typename?: 'LineItem';
      id: string;
      campaignId: string;
      status: string;
      adStatus: string | null;
      adFormat: string | null;
      adDuration: string | null;
      startTime: any | null;
      name: string;
      budget: number | null;
      endTime: any | null;
      targetImpressions: number | null;
      targetImpressionsBeforeDiscount: number | null;
      publicId: number | null;
      deliveredImpressions: number | null;
      deliveredReach: number | null;
      deliveredFrequency: number | null;
      unitCost: number | null;
      updatedAt: any | null;
      updatedBy: string | null;
      discountedBudget: number | null;
      discountedUnitCost: number | null;
      allowMatureContent: boolean | null;
      frequencyCapUnit: string | null;
      frequencyCap: number | null;
      revisionNumber: string;
      totalSpent: number | null;
      hasRateCardOverride: boolean | null;
      hasKervOverride: boolean | null;
      hasAdvancedOverride: boolean | null;
      hasDnaApplied: boolean | null;
      prepaymentStatus: PrepaymentStatus | null;
      ads: Array<{
        __typename?: 'AdType';
        weight: number | null;
        creative: {
          __typename?: 'LineItemCreative';
          url: string | null;
          name: string | null;
          thumbnail: string | null;
          duration: number | null;
          size: number | null;
          format: string | null;
          id: string;
          creativeLibraryId: string;
          deletable: boolean;
          status: string | null;
          creativeType: CreativeType;
          previewUrl: string | null;
          thumbnailUrl: string | null;
          experienceId: string | null;
          brandId: string | null;
          isDisneyAi: boolean | null;
          asset: {
            __typename?: 'AdAsset';
            id: string;
            name: string;
            sourceUrl: string | null;
            status: CreativeStatus;
            createdAt: any;
            rejectionReason: Array<string> | null;
            externalAssetId: string | null;
          } | null;
          assets: Array<{
            __typename?: 'AdAsset';
            id: string;
            name: string;
            sourceUrl: string | null;
            status: CreativeStatus;
            caption: string | null;
          } | null> | null;
        } | null;
        adTags: Array<{
          __typename?: 'AdTags';
          id: string;
          name: string;
          type: string;
          url: string;
          configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
        } | null> | null;
        actions: { __typename?: 'LineItemCreativeActions'; canDetach: boolean | null } | null;
        disabledReasons: { __typename?: 'LineItemCreativeDisableReasons'; detach: Array<string | null> | null } | null;
      } | null> | null;
      publishers: Array<{
        __typename?: 'PublisherType';
        id: string;
        systemName: string;
        displayName: string;
      } | null> | null;
      package: {
        __typename?: 'Package';
        id: string;
        title: string;
        rank: number | null;
        startDate: string | null;
        endDate: string | null;
        largeHeroImageFile: string | null;
        smallHeroImageFile: string | null;
        shortDescription: string | null;
        longDescription: string | null;
        allowDayparting: boolean | null;
        partners: Array<string | null> | null;
        selectable: boolean | null;
        showLearnMore: boolean | null;
        categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
        publishers: Array<{
          __typename?: 'PublisherType';
          id: string;
          systemName: string;
          displayName: string;
        } | null> | null;
        coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
      } | null;
      pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
      dayPartings: Array<{
        __typename?: 'DayPartings';
        friday: boolean | null;
        monday: boolean | null;
        thursday: boolean | null;
        tuesday: boolean | null;
        wednesday: boolean | null;
        sunday: boolean | null;
        saturday: boolean | null;
        lastActiveHour: number | null;
        firstActiveHour: number | null;
      } | null> | null;
      targetValues: {
        __typename?: 'LineItemTargets';
        zip: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        state: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        city: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        dma: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        platform: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        audiences: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        retargeting: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        age: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        content: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
      } | null;
      orderProduct: {
        __typename?: 'LineItemOrderProduct';
        isPreemptible: boolean | null;
        specialCategory: string | null;
      } | null;
    }> | null;
  };
};

export type GetCampaignByUuidWithRevisionQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  lineItemList?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  revisionType?: InputMaybe<Scalars['String']>;
}>;

export type GetCampaignByUuidWithRevisionQuery = {
  __typename?: 'Query';
  getCampaignByUUIDWithRevision: {
    __typename?: 'CampaignInfo';
    id: string;
    adAccountId: string | null;
    name: string;
    startTime: any | null;
    endTime: any | null;
    budget: number;
    discountedBudget: number | null;
    deliveredReach: number | null;
    targetImpressions: number | null;
    publicId: number | null;
    deliveredImpressions: number | null;
    hasMajorLineItems: boolean | null;
    hasLineItems: boolean | null;
    promoCodeName: string | null;
    promoCodeDiscountPercentage: number | null;
    revisionType: string | null;
    totalLineItemCount: number | null;
    hasMoreLines: boolean | null;
    o1Id: string | null;
    timeZone: string | null;
    organizationId: string | null;
    lineItems: Array<{
      __typename?: 'LineItem';
      id: string;
      campaignId: string;
      status: string;
      adStatus: string | null;
      adFormat: string | null;
      adDuration: string | null;
      startTime: any | null;
      name: string;
      budget: number | null;
      endTime: any | null;
      targetImpressions: number | null;
      targetImpressionsBeforeDiscount: number | null;
      publicId: number | null;
      deliveredImpressions: number | null;
      deliveredReach: number | null;
      deliveredFrequency: number | null;
      unitCost: number | null;
      updatedAt: any | null;
      updatedBy: string | null;
      discountedBudget: number | null;
      discountedUnitCost: number | null;
      allowMatureContent: boolean | null;
      frequencyCapUnit: string | null;
      frequencyCap: number | null;
      revisionNumber: string;
      totalSpent: number | null;
      hasRateCardOverride: boolean | null;
      hasKervOverride: boolean | null;
      hasAdvancedOverride: boolean | null;
      hasDnaApplied: boolean | null;
      prepaymentStatus: PrepaymentStatus | null;
      ads: Array<{
        __typename?: 'AdType';
        weight: number | null;
        creative: {
          __typename?: 'LineItemCreative';
          url: string | null;
          name: string | null;
          thumbnail: string | null;
          duration: number | null;
          size: number | null;
          format: string | null;
          id: string;
          creativeLibraryId: string;
          deletable: boolean;
          status: string | null;
          creativeType: CreativeType;
          previewUrl: string | null;
          thumbnailUrl: string | null;
          experienceId: string | null;
          brandId: string | null;
          isDisneyAi: boolean | null;
          asset: {
            __typename?: 'AdAsset';
            id: string;
            name: string;
            sourceUrl: string | null;
            status: CreativeStatus;
            createdAt: any;
            rejectionReason: Array<string> | null;
            externalAssetId: string | null;
          } | null;
          assets: Array<{
            __typename?: 'AdAsset';
            id: string;
            name: string;
            sourceUrl: string | null;
            status: CreativeStatus;
            caption: string | null;
          } | null> | null;
        } | null;
        adTags: Array<{
          __typename?: 'AdTags';
          id: string;
          name: string;
          type: string;
          url: string;
          configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
        } | null> | null;
        actions: { __typename?: 'LineItemCreativeActions'; canDetach: boolean | null } | null;
        disabledReasons: { __typename?: 'LineItemCreativeDisableReasons'; detach: Array<string | null> | null } | null;
      } | null> | null;
      publishers: Array<{
        __typename?: 'PublisherType';
        id: string;
        systemName: string;
        displayName: string;
      } | null> | null;
      package: {
        __typename?: 'Package';
        id: string;
        title: string;
        rank: number | null;
        startDate: string | null;
        endDate: string | null;
        largeHeroImageFile: string | null;
        smallHeroImageFile: string | null;
        shortDescription: string | null;
        longDescription: string | null;
        allowDayparting: boolean | null;
        partners: Array<string | null> | null;
        selectable: boolean | null;
        showLearnMore: boolean | null;
        categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
        publishers: Array<{
          __typename?: 'PublisherType';
          id: string;
          systemName: string;
          displayName: string;
        } | null> | null;
        coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
      } | null;
      pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
      dayPartings: Array<{
        __typename?: 'DayPartings';
        friday: boolean | null;
        monday: boolean | null;
        thursday: boolean | null;
        tuesday: boolean | null;
        wednesday: boolean | null;
        sunday: boolean | null;
        saturday: boolean | null;
        lastActiveHour: number | null;
        firstActiveHour: number | null;
      } | null> | null;
      targetValues: {
        __typename?: 'LineItemTargets';
        zip: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        state: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        city: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        dma: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        platform: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        audiences: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        retargeting: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        age: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        content: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
      } | null;
      orderProduct: {
        __typename?: 'LineItemOrderProduct';
        isPreemptible: boolean | null;
        specialCategory: string | null;
      } | null;
    }> | null;
  };
};

export type GetCampaignCountQueryVariables = Exact<{
  adAccountIds: Array<Scalars['String']> | Scalars['String'];
  isSubmitted?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetCampaignCountQuery = { __typename?: 'Query'; campaignCount: { __typename?: 'Campaign'; count: number } };

export type GetCampaignsQueryVariables = Exact<{
  filterOptions: CampaignsFilterOptions;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<CampaignsSortOptions>;
  includeTargetAllowed?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetCampaignsQuery = {
  __typename?: 'Query';
  getCampaigns: {
    __typename?: 'CampaignsPage';
    total: number;
    edges: Array<{
      __typename?: 'CampaignEdge';
      node: {
        __typename?: 'CampaignInfo';
        id: string;
        adAccountId: string | null;
        name: string;
        startTime: any | null;
        endTime: any | null;
        budget: number;
        discountedBudget: number | null;
        deliveredReach: number | null;
        targetImpressions: number | null;
        publicId: number | null;
        deliveredImpressions: number | null;
        hasMajorLineItems: boolean | null;
        hasLineItems: boolean | null;
        promoCodeName: string | null;
        promoCodeDiscountPercentage: number | null;
        revisionType: string | null;
        totalLineItemCount: number | null;
        hasMoreLines: boolean | null;
        o1Id: string | null;
        timeZone: string | null;
        organizationId: string | null;
        lineItems: Array<{
          __typename?: 'LineItem';
          id: string;
          campaignId: string;
          status: string;
          adStatus: string | null;
          adFormat: string | null;
          adDuration: string | null;
          startTime: any | null;
          name: string;
          budget: number | null;
          endTime: any | null;
          targetImpressions: number | null;
          targetImpressionsBeforeDiscount: number | null;
          publicId: number | null;
          deliveredImpressions: number | null;
          deliveredReach: number | null;
          deliveredFrequency: number | null;
          unitCost: number | null;
          updatedAt: any | null;
          updatedBy: string | null;
          discountedBudget: number | null;
          discountedUnitCost: number | null;
          allowMatureContent: boolean | null;
          frequencyCapUnit: string | null;
          frequencyCap: number | null;
          revisionNumber: string;
          totalSpent: number | null;
          hasRateCardOverride: boolean | null;
          hasKervOverride: boolean | null;
          hasAdvancedOverride: boolean | null;
          hasDnaApplied: boolean | null;
          prepaymentStatus: PrepaymentStatus | null;
          ads: Array<{
            __typename?: 'AdType';
            weight: number | null;
            creative: {
              __typename?: 'LineItemCreative';
              url: string | null;
              name: string | null;
              thumbnail: string | null;
              duration: number | null;
              size: number | null;
              format: string | null;
              id: string;
              creativeLibraryId: string;
              deletable: boolean;
              status: string | null;
              creativeType: CreativeType;
              previewUrl: string | null;
              thumbnailUrl: string | null;
              experienceId: string | null;
              brandId: string | null;
              isDisneyAi: boolean | null;
              asset: {
                __typename?: 'AdAsset';
                id: string;
                name: string;
                sourceUrl: string | null;
                status: CreativeStatus;
                createdAt: any;
                rejectionReason: Array<string> | null;
                externalAssetId: string | null;
              } | null;
              assets: Array<{
                __typename?: 'AdAsset';
                id: string;
                name: string;
                sourceUrl: string | null;
                status: CreativeStatus;
                caption: string | null;
              } | null> | null;
            } | null;
            adTags: Array<{
              __typename?: 'AdTags';
              id: string;
              name: string;
              type: string;
              url: string;
              configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
            } | null> | null;
            actions: { __typename?: 'LineItemCreativeActions'; canDetach: boolean | null } | null;
            disabledReasons: {
              __typename?: 'LineItemCreativeDisableReasons';
              detach: Array<string | null> | null;
            } | null;
          } | null> | null;
          publishers: Array<{
            __typename?: 'PublisherType';
            id: string;
            systemName: string;
            displayName: string;
          } | null> | null;
          package: {
            __typename?: 'Package';
            id: string;
            title: string;
            rank: number | null;
            startDate: string | null;
            endDate: string | null;
            largeHeroImageFile: string | null;
            smallHeroImageFile: string | null;
            shortDescription: string | null;
            longDescription: string | null;
            allowDayparting: boolean | null;
            partners: Array<string | null> | null;
            selectable: boolean | null;
            showLearnMore: boolean | null;
            categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
            publishers: Array<{
              __typename?: 'PublisherType';
              id: string;
              systemName: string;
              displayName: string;
            } | null> | null;
            coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
          } | null;
          pacingSchedules: Array<{
            __typename?: 'PacingValues';
            startTime: any;
            endTime: any;
            pacingShare: number;
          }> | null;
          dayPartings: Array<{
            __typename?: 'DayPartings';
            friday: boolean | null;
            monday: boolean | null;
            thursday: boolean | null;
            tuesday: boolean | null;
            wednesday: boolean | null;
            sunday: boolean | null;
            saturday: boolean | null;
            lastActiveHour: number | null;
            firstActiveHour: number | null;
          } | null> | null;
          targetValues: {
            __typename?: 'LineItemTargets';
            zip: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            state: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            city: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            dma: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            platform: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            audiences: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            retargeting: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            age: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            content: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
          } | null;
          orderProduct: {
            __typename?: 'LineItemOrderProduct';
            isPreemptible: boolean | null;
            specialCategory: string | null;
          } | null;
        }> | null;
      };
    }>;
  };
};

export type CampaignInfoWithExtraDataFragment = {
  __typename?: 'CampaignInfoWithExtraData';
  id: string;
  publicId: number | null;
  name: string | null;
  submittedAt: any | null;
  startTime: any | null;
  endTime: any | null;
  timezone: string | null;
  totalSpent: number | null;
  budget: number | null;
  discountedBudget: number | null;
  targetImpressions: number | null;
  deliveredImpressions: number | null;
  deliveredReach: number | null;
  deliveredFrequency: number | null;
  hasMoreLines: boolean | null;
  promoCodeName: string | null;
  adAccount: { __typename?: 'AdAccountForCampaignWithExtraData'; id: string; name: string } | null;
  organization: { __typename?: 'OrganizationForCampaignWithExtraData'; id: string; name: string } | null;
  lineItems: Array<{
    __typename?: 'LineItemWithExtraData';
    id: string;
    publicId: number | null;
    pacingStatus: PacingStatus | null;
    deliveredReach: number | null;
    deliveredFrequency: number | null;
    submittedAt: any | null;
    totalSpent: number | null;
    adTagsExist: boolean | null;
    unitCost: number | null;
    status: string | null;
    adStatus: string | null;
    startTime: any | null;
    name: string | null;
    budget: number | null;
    endTime: any | null;
    targetImpressions: number | null;
    deliveredImpressions: number | null;
    ifpAvailableImpressions: number | null;
    ifpForecastRunAt: any | null;
    updatedAt: any | null;
    updatedBy: string | null;
    discountedBudget: number | null;
    discountedUnitCost: number | null;
    allowMatureContent: boolean | null;
    frequencyCapUnit: string | null;
    adFormat: string | null;
    frequencyCap: number | null;
    revisionNumber: number | null;
    rateCardId: string | null;
    hasRateCardOverride: boolean | null;
    hasKervOverride: boolean | null;
    hasAdvancedOverride: boolean | null;
    ads: Array<{
      __typename?: 'AdType';
      creative: {
        __typename?: 'LineItemCreative';
        url: string | null;
        thumbnail: string | null;
        duration: number | null;
        size: number | null;
        format: string | null;
        id: string;
        creativeLibraryId: string;
        deletable: boolean;
        status: string | null;
        creativeType: CreativeType;
        name: string | null;
        brandId: string | null;
        isDisneyAi: boolean | null;
        asset: {
          __typename?: 'AdAsset';
          id: string;
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          createdAt: any;
          rejectionReason: Array<string> | null;
          externalAssetId: string | null;
        } | null;
      } | null;
      adTags: Array<{
        __typename?: 'AdTags';
        id: string;
        name: string;
        type: string;
        url: string;
        configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
      } | null> | null;
    } | null> | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    package: {
      __typename?: 'Package';
      id: string;
      title: string;
      rank: number | null;
      startDate: string | null;
      endDate: string | null;
      largeHeroImageFile: string | null;
      smallHeroImageFile: string | null;
      shortDescription: string | null;
      longDescription: string | null;
      allowDayparting: boolean | null;
      partners: Array<string | null> | null;
      selectable: boolean | null;
      showLearnMore: boolean | null;
      categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
      publishers: Array<{
        __typename?: 'PublisherType';
        id: string;
        systemName: string;
        displayName: string;
      } | null> | null;
      coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
    } | null;
    pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
    orderProduct: {
      __typename?: 'LineItemOrderProduct';
      isPreemptible: boolean | null;
      specialCategory: string | null;
    } | null;
    dayPartings: Array<{
      __typename?: 'DayPartings';
      friday: boolean | null;
      monday: boolean | null;
      thursday: boolean | null;
      tuesday: boolean | null;
      wednesday: boolean | null;
      sunday: boolean | null;
      saturday: boolean | null;
      lastActiveHour: number | null;
      firstActiveHour: number | null;
    } | null> | null;
    targetValues: {
      __typename?: 'LineItemTargets';
      zip: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      state: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      city: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      dma: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      platform: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      audiences: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      retargeting: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      age: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      content: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
    } | null;
  }> | null;
};

export type GetCampaignsWithExtraDataQueryVariables = Exact<{
  filterOptions?: InputMaybe<CampaignsFilterOptionsWithExtraData>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<CampaignsStrictSortOptions>;
}>;

export type GetCampaignsWithExtraDataQuery = {
  __typename?: 'Query';
  getCampaignsWithExtraData: {
    __typename?: 'CampaignsPageWithExtraData';
    total: number;
    edges: Array<{
      __typename?: 'CampaignEdgeWithExtraData';
      node: {
        __typename?: 'CampaignInfoWithExtraData';
        id: string;
        publicId: number | null;
        name: string | null;
        submittedAt: any | null;
        startTime: any | null;
        endTime: any | null;
        timezone: string | null;
        totalSpent: number | null;
        budget: number | null;
        discountedBudget: number | null;
        targetImpressions: number | null;
        deliveredImpressions: number | null;
        deliveredReach: number | null;
        deliveredFrequency: number | null;
        hasMoreLines: boolean | null;
        promoCodeName: string | null;
        adAccount: { __typename?: 'AdAccountForCampaignWithExtraData'; id: string; name: string } | null;
        organization: { __typename?: 'OrganizationForCampaignWithExtraData'; id: string; name: string } | null;
        lineItems: Array<{
          __typename?: 'LineItemWithExtraData';
          id: string;
          publicId: number | null;
          pacingStatus: PacingStatus | null;
          deliveredReach: number | null;
          deliveredFrequency: number | null;
          submittedAt: any | null;
          totalSpent: number | null;
          adTagsExist: boolean | null;
          unitCost: number | null;
          status: string | null;
          adStatus: string | null;
          startTime: any | null;
          name: string | null;
          budget: number | null;
          endTime: any | null;
          targetImpressions: number | null;
          deliveredImpressions: number | null;
          ifpAvailableImpressions: number | null;
          ifpForecastRunAt: any | null;
          updatedAt: any | null;
          updatedBy: string | null;
          discountedBudget: number | null;
          discountedUnitCost: number | null;
          allowMatureContent: boolean | null;
          frequencyCapUnit: string | null;
          adFormat: string | null;
          frequencyCap: number | null;
          revisionNumber: number | null;
          rateCardId: string | null;
          hasRateCardOverride: boolean | null;
          hasKervOverride: boolean | null;
          hasAdvancedOverride: boolean | null;
          ads: Array<{
            __typename?: 'AdType';
            creative: {
              __typename?: 'LineItemCreative';
              url: string | null;
              thumbnail: string | null;
              duration: number | null;
              size: number | null;
              format: string | null;
              id: string;
              creativeLibraryId: string;
              deletable: boolean;
              status: string | null;
              creativeType: CreativeType;
              name: string | null;
              brandId: string | null;
              isDisneyAi: boolean | null;
              asset: {
                __typename?: 'AdAsset';
                id: string;
                name: string;
                sourceUrl: string | null;
                status: CreativeStatus;
                createdAt: any;
                rejectionReason: Array<string> | null;
                externalAssetId: string | null;
              } | null;
            } | null;
            adTags: Array<{
              __typename?: 'AdTags';
              id: string;
              name: string;
              type: string;
              url: string;
              configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
            } | null> | null;
          } | null> | null;
          publishers: Array<{
            __typename?: 'PublisherType';
            id: string;
            systemName: string;
            displayName: string;
          } | null> | null;
          package: {
            __typename?: 'Package';
            id: string;
            title: string;
            rank: number | null;
            startDate: string | null;
            endDate: string | null;
            largeHeroImageFile: string | null;
            smallHeroImageFile: string | null;
            shortDescription: string | null;
            longDescription: string | null;
            allowDayparting: boolean | null;
            partners: Array<string | null> | null;
            selectable: boolean | null;
            showLearnMore: boolean | null;
            categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
            publishers: Array<{
              __typename?: 'PublisherType';
              id: string;
              systemName: string;
              displayName: string;
            } | null> | null;
            coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
          } | null;
          pacingSchedules: Array<{
            __typename?: 'PacingValues';
            startTime: any;
            endTime: any;
            pacingShare: number;
          }> | null;
          orderProduct: {
            __typename?: 'LineItemOrderProduct';
            isPreemptible: boolean | null;
            specialCategory: string | null;
          } | null;
          dayPartings: Array<{
            __typename?: 'DayPartings';
            friday: boolean | null;
            monday: boolean | null;
            thursday: boolean | null;
            tuesday: boolean | null;
            wednesday: boolean | null;
            sunday: boolean | null;
            saturday: boolean | null;
            lastActiveHour: number | null;
            firstActiveHour: number | null;
          } | null> | null;
          targetValues: {
            __typename?: 'LineItemTargets';
            zip: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            state: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            city: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            dma: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            platform: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            audiences: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            retargeting: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            age: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
            content: Array<{
              __typename?: 'LineItemTargetValue';
              id: string;
              name: string | null;
              targetTypeId: string | null;
              isExclusion: boolean | null;
              isAllowed: boolean | null;
              originalName: string | null;
            } | null> | null;
          } | null;
        }> | null;
      };
    }>;
  };
};

export type LineItemWithExtraDataFragment = {
  __typename?: 'LineItemWithExtraData';
  id: string;
  publicId: number | null;
  pacingStatus: PacingStatus | null;
  deliveredReach: number | null;
  deliveredFrequency: number | null;
  submittedAt: any | null;
  totalSpent: number | null;
  adTagsExist: boolean | null;
  unitCost: number | null;
  status: string | null;
  adStatus: string | null;
  startTime: any | null;
  name: string | null;
  budget: number | null;
  endTime: any | null;
  targetImpressions: number | null;
  deliveredImpressions: number | null;
  ifpAvailableImpressions: number | null;
  ifpForecastRunAt: any | null;
  updatedAt: any | null;
  updatedBy: string | null;
  discountedBudget: number | null;
  discountedUnitCost: number | null;
  allowMatureContent: boolean | null;
  frequencyCapUnit: string | null;
  adFormat: string | null;
  frequencyCap: number | null;
  revisionNumber: number | null;
  rateCardId: string | null;
  hasRateCardOverride: boolean | null;
  hasKervOverride: boolean | null;
  hasAdvancedOverride: boolean | null;
  ads: Array<{
    __typename?: 'AdType';
    creative: {
      __typename?: 'LineItemCreative';
      url: string | null;
      thumbnail: string | null;
      duration: number | null;
      size: number | null;
      format: string | null;
      id: string;
      creativeLibraryId: string;
      deletable: boolean;
      status: string | null;
      creativeType: CreativeType;
      name: string | null;
      brandId: string | null;
      isDisneyAi: boolean | null;
      asset: {
        __typename?: 'AdAsset';
        id: string;
        name: string;
        sourceUrl: string | null;
        status: CreativeStatus;
        createdAt: any;
        rejectionReason: Array<string> | null;
        externalAssetId: string | null;
      } | null;
    } | null;
    adTags: Array<{
      __typename?: 'AdTags';
      id: string;
      name: string;
      type: string;
      url: string;
      configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
    } | null> | null;
  } | null> | null;
  publishers: Array<{
    __typename?: 'PublisherType';
    id: string;
    systemName: string;
    displayName: string;
  } | null> | null;
  package: {
    __typename?: 'Package';
    id: string;
    title: string;
    rank: number | null;
    startDate: string | null;
    endDate: string | null;
    largeHeroImageFile: string | null;
    smallHeroImageFile: string | null;
    shortDescription: string | null;
    longDescription: string | null;
    allowDayparting: boolean | null;
    partners: Array<string | null> | null;
    selectable: boolean | null;
    showLearnMore: boolean | null;
    categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
  } | null;
  pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
  orderProduct: {
    __typename?: 'LineItemOrderProduct';
    isPreemptible: boolean | null;
    specialCategory: string | null;
  } | null;
  dayPartings: Array<{
    __typename?: 'DayPartings';
    friday: boolean | null;
    monday: boolean | null;
    thursday: boolean | null;
    tuesday: boolean | null;
    wednesday: boolean | null;
    sunday: boolean | null;
    saturday: boolean | null;
    lastActiveHour: number | null;
    firstActiveHour: number | null;
  } | null> | null;
  targetValues: {
    __typename?: 'LineItemTargets';
    zip: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    state: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    city: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    dma: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    platform: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    audiences: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    retargeting: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    age: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
    content: Array<{
      __typename?: 'LineItemTargetValue';
      id: string;
      name: string | null;
      targetTypeId: string | null;
      isExclusion: boolean | null;
      isAllowed: boolean | null;
      originalName: string | null;
    } | null> | null;
  } | null;
};

export type GetInventoryDetailQueryVariables = Exact<{
  input?: InputMaybe<InventoryDetailInput>;
}>;

export type GetInventoryDetailQuery = {
  __typename?: 'Query';
  getInventoryDetail: {
    __typename?: 'InventoryDetail';
    availableInventory: number | null;
    suggestions: Array<string | null>;
    availableInventoryPercentage: number;
  };
};

export type LineItemByIdQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
  shouldValidate?: InputMaybe<Scalars['Boolean']>;
  lastMajor?: InputMaybe<Scalars['Boolean']>;
  adAccountId?: InputMaybe<Scalars['ID']>;
}>;

export type LineItemByIdQuery = {
  __typename?: 'Query';
  lineItemById: {
    __typename?: 'LineItem';
    id: string;
    campaignId: string;
    status: string;
    adStatus: string | null;
    adFormat: string | null;
    adDuration: string | null;
    startTime: any | null;
    name: string;
    budget: number | null;
    endTime: any | null;
    targetImpressions: number | null;
    targetImpressionsBeforeDiscount: number | null;
    publicId: number | null;
    deliveredImpressions: number | null;
    deliveredReach: number | null;
    deliveredFrequency: number | null;
    unitCost: number | null;
    updatedAt: any | null;
    updatedBy: string | null;
    discountedBudget: number | null;
    discountedUnitCost: number | null;
    allowMatureContent: boolean | null;
    frequencyCapUnit: string | null;
    frequencyCap: number | null;
    revisionNumber: string;
    totalSpent: number | null;
    hasRateCardOverride: boolean | null;
    hasKervOverride: boolean | null;
    hasAdvancedOverride: boolean | null;
    hasDnaApplied: boolean | null;
    prepaymentStatus: PrepaymentStatus | null;
    ads: Array<{
      __typename?: 'AdType';
      weight: number | null;
      creative: {
        __typename?: 'LineItemCreative';
        url: string | null;
        name: string | null;
        thumbnail: string | null;
        duration: number | null;
        size: number | null;
        format: string | null;
        id: string;
        creativeLibraryId: string;
        deletable: boolean;
        status: string | null;
        creativeType: CreativeType;
        previewUrl: string | null;
        thumbnailUrl: string | null;
        experienceId: string | null;
        brandId: string | null;
        isDisneyAi: boolean | null;
        asset: {
          __typename?: 'AdAsset';
          id: string;
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          createdAt: any;
          rejectionReason: Array<string> | null;
          externalAssetId: string | null;
        } | null;
        assets: Array<{
          __typename?: 'AdAsset';
          id: string;
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          caption: string | null;
        } | null> | null;
      } | null;
      adTags: Array<{
        __typename?: 'AdTags';
        id: string;
        name: string;
        type: string;
        url: string;
        configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
      } | null> | null;
      actions: { __typename?: 'LineItemCreativeActions'; canDetach: boolean | null } | null;
      disabledReasons: { __typename?: 'LineItemCreativeDisableReasons'; detach: Array<string | null> | null } | null;
    } | null> | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    package: {
      __typename?: 'Package';
      id: string;
      title: string;
      rank: number | null;
      startDate: string | null;
      endDate: string | null;
      largeHeroImageFile: string | null;
      smallHeroImageFile: string | null;
      shortDescription: string | null;
      longDescription: string | null;
      allowDayparting: boolean | null;
      partners: Array<string | null> | null;
      selectable: boolean | null;
      showLearnMore: boolean | null;
      categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
      publishers: Array<{
        __typename?: 'PublisherType';
        id: string;
        systemName: string;
        displayName: string;
      } | null> | null;
      coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
    } | null;
    pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
    dayPartings: Array<{
      __typename?: 'DayPartings';
      friday: boolean | null;
      monday: boolean | null;
      thursday: boolean | null;
      tuesday: boolean | null;
      wednesday: boolean | null;
      sunday: boolean | null;
      saturday: boolean | null;
      lastActiveHour: number | null;
      firstActiveHour: number | null;
    } | null> | null;
    targetValues: {
      __typename?: 'LineItemTargets';
      zip: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      state: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      city: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      dma: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      platform: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      audiences: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      retargeting: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      age: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      content: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
    } | null;
    orderProduct: {
      __typename?: 'LineItemOrderProduct';
      isPreemptible: boolean | null;
      specialCategory: string | null;
    } | null;
  };
};

export type LineItemByIdWithRevisionsQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type LineItemByIdWithRevisionsQuery = {
  __typename?: 'Query';
  lineItemByIdWithRevisions: Array<{
    __typename?: 'LineItem';
    id: string;
    campaignId: string;
    status: string;
    adStatus: string | null;
    adFormat: string | null;
    adDuration: string | null;
    startTime: any | null;
    name: string;
    budget: number | null;
    endTime: any | null;
    targetImpressions: number | null;
    targetImpressionsBeforeDiscount: number | null;
    publicId: number | null;
    deliveredImpressions: number | null;
    deliveredReach: number | null;
    deliveredFrequency: number | null;
    unitCost: number | null;
    updatedAt: any | null;
    updatedBy: string | null;
    discountedBudget: number | null;
    discountedUnitCost: number | null;
    allowMatureContent: boolean | null;
    frequencyCapUnit: string | null;
    frequencyCap: number | null;
    revisionNumber: string;
    totalSpent: number | null;
    hasRateCardOverride: boolean | null;
    hasKervOverride: boolean | null;
    hasAdvancedOverride: boolean | null;
    hasDnaApplied: boolean | null;
    prepaymentStatus: PrepaymentStatus | null;
    ads: Array<{
      __typename?: 'AdType';
      weight: number | null;
      creative: {
        __typename?: 'LineItemCreative';
        url: string | null;
        name: string | null;
        thumbnail: string | null;
        duration: number | null;
        size: number | null;
        format: string | null;
        id: string;
        creativeLibraryId: string;
        deletable: boolean;
        status: string | null;
        creativeType: CreativeType;
        previewUrl: string | null;
        thumbnailUrl: string | null;
        experienceId: string | null;
        brandId: string | null;
        isDisneyAi: boolean | null;
        asset: {
          __typename?: 'AdAsset';
          id: string;
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          createdAt: any;
          rejectionReason: Array<string> | null;
          externalAssetId: string | null;
        } | null;
        assets: Array<{
          __typename?: 'AdAsset';
          id: string;
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          caption: string | null;
        } | null> | null;
      } | null;
      adTags: Array<{
        __typename?: 'AdTags';
        id: string;
        name: string;
        type: string;
        url: string;
        configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
      } | null> | null;
      actions: { __typename?: 'LineItemCreativeActions'; canDetach: boolean | null } | null;
      disabledReasons: { __typename?: 'LineItemCreativeDisableReasons'; detach: Array<string | null> | null } | null;
    } | null> | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    package: {
      __typename?: 'Package';
      id: string;
      title: string;
      rank: number | null;
      startDate: string | null;
      endDate: string | null;
      largeHeroImageFile: string | null;
      smallHeroImageFile: string | null;
      shortDescription: string | null;
      longDescription: string | null;
      allowDayparting: boolean | null;
      partners: Array<string | null> | null;
      selectable: boolean | null;
      showLearnMore: boolean | null;
      categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
      publishers: Array<{
        __typename?: 'PublisherType';
        id: string;
        systemName: string;
        displayName: string;
      } | null> | null;
      coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
    } | null;
    pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
    dayPartings: Array<{
      __typename?: 'DayPartings';
      friday: boolean | null;
      monday: boolean | null;
      thursday: boolean | null;
      tuesday: boolean | null;
      wednesday: boolean | null;
      sunday: boolean | null;
      saturday: boolean | null;
      lastActiveHour: number | null;
      firstActiveHour: number | null;
    } | null> | null;
    targetValues: {
      __typename?: 'LineItemTargets';
      zip: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      state: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      city: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      dma: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      platform: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      audiences: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      retargeting: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      age: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      content: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
    } | null;
    orderProduct: {
      __typename?: 'LineItemOrderProduct';
      isPreemptible: boolean | null;
      specialCategory: string | null;
    } | null;
  }> | null;
};

export type GetLineItemsByCampaignIdQueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions?: InputMaybe<LineItemsByCampaignIdFilterOptions>;
}>;

export type GetLineItemsByCampaignIdQuery = {
  __typename?: 'Query';
  getLineItemsByCampaignId: Array<{
    __typename?: 'LineItem';
    name: string;
    id: string;
    startTime: any | null;
    endTime: any | null;
    status: string;
    adStatus: string | null;
    discountedBudget: number | null;
    targetImpressions: number | null;
    deliveredImpressions: number | null;
    ifpAvailableImpressions: number | null;
    ifpForecastRunAt: any | null;
    deliveredFrequency: number | null;
    budget: number | null;
    frequencyCap: number | null;
    frequencyCapUnit: string | null;
    pacingStatus: PacingStatus | null;
    allowMatureContent: boolean | null;
    unitCost: number | null;
    discountedUnitCost: number | null;
    totalSpent: number | null;
    updatedAt: any | null;
    updatedBy: string | null;
    adFormat: string | null;
    prepaymentStatus: PrepaymentStatus | null;
    pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
    publishers: Array<{
      __typename?: 'PublisherType';
      id: string;
      systemName: string;
      displayName: string;
    } | null> | null;
    package: {
      __typename?: 'Package';
      id: string;
      title: string;
      rank: number | null;
      startDate: string | null;
      endDate: string | null;
      largeHeroImageFile: string | null;
      smallHeroImageFile: string | null;
      shortDescription: string | null;
      longDescription: string | null;
      allowDayparting: boolean | null;
      partners: Array<string | null> | null;
      selectable: boolean | null;
      showLearnMore: boolean | null;
      categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
      publishers: Array<{
        __typename?: 'PublisherType';
        id: string;
        systemName: string;
        displayName: string;
      } | null> | null;
      coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
    } | null;
    dayPartings: Array<{
      __typename?: 'DayPartings';
      friday: boolean | null;
      monday: boolean | null;
      thursday: boolean | null;
      tuesday: boolean | null;
      wednesday: boolean | null;
      sunday: boolean | null;
      saturday: boolean | null;
      lastActiveHour: number | null;
      firstActiveHour: number | null;
    } | null> | null;
    ads: Array<{
      __typename?: 'AdType';
      creative: {
        __typename?: 'LineItemCreative';
        url: string | null;
        thumbnailUrl: string | null;
        duration: number | null;
        size: number | null;
        format: string | null;
        deletable: boolean;
        id: string;
        creativeLibraryId: string;
        status: string | null;
        creativeType: CreativeType;
        asset: {
          __typename?: 'AdAsset';
          id: string;
          name: string;
          sourceUrl: string | null;
          status: CreativeStatus;
          createdAt: any;
        } | null;
      } | null;
      adTags: Array<{
        __typename?: 'AdTags';
        id: string;
        name: string;
        type: string;
        url: string;
        configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
      } | null> | null;
    } | null> | null;
    targetValues: {
      __typename?: 'LineItemTargets';
      zip: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      state: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      city: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      dma: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      platform: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      audiences: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      retargeting: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      age: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
      content: Array<{
        __typename?: 'LineItemTargetValue';
        id: string;
        name: string | null;
        targetTypeId: string | null;
        isExclusion: boolean | null;
        isAllowed: boolean | null;
        originalName: string | null;
      } | null> | null;
    } | null;
    orderProduct: { __typename?: 'LineItemOrderProduct'; isPreemptible: boolean | null } | null;
  }> | null;
};

export type GetLineItemsTotalCountQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  lineItemList?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;

export type GetLineItemsTotalCountQuery = {
  __typename?: 'Query';
  getCampaignByUUID: { __typename?: 'CampaignInfo'; lineItems: Array<{ __typename?: 'LineItem'; id: string }> | null };
};

export type CheckIfMatureContentIsAllowedQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;

export type CheckIfMatureContentIsAllowedQuery = {
  __typename?: 'Query';
  checkIfMatureContentIsAllowed: boolean | null;
};

export type GetReportByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetReportByIdQuery = {
  __typename?: 'Query';
  getReportById: {
    __typename?: 'DeprecatedReport';
    id: string;
    status: string | null;
    startTime: any | null;
    endTime: any | null;
    emailNow: boolean | null;
    campaign: {
      __typename?: 'CampaignReportResponse';
      adAccountId: string | null;
      id: string;
      name: string | null;
      sfOpportunityId: string | null;
      sourceSystem: string | null;
    } | null;
    targetTypes: Array<{
      __typename?: 'TargetType';
      displayName: string | null;
      id: string;
      name: string;
    } | null> | null;
    lineItems: Array<{
      __typename?: 'LineItem';
      id: string;
      campaignId: string;
      status: string;
      adStatus: string | null;
      adFormat: string | null;
      adDuration: string | null;
      startTime: any | null;
      name: string;
      budget: number | null;
      endTime: any | null;
      targetImpressions: number | null;
      targetImpressionsBeforeDiscount: number | null;
      publicId: number | null;
      deliveredImpressions: number | null;
      deliveredReach: number | null;
      deliveredFrequency: number | null;
      unitCost: number | null;
      updatedAt: any | null;
      updatedBy: string | null;
      discountedBudget: number | null;
      discountedUnitCost: number | null;
      allowMatureContent: boolean | null;
      frequencyCapUnit: string | null;
      frequencyCap: number | null;
      revisionNumber: string;
      totalSpent: number | null;
      hasRateCardOverride: boolean | null;
      hasKervOverride: boolean | null;
      hasAdvancedOverride: boolean | null;
      hasDnaApplied: boolean | null;
      prepaymentStatus: PrepaymentStatus | null;
      ads: Array<{
        __typename?: 'AdType';
        weight: number | null;
        creative: {
          __typename?: 'LineItemCreative';
          url: string | null;
          name: string | null;
          thumbnail: string | null;
          duration: number | null;
          size: number | null;
          format: string | null;
          id: string;
          creativeLibraryId: string;
          deletable: boolean;
          status: string | null;
          creativeType: CreativeType;
          previewUrl: string | null;
          thumbnailUrl: string | null;
          experienceId: string | null;
          brandId: string | null;
          isDisneyAi: boolean | null;
          asset: {
            __typename?: 'AdAsset';
            id: string;
            name: string;
            sourceUrl: string | null;
            status: CreativeStatus;
            createdAt: any;
            rejectionReason: Array<string> | null;
            externalAssetId: string | null;
          } | null;
          assets: Array<{
            __typename?: 'AdAsset';
            id: string;
            name: string;
            sourceUrl: string | null;
            status: CreativeStatus;
            caption: string | null;
          } | null> | null;
        } | null;
        adTags: Array<{
          __typename?: 'AdTags';
          id: string;
          name: string;
          type: string;
          url: string;
          configuredAdTag: { __typename?: 'ConfiguredUrl'; url: string; replacedValues: Record<string, string> };
        } | null> | null;
        actions: { __typename?: 'LineItemCreativeActions'; canDetach: boolean | null } | null;
        disabledReasons: { __typename?: 'LineItemCreativeDisableReasons'; detach: Array<string | null> | null } | null;
      } | null> | null;
      publishers: Array<{
        __typename?: 'PublisherType';
        id: string;
        systemName: string;
        displayName: string;
      } | null> | null;
      package: {
        __typename?: 'Package';
        id: string;
        title: string;
        rank: number | null;
        startDate: string | null;
        endDate: string | null;
        largeHeroImageFile: string | null;
        smallHeroImageFile: string | null;
        shortDescription: string | null;
        longDescription: string | null;
        allowDayparting: boolean | null;
        partners: Array<string | null> | null;
        selectable: boolean | null;
        showLearnMore: boolean | null;
        categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
        publishers: Array<{
          __typename?: 'PublisherType';
          id: string;
          systemName: string;
          displayName: string;
        } | null> | null;
        coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
      } | null;
      pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
      dayPartings: Array<{
        __typename?: 'DayPartings';
        friday: boolean | null;
        monday: boolean | null;
        thursday: boolean | null;
        tuesday: boolean | null;
        wednesday: boolean | null;
        sunday: boolean | null;
        saturday: boolean | null;
        lastActiveHour: number | null;
        firstActiveHour: number | null;
      } | null> | null;
      targetValues: {
        __typename?: 'LineItemTargets';
        zip: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        state: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        city: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        dma: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        platform: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        audiences: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        retargeting: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        age: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
        content: Array<{
          __typename?: 'LineItemTargetValue';
          id: string;
          name: string | null;
          targetTypeId: string | null;
          isExclusion: boolean | null;
          isAllowed: boolean | null;
          originalName: string | null;
        } | null> | null;
      } | null;
      orderProduct: {
        __typename?: 'LineItemOrderProduct';
        isPreemptible: boolean | null;
        specialCategory: string | null;
      } | null;
    } | null> | null;
  };
};

export type GetTimezonesQueryVariables = Exact<{ [key: string]: never }>;

export type GetTimezonesQuery = {
  __typename?: 'Query';
  getTimezones: Array<{ __typename?: 'Timezone'; value: string; label: string }>;
};

export type GetAdAccountAndOrganizationStatusesQueryVariables = Exact<{
  adAccountId: Scalars['ID'];
  orgId: Scalars['ID'];
}>;

export type GetAdAccountAndOrganizationStatusesQuery = {
  __typename?: 'Query';
  getAdAccountAndOrganizationStatuses: {
    __typename?: 'AdAccountAndOrganizationStatuses';
    adAccountStatus: AdAccountStatus;
    organizationStatus: OrganizationStatus;
  };
};

export type GetZipCodesQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
  zipCodes: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetZipCodesQuery = {
  __typename?: 'Query';
  getZipCodes: Array<{
    __typename?: 'TargetValue';
    targetTypeName: string;
    id: string;
    name: string | null;
    displayName: string;
    isAllowed: boolean;
    isRequired: boolean | null;
  }>;
};

export type GetLineItemsByCampaignIdV2QueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions?: InputMaybe<LineItemsByCampaignIdV2FilterOptions>;
  paginationOptions?: InputMaybe<PaginationLimit>;
  sortOptions?: InputMaybe<LineItemsByCampaignV2SortOptions>;
}>;

export type GetLineItemsByCampaignIdV2Query = {
  __typename?: 'Query';
  getLineItemsByCampaignIdV2: Array<{
    __typename?: 'LineItemByCampaignIdV2';
    id: string;
    name: string;
    startTime: any | null;
    endTime: any | null;
    ifpAvailableImpressions: number | null;
    ifpForecastRunAt: any | null;
    pacingStatus: PacingStatus | null;
    deliveredFrequency: number | null;
    targetImpressions: number | null;
    deliveredImpressions: number | null;
    discountedBudget: number | null;
    budget: number | null;
    deliveredReach: number | null;
    totalSpent: number | null;
    status: string;
    adStatus: AdStatus | null;
    adFormat: string | null;
    organizationId: string | null;
    unitCost: number | null;
    hasRateCardOverride: boolean | null;
    rateCardId: string | null;
    dayPartings: Array<{
      __typename?: 'DayPartings';
      friday: boolean | null;
      monday: boolean | null;
      thursday: boolean | null;
      tuesday: boolean | null;
      wednesday: boolean | null;
      sunday: boolean | null;
      saturday: boolean | null;
      lastActiveHour: number | null;
      firstActiveHour: number | null;
    } | null> | null;
    pacingSchedules: Array<{ __typename?: 'PacingValues'; startTime: any; endTime: any; pacingShare: number }> | null;
    package: {
      __typename?: 'Package';
      id: string;
      title: string;
      rank: number | null;
      startDate: string | null;
      endDate: string | null;
      largeHeroImageFile: string | null;
      smallHeroImageFile: string | null;
      shortDescription: string | null;
      longDescription: string | null;
      allowDayparting: boolean | null;
      partners: Array<string | null> | null;
      selectable: boolean | null;
      showLearnMore: boolean | null;
      categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
      publishers: Array<{
        __typename?: 'PublisherType';
        id: string;
        systemName: string;
        displayName: string;
      } | null> | null;
      coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
    } | null;
  }>;
};

export type LineItemEditCurrentStateQueryVariables = Exact<{
  lineItemUuid: Scalars['ID'];
}>;

export type LineItemEditCurrentStateQuery = {
  __typename?: 'Query';
  lineItemEditCurrentState: {
    __typename?: 'LineItemStateSnapshot';
    name: string | null;
    startTime: string | null;
    endTime: string | null;
    budget: number | null;
    platformTargets: Array<PlatformTarget> | null;
    genreTargets: Array<string> | null;
    geoTargets: Array<{ __typename?: 'GeoTarget'; type: GeoTargetType; id: string }> | null;
    demoTargets: Array<{ __typename?: 'DemoTarget'; type: DemoTargetType; id: string }> | null;
    audienceTargets: Array<{ __typename?: 'AudienceTarget'; id: string; premiumType: AudiencePremiumType }> | null;
    ads: Array<{
      __typename?: 'AdSnapshot';
      creativeId: string;
      weight: number | null;
      adTags: Array<{
        __typename?: 'AdSnapshotTag';
        id: string | null;
        type: string;
        url: string;
        name: string;
      }> | null;
    }> | null;
  };
};

export type LineItemEditValidationRoleQueryVariables = Exact<{ [key: string]: never }>;

export type LineItemEditValidationRoleQuery = {
  __typename?: 'Query';
  lineItemEditValidationRole: {
    __typename?: 'EditValidationRoleResponse';
    role: LineItemEditRole | null;
    securityEnabled: boolean;
  };
};

export type LineItemEstimatedCostQueryVariables = Exact<{
  input: LineItemEstimatedCostInput;
}>;

export type LineItemEstimatedCostQuery = {
  __typename?: 'Query';
  lineItemEstimatedCost: {
    __typename?: 'LineItemEstimatedCost';
    estimatedDailyImpressions: number;
    impressions: number;
    unitCost: number;
    preEmptibleAvailable: boolean;
  };
};

export type ValidateLineItemEditQueryVariables = Exact<{
  input: LineItemEditInput;
}>;

export type ValidateLineItemEditQuery = {
  __typename?: 'Query';
  validateLineItemEdit: {
    __typename?: 'LineItemEditValidationResponse';
    valid: boolean;
    keepsCpmUnchanged: boolean;
    violatedRules: Array<{
      __typename?: 'RuleViolation';
      ruleCode: RuleViolationCode;
      field: string | null;
      message: string;
    }>;
  };
};

export type AdAssetFragment = {
  __typename?: 'AdAsset';
  id: string;
  name: string;
  status: CreativeStatus;
  sourceUrl: string | null;
  createdAt: any;
  externalAssetId: string | null;
  rejectionReason: Array<string> | null;
};

export type AdBrandFragment = { __typename?: 'AdBrand'; id: string | null; name: string };

export type AdInfoFragment = {
  __typename?: 'AdInfo';
  id: string;
  creativeLibraryId: string;
  creativeManagerId: string | null;
  status: CreativeStatus;
  creativeType: string;
  duration: number | null;
  size: number | null;
  format: string | null;
  deletable: boolean;
  assetS3Url: string | null;
  isDisneyAi: boolean | null;
  asset: {
    __typename?: 'AdAsset';
    id: string;
    name: string;
    status: CreativeStatus;
    sourceUrl: string | null;
    createdAt: any;
    externalAssetId: string | null;
    rejectionReason: Array<string> | null;
  };
  brand: { __typename?: 'AdBrand'; id: string | null; name: string };
  submittedBy: {
    __typename?: 'SubmittedBy';
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    isPublisher: boolean | null;
  } | null;
};

export type CloneCreativeMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  creativeId: Scalars['ID'];
}>;

export type CloneCreativeMutation = {
  __typename?: 'Mutation';
  cloneCreative: {
    __typename?: 'CloneCreativeResult';
    creativeId: string;
    status: CreativeLibraryStatus;
    creativeManagerId: string | null;
    experienceId: string | null;
    adFormat: AdFormat | null;
    thumbnailUrl: string | null;
    previewUrl: string | null;
  };
};

export type DeleteAdGalleryCreativeMutationVariables = Exact<{
  creativeId: Scalars['ID'];
}>;

export type DeleteAdGalleryCreativeMutation = { __typename?: 'Mutation'; deleteCreative: any | null };

export type DeleteAssetMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  assetSourceId: Scalars['ID'];
}>;

export type DeleteAssetMutation = { __typename?: 'Mutation'; deleteAsset: any | null };

export type DeleteCreativeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteCreativeMutation = { __typename?: 'Mutation'; deleteCreative: any | null };

export type DeleteDxcCreativeMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  creativeId: Scalars['ID'];
}>;

export type DeleteDxcCreativeMutation = { __typename?: 'Mutation'; deleteDxcCreative: any | null };

export type DeleteLineItemCreativeByRevisionMutationVariables = Exact<{
  lineItemId: Scalars['ID'];
  lineItemVersion: Scalars['String'];
  creativeId: Scalars['ID'];
}>;

export type DeleteLineItemCreativeByRevisionMutation = {
  __typename?: 'Mutation';
  deleteLineItemCreativeByRevision: any | null;
};

export type LinkAssetMutationVariables = Exact<{
  organizationId: Scalars['String'];
  brandId: Scalars['String'];
  s3Key: Scalars['String'];
  assetType: Scalars['String'];
  adFormat?: InputMaybe<AdFormat>;
}>;

export type LinkAssetMutation = {
  __typename?: 'Mutation';
  linkAsset: { __typename?: 'LinkAssetResult'; assetId: string; assetSourceId: string | null };
};

export type LinkVideoCreativeMutationVariables = Exact<{
  organizationId: Scalars['String'];
  brandId: Scalars['String'];
  s3Key: Scalars['String'];
}>;

export type LinkVideoCreativeMutation = {
  __typename?: 'Mutation';
  linkVideoCreative: {
    __typename?: 'AdInfo';
    id: string;
    creativeLibraryId: string;
    creativeManagerId: string | null;
    status: CreativeStatus;
    creativeType: string;
    duration: number | null;
    size: number | null;
    format: string | null;
    deletable: boolean;
    assetS3Url: string | null;
    isDisneyAi: boolean | null;
    lineItems: Array<{
      __typename?: 'CreativeLineItemInfo';
      id: string;
      name: string;
      status: string;
      adAccountId: string;
    } | null> | null;
    asset: {
      __typename?: 'AdAsset';
      id: string;
      name: string;
      status: CreativeStatus;
      sourceUrl: string | null;
      createdAt: any;
      externalAssetId: string | null;
      rejectionReason: Array<string> | null;
    };
    brand: { __typename?: 'AdBrand'; id: string | null; name: string };
    submittedBy: {
      __typename?: 'SubmittedBy';
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      isPublisher: boolean | null;
    } | null;
  };
};

export type SaveDxcCreativeMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  brandId: Scalars['String'];
  creativeManagerId: Scalars['ID'];
  experienceId: Scalars['ID'];
}>;

export type SaveDxcCreativeMutation = {
  __typename?: 'Mutation';
  saveDxcCreative: {
    __typename?: 'DxcCreative';
    adFormat: AdFormat | null;
    creativeId: string;
    creativeManagerId: string;
    experienceId: string | null;
    name: string | null;
    previewUrl: string | null;
    status: CreativeLibraryStatus;
    thumbnailUrl: string | null;
  };
};

export type SubmitDxcCreativeMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  creativeId: Scalars['ID'];
}>;

export type SubmitDxcCreativeMutation = {
  __typename?: 'Mutation';
  submitDxcCreative: {
    __typename?: 'DxcCreative';
    adFormat: AdFormat | null;
    creativeId: string;
    creativeManagerId: string;
    experienceId: string | null;
    name: string | null;
    previewUrl: string | null;
    status: CreativeLibraryStatus;
    thumbnailUrl: string | null;
  };
};

export type UpdateCreativeNameMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  creativeId: Scalars['ID'];
  name: Scalars['String'];
}>;

export type UpdateCreativeNameMutation = {
  __typename?: 'Mutation';
  updateCreativeName: { __typename?: 'UpdateCreativeNameResult'; creativeId: string; name: string };
};

export type AssetLibrarySearchQueryVariables = Exact<{
  input: AssetLibrarySearchInput;
}>;

export type AssetLibrarySearchQuery = {
  __typename?: 'Query';
  assetLibrarySearch: {
    __typename?: 'AssetLibrarySearchPayloadPage';
    total: number;
    edges: Array<{
      __typename?: 'AssetEdge';
      node: {
        __typename?: 'AssetLibraryItem';
        assetId: string;
        name: string | null;
        status: AssetStatus | null;
        sourceUrl: string | null;
        createdAt: any;
        size: number | null;
        format: string | null;
        duration: number | null;
        actions: {
          __typename?: 'AssetActions';
          canAttach: boolean | null;
          disabledReasons: {
            __typename?: 'AssetDisableReasons';
            delete: Array<string | null> | null;
            attach: Array<string | null> | null;
          } | null;
        } | null;
      };
    }>;
  };
};

export type CreativeQueryVariables = Exact<{
  id: Scalars['ID'];
  includeUserData?: InputMaybe<Scalars['Boolean']>;
}>;

export type CreativeQuery = {
  __typename?: 'Query';
  creative: {
    __typename?: 'AdInfo';
    id: string;
    creativeLibraryId: string;
    creativeManagerId: string | null;
    status: CreativeStatus;
    creativeType: string;
    duration: number | null;
    size: number | null;
    format: string | null;
    deletable: boolean;
    assetS3Url: string | null;
    isDisneyAi: boolean | null;
    lineItems: Array<{
      __typename?: 'CreativeLineItemInfo';
      id: string;
      name: string;
      status: string;
      adAccountId: string;
    } | null> | null;
    submittedBy: {
      __typename?: 'SubmittedBy';
      id: string;
      firstName: string | null;
      lastName: string | null;
      email: string;
      isPublisher: boolean | null;
    } | null;
    asset: {
      __typename?: 'AdAsset';
      id: string;
      name: string;
      status: CreativeStatus;
      sourceUrl: string | null;
      createdAt: any;
      externalAssetId: string | null;
      rejectionReason: Array<string> | null;
    };
    brand: { __typename?: 'AdBrand'; id: string | null; name: string };
  };
};

export type AssetDetailsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  assetId: Scalars['ID'];
}>;

export type AssetDetailsQuery = {
  __typename?: 'Query';
  assetDetails: {
    __typename?: 'AssetDetails';
    assetId: string;
    assetSourceId: string | null;
    assetType: AssetType | null;
    name: string | null;
    status: AssetStatus | null;
    sourceUrl: string | null;
    createdAt: any | null;
    brandId: string | null;
    brandName: string | null;
    rejectionReason: Array<string> | null;
    format: string | null;
    size: number | null;
    duration: number | null;
    actions: {
      __typename?: 'AssetActions';
      canDelete: boolean | null;
      disabledReasons: { __typename?: 'AssetDisableReasons'; delete: Array<string | null> | null } | null;
    } | null;
  };
};

export type CreativeDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CreativeDetailsQuery = {
  __typename?: 'Query';
  creativeDetails: {
    __typename?: 'CreativeDetails';
    id: string;
    adFormat: AdFormat | null;
    name: string | null;
    status: CreativeLibraryStatus | null;
    thumbnailUrl: string | null;
    previewUrl: string | null;
    createdAt: any | null;
    experienceId: string | null;
    creativeManagerId: string | null;
    rejectionReason: Array<string> | null;
    isDisneyAi: boolean | null;
    size: number | null;
    duration: number | null;
    format: string | null;
    asset: {
      __typename?: 'CreativeDetailsAsset';
      sourceUrl: string | null;
      rejectionReason: Array<string> | null;
      createdAt: any | null;
    } | null;
    brand: { __typename?: 'CreativeDetailsBrand'; id: string | null; name: string | null } | null;
    lineItems: Array<{
      __typename?: 'CreativeLineItemInfo';
      id: string;
      name: string;
      status: string;
      adAccountId: string;
    }> | null;
    actions: {
      __typename?: 'CreativeActions';
      canAttach: boolean | null;
      canClone: boolean | null;
      canDelete: boolean | null;
      disabledReasons: {
        __typename?: 'CreativeDisableReasons';
        attach: Array<string | null> | null;
        clone: Array<string | null> | null;
        delete: Array<string | null> | null;
      } | null;
    } | null;
  };
};

export type GetCreativesByOrgIdQueryVariables = Exact<{
  orgId: Scalars['ID'];
  includeUserData?: InputMaybe<Scalars['Boolean']>;
  filterOptions?: InputMaybe<AdFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<AdSortOptions>;
}>;

export type GetCreativesByOrgIdQuery = {
  __typename?: 'Query';
  getCreativesByOrgId: {
    __typename?: 'AdsList';
    total: number;
    edges: Array<{
      __typename?: 'AdEdge';
      node: {
        __typename?: 'AdInfo';
        id: string;
        creativeLibraryId: string;
        creativeManagerId: string | null;
        status: CreativeStatus;
        creativeType: string;
        duration: number | null;
        size: number | null;
        format: string | null;
        deletable: boolean;
        assetS3Url: string | null;
        isDisneyAi: boolean | null;
        asset: {
          __typename?: 'AdAsset';
          id: string;
          name: string;
          status: CreativeStatus;
          sourceUrl: string | null;
          createdAt: any;
          externalAssetId: string | null;
          rejectionReason: Array<string> | null;
        };
        brand: { __typename?: 'AdBrand'; id: string | null; name: string };
        submittedBy: {
          __typename?: 'SubmittedBy';
          id: string;
          email: string;
          firstName: string | null;
          lastName: string | null;
          isPublisher: boolean | null;
        } | null;
      };
    }>;
  };
};

export type CreativeLibrarySearchQueryVariables = Exact<{
  input: CreativeLibrarySearchInput;
}>;

export type CreativeLibrarySearchQuery = {
  __typename?: 'Query';
  creativeLibrarySearch: {
    __typename?: 'CreativeLibrarySearchPayloadPage';
    total: number;
    edges: Array<{
      __typename?: 'CreativeEdge';
      node: {
        __typename?: 'CreativeLibraryItem';
        creativeId: string;
        name: string | null;
        createdAt: any;
        brandId: string | null;
        updatedAt: any | null;
        status: CreativeLibraryStatus | null;
        thumbnailUrl: string | null;
        sourceUrl: string | null;
        previewUrl: string | null;
        createdBy: string | null;
        description: string | null;
        experienceId: string | null;
        isDisneyAi: boolean | null;
        actions: {
          __typename?: 'CreativeActions';
          canAttach: boolean | null;
          canClone: boolean | null;
          canDelete: boolean | null;
          disabledReasons: {
            __typename?: 'CreativeDisableReasons';
            delete: Array<string | null> | null;
            attach: Array<string | null> | null;
          } | null;
        } | null;
      };
    }>;
  };
};

export type GetOrgCreativeLibraryQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;

export type GetOrgCreativeLibraryQuery = {
  __typename?: 'Query';
  getCreativeLibrary: { __typename?: 'OrgCreativeLibrary'; creativeLibraryId: string };
};

export type NewAdGalleryAdsSearchQueryVariables = Exact<{
  input: CreativeLibrarySearchInput;
}>;

export type NewAdGalleryAdsSearchQuery = {
  __typename?: 'Query';
  creativeLibrarySearch: {
    __typename?: 'CreativeLibrarySearchPayloadPage';
    total: number;
    edges: Array<{
      __typename?: 'CreativeEdge';
      node: {
        __typename?: 'CreativeLibraryItem';
        creativeId: string;
        name: string | null;
        adFormat: AdFormat | null;
        brandId: string | null;
        brandName: string | null;
        createdAt: any;
        status: CreativeLibraryStatus | null;
        experienceId: string | null;
        creativeManagerId: string | null;
        sourceUrl: string | null;
        thumbnailUrl: string | null;
        previewUrl: string | null;
        description: string | null;
        isDisneyAi: boolean | null;
        actions: {
          __typename?: 'CreativeActions';
          canClone: boolean | null;
          canDelete: boolean | null;
          disabledReasons: {
            __typename?: 'CreativeDisableReasons';
            delete: Array<string | null> | null;
            clone: Array<string | null> | null;
          } | null;
        } | null;
      };
    }>;
  };
};

export type NewAdGalleryAssetsSearchQueryVariables = Exact<{
  input: AssetLibrarySearchInput;
}>;

export type NewAdGalleryAssetsSearchQuery = {
  __typename?: 'Query';
  assetLibrarySearch: {
    __typename?: 'AssetLibrarySearchPayloadPage';
    total: number;
    edges: Array<{
      __typename?: 'AssetEdge';
      node: {
        __typename?: 'AssetLibraryItem';
        assetId: string;
        assetSourceId: string | null;
        name: string | null;
        assetType: AssetType | null;
        brandName: string | null;
        createdAt: any;
        status: AssetStatus | null;
        sourceUrl: string | null;
        format: string | null;
        size: number | null;
        duration: number | null;
        actions: {
          __typename?: 'AssetActions';
          canDelete: boolean | null;
          disabledReasons: { __typename?: 'AssetDisableReasons'; delete: Array<string | null> | null } | null;
        } | null;
      };
    }>;
  };
};

export type GetSubmittedByListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetSubmittedByListQuery = {
  __typename?: 'Query';
  getSubmittedByList: Array<{
    __typename?: 'SubmittedBy';
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    rolesV4: Array<{ __typename?: 'RolesV4'; entityId: string; entityType: EntityType }> | null;
  } | null>;
};

export type FeatureFlagsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']>;
}>;

export type FeatureFlagsQuery = {
  __typename?: 'Query';
  featureFlags: {
    __typename?: 'FeatureFlagsResponse';
    flags: Array<{ __typename?: 'FeatureFlag'; key: string; value: string }>;
  };
};

export type AdAccountFragment = {
  __typename?: 'AdAccount';
  id: string;
  name: string;
  status: AdAccountStatus | null;
  createdAt: any | null;
  lastLoginAt: any | null;
  fundingSource: FundingSource | null;
  accountsApprovedForTerms: boolean | null;
  approvedForPrepaymentTerms: boolean | null;
  campaignsCountStatistic: number | null;
  billableAdServer: string | null;
  invoiceByCampaign: boolean | null;
  isMatureBrand: boolean | null;
  billingCalendar: string | null;
  agencyCommissionPercentage: number | null;
  dnaListPresetId: string | null;
  dnaListAppliedByDefault: boolean | null;
  billingContact: {
    __typename?: 'BillingContact';
    id: string | null;
    firstName: string;
    lastName: string;
    email: string | null;
  } | null;
  brand: {
    __typename?: 'Brand';
    id: string;
    name: string;
    industry: { __typename?: 'Industry'; id: string; name: string };
  } | null;
  assignedUsers: Array<{
    __typename?: 'User';
    firstName: string | null;
    lastName: string | null;
    id: string;
    adAccountScopedAssignmentName: string | null;
  }> | null;
  paymentMethod: {
    __typename?: 'PaymentMethod';
    paymentMethodExternalId: string;
    paymentMethodName: string;
    lastFour: string | null;
    brand: string | null;
  } | null;
};

export type AddressFragmentFragment = {
  __typename?: 'Address';
  line1: string;
  line2: string | null;
  city: string;
  country: string;
  zipCode: string;
  state: string;
};

export type BrandFragmentFragment = {
  __typename?: 'Brand';
  id: string;
  name: string;
  industry: { __typename?: 'Industry'; id: string; name: string };
};

export type BrandFullFragmentFragment = {
  __typename?: 'Brand';
  status: BrandStatus;
  createdAt: any | null;
  id: string;
  name: string;
  address: {
    __typename?: 'Address';
    line1: string;
    line2: string | null;
    city: string;
    country: string;
    zipCode: string;
    state: string;
  };
  industry: { __typename?: 'Industry'; id: string; name: string };
};

export type CrmLinkFragment = {
  __typename?: 'CrmLink';
  crmId: string | null;
  name: string | null;
  type: string | null;
  url: string | null;
};

export type PackageFragment = {
  __typename?: 'Package';
  id: string;
  title: string;
  rank: number | null;
  startDate: string | null;
  endDate: string | null;
  largeHeroImageFile: string | null;
  smallHeroImageFile: string | null;
  shortDescription: string | null;
  longDescription: string | null;
  allowDayparting: boolean | null;
  partners: Array<string | null> | null;
  selectable: boolean | null;
  showLearnMore: boolean | null;
  categories: Array<{ __typename?: 'PackageCategory'; id: string; name: string } | null> | null;
  publishers: Array<{
    __typename?: 'PublisherType';
    id: string;
    systemName: string;
    displayName: string;
  } | null> | null;
  coreOffering: { __typename?: 'CoreOffering'; id: string; title: string; systemName: string } | null;
};

export type PermissionsFragmentFragment = {
  __typename?: 'Permissions';
  ADMIN_CREATE_PAYMENTS: boolean;
  ADMIN_DELETE_PAYMENTS: boolean;
  ADMIN_READ_PAYMENTS: boolean;
  ADMIN_RETRY_PAYMENTS: boolean;
  ADMIN_REFUND_PAYMENTS: boolean;
  ADMIN_UPDATE_PAYMENTS: boolean;
  ADMIN_UPDATE_THRESHOLD: boolean;
  APPLY_PROMO_CODE: boolean;
  BUILD_REPORT: boolean;
  CANCEL_LINE_ITEM: boolean;
  CLONE_LINE_ITEM: boolean;
  CONFIGURE_AD_TAG: boolean;
  CREATE_AD_ACCOUNT: boolean;
  CREATE_ASSET: boolean;
  CREATE_BRAND: boolean;
  CREATE_BROADCAST: boolean;
  CREATE_CAMPAIGN: boolean;
  CREATE_CREATIVE: boolean;
  UPDATE_AD_FORMAT: boolean;
  CREATE_ADVANCED_CREATIVE: boolean;
  CREATE_INDUSTRY: boolean;
  CREATE_LINEITEM: boolean;
  CREATE_PAYMENTS: boolean;
  CREATE_REPORT: boolean;
  CREATE_USER: boolean;
  DELETE_AD_ACCOUNT: boolean;
  DELETE_BROADCAST: boolean;
  DELETE_CAMPAIGN: boolean;
  DELETE_CREATIVE: boolean;
  DELETE_CREATIVES: boolean;
  DELETE_LINE_ITEM: boolean;
  DELETE_ORGANIZATION: boolean;
  DELETE_PAYMENTS: boolean;
  DELETE_REPORT: boolean;
  DETACH_PROMO_CODE: boolean;
  GET_CAMPAIGN: boolean;
  GET_LINE_ITEM: boolean;
  INVITE_USER: boolean;
  PAUSE_LINE_ITEM: boolean;
  READ_AD_ACCOUNT: boolean;
  READ_ALL_ADS: boolean;
  READ_ALL_CAMPAIGNS: boolean;
  READ_ALL_LINE_ITEMS: boolean;
  READ_BRAND: boolean;
  READ_BROADCAST: boolean;
  READ_CAMPAIGN_LINEITEMS: boolean;
  READ_CREATIVE: boolean;
  READ_CREATIVES: boolean;
  READ_INDUSTRY: boolean;
  READ_LEGACY_REPORT: boolean;
  READ_NOTIFICATION: boolean;
  READ_ORGANIZATION: boolean;
  READ_OWN_USER: boolean;
  READ_PAYMENTS: boolean;
  READ_REPORT: boolean;
  READ_REPORT_TEMPLATE: boolean;
  READ_ROLES: boolean;
  READ_TARGETING: boolean;
  READ_USER: boolean;
  READ_USERS: boolean;
  RESUME_LINE_ITEM: boolean;
  SUBMIT_LINE_ITEM: boolean;
  SUSPEND_LINE_ITEM: boolean;
  UPDATE_AD_ACCOUNT: boolean;
  UPDATE_AD_ACCOUNT_BILLING_CONTACT: boolean;
  UPDATE_AD_ACCOUNT_BRAND: boolean;
  UPDATE_AD_ACCOUNT_NAME: boolean;
  UPDATE_AD_ACCOUNT_STATUS: boolean;
  UPDATE_BRAND: boolean;
  UPDATE_BROADCAST: boolean;
  UPDATE_CAMPAIGN: boolean;
  UPDATE_INDUSTRY: boolean;
  UPDATE_LINE_ITEM: boolean;
  UPDATE_NOTIFICATION_SETTINGS: boolean;
  UPDATE_ORGANIZATION: boolean;
  UPDATE_PAYMENTS: boolean;
  UPDATE_REPORT: boolean;
  UPDATE_USER: boolean;
  USER_STATUS_UPDATE: boolean;
  OVERRIDE_LINE_ITEM_PRICE: boolean;
  OVERRIDE_LINE_ITEM_KERV: boolean;
  READ_PACKAGE: boolean;
  SUBMIT_ADS: boolean;
  GENIE_UI_ACCESS: boolean;
};

export type GetHamIndustriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetHamIndustriesQuery = {
  __typename?: 'Query';
  hamIndustries: Array<{ __typename?: 'Industry'; id: string; name: string }>;
};

export type GetIndustriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetIndustriesQuery = {
  __typename?: 'Query';
  industries: Array<{ __typename?: 'Industry'; id: string; name: string }>;
};

export type GetInvoicesByIdAndSourceQueryVariables = Exact<{
  filterInput: InvoiceSearchInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
  source?: InputMaybe<InvoicesSource>;
  sortOptions?: InputMaybe<InvoiceSortOptions>;
}>;

export type GetInvoicesByIdAndSourceQuery = {
  __typename?: 'Query';
  invoices: {
    __typename?: 'InvoicePage';
    total: number;
    edges: Array<{
      __typename?: 'InvoiceEdge';
      node: {
        __typename?: 'Invoice';
        invoiceExternalId: string;
        invoiceName: string;
        startDate: any;
        endDate: any | null;
        dueDate: any;
        billedAmount: any;
        remainingAmount: number;
        invoicePaymentStatus: InvoicePaymentStatuses;
        adAccountId: string;
        adAccountName: string | null;
        billingType: BillingType;
        billingPeriod: string;
        advertiserName: string;
        id: string;
      };
    }>;
  };
};

export type GetInvoicesFiltersQueryVariables = Exact<{
  orgId?: InputMaybe<Scalars['ID']>;
  adAccountId?: InputMaybe<Scalars['ID']>;
}>;

export type GetInvoicesFiltersQuery = {
  __typename?: 'Query';
  getInvoicesFilters: {
    __typename?: 'InvoicesFilters';
    accountFilterOptions: Array<{
      __typename?: 'AccountFilterOptions';
      adAccountId: string;
      adAccountName: string;
    }> | null;
    billingTypeOptions: Array<{ __typename?: 'BillingTypeOptions'; name: string; value: number }> | null;
    invoicePaymentStatusOptions: Array<{
      __typename?: 'InvoiceStatusFilterOptions';
      name: InvoicePaymentStatuses;
      value: number;
    }> | null;
  };
};

export type GetThresholdListQueryVariables = Exact<{ [key: string]: never }>;

export type GetThresholdListQuery = {
  __typename?: 'Query';
  getThresholdList: Array<{ __typename?: 'ThresholdLevel'; level: number; amount: number }>;
};

export type GenerateLateLinesReportFileUrlMutationVariables = Exact<{
  orgId: Scalars['ID'];
  advertiserId: Scalars['ID'];
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  filterOptions?: InputMaybe<LateLinesFilterInput>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type GenerateLateLinesReportFileUrlMutation = { __typename?: 'Mutation'; generateLateLinesReport: string };

export type GetLateLinesQueryVariables = Exact<{
  orgId: Scalars['ID'];
  advertiserId: Scalars['ID'];
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  filterOptions?: InputMaybe<LateLinesFilterInput>;
}>;

export type GetLateLinesQuery = {
  __typename?: 'Query';
  getLateLines: {
    __typename?: 'LateLinesPage';
    total: number;
    edges: Array<{
      __typename?: 'LateLineEdge';
      node: {
        __typename?: 'LateLine';
        startDate: string;
        operativeOrderId: string;
        campaignName: string;
        lineItemName: string;
        endDate: string;
        id: string;
        accountExecutive: {
          __typename?: 'AccountExecutive';
          firstName: string | null;
          lastName: string | null;
          email: string | null;
        } | null;
      };
    }>;
  };
};

export type MetricsStatusQueryVariables = Exact<{
  metricsStatusRequest: MetricsStatusRequest;
}>;

export type MetricsStatusQuery = {
  __typename?: 'Query';
  getMetricsStatus: {
    __typename?: 'MetricsStatus';
    lastUpdated: string | null;
    delay: { __typename?: 'DelayDates'; startDate: string; endDate: string } | null;
  };
};

export type MakeAllNotificationsReadMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type MakeAllNotificationsReadMutation = { __typename?: 'Mutation'; makeAllNotificationsRead: any | null };

export type MarkSelectedNotificationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  action: ReadOrUnread;
}>;

export type MarkSelectedNotificationsMutation = { __typename?: 'Mutation'; markSelectedNotifications: any | null };

export type ToggleNotificationSettingsMutationVariables = Exact<{
  userId: Scalars['ID'];
  input: NotificationSettingsInput;
}>;

export type ToggleNotificationSettingsMutation = { __typename?: 'Mutation'; toggleNotificationSettings: any | null };

export type ToggleNotificationSettingsByTheUserMutationVariables = Exact<{
  userId: Scalars['ID'];
  enableForAll: Scalars['Boolean'];
}>;

export type ToggleNotificationSettingsByTheUserMutation = {
  __typename?: 'Mutation';
  toggleNotificationSettingsByTheUser: any | null;
};

export type GetPopUpNotificationsQueryVariables = Exact<{
  userId: Scalars['ID'];
  filterOptions?: InputMaybe<NotificationsFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
}>;

export type GetPopUpNotificationsQuery = {
  __typename?: 'Query';
  getNotificationsByUser: {
    __typename?: 'NotificationPage';
    total: number;
    edges: Array<{
      __typename?: 'NotificationEdge';
      node: {
        __typename?: 'Notification';
        id: string;
        text: string;
        header: string;
        icon: string | null;
        acked: boolean;
        createdAt: string | null;
        isPopUp: boolean | null;
      };
    }>;
  };
};

export type GetUnreadNotificationsCountByUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type GetUnreadNotificationsCountByUserQuery = {
  __typename?: 'Query';
  getNotificationsByUser: { __typename?: 'NotificationPage'; total: number };
};

export type AdAccountNotificationOptionsQueryVariables = Exact<{
  userId: Scalars['ID'];
  adAccountId: Scalars['ID'];
}>;

export type AdAccountNotificationOptionsQuery = {
  __typename?: 'Query';
  adAccountNotificationOptions: { __typename?: 'AdAccountNotificationOptionsType'; notificationTypes: Array<string> };
};

export type GetLastFourNotificationsQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type GetLastFourNotificationsQuery = {
  __typename?: 'Query';
  getNotificationsByUser: {
    __typename?: 'NotificationPage';
    edges: Array<{
      __typename?: 'NotificationEdge';
      node: {
        __typename?: 'Notification';
        id: string;
        text: string;
        header: string;
        icon: string | null;
        acked: boolean;
        createdAt: string | null;
      };
    }>;
  };
};

export type GetNotificationsByUserQueryVariables = Exact<{
  userId: Scalars['ID'];
  filterOptions?: InputMaybe<NotificationsFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
}>;

export type GetNotificationsByUserQuery = {
  __typename?: 'Query';
  getNotificationsByUser: {
    __typename?: 'NotificationPage';
    total: number;
    edges: Array<{
      __typename?: 'NotificationEdge';
      node: {
        __typename?: 'Notification';
        id: string;
        text: string;
        category: CategoryEnum | null;
        header: string;
        icon: string | null;
        acked: boolean;
        createdAt: string | null;
      };
    }>;
  };
};

export type OrganizationListItemFragmentFragment = {
  __typename?: 'OrganizationListItem';
  id: string;
  name: string;
  status: OrganizationStatus;
  baymaxEnabled: boolean | null;
  adAccountsCount: number;
  usersCount: number;
  createdAt: any | null;
  lastLoginAt: any | null;
  campaignsCount: number | null;
  totalSpent: number | null;
  activeCampaignsCount: number | null;
  crmLink: {
    __typename?: 'CrmLink';
    crmId: string | null;
    name: string | null;
    type: string | null;
    url: string | null;
  } | null;
};

export type OrganizationFragmentFragment = {
  __typename?: 'Organization';
  name: string;
  status: OrganizationStatus;
  id: string;
  disabledReason: string | null;
  phoneNumber: string | null;
  operatesAsAgency: boolean;
  isBaymaxEnabled: boolean | null;
  createdAt: any | null;
  lastLoginAt: any | null;
  threepBillingEligible: boolean | null;
  daypartingAllowed: boolean | null;
  scheduledPacingAllowed: boolean | null;
  minLineItemBudgetOverrideAllowed: boolean | null;
  minLineItemBudgetOverride: number | null;
  dailySpendLimitOverride: number | null;
  dailySpendLimitOverrideAllowed: boolean | null;
  crmLink: string | null;
  creativeAgentAccessAllowed: boolean | null;
  address: {
    __typename?: 'Address';
    line1: string;
    line2: string | null;
    city: string;
    country: string;
    zipCode: string;
    state: string;
  };
};

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteOrganizationMutation = { __typename?: 'Mutation'; deleteOrganization: any | null };

export type UpdateOrganizationStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
}>;

export type UpdateOrganizationStatusMutation = { __typename?: 'Mutation'; updateOrganizationStatus: any | null };

export type OperateAsAgencyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type OperateAsAgencyMutation = { __typename?: 'Mutation'; operateAsAgency: any | null };

export type UpdateOrgActivityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type UpdateOrgActivityMutation = { __typename?: 'Mutation'; updateOrgActivity: any | null };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
  input: OrganizationInput;
}>;

export type UpdateOrganizationMutation = {
  __typename?: 'Mutation';
  updateOrganization: {
    __typename?: 'Organization';
    name: string;
    phoneNumber: string | null;
    creativeAgentAccessAllowed: boolean | null;
  };
};

export type OrganizationsNamesQueryVariables = Exact<{
  paginationOptions?: InputMaybe<PaginationOptions>;
  filterOptions?: InputMaybe<OrganizationFilterOptions>;
  sortOptions?: InputMaybe<OrganizationSortOptions>;
}>;

export type OrganizationsNamesQuery = {
  __typename?: 'Query';
  searchOrganizationsFilter: {
    __typename?: 'OrganizationsList';
    total: number;
    edges: Array<{
      __typename?: 'OrganizationEdge';
      node: { __typename?: 'OrganizationListItem'; id: string; name: string };
    }>;
  };
};

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetOrganizationQuery = {
  __typename?: 'Query';
  organization: {
    __typename?: 'Organization';
    name: string;
    status: OrganizationStatus;
    id: string;
    disabledReason: string | null;
    phoneNumber: string | null;
    operatesAsAgency: boolean;
    isBaymaxEnabled: boolean | null;
    createdAt: any | null;
    lastLoginAt: any | null;
    threepBillingEligible: boolean | null;
    daypartingAllowed: boolean | null;
    scheduledPacingAllowed: boolean | null;
    minLineItemBudgetOverrideAllowed: boolean | null;
    minLineItemBudgetOverride: number | null;
    dailySpendLimitOverride: number | null;
    dailySpendLimitOverrideAllowed: boolean | null;
    crmLink: string | null;
    creativeAgentAccessAllowed: boolean | null;
    address: {
      __typename?: 'Address';
      line1: string;
      line2: string | null;
      city: string;
      country: string;
      zipCode: string;
      state: string;
    };
  };
};

export type GetOrganizationDetailsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  hasPermissionsForGetSellers?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetOrganizationDetailsQuery = {
  __typename?: 'Query';
  getOrganizationDetails: {
    __typename?: 'OrganizationDetails';
    id: string;
    name: string;
    phoneNumber: string | null;
    status: OrganizationStatus;
    lineOfCredit: number;
    operatesAsAgency: boolean | null;
    thresholdAmount: number | null;
    threepBillingEligible: boolean | null;
    daypartingAllowed: boolean | null;
    scheduledPacingAllowed: boolean | null;
    minLineItemBudgetOverrideAllowed: boolean | null;
    minLineItemBudgetOverride: number | null;
    dailySpendLimitOverride: number | null;
    dailySpendLimitOverrideAllowed: boolean | null;
    paidInvoicingEnabled: boolean;
    isBaymaxEnabled: boolean;
    draftAdsLimit: number | null;
    monthlyAdsLimit: number | null;
    lastLoginAt: any | null;
    createdAt: any | null;
    crmLink: string;
    totalSpent: any | null;
    activeCpm: any;
    monthlyCreativesCount: number | null;
    draftCreativesCount: number | null;
    sellers: Array<string | null>;
    approvedForTerms: boolean | null;
    activeCampaignsCount: number;
    creativeAgentAccessAllowed: boolean | null;
    address: {
      __typename?: 'Address';
      line1: string;
      line2: string | null;
      city: string;
      country: string;
      zipCode: string;
      state: string;
    };
  };
};

export type GetOrganizationsByUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrganizationsByUserQuery = {
  __typename?: 'Query';
  organizationsByUser: Array<{
    __typename?: 'Organization';
    id: string;
    name: string;
    phoneNumber: string | null;
    operatesAsAgency: boolean;
    isBaymaxEnabled: boolean | null;
    address: {
      __typename?: 'Address';
      line1: string;
      line2: string | null;
      city: string;
      country: string;
      zipCode: string;
      state: string;
    };
  }>;
};

export type GetThresholdAmountByOrgIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetThresholdAmountByOrgIdQuery = {
  __typename?: 'Query';
  getThresholdAmountByOrgId: { __typename?: 'Threshold'; thresholdAmount: number | null };
};

export type SearchOrganizationsQueryVariables = Exact<{
  filterOptions: OrganizationFilterOptions;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<OrganizationSortOptions>;
}>;

export type SearchOrganizationsQuery = {
  __typename?: 'Query';
  searchOrganizations: {
    __typename?: 'OrganizationsList';
    total: number;
    edges: Array<{
      __typename?: 'OrganizationEdge';
      node: {
        __typename?: 'OrganizationListItem';
        id: string;
        name: string;
        status: OrganizationStatus;
        baymaxEnabled: boolean | null;
        adAccountsCount: number;
        usersCount: number;
        createdAt: any | null;
        lastLoginAt: any | null;
        campaignsCount: number | null;
        totalSpent: number | null;
        activeCampaignsCount: number | null;
        crmLink: {
          __typename?: 'CrmLink';
          crmId: string | null;
          name: string | null;
          type: string | null;
          url: string | null;
        } | null;
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; nextCursor: string | null };
  };
};

export type DeletePaymentMethodMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeletePaymentMethodMutation = { __typename?: 'Mutation'; deletePaymentMethod: any | null };

export type CreatePaymentMethodMutationVariables = Exact<{
  input: PaymentMethodInput;
}>;

export type CreatePaymentMethodMutation = {
  __typename?: 'Mutation';
  createPaymentMethodAdyen: { __typename?: 'AdyenPaymentMethod'; paymentMethodExternalId: string };
};

export type RetryPaymentMethodByInvoiceExtIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type RetryPaymentMethodByInvoiceExtIdMutation = {
  __typename?: 'Mutation';
  retryPaymentMethodByInvoiceExtId: {
    __typename?: 'RetryPaymentMethod';
    adAccountId: string;
    billedAmount: number;
    chargedAmount: number;
    remainingBalance: number;
    invoiceExternalId: string;
    invoicePaymentStatus: string;
    transactionId: number;
    transactionStatus: string;
    declineReason: string | null;
    errorCode: string | null;
  };
};

export type RetryPaymentMethodMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type RetryPaymentMethodMutation = {
  __typename?: 'Mutation';
  retryPaymentMethodByPaymentId: Array<{ __typename?: 'RetryPaymentMethod'; declineReason: string | null } | null>;
};

export type UpdatePaymentMethodMutationVariables = Exact<{
  methodId: Scalars['String'];
  input: UpdateAdyenPaymentMethodInput;
}>;

export type UpdatePaymentMethodMutation = {
  __typename?: 'Mutation';
  updatePaymentMethodAdyen: { __typename?: 'AdyenPaymentMethod'; paymentMethodExternalId: string };
};

export type GetPaymentMethodByPaymentIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetPaymentMethodByPaymentIdQuery = {
  __typename?: 'Query';
  paymentMethodByPaymentId: {
    __typename?: 'PaymentMethod';
    paymentMethodExternalId: string;
    organizationExternalId: string;
    paymentType: PaymentType;
    paymentMethodName: string;
    updatedOn: any | null;
    lastFour: string | null;
    cardholderName: string | null;
    expirationYear: number | null;
    expirationMonth: number | null;
    token: string | null;
    brand: string | null;
    paymentMethodProcessor: PaymentMethodProcessor | null;
    invoicePaymentStatus: InvoicePaymentStatuses | null;
    billingAddress: {
      __typename?: 'BillingAddress';
      houseNumberOrName: string | null;
      street: string | null;
      city: string | null;
      state: string | null;
      postalCode: string | null;
      country: string | null;
    } | null;
    accountSet: Array<{
      __typename?: 'AccountSetInfo';
      accountId: number;
      adAccountId: string;
      adAccountName: string;
    } | null> | null;
    lastPayment: {
      __typename?: 'LastPaymentInfo';
      declineCode: string | null;
      updatedOn: string | null;
      invoiceExternalId: string | null;
      chargedAmount: any | null;
      transactionStatus: TransactionStatuses | null;
      declineReason: string | null;
      cannotRefundReason: string | null;
    } | null;
  };
};

export type GetPaymentMethodsByOrgIdQueryVariables = Exact<{
  orgId: Scalars['ID'];
  filterOptions?: InputMaybe<PaymentFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<PaymentMethodSortOptions>;
}>;

export type GetPaymentMethodsByOrgIdQuery = {
  __typename?: 'Query';
  paymentMethods: {
    __typename?: 'PaymentsList';
    total: number;
    edges: Array<{
      __typename?: 'PaymentsEdge';
      node: {
        __typename?: 'PaymentMethod';
        id: string;
        paymentMethodExternalId: string;
        organizationExternalId: string;
        paymentType: PaymentType;
        paymentMethodName: string;
        updatedOn: any | null;
        cardholderName: string | null;
        expirationYear: number | null;
        expirationMonth: number | null;
        lastFour: string | null;
        token: string | null;
        brand: string | null;
        paymentMethodProcessor: PaymentMethodProcessor | null;
      };
    }>;
  };
};

export type GetInvoiceByInvoiceExtIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GetInvoiceByInvoiceExtIdQuery = {
  __typename?: 'Query';
  getInvoiceByInvoiceExtId: {
    __typename?: 'InvoiceWithLastTransaction';
    invoiceExternalId: string;
    invoiceEndDate: string | null;
    invoiceStartDate: string | null;
    invoicePaymentStatus: InvoicePaymentStatuses;
    billedAmount: any;
    lastTransaction: { __typename?: 'ShortTransactionData'; status: string; transactionDate: any; amount: any } | null;
  };
};

export type GetPresetListQueryVariables = Exact<{
  idList?: InputMaybe<Scalars['ID']>;
}>;

export type GetPresetListQuery = {
  __typename?: 'Query';
  getPresetList: Array<{ __typename?: 'Preset'; id: string; name: string }> | null;
};

export type ReportTemplateFragmentFragment = {
  __typename?: 'Template';
  id: string;
  name: string;
  description: string;
  systemName: TemplateSystemName;
};

export type GetReportTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetReportTemplateQuery = {
  __typename?: 'Query';
  template: { __typename?: 'Template'; id: string; name: string; description: string; systemName: TemplateSystemName };
};

export type AllCampaignsFiltersFragment = {
  __typename?: 'AllCampaignsFilters';
  adAccounts: Array<{ __typename?: 'AllCampaignsAdAccountFilter'; id: string; name: string; orgId: string } | null>;
};

type BrunoBaseReport_AllCampaignsCreateReportResponse_Fragment = {
  __typename?: 'AllCampaignsCreateReportResponse';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  failedReason: string | null;
  failedExceptionType: string | null;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  createdAt: any;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
  reportTemplate: {
    __typename?: 'BrunoReportTemplate';
    id: string;
    name: string;
    description: string;
    systemName: ReportTemplateSystemName;
    lastUpdatedAt: string | null;
  };
};

type BrunoBaseReport_AllCampaignsReport_Fragment = {
  __typename?: 'AllCampaignsReport';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  failedReason: string | null;
  failedExceptionType: string | null;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  createdAt: any;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
  reportTemplate: {
    __typename?: 'BrunoReportTemplate';
    id: string;
    name: string;
    description: string;
    systemName: ReportTemplateSystemName;
    lastUpdatedAt: string | null;
  };
};

type BrunoBaseReport_BrunoCreateDetailedReportReportResponse_Fragment = {
  __typename?: 'BrunoCreateDetailedReportReportResponse';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  failedReason: string | null;
  failedExceptionType: string | null;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  createdAt: any;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
  reportTemplate: {
    __typename?: 'BrunoReportTemplate';
    id: string;
    name: string;
    description: string;
    systemName: ReportTemplateSystemName;
    lastUpdatedAt: string | null;
  };
};

type BrunoBaseReport_BrunoDetailedReportReport_Fragment = {
  __typename?: 'BrunoDetailedReportReport';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  failedReason: string | null;
  failedExceptionType: string | null;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  createdAt: any;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
  reportTemplate: {
    __typename?: 'BrunoReportTemplate';
    id: string;
    name: string;
    description: string;
    systemName: ReportTemplateSystemName;
    lastUpdatedAt: string | null;
  };
};

type BrunoBaseReport_CuratedAudienceUsageReport_Fragment = {
  __typename?: 'CuratedAudienceUsageReport';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  failedReason: string | null;
  failedExceptionType: string | null;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  createdAt: any;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
  reportTemplate: {
    __typename?: 'BrunoReportTemplate';
    id: string;
    name: string;
    description: string;
    systemName: ReportTemplateSystemName;
    lastUpdatedAt: string | null;
  };
};

type BrunoBaseReport_DeliveryPerformanceReport_Fragment = {
  __typename?: 'DeliveryPerformanceReport';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  failedReason: string | null;
  failedExceptionType: string | null;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  createdAt: any;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
  reportTemplate: {
    __typename?: 'BrunoReportTemplate';
    id: string;
    name: string;
    description: string;
    systemName: ReportTemplateSystemName;
    lastUpdatedAt: string | null;
  };
};

type BrunoBaseReport_DeliveryPerformanceReportResponse_Fragment = {
  __typename?: 'DeliveryPerformanceReportResponse';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  failedReason: string | null;
  failedExceptionType: string | null;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  createdAt: any;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
  reportTemplate: {
    __typename?: 'BrunoReportTemplate';
    id: string;
    name: string;
    description: string;
    systemName: ReportTemplateSystemName;
    lastUpdatedAt: string | null;
  };
};

export type BrunoBaseReportFragment =
  | BrunoBaseReport_AllCampaignsCreateReportResponse_Fragment
  | BrunoBaseReport_AllCampaignsReport_Fragment
  | BrunoBaseReport_BrunoCreateDetailedReportReportResponse_Fragment
  | BrunoBaseReport_BrunoDetailedReportReport_Fragment
  | BrunoBaseReport_CuratedAudienceUsageReport_Fragment
  | BrunoBaseReport_DeliveryPerformanceReport_Fragment
  | BrunoBaseReport_DeliveryPerformanceReportResponse_Fragment;

export type BrunoReportFragment = {
  __typename?: 'BrunoReportInfo';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  failedReason: string | null;
  failedExceptionType: string | null;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  createdAt: any;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  } | null;
  reportTemplate: {
    __typename?: 'BrunoReportTemplate';
    id: string;
    name: string;
    description: string;
    systemName: ReportTemplateSystemName;
    lastUpdatedAt: string | null;
  };
};

export type BrunoDetailedReportFiltersFragment = {
  __typename?: 'BrunoDetailedReportFilters';
  adAccountId: string | null;
  dimensions: Array<string | null>;
  campaign: { __typename?: 'BrunoDetailedReportCampaignFilter'; id: string; name: string; adAccountId: string | null };
  lineItems: Array<{
    __typename?: 'BrunoDetailedReportLineItemFilter';
    id: string;
    name: string;
    endDate: string;
    startDate: string;
  } | null>;
};

export type CreateAllCampaignsDataReportMutationVariables = Exact<{
  report: ReportInput;
  filters: AllCampaignsCreateReportInput;
}>;

export type CreateAllCampaignsDataReportMutation = {
  __typename?: 'Mutation';
  createAllCampaignsDataReport: { __typename?: 'AllCampaignsCreateReportResponse'; id: string } | null;
};

export type CreateBrunoReportMutationVariables = Exact<{
  report: ReportInput;
}>;

export type CreateBrunoReportMutation = {
  __typename?: 'Mutation';
  createBrunoReport: { __typename?: 'BrunoReportInfo'; id: string } | null;
};

export type CreateDeliveryPerformanceMutationVariables = Exact<{
  report: ReportInput;
  filters: DeliveryPerformanceReportInput;
}>;

export type CreateDeliveryPerformanceMutation = {
  __typename?: 'Mutation';
  createDeliveryPerformance: { __typename?: 'DeliveryPerformanceReportResponse'; id: string } | null;
};

export type CreateBrunoDetailedDataReportMutationVariables = Exact<{
  report: ReportInput;
  filters: BrunoCreateDetailedReportReportInput;
}>;

export type CreateBrunoDetailedDataReportMutation = {
  __typename?: 'Mutation';
  createBrunoDetailedDataReport: { __typename?: 'BrunoCreateDetailedReportReportResponse'; id: string } | null;
};

export type RetryReportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type RetryReportMutation = {
  __typename?: 'Mutation';
  retryReport: { __typename?: 'BrunoReportInfo'; id: string } | null;
};

export type UpdateAllCampaignsReportMutationVariables = Exact<{
  id: Scalars['ID'];
  report: UpdateReportInput;
  filters: AllCampaignsCreateReportInput;
}>;

export type UpdateAllCampaignsReportMutation = {
  __typename?: 'Mutation';
  updateAllCampaignsReport: { __typename?: 'AllCampaignsCreateReportResponse'; id: string } | null;
};

export type UpdateBrunoReportMutationVariables = Exact<{
  id: Scalars['ID'];
  report: UpdateReportInput;
}>;

export type UpdateBrunoReportMutation = {
  __typename?: 'Mutation';
  updateBrunoReport: { __typename?: 'BrunoReportInfo'; id: string } | null;
};

export type UpdateCuratedAudienceUsageReportMutationVariables = Exact<{
  id: Scalars['ID'];
  report: UpdateReportInput;
  filters: CuratedAudienceUsageReportInput;
}>;

export type UpdateCuratedAudienceUsageReportMutation = {
  __typename?: 'Mutation';
  updateCuratedAudienceUsageReport: { __typename?: 'CuratedAudienceUsageReport'; id: string } | null;
};

export type UpdateDeliveryPerformanceMutationVariables = Exact<{
  id: Scalars['ID'];
  report: UpdateReportInput;
  filters: DeliveryPerformanceReportInput;
}>;

export type UpdateDeliveryPerformanceMutation = {
  __typename?: 'Mutation';
  updateDeliveryPerformance: { __typename?: 'DeliveryPerformanceReportResponse'; id: string } | null;
};

export type UpdateBrunoDetailedReportMutationVariables = Exact<{
  id: Scalars['ID'];
  report: UpdateReportInput;
  filters: BrunoCreateDetailedReportReportInput;
}>;

export type UpdateBrunoDetailedReportMutation = {
  __typename?: 'Mutation';
  updateBrunoDetailedReport: { __typename?: 'BrunoCreateDetailedReportReportResponse'; id: string } | null;
};

export type GetBrunoReportTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetBrunoReportTemplatesQuery = {
  __typename?: 'Query';
  getBrunoReportTemplates: Array<{
    __typename?: 'BrunoReportTemplatesResponse';
    id: string;
    name: string;
    description: string;
    systemName: AdminReportsTemplateSystemName;
  }>;
};

export type GetUsersQueryVariables = Exact<{
  idList?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orgId?: InputMaybe<Scalars['ID']>;
  paginationOptions?: InputMaybe<PaginationOptions>;
}>;

export type GetUsersQuery = {
  __typename?: 'Query';
  getUsers: {
    __typename?: 'SearchUsersPage';
    total: number;
    edges: Array<{
      __typename?: 'SearchUserEdge';
      node: { __typename?: 'SearchUser'; id: string; email: string; firstName: string | null; lastName: string | null };
    }>;
  };
};

export type GetAllCampaignsReportByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  canReadAdAccount?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAllCampaignsReportByIdQuery = {
  __typename?: 'Query';
  getAllCampaignsReportById: {
    __typename?: 'AllCampaignsReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    failedReason: string | null;
    failedExceptionType: string | null;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    createdAt: any;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'AllCampaignsFilters';
      adAccounts: Array<{ __typename?: 'AllCampaignsAdAccountFilter'; id: string; name: string; orgId: string } | null>;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
    reportTemplate: {
      __typename?: 'BrunoReportTemplate';
      id: string;
      name: string;
      description: string;
      systemName: ReportTemplateSystemName;
      lastUpdatedAt: string | null;
    };
  };
};

export type GetBrunoReportByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetBrunoReportByIdQuery = {
  __typename?: 'Query';
  getBrunoReportById: {
    __typename?: 'BrunoReportInfo';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    failedReason: string | null;
    failedExceptionType: string | null;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    createdAt: any;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    } | null;
    reportTemplate: {
      __typename?: 'BrunoReportTemplate';
      id: string;
      name: string;
      description: string;
      systemName: ReportTemplateSystemName;
      lastUpdatedAt: string | null;
    };
  };
};

export type GetBrunoReportsQueryVariables = Exact<{
  filterOptions?: InputMaybe<BrunoReportsFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<ReportStrictSortOptions>;
}>;

export type GetBrunoReportsQuery = {
  __typename?: 'Query';
  getBrunoReports: {
    __typename?: 'BrunoReportsPage';
    total: number;
    edges: Array<{
      __typename?: 'BrunoReportEdge';
      node: {
        __typename?: 'BrunoReportInfo';
        id: string;
        templateId: string;
        name: string;
        status: ReportStatus;
        failedReason: string | null;
        failedExceptionType: string | null;
        dateRange: DateRange;
        startDate: string | null;
        endDate: string | null;
        createdAt: any;
        exportFormat: ExportFormat;
        ownerId: string;
        recipients: Array<string> | null;
        lastGeneratedAt: string | null;
        updatedAt: string;
        schedule: {
          __typename?: 'ReportSchedule';
          days: Array<Day> | null;
          frequency: Frequency | null;
          emailNow: boolean | null;
          emailAttachment: boolean | null;
        } | null;
        reportTemplate: {
          __typename?: 'BrunoReportTemplate';
          id: string;
          name: string;
          description: string;
          systemName: ReportTemplateSystemName;
          lastUpdatedAt: string | null;
        };
      };
    }>;
  };
};

export type GetCuratedAudienceUsageReportByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetCuratedAudienceUsageReportByIdQuery = {
  __typename?: 'Query';
  getCuratedAudienceUsageReportById: {
    __typename?: 'CuratedAudienceUsageReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    failedReason: string | null;
    failedExceptionType: string | null;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    createdAt: any;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: { __typename?: 'CuratedAudienceUsageReportFilters'; initialFromDate: any };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
    reportTemplate: {
      __typename?: 'BrunoReportTemplate';
      id: string;
      name: string;
      description: string;
      systemName: ReportTemplateSystemName;
      lastUpdatedAt: string | null;
    };
  };
};

export type GetDeliveryPerformanceReportByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  canReadCampaigns: Scalars['Boolean'];
}>;

export type GetDeliveryPerformanceReportByIdQuery = {
  __typename?: 'Query';
  getDeliveryPerformanceReportById: {
    __typename?: 'DeliveryPerformanceReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    failedReason: string | null;
    failedExceptionType: string | null;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    createdAt: any;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'DeliveryPerformanceReportFilters';
      adAccountId: string | null;
      campaign: {
        __typename?: 'BrunoDetailedReportCampaignFilter';
        id: string;
        name: string;
        adAccountId: string | null;
      };
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
    reportTemplate: {
      __typename?: 'BrunoReportTemplate';
      id: string;
      name: string;
      description: string;
      systemName: ReportTemplateSystemName;
      lastUpdatedAt: string | null;
    };
  };
};

export type GetBrunoDetailedDataReportByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  permissions?: InputMaybe<BrunoDetailedReportPermissions>;
}>;

export type GetBrunoDetailedDataReportByIdQuery = {
  __typename?: 'Query';
  getBrunoDetailedDataReportById: {
    __typename?: 'BrunoDetailedReportReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    failedReason: string | null;
    failedExceptionType: string | null;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    createdAt: any;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'BrunoDetailedReportFilters';
      adAccountId: string | null;
      dimensions: Array<string | null>;
      campaign: {
        __typename?: 'BrunoDetailedReportCampaignFilter';
        id: string;
        name: string;
        adAccountId: string | null;
      };
      lineItems: Array<{
        __typename?: 'BrunoDetailedReportLineItemFilter';
        id: string;
        name: string;
        endDate: string;
        startDate: string;
      } | null>;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
    reportTemplate: {
      __typename?: 'BrunoReportTemplate';
      id: string;
      name: string;
      description: string;
      systemName: ReportTemplateSystemName;
      lastUpdatedAt: string | null;
    };
  };
};

export type AllAdAccountsOptionsQueryVariables = Exact<{
  paginationOptions?: InputMaybe<PaginationOptions>;
  name?: InputMaybe<Scalars['String']>;
  billingContactUserId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
}>;

export type AllAdAccountsOptionsQuery = {
  __typename?: 'Query';
  allAdAccountsOptions: {
    __typename?: 'AdAccountsOptionsPages';
    total: number;
    edges: Array<{
      __typename?: 'AdAccountOptionsEdge';
      node: {
        __typename?: 'AdAccountOptions';
        id: string;
        name: string;
        billableAdServer: string | null;
        accountsApprovedForTerms: boolean | null;
        fundingSource: FundingSource | null;
      };
    }>;
  };
};

export type GetCampaignOptionsQueryVariables = Exact<{
  searchField?: InputMaybe<Scalars['String']>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  hasDeliveryImpressions?: InputMaybe<Scalars['Boolean']>;
  adAccountId?: InputMaybe<Scalars['String']>;
}>;

export type GetCampaignOptionsQuery = {
  __typename?: 'Query';
  getCampaignOptions: {
    __typename?: 'CampaignsOptions';
    total: number;
    edges: Array<{
      __typename?: 'CampaignOptionsEdge';
      node: {
        __typename?: 'CampaignOption';
        id: string;
        name: string;
        adAccountId: string;
        startTime: any | null;
        endTime: any | null;
      };
    }>;
  };
};

export type GetLineItemsOptionsByCampaignIdQueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions?: InputMaybe<LineItemsByCampaignIdFilterOptions>;
}>;

export type GetLineItemsOptionsByCampaignIdQuery = {
  __typename?: 'Query';
  getLineItemsByCampaignId: Array<{
    __typename?: 'LineItem';
    name: string;
    id: string;
    startTime: any | null;
    endTime: any | null;
  }> | null;
};

export type GetBrunoDownloadLinkQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetBrunoDownloadLinkQuery = { __typename?: 'Query'; getBrunoDownloadLink: string };

export type GetBrunoReportTypeByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetBrunoReportTypeByIdQuery = {
  __typename?: 'Query';
  getBrunoReportTypeById: {
    __typename?: 'GetBrunoReportTypeByIdResponse';
    systemName: ReportTemplateSystemName;
    templateId: string;
  };
};

export type ReportItemMetricsFragment = {
  __typename?: 'ReportItemMetrics';
  emailNow: boolean;
  endDate: any;
  externalId: string;
  latestReportLink: string;
  lineItems: Array<string | null> | null;
  metricsTypes: Array<string | null>;
  name: string;
  rollUpType: string | null;
  startDate: any;
  status: string;
  userIds: Array<string | null> | null;
  schedule: { __typename?: 'ReportSchedule'; days: Array<Day> | null; frequency: Frequency | null } | null;
};

export type ScheduleFragment = { __typename?: 'ReportSchedule'; days: Array<Day> | null; frequency: Frequency | null };

export type UpdateReportMutationVariables = Exact<{
  id: Scalars['ID'];
  input: DeprecatedReportInput;
}>;

export type UpdateReportMutation = {
  __typename?: 'Mutation';
  updateReport: { __typename?: 'ReportInfo'; externalId: string; name: string | null } | null;
};

export type FetchReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchReportQuery = {
  __typename?: 'Query';
  getReport: {
    __typename?: 'ReportItemMetrics';
    emailNow: boolean;
    endDate: any;
    externalId: string;
    latestReportLink: string;
    lineItems: Array<string | null> | null;
    metricsTypes: Array<string | null>;
    name: string;
    rollUpType: string | null;
    startDate: any;
    status: string;
    userIds: Array<string | null> | null;
    schedule: { __typename?: 'ReportSchedule'; days: Array<Day> | null; frequency: Frequency | null } | null;
  };
};

export type GetReportsQueryVariables = Exact<{
  adAccountId: Scalars['ID'];
  filterOptions?: InputMaybe<ReportFilterOptions>;
  sortOptions?: InputMaybe<ReportSortOptions>;
  paginationOptions?: InputMaybe<ReportPaginationOptions>;
}>;

export type GetReportsQuery = {
  __typename?: 'Query';
  reportList: {
    __typename?: 'ReportListMetrics';
    curPageNumber: number;
    totalNumbers: number;
    totalPageNumbers: number;
    limit: number;
    data: {
      __typename?: 'Reports';
      reports: Array<{
        __typename?: 'ReportItemMetrics';
        campaignId: string;
        emailNow: boolean;
        endDate: any;
        externalId: string;
        latestReportLink: string;
        lineItems: Array<string | null> | null;
        metricsTypes: Array<string | null>;
        name: string;
        rollUpType: string | null;
        startDate: any;
        status: string;
        userIds: Array<string | null> | null;
        schedule: { __typename?: 'ReportSchedule'; days: Array<Day> | null; frequency: Frequency | null } | null;
      }>;
    };
  };
};

export type ReportCsvQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  metricsTypes: Array<MetricTypes> | MetricTypes;
}>;

export type ReportCsvQuery = { __typename?: 'Query'; reportCsv: { __typename?: 'ReportLink'; url: string } };

export type ReportScheduleFragmentFragment = {
  __typename?: 'ReportSchedule';
  days: Array<Day> | null;
  frequency: Frequency | null;
  emailNow: boolean | null;
  emailAttachment: boolean | null;
};

export type MinMaxStringValuesFragmentFragment = {
  __typename?: 'MinMaxStringValues';
  min: string | null;
  max: string | null;
};

export type MinMaxNumberValuesFragmentFragment = {
  __typename?: 'MinMaxNumberValues';
  min: number | null;
  max: number | null;
};

export type DetailedDataReportFiltersFragment = {
  __typename?: 'DetailedDataReportFilters';
  advertiserId: string | null;
  lineItems: Array<string> | null;
  rollUpType: RollUpType | null;
  metricsTypes: Array<string> | null;
};

type ReportCommonFields_DetailedDataReport_Fragment = {
  __typename?: 'DetailedDataReport';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
};

type ReportCommonFields_ReachFrequencyReport_Fragment = {
  __typename?: 'ReachFrequencyReport';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
};

type ReportCommonFields_Report_Fragment = {
  __typename?: 'Report';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
};

type ReportCommonFields_StandardDeliveryDeviceHigherCategoryReport_Fragment = {
  __typename?: 'StandardDeliveryDeviceHigherCategoryReport';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
};

type ReportCommonFields_StandardDeliveryReport_Fragment = {
  __typename?: 'StandardDeliveryReport';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
};

type ReportCommonFields_TopLineGenreDeliveryReport_Fragment = {
  __typename?: 'TopLineGenreDeliveryReport';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  };
};

export type ReportCommonFieldsFragment =
  | ReportCommonFields_DetailedDataReport_Fragment
  | ReportCommonFields_ReachFrequencyReport_Fragment
  | ReportCommonFields_Report_Fragment
  | ReportCommonFields_StandardDeliveryDeviceHigherCategoryReport_Fragment
  | ReportCommonFields_StandardDeliveryReport_Fragment
  | ReportCommonFields_TopLineGenreDeliveryReport_Fragment;

export type StandardDeliveryDeviceHigherCategoryReportFiltersFragment = {
  __typename?: 'StandardDeliveryDeviceHigherCategoryReportFilters';
  organizationId: string;
  campaignIds: Array<string>;
  adProduct: Array<AdProduct> | null;
  publisher: Array<Publisher> | null;
  startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
  endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
  cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  deliveryGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  lifetimeCompletions: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
};

export type StandardDeliveryReportFiltersFragment = {
  __typename?: 'StandardDeliveryReportFilters';
  organizationId: string;
  campaignIds: Array<string>;
  adProduct: Array<AdProduct> | null;
  publisher: Array<Publisher> | null;
  startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
  endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
  cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  orderGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
};

export type DeleteReportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteReportMutation = { __typename?: 'Mutation'; deleteReport: any | null };

export type ResumeOrStopReportMutationVariables = Exact<{
  id: Scalars['ID'];
  action: StopOrResumeReport;
}>;

export type ResumeOrStopReportMutation = {
  __typename?: 'Mutation';
  resumeOrStopReport: { __typename?: 'ReportStatusInfo'; id: string; status: ReportStatus };
};

export type UnsubscribeFromReportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type UnsubscribeFromReportMutation = { __typename?: 'Mutation'; unsubscribeFromReport: any | null };

export type ExportAllReportsMutationVariables = Exact<{
  input: ExportAllReportsInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type ExportAllReportsMutation = { __typename?: 'Mutation'; exportAllReports: string };

export type GenerateDetailedDataReportFileUrlMutationVariables = Exact<{
  reportData: DetailedDataReportFileUrlInput;
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type GenerateDetailedDataReportFileUrlMutation = {
  __typename?: 'Mutation';
  generateDetailedDataReportFileUrl: string;
};

export type GenerateReachFrequencyReportFileUrlMutationVariables = Exact<{
  reportData: ReachFrequencyReportFileUrlInput;
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type GenerateReachFrequencyReportFileUrlMutation = {
  __typename?: 'Mutation';
  generateReachFrequencyReportFileUrl: string;
};

export type GenerateStandardDeliveryDeviceHigherCategoryReportFileUrlMutationVariables = Exact<{
  reportData: StandardDeliveryDeviceHigherCategoryReportFileUrlInput;
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type GenerateStandardDeliveryDeviceHigherCategoryReportFileUrlMutation = {
  __typename?: 'Mutation';
  generateStandardDeliveryDeviceHigherCategoryReportFileUrl: string;
};

export type GenerateStandardDeliveryReportFileUrlMutationVariables = Exact<{
  reportData: StandardDeliveryReportFileUrlInput;
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type GenerateStandardDeliveryReportFileUrlMutation = {
  __typename?: 'Mutation';
  generateStandardDeliveryReportFileUrl: string;
};

export type GenerateTopLineGenreDeliveryReportFileUrlMutationVariables = Exact<{
  reportData: TopLineGenreDeliveryReportFileUrlInput;
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type GenerateTopLineGenreDeliveryReportFileUrlMutation = {
  __typename?: 'Mutation';
  generateTopLineGenreDeliveryReportFileUrl: string;
};

export type AudiencesChartMetricsQueryVariables = Exact<{
  lineItems: Array<Scalars['String']> | Scalars['String'];
  campaignId: Scalars['ID'];
}>;

export type AudiencesChartMetricsQuery = {
  __typename?: 'Query';
  getAudiencesChartMetrics: Array<{
    __typename?: 'AudiencesChartMetrics';
    total: number;
    metrics: Array<{ __typename?: 'AudiencesReportChartMetric'; total: number; percentile: number; value: string }>;
  }>;
};

export type GetBrunoDetailedReportsQueryVariables = Exact<{
  filterOptions?: InputMaybe<BrunoReportsFilterOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
}>;

export type GetBrunoDetailedReportsQuery = {
  __typename?: 'Query';
  getBrunoDetailedReports: {
    __typename?: 'BrunoDetailedReportsPage';
    total: number;
    edges: Array<{
      __typename?: 'BrunoDetailedReportEdge';
      node: {
        __typename?: 'BrunoDetailedReportInfo';
        id: string;
        templateId: string;
        name: string;
        status: ReportStatus;
        dateRange: DateRange;
        startDate: string | null;
        endDate: string | null;
        createdAt: any;
        exportFormat: ExportFormat;
        ownerId: string;
        recipients: Array<string> | null;
        lastGeneratedAt: string | null;
        updatedAt: string;
        schedule: {
          __typename?: 'ReportSchedule';
          days: Array<Day> | null;
          frequency: Frequency | null;
          emailNow: boolean | null;
          emailAttachment: boolean | null;
        } | null;
        filters: {
          __typename?: 'BrunoDetailedReportPageFilter';
          campaign: {
            __typename?: 'BrunoDetailedReportCampaignFilter';
            id: string;
            name: string;
            adAccountId: string | null;
          };
        };
        reportTemplate: {
          __typename?: 'BrunoReportTemplate';
          id: string;
          name: string;
          description: string;
          systemName: ReportTemplateSystemName;
          lastUpdatedAt: string | null;
        };
      };
    }>;
  };
};

export type BrunoDetailedReportFragment = {
  __typename?: 'BrunoDetailedReportInfo';
  id: string;
  templateId: string;
  name: string;
  status: ReportStatus;
  dateRange: DateRange;
  startDate: string | null;
  endDate: string | null;
  createdAt: any;
  exportFormat: ExportFormat;
  ownerId: string;
  recipients: Array<string> | null;
  lastGeneratedAt: string | null;
  updatedAt: string;
  schedule: {
    __typename?: 'ReportSchedule';
    days: Array<Day> | null;
    frequency: Frequency | null;
    emailNow: boolean | null;
    emailAttachment: boolean | null;
  } | null;
  filters: {
    __typename?: 'BrunoDetailedReportPageFilter';
    campaign: {
      __typename?: 'BrunoDetailedReportCampaignFilter';
      id: string;
      name: string;
      adAccountId: string | null;
    };
  };
  reportTemplate: {
    __typename?: 'BrunoReportTemplate';
    id: string;
    name: string;
    description: string;
    systemName: ReportTemplateSystemName;
    lastUpdatedAt: string | null;
  };
};

export type DownloadPerformanceReportsQueryVariables = Exact<{
  lineItems: Array<Scalars['String']> | Scalars['String'];
  dimensionList: Array<InputMaybe<Dimensions>> | InputMaybe<Dimensions>;
  campaignId: Scalars['ID'];
}>;

export type DownloadPerformanceReportsQuery = { __typename?: 'Query'; downloadPerformanceReports: string | null };

export type GenreChartMetricsQueryVariables = Exact<{
  lineItems: Array<Scalars['String']> | Scalars['String'];
  campaignId: Scalars['ID'];
}>;

export type GenreChartMetricsQuery = {
  __typename?: 'Query';
  getGenreChartMetrics: Array<{
    __typename?: 'GenreChartMetrics';
    total: number;
    metrics: Array<{ __typename?: 'PlatformReportChartMetric'; total: number; percentile: number; value: string }>;
  }>;
};

export type GetCampaignReviewSummaryReportQueryVariables = Exact<{
  filterOptions: CampaignReviewSummaryReportInput;
  sortOptions: SortOptions;
  exportFormat: ExportFormat;
}>;

export type GetCampaignReviewSummaryReportQuery = {
  __typename?: 'Query';
  getCampaignReviewSummaryReport: string | null;
};

export type ReportSecondaryUsersListQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  adAccountIds: Array<Scalars['ID']> | Scalars['ID'];
  excludeSellers?: InputMaybe<Scalars['Boolean']>;
}>;

export type ReportSecondaryUsersListQuery = {
  __typename?: 'Query';
  getReportSecondaryUsersList: Array<{
    __typename?: 'GetReportSecondaryUsersList';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    createdAt: string;
    lastLoginAt: string | null;
    updatedAt: string;
    entityType: string;
  }>;
};

export type LocationTableMetricsQueryVariables = Exact<{
  lineItems: Array<Scalars['String']> | Scalars['String'];
  campaignId: Scalars['ID'];
  sortOptions?: InputMaybe<SortOptions>;
  paginationOptions?: InputMaybe<PaginationOptions>;
}>;

export type LocationTableMetricsQuery = {
  __typename?: 'Query';
  getLocationsTableMetrics: Array<{
    __typename?: 'LocationsTableMetricsResult';
    total: number;
    metrics: Array<{
      __typename?: 'LocationsTableMetricResult';
      city: string;
      state: string;
      zipCode: string;
      totalImpressions: number;
    }>;
  }>;
};

export type GetOrganizationStatisticQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  adAccountIds: Array<Scalars['ID']> | Scalars['ID'];
  dateRange: DateRangeForStatistic;
}>;

export type GetOrganizationStatisticQuery = {
  __typename?: 'Query';
  getOrganizationStatistic: {
    __typename?: 'OrganizationStatistics';
    campaignsTotal: number;
    campaignsActive: number;
    lineItemsLate: number;
    lineItemsTotal: number;
    lineItemsInFlight: number;
    lineItemsUpcoming: number;
    lineItemsEnded: number;
  };
};

export type PlatformChartMetricsQueryVariables = Exact<{
  lineItems: Array<Scalars['String']> | Scalars['String'];
  campaignId: Scalars['ID'];
}>;

export type PlatformChartMetricsQuery = {
  __typename?: 'Query';
  getPlatformChartMetrics: Array<{
    __typename?: 'PlatformChartMetrics';
    total: number;
    metrics: Array<{ __typename?: 'PlatformReportChartMetric'; total: number; percentile: number; value: string }>;
  }>;
};

export type GetReportStatisticsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignIds: Array<Scalars['ID']> | Scalars['ID'];
  dateRange: DateRange;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;

export type GetReportStatisticsQuery = {
  __typename?: 'Query';
  getReportStatistics: {
    __typename?: 'ReportStatistics';
    platform: Array<{ __typename?: 'StatisticType'; type: string; value: string }> | null;
    adProduct: Array<{ __typename?: 'StatisticType'; type: string; value: string }> | null;
    publisherBreakdown: Array<{ __typename?: 'StatisticType'; type: string; value: string }> | null;
  };
};

export type TemplatesWithReportsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  advertiserId?: InputMaybe<Scalars['String']>;
}>;

export type TemplatesWithReportsQuery = {
  __typename?: 'Query';
  templatesWithReports: Array<{
    __typename?: 'TemplateWithReport';
    id: string;
    name: string;
    systemName: TemplateSystemName;
    totalScheduled: number;
    description: string;
    lastUpdatedAt: string | null;
    reports: Array<{
      __typename?: 'Report';
      id: string;
      templateId: string;
      name: string;
      status: ReportStatus;
      dateRange: DateRange;
      startDate: string | null;
      endDate: string | null;
      exportFormat: ExportFormat;
      ownerId: string;
      recipients: Array<string> | null;
      lastGeneratedAt: string | null;
      updatedAt: string;
      filters:
        | {
            __typename?: 'DetailedDataReportFilters';
            advertiserId: string | null;
            lineItems: Array<string> | null;
            rollUpType: RollUpType | null;
            metricsTypes: Array<string> | null;
          }
        | {
            __typename?: 'ReachFrequencyReportFilters';
            organizationId: string;
            campaignIds: Array<string>;
            adProduct: Array<AdProduct> | null;
            publisher: Array<Publisher> | null;
            startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
            endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
            cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            deliveryGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            netCompletions: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            estimatedAdFrequency: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            estimatedUniqueDevices: {
              __typename?: 'MinMaxNumberValues';
              min: number | null;
              max: number | null;
            } | null;
            campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
          }
        | {
            __typename?: 'StandardDeliveryDeviceHigherCategoryReportFilters';
            organizationId: string;
            campaignIds: Array<string>;
            adProduct: Array<AdProduct> | null;
            publisher: Array<Publisher> | null;
            startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
            endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
            cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            deliveryGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            lifetimeCompletions: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
          }
        | {
            __typename?: 'StandardDeliveryReportFilters';
            organizationId: string;
            campaignIds: Array<string>;
            adProduct: Array<AdProduct> | null;
            publisher: Array<Publisher> | null;
            startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
            endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
            cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            orderGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
            campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
          }
        | {
            __typename?: 'TopLineGenreDeliveryReportFilters';
            organizationId: string;
            campaignIds: Array<string>;
            adProduct: Array<AdProduct> | null;
            publisher: Array<Publisher> | null;
            genres: Array<{ __typename?: 'Genres'; genreName: string; genreDelivery: number }> | null;
            campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
          };
      schedule: {
        __typename?: 'ReportSchedule';
        days: Array<Day> | null;
        frequency: Frequency | null;
        emailNow: boolean | null;
        emailAttachment: boolean | null;
      };
    }>;
  }>;
};

export type ReachFrequencyReportFiltersFragment = {
  __typename?: 'ReachFrequencyReportFilters';
  organizationId: string;
  campaignIds: Array<string>;
  adProduct: Array<AdProduct> | null;
  publisher: Array<Publisher> | null;
  startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
  endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
  cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  deliveryGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  netCompletions: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  estimatedAdFrequency: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  estimatedUniqueDevices: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
  campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
};

export type ReachFrequencyReportMetricsFragmentFragment = {
  __typename?: 'ReachFrequencyReportMetrics';
  id: string;
  campaignId: string;
  campaignName: string | null;
  accountManager: string | null;
  accountExecutive: string | null;
  lineItemName: string;
  lineItems: Array<{
    __typename?: 'ReachFrequencyReportLineItem';
    id: string;
    adProduct: AdProduct | null;
    publisher: string | null;
    startDate: string | null;
    endDate: string | null;
    cpm: number | null;
    revenue: number | null;
    deliveryGoal: number | null;
    netCompletions: number | null;
    estimatedAdFrequency: number | null;
    estimatedUniqueDevices: number | null;
  }>;
};

export type CreateReachFrequencyReportMutationVariables = Exact<{
  report: ReportInput;
  filters: ReachFrequencyReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type CreateReachFrequencyReportMutation = {
  __typename?: 'Mutation';
  createReachFrequencyReport: {
    __typename?: 'ReachFrequencyReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'ReachFrequencyReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      deliveryGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      netCompletions: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      estimatedAdFrequency: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      estimatedUniqueDevices: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  } | null;
};

export type UpdateReachFrequencyReportMutationVariables = Exact<{
  id: Scalars['ID'];
  report: UpdateReportInput;
  filters: ReachFrequencyReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateReachFrequencyReportMutation = {
  __typename?: 'Mutation';
  updateReachFrequencyReport: {
    __typename?: 'ReachFrequencyReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'ReachFrequencyReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      deliveryGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      netCompletions: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      estimatedAdFrequency: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      estimatedUniqueDevices: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  } | null;
};

export type GetReachFrequencyReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetReachFrequencyReportQuery = {
  __typename?: 'Query';
  getReachFrequencyReport: {
    __typename?: 'ReachFrequencyReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'ReachFrequencyReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
      startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      deliveryGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      netCompletions: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      estimatedAdFrequency: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      estimatedUniqueDevices: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  };
};

export type GetReachFrequencyReportMetricsQueryVariables = Exact<{
  metricsOptions: MetricsInput;
  filterOptions: ReachFrequencyReportFiltersInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetReachFrequencyReportMetricsQuery = {
  __typename?: 'Query';
  getReachFrequencyReportMetrics: {
    __typename?: 'ReachFrequencyReportMetricsPage';
    total: number;
    edges: Array<{
      __typename?: 'ReachFrequencyReportMetricsEdge';
      node: {
        __typename?: 'ReachFrequencyReportMetrics';
        id: string;
        campaignId: string;
        campaignName: string | null;
        accountManager: string | null;
        accountExecutive: string | null;
        lineItemName: string;
        lineItems: Array<{
          __typename?: 'ReachFrequencyReportLineItem';
          id: string;
          adProduct: AdProduct | null;
          publisher: string | null;
          startDate: string | null;
          endDate: string | null;
          cpm: number | null;
          revenue: number | null;
          deliveryGoal: number | null;
          netCompletions: number | null;
          estimatedAdFrequency: number | null;
          estimatedUniqueDevices: number | null;
        }>;
      };
    }>;
  };
};

export type GetTotalImpressionChartMetricsQueryVariables = Exact<{
  lineItems: Array<Scalars['String']> | Scalars['String'];
  campaignId: Scalars['ID'];
}>;

export type GetTotalImpressionChartMetricsQuery = {
  __typename?: 'Query';
  getTotalImpressionChartMetrics: Array<{
    __typename?: 'TotalImpressionsChartMetrics';
    total: number;
    metrics: Array<{ __typename?: 'TotalImpressionsChartMetric'; time: string; percentile: number; total: number }>;
  }>;
};

export type StandardDeliveryReportMetricsFragmentFragment = {
  __typename?: 'StandardDeliveryReportMetrics';
  id: string;
  campaignId: string;
  campaignName: string | null;
  accountManager: string | null;
  accountExecutive: string | null;
  lineItemName: string;
  lineItems: Array<{
    __typename?: 'StandardDeliveryReportLineItem';
    id: string;
    adProduct: AdProduct | null;
    publisher: string | null;
    startDate: string | null;
    endDate: string | null;
    cpm: number | null;
    revenue: number | null;
    orderGoal: number | null;
    impressions: number | null;
    completions: number | null;
    vcrPercentage: number | null;
    overUnderDelivery: number | null;
    overUnderSpend: number | null;
    estimatedBillable: number | null;
    thirdPartyGrossBillableImpressions: number | null;
  }>;
};

export type CreateStandardDeliveryReportsMutationVariables = Exact<{
  report: ReportInput;
  filters: StandardDeliveryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type CreateStandardDeliveryReportsMutation = {
  __typename?: 'Mutation';
  createStandardDeliveryReport: {
    __typename?: 'StandardDeliveryReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'StandardDeliveryReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      orderGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  } | null;
};

export type UpdateStandardDeliveryReportMutationVariables = Exact<{
  id: Scalars['ID'];
  report: UpdateReportInput;
  filters: StandardDeliveryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateStandardDeliveryReportMutation = {
  __typename?: 'Mutation';
  updateStandardDeliveryReport: {
    __typename?: 'StandardDeliveryReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'StandardDeliveryReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      orderGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  } | null;
};

export type GetStandardDeliveryReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetStandardDeliveryReportQuery = {
  __typename?: 'Query';
  getStandardDeliveryReport: {
    __typename?: 'StandardDeliveryReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'StandardDeliveryReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
      startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      orderGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  };
};

export type GetStandardDeliveryReportMetricsQueryVariables = Exact<{
  metricsOptions: MetricsInput;
  filterOptions: StandardDeliveryReportFiltersInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetStandardDeliveryReportMetricsQuery = {
  __typename?: 'Query';
  getStandardDeliveryReportMetrics: {
    __typename?: 'StandardDeliveryReportMetricsPage';
    total: number;
    edges: Array<{
      __typename?: 'StandardDeliveryReportMetricsEdge';
      node: {
        __typename?: 'StandardDeliveryReportMetrics';
        id: string;
        campaignId: string;
        campaignName: string | null;
        accountManager: string | null;
        accountExecutive: string | null;
        lineItemName: string;
        lineItems: Array<{
          __typename?: 'StandardDeliveryReportLineItem';
          id: string;
          adProduct: AdProduct | null;
          publisher: string | null;
          startDate: string | null;
          endDate: string | null;
          cpm: number | null;
          revenue: number | null;
          orderGoal: number | null;
          impressions: number | null;
          completions: number | null;
          vcrPercentage: number | null;
          overUnderDelivery: number | null;
          overUnderSpend: number | null;
          estimatedBillable: number | null;
          thirdPartyGrossBillableImpressions: number | null;
        }>;
      };
    }>;
  };
};

export type StandardDeliveryDhcReportMetricsFragmentFragment = {
  __typename?: 'StandardDeliveryDeviceHigherCategoryReportMetrics';
  id: string;
  campaignId: string;
  campaignName: string | null;
  accountManager: string | null;
  accountExecutive: string | null;
  lineItemName: string;
  lineItems: Array<{
    __typename?: 'StandardDeliveryDeviceHigherCategoryReportLineItem';
    id: string;
    adProduct: AdProduct | null;
    publisher: string | null;
    startDate: string | null;
    endDate: string | null;
    cpm: number | null;
    revenue: number | null;
    deliveryGoal: number | null;
    lifetimeCompletions: number | null;
    deviceBreakout: Array<{
      __typename?: 'DeviceBreakout';
      deviceName: string;
      impressions: number;
      completions: number;
      deviceBreakdown: number;
    }> | null;
  }>;
};

export type CreateStandardDeliveryDeviceHigherCategoryReportMutationVariables = Exact<{
  report: ReportInput;
  filters: StandardDeliveryDeviceHigherCategoryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type CreateStandardDeliveryDeviceHigherCategoryReportMutation = {
  __typename?: 'Mutation';
  createStandardDeliveryDeviceHigherCategoryReport: {
    __typename?: 'StandardDeliveryDeviceHigherCategoryReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'StandardDeliveryDeviceHigherCategoryReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      deliveryGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      lifetimeCompletions: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  } | null;
};

export type UpdateStandardDeliveryDeviceHigherCategoryReportMutationVariables = Exact<{
  id: Scalars['ID'];
  report: UpdateReportInput;
  filters: StandardDeliveryDeviceHigherCategoryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateStandardDeliveryDeviceHigherCategoryReportMutation = {
  __typename?: 'Mutation';
  updateStandardDeliveryDeviceHigherCategoryReport: {
    __typename?: 'StandardDeliveryDeviceHigherCategoryReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'StandardDeliveryDeviceHigherCategoryReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      deliveryGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      lifetimeCompletions: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  } | null;
};

export type GetStandardDeliveryDeviceHigherCategoryReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetStandardDeliveryDeviceHigherCategoryReportQuery = {
  __typename?: 'Query';
  getStandardDeliveryDeviceHigherCategoryReport: {
    __typename?: 'StandardDeliveryDeviceHigherCategoryReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'StandardDeliveryDeviceHigherCategoryReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
      startDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      endDate: { __typename?: 'MinMaxStringValues'; min: string | null; max: string | null } | null;
      cpm: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      revenue: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      deliveryGoal: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
      lifetimeCompletions: { __typename?: 'MinMaxNumberValues'; min: number | null; max: number | null } | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  };
};

export type GetStandardDeliveryDeviceHigherCategoryReportMetricsQueryVariables = Exact<{
  metricsOptions: MetricsInput;
  filterOptions: StandardDeliveryDeviceHigherCategoryReportFiltersInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetStandardDeliveryDeviceHigherCategoryReportMetricsQuery = {
  __typename?: 'Query';
  getStandardDeliveryDeviceHigherCategoryReportMetrics: {
    __typename?: 'StandardDeliveryDeviceHigherCategoryReportMetricsPage';
    total: number;
    edges: Array<{
      __typename?: 'StandardDeliveryDeviceHigherCategoryReportMetricsEdge';
      node: {
        __typename?: 'StandardDeliveryDeviceHigherCategoryReportMetrics';
        id: string;
        campaignId: string;
        campaignName: string | null;
        accountManager: string | null;
        accountExecutive: string | null;
        lineItemName: string;
        lineItems: Array<{
          __typename?: 'StandardDeliveryDeviceHigherCategoryReportLineItem';
          id: string;
          adProduct: AdProduct | null;
          publisher: string | null;
          startDate: string | null;
          endDate: string | null;
          cpm: number | null;
          revenue: number | null;
          deliveryGoal: number | null;
          lifetimeCompletions: number | null;
          deviceBreakout: Array<{
            __typename?: 'DeviceBreakout';
            deviceName: string;
            impressions: number;
            completions: number;
            deviceBreakdown: number;
          }> | null;
        }>;
      };
    }>;
  };
};

export type TopLineGenreDeliveryReportFiltersFragment = {
  __typename?: 'TopLineGenreDeliveryReportFilters';
  organizationId: string;
  campaignIds: Array<string>;
  adProduct: Array<AdProduct> | null;
  publisher: Array<Publisher> | null;
  genres: Array<{ __typename?: 'Genres'; genreName: string; genreDelivery: number }> | null;
  campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
};

export type TopLineGenreDeliveryReportMetricsFragmentFragment = {
  __typename?: 'TopLineGenreDeliveryReportMetrics';
  id: string;
  campaignId: string;
  campaignName: string | null;
  accountManager: string | null;
  accountExecutive: string | null;
  lineItemName: string;
  lineItems: Array<{
    __typename?: 'TopLineGenreDeliveryReportLineItem';
    id: string;
    adProduct: AdProduct | null;
    publisher: string | null;
    genres: Array<{ __typename?: 'Genres'; genreName: string; genreDelivery: number }> | null;
  }>;
};

export type CreateTopLineGenreDeliveryReportMutationVariables = Exact<{
  report: ReportInput;
  filters: TopLineGenreDeliveryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type CreateTopLineGenreDeliveryReportMutation = {
  __typename?: 'Mutation';
  createTopLineGenreDeliveryReport: {
    __typename?: 'TopLineGenreDeliveryReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'TopLineGenreDeliveryReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      genres: Array<{ __typename?: 'Genres'; genreName: string; genreDelivery: number }> | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  } | null;
};

export type UpdateTopLineGenreDeliveryReportMutationVariables = Exact<{
  id: Scalars['ID'];
  report: UpdateReportInput;
  filters: TopLineGenreDeliveryReportFiltersInput;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateTopLineGenreDeliveryReportMutation = {
  __typename?: 'Mutation';
  updateTopLineGenreDeliveryReport: {
    __typename?: 'TopLineGenreDeliveryReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'TopLineGenreDeliveryReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      genres: Array<{ __typename?: 'Genres'; genreName: string; genreDelivery: number }> | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  } | null;
};

export type GetTopGenreDeliveryReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetTopGenreDeliveryReportQuery = {
  __typename?: 'Query';
  getTopLineGenreDeliveryReport: {
    __typename?: 'TopLineGenreDeliveryReport';
    id: string;
    templateId: string;
    name: string;
    status: ReportStatus;
    dateRange: DateRange;
    startDate: string | null;
    endDate: string | null;
    exportFormat: ExportFormat;
    ownerId: string;
    recipients: Array<string> | null;
    lastGeneratedAt: string | null;
    updatedAt: string;
    filters: {
      __typename?: 'TopLineGenreDeliveryReportFilters';
      organizationId: string;
      campaignIds: Array<string>;
      adProduct: Array<AdProduct> | null;
      publisher: Array<Publisher> | null;
      campaigns: Array<{ __typename?: 'CampaignShortInfo'; id: string; name: string }> | null;
      genres: Array<{ __typename?: 'Genres'; genreName: string; genreDelivery: number }> | null;
    };
    schedule: {
      __typename?: 'ReportSchedule';
      days: Array<Day> | null;
      frequency: Frequency | null;
      emailNow: boolean | null;
      emailAttachment: boolean | null;
    };
  };
};

export type GetTopLineGenreDeliveryReportMetricsQueryVariables = Exact<{
  metricsOptions: MetricsInput;
  filterOptions: TopLineGenreDeliveryReportFiltersInput;
  paginationOptions?: InputMaybe<PaginationOptions>;
  sortOptions?: InputMaybe<SortOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
  isAdminRequest?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetTopLineGenreDeliveryReportMetricsQuery = {
  __typename?: 'Query';
  getTopLineGenreDeliveryReportMetrics: {
    __typename?: 'TopLineGenreDeliveryReportMetricsPage';
    total: number;
    edges: Array<{
      __typename?: 'TopLineGenreDeliveryReportMetricsEdge';
      node: {
        __typename?: 'TopLineGenreDeliveryReportMetrics';
        id: string;
        campaignId: string;
        campaignName: string | null;
        accountManager: string | null;
        accountExecutive: string | null;
        lineItemName: string;
        lineItems: Array<{
          __typename?: 'TopLineGenreDeliveryReportLineItem';
          id: string;
          adProduct: AdProduct | null;
          publisher: string | null;
          genres: Array<{ __typename?: 'Genres'; genreName: string; genreDelivery: number }> | null;
        }>;
      };
    }>;
  };
};

export type UserFragmentFragment = {
  __typename?: 'User';
  id: string;
  phone: string | null;
  lastName: string | null;
  firstName: string | null;
  email: string;
  status: string | null;
  createdAt: any | null;
  roleList: Array<{
    __typename?: 'UserOrganizationInfoRoles';
    role: any;
    entityId: string;
    entityType: EntityType;
    entityName:
      | { __typename?: 'AdAccountRole'; accountName: string }
      | { __typename?: 'GenericRole'; id: string }
      | null;
  }>;
};

export type UserInfoFragmentFragment = {
  __typename?: 'User';
  id: string;
  phone: string | null;
  lastName: string | null;
  firstName: string | null;
  email: string;
};

export type SearchUserFragmentFragment = {
  __typename?: 'SearchUser';
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  status: string | null;
  role: any | null;
  updatedAt: any | null;
  createdAt: any | null;
  lastLoginAt: any | null;
};

export type ActivateUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ActivateUserMutation = { __typename?: 'Mutation'; activateUser: any | null };

export type BulkChangeUserRolesMutationVariables = Exact<{
  orgId: Scalars['ID'];
  id: Scalars['ID'];
  assignments: Array<BulkChangeRoles> | BulkChangeRoles;
}>;

export type BulkChangeUserRolesMutation = { __typename?: 'Mutation'; bulkChangeUserRoles: any | null };

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeactivateUserMutation = { __typename?: 'Mutation'; deactivateUser: any | null };

export type DeleteSellerMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type DeleteSellerMutation = {
  __typename?: 'Mutation';
  deleteSeller: { __typename?: 'User'; id: string } | null;
};

export type EditSellerMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  roleList: Array<Roles> | Roles;
}>;

export type EditSellerMutation = { __typename?: 'Mutation'; editSeller: { __typename?: 'User'; id: string } | null };

export type InviteSellerMutationVariables = Exact<{
  input: SellerInviteInput;
}>;

export type InviteSellerMutation = {
  __typename?: 'Mutation';
  inviteSeller: Array<{ __typename?: 'User'; id: string; email: string }>;
};

export type InviteSellerWithCsvMutationVariables = Exact<{
  input: Array<SellerInviteInput> | SellerInviteInput;
}>;

export type InviteSellerWithCsvMutation = { __typename?: 'Mutation'; inviteSellerWithCsv: Array<string | null> };

export type InviteUserMutationVariables = Exact<{
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  roleList: Array<Roles> | Roles;
  id: Scalars['ID'];
  assignments?: InputMaybe<Array<InputMaybe<BulkChangeRoles>> | InputMaybe<BulkChangeRoles>>;
}>;

export type InviteUserMutation = { __typename?: 'Mutation'; inviteUser: { __typename?: 'User'; id: string } };

export type UpdateUserDetailsMutationVariables = Exact<{
  id: Scalars['ID'];
  orgId: Scalars['ID'];
  input: UserInput;
}>;

export type UpdateUserDetailsMutation = {
  __typename?: 'Mutation';
  updateUser: { __typename?: 'User'; id: string; email: string; firstName: string | null; lastName: string | null };
};

export type UpdateUserPhoneMutationVariables = Exact<{
  id: Scalars['ID'];
  phone: Scalars['String'];
}>;

export type UpdateUserPhoneMutation = { __typename?: 'Mutation'; updateUserPhone: { __typename?: 'User'; id: string } };

export type UpdateUserRolesMutationVariables = Exact<{
  orgId: Scalars['ID'];
  id: Scalars['ID'];
  roleList: Array<Roles> | Roles;
  assignments?: InputMaybe<Array<InputMaybe<BulkChangeRoles>> | InputMaybe<BulkChangeRoles>>;
}>;

export type UpdateUserRolesMutation = {
  __typename?: 'Mutation';
  updateUserRoles: {
    __typename?: 'User';
    id: string;
    phone: string | null;
    lastName: string | null;
    firstName: string | null;
    email: string;
    status: string | null;
    createdAt: any | null;
    roleList: Array<{
      __typename?: 'UserOrganizationInfoRoles';
      role: any;
      entityId: string;
      entityType: EntityType;
      entityName:
        | { __typename?: 'AdAccountRole'; accountName: string }
        | { __typename?: 'GenericRole'; id: string }
        | null;
    }>;
  } | null;
};

export type GetActiveUsersStatisticsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']>;
  sellerId?: InputMaybe<Scalars['ID']>;
  loginActivity?: InputMaybe<LoginActivity>;
  dateRange: DateRange;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  hamIndustryName?: InputMaybe<Scalars['String']>;
}>;

export type GetActiveUsersStatisticsQuery = {
  __typename?: 'Query';
  getActiveUsersStatistics: {
    __typename?: 'ActiveUsersStatistics';
    activeUsers: number;
    percentUniqueSubmittedBy: number | null;
    totalUsers: number;
    percentActive: number | null;
    totalSpend: number;
  };
};

export type ExportUsersSummaryQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  sellerId?: InputMaybe<Scalars['ID']>;
  loginActivity?: InputMaybe<LoginActivity>;
}>;

export type ExportUsersSummaryQuery = { __typename?: 'Query'; exportUsersSummary: string };

export type AdAccountsByUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type AdAccountsByUserQuery = {
  __typename?: 'Query';
  adAccountsByUser: {
    __typename?: 'AdAccountsPages';
    total: number;
    edges: Array<{
      __typename?: 'AdAccountEdge';
      cursor: string;
      node: {
        __typename?: 'AdAccount';
        id: string;
        name: string;
        organizationId: string | null;
        isBaymaxEnabled: boolean | null;
        brand: {
          __typename?: 'Brand';
          id: string;
          name: string;
          industry: { __typename?: 'Industry'; id: string; name: string };
        } | null;
      };
    }>;
  };
};

export type GetPermittedUserRolesQueryVariables = Exact<{
  orgId: Scalars['ID'];
  isForUpdate?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetPermittedUserRolesQuery = {
  __typename?: 'Query';
  getPermittedUserRoles: {
    __typename?: 'UserRoles';
    creativeLibraryId: string | null;
    organizationRoles: Array<{ __typename?: 'PermittedRole'; name: any; displayName: string }> | null;
    adAccountRoles: Array<{ __typename?: 'PermittedRole'; name: any; displayName: string }> | null;
    adAccounts: Array<{ __typename?: 'AdAccountAssignment'; id: string; name: string }> | null;
  };
};

export type GetSellersQueryVariables = Exact<{
  orgId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  includeOrganizations: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  email?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Array<SellerSortBy> | SellerSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
}>;

export type GetSellersQuery = {
  __typename?: 'Query';
  getSellers: {
    __typename?: 'SearchUsersPage';
    total: number;
    edges: Array<{
      __typename?: 'SearchUserEdge';
      node: {
        __typename?: 'SearchUser';
        id: string;
        email: string;
        firstName: string | null;
        lastName: string | null;
        status: string | null;
        phone: string | null;
        role: any | null;
        updatedAt: any | null;
        createdAt: any | null;
        lastLoginAt: any | null;
        organizationsCount: number | null;
        organizations: Array<{ __typename?: 'UserOrganization'; id: string; name: string }> | null;
      };
    }>;
  };
};

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetUserByIdQuery = {
  __typename?: 'Query';
  getUserById: {
    __typename?: 'User';
    status: string | null;
    createdAt: any | null;
    lastLoginAt: any | null;
    id: string;
    phone: string | null;
    lastName: string | null;
    firstName: string | null;
    email: string;
    roleList: Array<{
      __typename?: 'UserOrganizationInfoRoles';
      entityId: string;
      entityType: EntityType;
      role: any;
      entityName:
        | { __typename?: 'AdAccountRole'; accountName: string }
        | { __typename?: 'GenericRole'; id: string }
        | null;
    }>;
  };
};

export type GetUserByOrgIdQueryVariables = Exact<{
  orgId: Scalars['ID'];
  userId: Scalars['ID'];
  isUserNonDeletable?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetUserByOrgIdQuery = {
  __typename?: 'Query';
  getUserByOrgId: Array<{ __typename?: 'SearchUser'; id: string; deletable: boolean | null }> | null;
};

export type GetUserByOrganizationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetUserByOrganizationQuery = {
  __typename?: 'Query';
  loggedInUserByOrganization: {
    __typename?: 'User';
    id: string;
    phone: string | null;
    lastName: string | null;
    firstName: string | null;
    email: string;
    status: string | null;
    createdAt: any | null;
    assignments: Array<{
      __typename?: 'Assignment';
      adAccountId: string;
      adAccountName: string;
      assignment: string;
    }> | null;
    roleList: Array<{
      __typename?: 'UserOrganizationInfoRoles';
      role: any;
      entityId: string;
      entityType: EntityType;
      entityName:
        | { __typename?: 'AdAccountRole'; accountName: string }
        | { __typename?: 'GenericRole'; id: string }
        | null;
    }>;
  };
};

export type UserOrganizationInfoQueryVariables = Exact<{
  userId: Scalars['ID'];
  orgId: Scalars['ID'];
}>;

export type UserOrganizationInfoQuery = {
  __typename?: 'Query';
  userOrganizationInfo: {
    __typename?: 'User';
    status: string | null;
    createdAt: any | null;
    lastLoginAt: any | null;
    deletable: boolean | null;
    id: string;
    phone: string | null;
    lastName: string | null;
    firstName: string | null;
    email: string;
    roleList: Array<{
      __typename?: 'UserOrganizationInfoRoles';
      entityId: string;
      entityType: EntityType;
      role: any;
      entityName:
        | { __typename?: 'AdAccountRole'; accountName: string }
        | { __typename?: 'GenericRole'; id: string }
        | null;
    }>;
  };
};

export type GetRoleClaimsQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type GetRoleClaimsQuery = {
  __typename?: 'Query';
  getRoleClaims: { __typename?: 'UserRoleClaims'; userId: string; compressedRoles: string; roleCount: number | null };
};

export type UserRoleListByOrdQueryVariables = Exact<{
  userId: Scalars['ID'];
  orgId: Scalars['ID'];
}>;

export type UserRoleListByOrdQuery = {
  __typename?: 'Query';
  userOrganizationInfo: {
    __typename?: 'User';
    id: string;
    roleList: Array<{
      __typename?: 'UserOrganizationInfoRoles';
      entityId: string;
      entityType: EntityType;
      role: any;
      entityName:
        | { __typename?: 'AdAccountRole'; accountName: string }
        | { __typename?: 'GenericRole'; id: string }
        | null;
    }>;
  };
};

export type GetUsersByAdAccountQueryVariables = Exact<{
  adAccountId: Scalars['ID'];
}>;

export type GetUsersByAdAccountQuery = {
  __typename?: 'Query';
  getUsersByAdAccount: Array<{
    __typename?: 'User';
    id: string;
    firstName: string | null;
    lastName: string | null;
    status: string | null;
  }> | null;
};

export type GetUsersByOrgIdOrAdAccountIdQueryVariables = Exact<{
  currentId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<UserSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
  includeOrganizations: Scalars['Boolean'];
  isOrg: Scalars['Boolean'];
}>;

export type GetUsersByOrgIdOrAdAccountIdQuery = {
  __typename?: 'Query';
  getUsersByOrgIdOrAdAccountId: {
    __typename?: 'SearchUsersPage';
    total: number;
    edges: Array<{
      __typename?: 'SearchUserEdge';
      node: {
        __typename?: 'SearchUser';
        deletable: boolean | null;
        id: string;
        email: string;
        firstName: string | null;
        lastName: string | null;
        status: string | null;
        role: any | null;
        updatedAt: any | null;
        createdAt: any | null;
        lastLoginAt: any | null;
      };
    }>;
  };
};

export type GetUsersByOrgIdOrAdAccountIdWithoutDeletableFieldQueryVariables = Exact<{
  currentId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<UserSortBy>;
  sortOrder?: InputMaybe<OrderOption>;
  includeOrganizations: Scalars['Boolean'];
  isOrg: Scalars['Boolean'];
}>;

export type GetUsersByOrgIdOrAdAccountIdWithoutDeletableFieldQuery = {
  __typename?: 'Query';
  getUsersByOrgIdOrAdAccountId: {
    __typename?: 'SearchUsersPage';
    total: number;
    edges: Array<{
      __typename?: 'SearchUserEdge';
      node: {
        __typename?: 'SearchUser';
        id: string;
        email: string;
        firstName: string | null;
        lastName: string | null;
        status: string | null;
        role: any | null;
        updatedAt: any | null;
        createdAt: any | null;
        lastLoginAt: any | null;
      };
    }>;
  };
};

export type ResendInviteQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type ResendInviteQuery = {
  __typename?: 'Query';
  resendUserInvite: {
    __typename?: 'UserInvitation';
    userStatus: string;
    invitationStatus: InvitationStatus;
    inviteNotSentReason: InviteNotSentReason | null;
  };
};

export type MyPermissionsQueryVariables = Exact<{
  userId: Scalars['ID'];
  organizationId?: InputMaybe<Scalars['ID']>;
  isGhostMode?: InputMaybe<Scalars['Boolean']>;
}>;

export type MyPermissionsQuery = {
  __typename?: 'Query';
  myPermissions: {
    __typename?: 'UserPermissions';
    roles: Array<string>;
    adAccountPermissions: Array<{
      __typename?: 'PermissionsByAdAccount';
      id: string;
      permissions: {
        __typename?: 'Permissions';
        ADMIN_CREATE_PAYMENTS: boolean;
        ADMIN_DELETE_PAYMENTS: boolean;
        ADMIN_READ_PAYMENTS: boolean;
        ADMIN_RETRY_PAYMENTS: boolean;
        ADMIN_REFUND_PAYMENTS: boolean;
        ADMIN_UPDATE_PAYMENTS: boolean;
        ADMIN_UPDATE_THRESHOLD: boolean;
        APPLY_PROMO_CODE: boolean;
        BUILD_REPORT: boolean;
        CANCEL_LINE_ITEM: boolean;
        CLONE_LINE_ITEM: boolean;
        CONFIGURE_AD_TAG: boolean;
        CREATE_AD_ACCOUNT: boolean;
        CREATE_ASSET: boolean;
        CREATE_BRAND: boolean;
        CREATE_BROADCAST: boolean;
        CREATE_CAMPAIGN: boolean;
        CREATE_CREATIVE: boolean;
        UPDATE_AD_FORMAT: boolean;
        CREATE_ADVANCED_CREATIVE: boolean;
        CREATE_INDUSTRY: boolean;
        CREATE_LINEITEM: boolean;
        CREATE_PAYMENTS: boolean;
        CREATE_REPORT: boolean;
        CREATE_USER: boolean;
        DELETE_AD_ACCOUNT: boolean;
        DELETE_BROADCAST: boolean;
        DELETE_CAMPAIGN: boolean;
        DELETE_CREATIVE: boolean;
        DELETE_CREATIVES: boolean;
        DELETE_LINE_ITEM: boolean;
        DELETE_ORGANIZATION: boolean;
        DELETE_PAYMENTS: boolean;
        DELETE_REPORT: boolean;
        DETACH_PROMO_CODE: boolean;
        GET_CAMPAIGN: boolean;
        GET_LINE_ITEM: boolean;
        INVITE_USER: boolean;
        PAUSE_LINE_ITEM: boolean;
        READ_AD_ACCOUNT: boolean;
        READ_ALL_ADS: boolean;
        READ_ALL_CAMPAIGNS: boolean;
        READ_ALL_LINE_ITEMS: boolean;
        READ_BRAND: boolean;
        READ_BROADCAST: boolean;
        READ_CAMPAIGN_LINEITEMS: boolean;
        READ_CREATIVE: boolean;
        READ_CREATIVES: boolean;
        READ_INDUSTRY: boolean;
        READ_LEGACY_REPORT: boolean;
        READ_NOTIFICATION: boolean;
        READ_ORGANIZATION: boolean;
        READ_OWN_USER: boolean;
        READ_PAYMENTS: boolean;
        READ_REPORT: boolean;
        READ_REPORT_TEMPLATE: boolean;
        READ_ROLES: boolean;
        READ_TARGETING: boolean;
        READ_USER: boolean;
        READ_USERS: boolean;
        RESUME_LINE_ITEM: boolean;
        SUBMIT_LINE_ITEM: boolean;
        SUSPEND_LINE_ITEM: boolean;
        UPDATE_AD_ACCOUNT: boolean;
        UPDATE_AD_ACCOUNT_BILLING_CONTACT: boolean;
        UPDATE_AD_ACCOUNT_BRAND: boolean;
        UPDATE_AD_ACCOUNT_NAME: boolean;
        UPDATE_AD_ACCOUNT_STATUS: boolean;
        UPDATE_BRAND: boolean;
        UPDATE_BROADCAST: boolean;
        UPDATE_CAMPAIGN: boolean;
        UPDATE_INDUSTRY: boolean;
        UPDATE_LINE_ITEM: boolean;
        UPDATE_NOTIFICATION_SETTINGS: boolean;
        UPDATE_ORGANIZATION: boolean;
        UPDATE_PAYMENTS: boolean;
        UPDATE_REPORT: boolean;
        UPDATE_USER: boolean;
        USER_STATUS_UPDATE: boolean;
        OVERRIDE_LINE_ITEM_PRICE: boolean;
        OVERRIDE_LINE_ITEM_KERV: boolean;
        READ_PACKAGE: boolean;
        SUBMIT_ADS: boolean;
        GENIE_UI_ACCESS: boolean;
      };
    }> | null;
    permissions: {
      __typename?: 'Permissions';
      ADMIN_CREATE_PAYMENTS: boolean;
      ADMIN_DELETE_PAYMENTS: boolean;
      ADMIN_READ_PAYMENTS: boolean;
      ADMIN_RETRY_PAYMENTS: boolean;
      ADMIN_REFUND_PAYMENTS: boolean;
      ADMIN_UPDATE_PAYMENTS: boolean;
      ADMIN_UPDATE_THRESHOLD: boolean;
      APPLY_PROMO_CODE: boolean;
      BUILD_REPORT: boolean;
      CANCEL_LINE_ITEM: boolean;
      CLONE_LINE_ITEM: boolean;
      CONFIGURE_AD_TAG: boolean;
      CREATE_AD_ACCOUNT: boolean;
      CREATE_ASSET: boolean;
      CREATE_BRAND: boolean;
      CREATE_BROADCAST: boolean;
      CREATE_CAMPAIGN: boolean;
      CREATE_CREATIVE: boolean;
      UPDATE_AD_FORMAT: boolean;
      CREATE_ADVANCED_CREATIVE: boolean;
      CREATE_INDUSTRY: boolean;
      CREATE_LINEITEM: boolean;
      CREATE_PAYMENTS: boolean;
      CREATE_REPORT: boolean;
      CREATE_USER: boolean;
      DELETE_AD_ACCOUNT: boolean;
      DELETE_BROADCAST: boolean;
      DELETE_CAMPAIGN: boolean;
      DELETE_CREATIVE: boolean;
      DELETE_CREATIVES: boolean;
      DELETE_LINE_ITEM: boolean;
      DELETE_ORGANIZATION: boolean;
      DELETE_PAYMENTS: boolean;
      DELETE_REPORT: boolean;
      DETACH_PROMO_CODE: boolean;
      GET_CAMPAIGN: boolean;
      GET_LINE_ITEM: boolean;
      INVITE_USER: boolean;
      PAUSE_LINE_ITEM: boolean;
      READ_AD_ACCOUNT: boolean;
      READ_ALL_ADS: boolean;
      READ_ALL_CAMPAIGNS: boolean;
      READ_ALL_LINE_ITEMS: boolean;
      READ_BRAND: boolean;
      READ_BROADCAST: boolean;
      READ_CAMPAIGN_LINEITEMS: boolean;
      READ_CREATIVE: boolean;
      READ_CREATIVES: boolean;
      READ_INDUSTRY: boolean;
      READ_LEGACY_REPORT: boolean;
      READ_NOTIFICATION: boolean;
      READ_ORGANIZATION: boolean;
      READ_OWN_USER: boolean;
      READ_PAYMENTS: boolean;
      READ_REPORT: boolean;
      READ_REPORT_TEMPLATE: boolean;
      READ_ROLES: boolean;
      READ_TARGETING: boolean;
      READ_USER: boolean;
      READ_USERS: boolean;
      RESUME_LINE_ITEM: boolean;
      SUBMIT_LINE_ITEM: boolean;
      SUSPEND_LINE_ITEM: boolean;
      UPDATE_AD_ACCOUNT: boolean;
      UPDATE_AD_ACCOUNT_BILLING_CONTACT: boolean;
      UPDATE_AD_ACCOUNT_BRAND: boolean;
      UPDATE_AD_ACCOUNT_NAME: boolean;
      UPDATE_AD_ACCOUNT_STATUS: boolean;
      UPDATE_BRAND: boolean;
      UPDATE_BROADCAST: boolean;
      UPDATE_CAMPAIGN: boolean;
      UPDATE_INDUSTRY: boolean;
      UPDATE_LINE_ITEM: boolean;
      UPDATE_NOTIFICATION_SETTINGS: boolean;
      UPDATE_ORGANIZATION: boolean;
      UPDATE_PAYMENTS: boolean;
      UPDATE_REPORT: boolean;
      UPDATE_USER: boolean;
      USER_STATUS_UPDATE: boolean;
      OVERRIDE_LINE_ITEM_PRICE: boolean;
      OVERRIDE_LINE_ITEM_KERV: boolean;
      READ_PACKAGE: boolean;
      SUBMIT_ADS: boolean;
      GENIE_UI_ACCESS: boolean;
    };
  };
};

export type GetUserOrganizationsQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type GetUserOrganizationsQuery = {
  __typename?: 'Query';
  getOrganizationsByUser: Array<{ __typename?: 'Organization'; name: string; id: string }> | null;
};

export type ResendUserInviteWithReCaptchaValidationQueryVariables = Exact<{
  email: Scalars['String'];
  token: Scalars['String'];
}>;

export type ResendUserInviteWithReCaptchaValidationQuery = {
  __typename?: 'Query';
  resendUserInviteWithReCAPTCHAValidation: {
    __typename?: 'UserInvitationWithReCAPTCHAValidation';
    userStatus: string | null;
    invitationStatus: InvitationStatus | null;
    inviteNotSentReason: InviteNotSentReason | null;
    errorMessages: Array<string> | null;
    reCAPTCHASuccess: boolean;
  };
};

export type SearchUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type SearchUserQuery = {
  __typename?: 'Query';
  searchUser: Array<{ __typename?: 'SearchUser'; id: string; deletable: boolean | null } | null>;
};

export type SearchUsersQueryVariables = Exact<{
  paginationOptions: PaginationOptions;
  filterOptions?: InputMaybe<UsersFilterOptions>;
  sortOptions?: InputMaybe<AllUsersStrictSortOptions>;
}>;

export type SearchUsersQuery = {
  __typename?: 'Query';
  searchUsers: {
    __typename?: 'SearchUsersPage';
    total: number;
    edges: Array<{
      __typename?: 'SearchUserEdge';
      node: {
        __typename?: 'SearchUser';
        id: string;
        email: string;
        firstName: string | null;
        lastName: string | null;
        createdAt: any | null;
        lastLoginAt: any | null;
        phone: string | null;
        deletable: boolean | null;
        role: any | null;
        status: string | null;
        updatedAt: any | null;
        organizationsCount: number | null;
        organizations: Array<{ __typename?: 'UserOrganization'; id: string; name: string }> | null;
      };
    }>;
  };
};

export type UsersFilterOptionsFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type UsersFilterOptionsFieldsQuery = {
  __typename?: 'Query';
  __type: { __typename?: '__Type'; inputFields: Array<{ __typename?: '__InputValue'; name: string }> | null } | null;
};

export type SearchUsersByAdAccountIdQueryVariables = Exact<{
  adAccountId: Scalars['ID'];
  paginationOptions: PaginationOptions;
  filterOptions?: InputMaybe<UsersByAdAccountFilterOptions>;
  sortOptions?: InputMaybe<UsersSortOptions>;
}>;

export type SearchUsersByAdAccountIdQuery = {
  __typename?: 'Query';
  searchUsersByAdAccountId: {
    __typename?: 'SearchUsersPage';
    total: number;
    edges: Array<{
      __typename?: 'SearchUserEdge';
      node: {
        __typename?: 'SearchUser';
        id: string;
        email: string;
        firstName: string | null;
        lastName: string | null;
        createdAt: any | null;
        lastLoginAt: any | null;
        deletable: boolean | null;
        role: any | null;
        status: string | null;
      };
    }>;
  };
};

export type ValidateReCaptchaMutationVariables = Exact<{
  token: Scalars['String'];
}>;

export type ValidateReCaptchaMutation = {
  __typename?: 'Mutation';
  validateReCAPTCHA: {
    __typename?: 'ReCAPTCHAResponse';
    success: boolean;
    challengeTs: any | null;
    hostname: string | null;
    errorMessages: Array<string> | null;
  };
};

export type AssetInfoFragment = {
  __typename?: 'AssetInfo';
  name: string | null;
  status: VastStatus;
  sourceUrl: string | null;
  createdAt: any;
  duration: number;
  size: number | null;
  format: string | null;
};

export type AssetRequirementsFragment = {
  __typename?: 'AssetRequirements';
  isValid: boolean;
  parameterType: string;
  parameterName: string;
  parameterValue: string | null;
  message: string | null;
};

export type VastItemFragment = {
  __typename?: 'VastItem';
  asset: {
    __typename?: 'AssetInfo';
    name: string | null;
    status: VastStatus;
    sourceUrl: string | null;
    createdAt: any;
    duration: number;
    size: number | null;
    format: string | null;
  };
  requirements: Array<{
    __typename?: 'AssetRequirements';
    isValid: boolean;
    parameterType: string;
    parameterName: string;
    parameterValue: string | null;
    message: string | null;
  }>;
};

export type GeneratePresignedUrlMutationVariables = Exact<{
  key: Scalars['String'];
}>;

export type GeneratePresignedUrlMutation = {
  __typename?: 'Mutation';
  generatePresignedUrl: { __typename?: 'PresignedUrl'; key: string; url: string };
};

export type CreateVastMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  brandId: Scalars['ID'];
  type?: InputMaybe<VastCreativeType>;
  url: Scalars['String'];
}>;

export type CreateVastMutation = {
  __typename?: 'Mutation';
  createVast: { __typename?: 'CreateVast'; id: string; creativeType: CreativeType | null; url: string | null };
};

export type ValidateVastMutationVariables = Exact<{
  url: Scalars['String'];
  type?: InputMaybe<VastCreativeType>;
}>;

export type ValidateVastMutation = {
  __typename?: 'Mutation';
  validateVast: {
    __typename?: 'VastInfo';
    isValid: boolean;
    originalUrl: string | null;
    replacedUrl: string | null;
    replacedMacros: Array<{
      __typename?: 'VastReplacedMacros';
      key: string | null;
      values: { __typename?: 'VastReplacedMacrosValue'; from: string | null; to: string | null } | null;
    }> | null;
  } | null;
};

export type GetCreativeVastQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetCreativeVastQuery = {
  __typename?: 'Query';
  getCreativeVast: {
    __typename?: 'CreativeVast';
    id: string;
    creativeLibraryId: string;
    creativeType: CreativeType;
    creativeManagerId: string;
    url: string;
    status: CreativeStatus;
    replacedUrl: string | null;
    vendorName: string | null;
    deletable: boolean;
    lineItems: Array<{ __typename?: 'CreativeLineItemInfo'; id: string; name: string; status: string } | null> | null;
  };
};

export type QCheckVastQueryVariables = Exact<{
  vastId: Scalars['ID'];
  reIngest?: InputMaybe<Scalars['Boolean']>;
}>;

export type QCheckVastQuery = {
  __typename?: 'Query';
  qCheckVast: {
    __typename?: 'QCheckVast';
    id: string;
    isValid: boolean;
    rejectionReasons: Array<string> | null;
    results: Array<{
      __typename?: 'VastItem';
      asset: {
        __typename?: 'AssetInfo';
        name: string | null;
        status: VastStatus;
        sourceUrl: string | null;
        createdAt: any;
        duration: number;
        size: number | null;
        format: string | null;
      };
      requirements: Array<{
        __typename?: 'AssetRequirements';
        isValid: boolean;
        parameterType: string;
        parameterName: string;
        parameterValue: string | null;
        message: string | null;
      }>;
    } | null>;
  };
};
